'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _reactDom = require('react-dom');
var _reactDom__default = _interopDefault(_reactDom);
var _propTypes = _interopDefault(require('prop-types'));
var stream = _interopDefault(require('stream'));

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = 'object' === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

var runtimeModule = runtime;

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

var regenerator = runtimeModule;

var DISPLAY_MODE_PREVIEW = 'PREVIEW';
var DISPLAY_MODE_EDIT = 'EDIT';
var DISPLAY_MODE_TRANSLATE = 'TRANSLATE';
var DISPLAY_MODE_STATIC = 'STATIC';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function invariant(condition, format, a, b, c, d, e, f) {

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

var Dispatcher_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }



var _prefix = 'ID_';

/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */

var Dispatcher = (function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this._callbacks = {};
    this._isDispatching = false;
    this._isHandled = {};
    this._isPending = {};
    this._lastID = 1;
  }

  /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */

  Dispatcher.prototype.register = function register(callback) {
    var id = _prefix + this._lastID++;
    this._callbacks[id] = callback;
    return id;
  };

  /**
   * Removes a callback based on its token.
   */

  Dispatcher.prototype.unregister = function unregister(id) {
    !this._callbacks[id] ? invariant_1(false) : undefined;
    delete this._callbacks[id];
  };

  /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */

  Dispatcher.prototype.waitFor = function waitFor(ids) {
    !this._isDispatching ? invariant_1(false) : undefined;
    for (var ii = 0; ii < ids.length; ii++) {
      var id = ids[ii];
      if (this._isPending[id]) {
        !this._isHandled[id] ? invariant_1(false) : undefined;
        continue;
      }
      !this._callbacks[id] ? invariant_1(false) : undefined;
      this._invokeCallback(id);
    }
  };

  /**
   * Dispatches a payload to all registered callbacks.
   */

  Dispatcher.prototype.dispatch = function dispatch(payload) {
    !!this._isDispatching ? invariant_1(false) : undefined;
    this._startDispatching(payload);
    try {
      for (var id in this._callbacks) {
        if (this._isPending[id]) {
          continue;
        }
        this._invokeCallback(id);
      }
    } finally {
      this._stopDispatching();
    }
  };

  /**
   * Is this Dispatcher currently dispatching.
   */

  Dispatcher.prototype.isDispatching = function isDispatching() {
    return this._isDispatching;
  };

  /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */

  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
    this._isPending[id] = true;
    this._callbacks[id](this._pendingPayload);
    this._isHandled[id] = true;
  };

  /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
    for (var id in this._callbacks) {
      this._isPending[id] = false;
      this._isHandled[id] = false;
    }
    this._pendingPayload = payload;
    this._isDispatching = true;
  };

  /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
    delete this._pendingPayload;
    this._isDispatching = false;
  };

  return Dispatcher;
})();

module.exports = Dispatcher;
});

unwrapExports(Dispatcher_1);

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var Dispatcher$1 = Dispatcher_1;

var Dispatcher$2 = new Dispatcher$1();

var LoadingOverlayActionTypes = {
  LOADING_OVERLAY_SHOW: 'LOADING_OVERLAY_SHOW',
  LOADING_OVERLAY_HIDE: 'LOADING_OVERLAY_HIDE'
};

var LoadingOverlayActions = {
  show: function show() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    Dispatcher$2.dispatch({
      actionType: LoadingOverlayActionTypes.LOADING_OVERLAY_SHOW,
      text: text
    });
  },
  hide: function hide() {
    Dispatcher$2.dispatch({
      actionType: LoadingOverlayActionTypes.LOADING_OVERLAY_HIDE
    });
  }
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var Component = React__default.Component;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */

/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventSubscription = (function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */

  function EventSubscription(subscriber) {
    _classCallCheck$3(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */

  EventSubscription.prototype.remove = function remove() {
    if (this.subscriber) {
      this.subscriber.removeSubscription(this);
      this.subscriber = null;
    }
  };

  return EventSubscription;
})();

var EventSubscription_1 = EventSubscription;

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits$1(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/**
 * EmitterSubscription represents a subscription with listener and context data.
 */

var EmitterSubscription = (function (_EventSubscription) {
  _inherits$1(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  function EmitterSubscription(subscriber, listener, context) {
    _classCallCheck$4(this, EmitterSubscription);

    _EventSubscription.call(this, subscriber);
    this.listener = listener;
    this.context = context;
  }

  return EmitterSubscription;
})(EventSubscription_1);

var EmitterSubscription_1 = EmitterSubscription;

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }



/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */

var EventSubscriptionVendor = (function () {
  function EventSubscriptionVendor() {
    _classCallCheck$5(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */

  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    !(subscription.subscriber === this) ? invariant_1(false) : undefined;
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */

  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */

  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */

  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
})();

var EventSubscriptionVendor_1 = EventSubscriptionVendor;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }







/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var BaseEventEmitter = (function () {
  /**
   * @constructor
   */

  function BaseEventEmitter() {
    _classCallCheck$6(this, BaseEventEmitter);

    this._subscriber = new EventSubscriptionVendor_1();
    this._currentSubscription = null;
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new EmitterSubscription_1(this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
    var emitter = this;
    return this.addListener(eventType, function () {
      emitter.removeCurrentListener();
      listener.apply(context, arguments);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */

  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */

  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    !!!this._currentSubscription ? invariant_1(false) : undefined;
    this._subscriber.removeSubscription(this._currentSubscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */

  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(emptyFunction_1.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */

  BaseEventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      var keys = Object.keys(subscriptions);
      for (var ii = 0; ii < keys.length; ii++) {
        var key = keys[ii];
        var subscription = subscriptions[key];
        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */

  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
    var args = Array.prototype.slice.call(arguments, 2);
    subscription.listener.apply(subscription.context, args);
  };

  return BaseEventEmitter;
})();

var BaseEventEmitter_1 = BaseEventEmitter;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: BaseEventEmitter_1,
  EmitterSubscription : EmitterSubscription_1
};

var fbemitter_1 = fbemitter;

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }



var EventEmitter = fbemitter_1.EventEmitter;



/**
 * This class represents the most basic functionality for a FluxStore. Do not
 * extend this store directly; instead extend FluxReduceStore when creating a
 * new store.
 */

var FluxStore = (function () {
  function FluxStore(dispatcher) {
    var _this = this;

    _classCallCheck$7(this, FluxStore);

    this.__className = this.constructor.name;

    this.__changed = false;
    this.__changeEvent = 'change';
    this.__dispatcher = dispatcher;
    this.__emitter = new EventEmitter();
    this._dispatchToken = dispatcher.register(function (payload) {
      _this.__invokeOnDispatch(payload);
    });
  }

  FluxStore.prototype.addListener = function addListener(callback) {
    return this.__emitter.addListener(this.__changeEvent, callback);
  };

  FluxStore.prototype.getDispatcher = function getDispatcher() {
    return this.__dispatcher;
  };

  /**
   * This exposes a unique string to identify each store's registered callback.
   * This is used with the dispatcher's waitFor method to declaratively depend
   * on other stores updating themselves first.
   */

  FluxStore.prototype.getDispatchToken = function getDispatchToken() {
    return this._dispatchToken;
  };

  /**
   * Returns whether the store has changed during the most recent dispatch.
   */

  FluxStore.prototype.hasChanged = function hasChanged() {
    !this.__dispatcher.isDispatching() ? invariant_1(false) : undefined;
    return this.__changed;
  };

  FluxStore.prototype.__emitChange = function __emitChange() {
    !this.__dispatcher.isDispatching() ? invariant_1(false) : undefined;
    this.__changed = true;
  };

  /**
   * This method encapsulates all logic for invoking __onDispatch. It should
   * be used for things like catching changes and emitting them after the
   * subclass has handled a payload.
   */

  FluxStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(payload) {
    this.__changed = false;
    this.__onDispatch(payload);
    if (this.__changed) {
      this.__emitter.emit(this.__changeEvent);
    }
  };

  /**
   * The callback that will be registered with the dispatcher during
   * instantiation. Subclasses must override this method. This callback is the
   * only way the store receives new data.
   */

  FluxStore.prototype.__onDispatch = function __onDispatch(payload) {
    invariant_1(false);
  };

  return FluxStore;
})();

var FluxStore_1 = FluxStore;

function abstractMethod(className, methodName) {
  invariant_1(false);
}

var abstractMethod_1 = abstractMethod;

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits$2(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * This is the basic building block of a Flux application. All of your stores
 * should extend this class.
 *
 *   class CounterStore extends FluxReduceStore<number> {
 *     getInitialState(): number {
 *       return 1;
 *     }
 *
 *     reduce(state: number, action: Object): number {
 *       switch(action.type) {
 *         case: 'add':
 *           return state + action.value;
 *         case: 'double':
 *           return state * 2;
 *         default:
 *           return state;
 *       }
 *     }
 *   }
 */

var FluxReduceStore = (function (_FluxStore) {
  _inherits$2(FluxReduceStore, _FluxStore);

  function FluxReduceStore(dispatcher) {
    _classCallCheck$8(this, FluxReduceStore);

    _FluxStore.call(this, dispatcher);
    this._state = this.getInitialState();
  }

  /**
   * Getter that exposes the entire state of this store. If your state is not
   * immutable you should override this and not expose _state directly.
   */

  FluxReduceStore.prototype.getState = function getState() {
    return this._state;
  };

  /**
   * Constructs the initial state for this store. This is called once during
   * construction of the store.
   */

  FluxReduceStore.prototype.getInitialState = function getInitialState() {
    return abstractMethod_1('FluxReduceStore', 'getInitialState');
  };

  /**
   * Used to reduce a stream of actions coming from the dispatcher into a
   * single state object.
   */

  FluxReduceStore.prototype.reduce = function reduce(state, action) {
    return abstractMethod_1('FluxReduceStore', 'reduce');
  };

  /**
   * Checks if two versions of state are the same. You do not need to override
   * this if your state is immutable.
   */

  FluxReduceStore.prototype.areEqual = function areEqual(one, two) {
    return one === two;
  };

  FluxReduceStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(action) {
    this.__changed = false;

    // Reduce the stream of incoming actions to state, update when necessary.
    var startingState = this._state;
    var endingState = this.reduce(startingState, action);

    // This means your ending state should never be undefined.
    !(endingState !== undefined) ? invariant_1(false) : undefined;

    if (!this.areEqual(startingState, endingState)) {
      this._state = endingState;

      // `__emitChange()` sets `this.__changed` to true and then the actual
      // change will be fired from the emitter at the end of the dispatch, this
      // is required in order to support methods like `hasChanged()`
      this.__emitChange();
    }

    if (this.__changed) {
      this.__emitter.emit(this.__changeEvent);
    }
  };

  return FluxReduceStore;
})(FluxStore_1);

var FluxReduceStore_1 = FluxReduceStore;

var ReduceStore = FluxReduceStore_1;

// @todo 2018-03-07 Refactor this into a dedicated JSON file (alike Laravel)
var english = {
  "Intro": "Intro",
  "StreetCulture": "Mood",
  "Items": "Items",
  "HowToSell": "Selling tips",
  "AdvertisingCampaign": "Ad campaign",
  "PopUpProject": "Additional contents",
  "Hashtag": "Hashtags",
  "Highlights": "Highlights",

  "MoodboardIntro": "Intro collection",
  "MoodboardDetails": "Moodboard details",
  "MoodboardRunway": "Runway / press lookbook",
  "MoodboardLookbook": "Lookbook",

  "ExerciseConfirmButton": 'Confirm button',

  "en_UK": "English",
  "ja_JP": "Japanese",
  "ko_KP": "Korean",
  "pt_PT": "Portuguese",
  "ru_RU": "Russian",
  "zh_CN": "Chinese",
  "ar_AE": "Arabic", // United Arab Emirates
  "th_TH": "Thai"
};

function translate(key) {
  return english[key] || key;
}

function __(text) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return translate(text).replace(/:(\w+)/gi, function (match, attribute) {
    return attributes[attribute];
  });
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This message is not always used by the browser, right now Chrome, for example,
// prompts a "Changes that you made may not be saved." message.
// Refer to this for a more in-depth explanation: https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
var beforeUnloadText = __('An action is still in progress. By leaving this page you can potentially lose progress.');

function onBeforeUnload(e) {
  e.returnValue = beforeUnloadText;
  return beforeUnloadText;
}

var LoadingOverlayStore = function (_ReduceStore) {
  _inherits$3(LoadingOverlayStore, _ReduceStore);

  function LoadingOverlayStore() {
    _classCallCheck$9(this, LoadingOverlayStore);

    return _possibleConstructorReturn(this, (LoadingOverlayStore.__proto__ || Object.getPrototypeOf(LoadingOverlayStore)).call(this, Dispatcher$2));
  }

  _createClass(LoadingOverlayStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        text: null,
        isVisible: false
      };
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case LoadingOverlayActionTypes.LOADING_OVERLAY_SHOW:
          window.addEventListener('beforeunload', onBeforeUnload);

          return { isVisible: true, text: action.text };

        case LoadingOverlayActionTypes.LOADING_OVERLAY_HIDE:
          window.removeEventListener('beforeunload', onBeforeUnload);

          return { isVisible: false, text: null };

        default:
          return state;
      }
    }
  }]);

  return LoadingOverlayStore;
}(ReduceStore);

var LoadingOverlayStore$1 = new LoadingOverlayStore();

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 999;\n  background-color: rgba(0,0,0,.8);\n  \n  display: ', ';\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 999;\n  background-color: rgba(0,0,0,.8);\n  \n  display: ', ';\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
    _templateObject3 = _taggedTemplateLiteral([' \n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  background-color: #fff;\n  margin: 2rem;\n'], [' \n  display: inline-block;\n  width: 50px;\n  height: 50px;\n  background-color: #fff;\n  margin: 2rem;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: #fff;\n  text-align: center;\n'], ['\n  color: #fff;\n  text-align: center;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$10(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingOverlay = function (_Component) {
  _inherits$4(LoadingOverlay, _Component);

  function LoadingOverlay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$10(this, LoadingOverlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = LoadingOverlay.__proto__ || Object.getPrototypeOf(LoadingOverlay)).call.apply(_ref, [this].concat(args))), _this), _this.subscriptions = [], _this.state = LoadingOverlayStore$1.getState(), _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$1(LoadingOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.subscriptions.push(LoadingOverlayStore$1.addListener(function () {
        _this2.setState(LoadingOverlayStore$1.getState());
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        Overlay,
        { visible: this.state.isVisible },
        React__default.createElement(
          OverlayInner,
          null,
          React__default.createElement(OverlaySpinner, null),
          this.state.text && React__default.createElement(
            OverlayText,
            null,
            this.state.text
          )
        )
      );
    }
  }]);

  return LoadingOverlay;
}(React.Component);

var Overlay = styled__default.div(_templateObject, function (props) {
  return props.visible ? 'flex' : 'none';
});

var OverlayInner = styled__default.div(_templateObject2);

var OverlaySpinner = styled__default.div(_templateObject3);

var OverlayText = styled__default.div(_templateObject4);

// https://github.com/github/fetch#handling-http-error-statuses
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

function objectToFormUrlEncoded(params) {
  return Object.keys(params).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');
}

var api = (function (clientId, path) {
  return "https://" + clientId + "-view.thron.com/api/" + path;
});

function getCriteriaForLocation(query, location) {
  switch (location.type) {
    default:
    case 'textSearch':
      return {
        'textSearch': {
          'searchKey': query,
          'searchOnFields': ['NAME', 'DESCRIPTION', 'ITAGS']
        }
      };

    case 'imetadataKeyOp':
      return {
        'imetadataKeyOp': {
          'imetadata': location.options.map(function (option) {
            return {
              'classificationId': option.classificationId,
              'key': option.key,
              'value': query
            };
          })
        }
      };
  }
}

var thronThumbnail = (function (clientId, contentId, pKey) {
  return "//" + clientId + "-cdn.thron.com/delivery/public/thumbnail/" + clientId + "/" + contentId + "/" + pKey + "/std/0x0/" + contentId;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var ITEM_PER_PAGE = 50;

var ThronManager = {
  loginApplication: function loginApplication(clientId, appId, appKey) {
    return fetch(api(clientId, 'xadmin/resources/apps/loginApp/' + clientId), {
      method: 'POST',
      body: objectToFormUrlEncoded({ appId: appId, appKey: appKey }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).then(checkStatus);
  },


  //Thron category detail (folder)
  getCategory: function getCategory(clientId, contentId, tokenId) {
    return fetch(api(clientId, 'xcontents/resources/category/getCategory?clientId=' + clientId + '&categoryId=' + contentId + '&cascade=false'), {
      method: "GET",
      headers: {
        "X-TOKENID": tokenId,
        "Content-Type": "application/json"
      }
    }).then(checkStatus);
  },


  //Thron categories (folders)
  getFolderChildren: function getFolderChildren(clientId, folder) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ITEM_PER_PAGE;

    return fetch(api(clientId, 'xcontents/resources/category/findByProperties2'), {
      method: "POST",
      headers: {
        "X-TOKENID": folder.tokenId,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "client": {
          "clientId": clientId
        },
        "properties": {
          "childOf": folder.id,
          "excludeLevelHigherThan": folder.level + 2
        },
        "categoryFieldOption": {
          "returnAclInfo": false,
          "returnNumberOfContents": false,
          "returnNumberOfSubCategories": false,
          "returnNumberOfUnreadContents": false,
          "returnNumberOfUnreadContentsInSubCategories": false,
          "returnTotalResults": false
        },
        "locale": "IT",
        "orderBy": "categoryName_A",
        "offset": offset,
        "numberOfResult": limit
      })
    }).then(checkStatus).then(function (response) {
      return response.json();
    });
  },


  //Thron contents (assets)
  getFolderContents: function getFolderContents(clientId, folder) {
    var pageToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ITEM_PER_PAGE;

    return fetch(api(clientId, 'xcontents/resources/content/search/' + clientId), {
      method: "POST",
      headers: {
        "X-TOKENID": folder.tokenId,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "pageToken": pageToken,
        "criteria": {
          "linkedCategories": {
            "haveAtLeastOne": [{
              "id": folder.id,
              "cascade": false
            }]
          }
        },
        "responseOptions": {
          "resultsPageSize": limit,
          "sort": [{
            "lastUpdate": {
              "order": "desc"
            }
          }],
          "returnDetailsFields": ["locales"],
          "thumbsOptions": {
            "divArea": "200x200",
            "id": "200x200"
          }
        },
        "clientId": clientId
      })
    }).then(checkStatus).then(function (response) {
      return response.json();
    });
  },


  //Thron content (single asset)
  getSingleContent: function getSingleContent(clientId, tokenId, contentId) {
    return fetch(api(clientId, 'xcontents/resources/content/findByProperties'), {
      method: "POST",
      headers: {
        "X-TOKENID": tokenId,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "client": {
          "clientId": clientId
        },
        "criteria": {
          "contentIds": [contentId]
        },
        "offset": 0,
        "numberOfresults": 1
      })
    }).then(checkStatus).then(function (response) {
      return response.json();
    });
  },


  //Thron contents (assets)
  searchInFolders: function searchInFolders(clientId, query, location, rootFolder, folders) {
    var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ITEM_PER_PAGE;

    var criteria = getCriteriaForLocation(query, location);

    return fetch(api(clientId, 'xcontents/resources/content/findByProperties'), {
      method: "POST",
      headers: {
        "X-TOKENID": rootFolder.tokenId,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "client": {
          "clientId": clientId
        },
        "criteria": _extends$1({
          "linkedCategoryOp": {
            "linkedCategoryIds": folders,
            "cascade": true
          }
        }, criteria, {
          "locale": "IT,EN"
        }),
        "orderBy": "lastUpdate_D",
        "offset": offset,
        "numberOfresults": limit
      })
    }).then(checkStatus).then(function (response) {
      return response.json();
    });
  }
};

function createFolderByCategory(thronCategory, tokenId, pKey) {
  return {
    id: thronCategory['category']['id'],
    name: thronCategory['category']['locales'][0]['name'],
    level: thronCategory['category']['ancestorIds'].length,
    tokenId: tokenId,
    pKey: pKey
  };
}

function createAssetByContent(thronContent, tokenId, pKey, clientId) {
  var thumbUrl = thronThumbnail(clientId, thronContent['content']['id'], pKey);

  return {
    id: thronContent['content']['id'],
    type: thronContent['content']['contentType'],
    name: thronContent['content']['locales'][0]['name'],
    thumbUrl: thumbUrl.replace('/0x0/', '/200x200/'),
    thumbUrlOriginal: thumbUrl,
    tokenId: tokenId,
    pKey: pKey
  };
}

function createSearchItemByContent(item, tokenId, pKey, clientId) {
  var thumbUrl = thronThumbnail(clientId, item.id, pKey);

  return {
    id: item.id,
    type: item.contentType,
    name: item.details.locales[0].name,
    thumbUrl: thumbUrl.replace('/0x0/', '/200x200/'),
    thumbUrlOriginal: thumbUrl,
    tokenId: tokenId,
    pKey: pKey
  };
}

var Folder = function (_Component) {
    inherits(Folder, _Component);

    function Folder() {
        classCallCheck(this, Folder);
        return possibleConstructorReturn(this, (Folder.__proto__ || Object.getPrototypeOf(Folder)).apply(this, arguments));
    }

    createClass(Folder, [{
        key: "render",
        value: function render() {
            return React__default.createElement(
                "div",
                { className: "thron-folder-container" },
                React__default.createElement(
                    "div",
                    { className: "thron-folder", onClick: this.props.onFolderSelect, title: this.props.folder.name },
                    React__default.createElement(
                        "svg",
                        { className: "thron-folder-icon", xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 256 256" },
                        React__default.createElement("path", { d: "m4.5 34.74c-2.4852 0.000248-4.4998 2.0148-4.5 4.5v177.53c0.00024848 2.4852 2.0148 4.4998 4.5 4.5l247-0.002c2.4852-0.00025 4.4998-2.0148 4.5-4.5v-160.27c-0.00025-2.4852-2.0148-4.4998-4.5-4.5h-150.23l-9.8164-15.197c-0.82878-1.2831-2.2518-2.0582-3.7793-2.0586h-83.172z", fillRule: "evenodd" })
                    ),
                    React__default.createElement(
                        "div",
                        { className: "thron-folder-name-container" },
                        React__default.createElement(
                            "span",
                            { className: "thron-folder-name" },
                            this.props.folder.name
                        )
                    )
                )
            );
        }
    }]);
    return Folder;
}(React.Component);

var Asset = function (_Component) {
    inherits(Asset, _Component);

    function Asset() {
        var _ref;

        var _temp, _this, _ret;

        classCallCheck(this, Asset);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Asset.__proto__ || Object.getPrototypeOf(Asset)).call.apply(_ref, [this].concat(args))), _this), _this.onAssetSelect = function () {
            _this.props.onAssetSelect(_this.props.asset);
        }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Asset, [{
        key: 'render',


        // title={this.props.asset.metadatas.map(metadata => `${metadata.name}: ${metadata.value}`).join(', ')}

        value: function render() {
            return React__default.createElement(
                'div',
                { className: 'thron-thumb ' + (this.props.selected ? 'selected' : ''), onClick: this.onAssetSelect },
                React__default.createElement('div', { className: 'thron-thumb-img', style: { backgroundImage: 'url("' + this.props.asset.thumbUrl + '")' }, title: this.props.asset.name }),
                React__default.createElement(
                    'div',
                    { className: 'thron-asset-name' },
                    this.props.asset.name
                )
            );
        }
    }]);
    return Asset;
}(React.Component);

var Breadcrumb = function (_Component) {
    inherits(Breadcrumb, _Component);

    function Breadcrumb() {
        classCallCheck(this, Breadcrumb);
        return possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).apply(this, arguments));
    }

    createClass(Breadcrumb, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return React__default.createElement(
                "div",
                { className: "breadcrumbs" },
                React__default.createElement(
                    "span",
                    { className: "breadcrumb", onClick: this.props.onHomeSelect },
                    "Home"
                ),
                this.props.breadcrumbs.length > 0 ? React__default.createElement(
                    "span",
                    null,
                    "/"
                ) : null,
                this.props.breadcrumbs.map(function (folder, index) {
                    return [_this2.props.breadcrumbs.length - 1 === index ? React__default.createElement(
                        "span",
                        { key: folder.id },
                        folder.name
                    ) : React__default.createElement(
                        "span",
                        { className: "breadcrumb", key: folder.id, onClick: function onClick() {
                                return _this2.props.onFolderSelect(folder);
                            } },
                        folder.name
                    ), _this2.props.breadcrumbs.length - 1 > index ? React__default.createElement(
                        "span",
                        { key: folder.id + '-separator' },
                        "/"
                    ) : null];
                })
            );
        }
    }]);
    return Breadcrumb;
}(React.Component);

function LoadMore(props) {
    return React__default.createElement(
        'div',
        { style: { marginTop: '16px', textAlign: 'center' } },
        React__default.createElement(
            'span',
            { style: { color: '#8f8f8f', fontWeight: 'bold', fontSize: '0.8rem' } },
            props.numVisible,
            '/',
            props.numTotal
        ),
        React__default.createElement('br', null),
        React__default.createElement(
            'button',
            { className: 'btn-more', onClick: props.handleLoadMore },
            'More results'
        )
    );
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".thron-browser{\n    font-size: 16px;\n    position: relative;\n}\n\n.thron-browser * {\n    box-sizing: border-box;\n}\n\n.thron-browser h4 {\n    color:#8f8f8f;\n    font-size: 1rem;\n    margin-bottom: .25rem;\n}\n\n.thron-browser .spinner{\n    position:fixed;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n    opacity:0.5;\n    background-color: #808080;\n    z-index: 999;\n}\n\n.thron-browser .flex-container{\n   display:flex;\n   flex-wrap:wrap;\n}\n\n.thron-browser .thron-folder-container{\n    width: 20%;\n}\n\n.thron-browser .thron-folder{\n    padding: 10px 0px 6px 8px;\n    margin: 10px 10px 10px 0px;\n    border: 1px solid #dfdfdf;\n    border-radius: 3px;\n    box-shadow: 2px 2px 1px -1px rgba(0,0,0,0.1);\n    cursor: pointer;\n}\n\n.thron-browser .thron-folder:hover{\n    background-color: #4285f4;\n    color: #fff;\n}\n\n.thron-browser .thron-folder-name-container{\n    display: inline-block;\n    line-height: 18px;\n    width: calc(100% - 38px);\n}\n\n.thron-browser .thron-folder-name{\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 0.75rem;\n    width: 100%;\n}\n\n.thron-browser .thron-folder-icon{\n    padding: 0px 6px 0px 6px;\n    width: 32px;\n    display: inline-block;\n}\n\n.thron-browser .thron-folder-icon path {fill : #8f8f8f;}\n.thron-browser .thron-folder:hover path{fill: #fff;}\n\n.thron-browser .icon-remove{\n    position: absolute;\n    top: -5px;\n    right:5px;\n    width:20px;\n    height: 20px;\n    font-family: monospace;\n    line-height: 21px;\n    font-size: 16px;\n    background-color:#4285f4;\n    color:#fff;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.thron-browser .thron-thumb-container {\n    margin-right: -7px;\n    margin-left: -7px;\n}\n\n.thron-browser .thron-thumb{\n    width: 210px;\n    margin: 7px;\n    text-align: center;\n    cursor: pointer;\n    background-color: #f3f3f3;\n}\n\n.thron-browser .thron-thumb-small{\n    width: 100px;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.thron-browser .thron-thumb.selected {\n    background-color: #4285f4;\n    color:white;\n    font-weight: bold;\n}\n\n.thron-browser .thron-thumb .thron-asset-name {\n    text-align:center;\n    overflow:hidden;\n    text-overflow: ellipsis;\n    font-size: 11px;\n    white-space: nowrap;\n    padding: 5px 10px 10px;\n}\n\n.thron-browser .thron-thumb .thron-thumb-img{\n    width: 200px;\n    height: 200px;\n    margin: 5px auto;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: contain;\n    background-color: #f3f3f3;\n\n}\n\n.thron-browser .thron-thumb-small .thron-thumb-img-small{\n    width: 80px;\n    height: 80px;\n}\n\n.thron-browser .breadcrumbs {\n    padding: 10px;\n    font-size: 0.8rem;\n    border-bottom: 1px solid #dedede;\n    background-color: #f3f0f0;\n}\n\n.thron-browser .selection-panel{\n    padding-top: 10px;\n    padding-left: 10px;\n    padding-bottom: 10px;\n    border-top: 1px solid #dedede;\n    background-color: #d6d2d2;\n}\n\n.thron-browser .breadcrumbs span {\n    padding: 5px 5px 5px 5px;\n    color:inherit;\n    cursor: default;\n    background-color: transparent;\n}\n\n\n.thron-browser .breadcrumbs span.breadcrumb{\n    color:#4285ff;\n    cursor: pointer;\n    display: initial;\n}\n.thron-browser .breadcrumbs span.breadcrumb:hover{\n    text-decoration: underline;\n}\n\n.thron-browser .breadcrumbs span:first-child {\n    padding: 5px 5px 5px 0px;\n}\n\n.thron-browser button.btn-more,\n.thron-browser button.btn-secondary{\n    color: #4285ff;\n    background-color: transparent;\n    text-transform: none;\n    outline: none;\n}\n\n\n.thron-browser button.btn-more:hover{\n    text-decoration: underline;\n}\n\n.thron-browser button{\n    font-size: 14px;\n    padding:8px 12px;\n    background-color:#4285f4;\n    margin:10px 10px 0px 0px;\n    border:none;\n    border-radius:2px;\n    color:white;\n    cursor:pointer;\n    outline: none;\n}\n\n.thron-browser .search {\n    display: flex;\n    justify-content: space-between;\n    padding: .5rem;\n    background-color: #f3f0f0;\n    border-bottom: 1px solid #dedede;\n}\n\n.thron-browser .search .search-hint {\n    width: 100%;\n    padding: .25rem;\n    font-size: .875rem;\n    text-align: right;\n    color: #888;\n    font-style: italic;\n}\n\n.thron-browser .search .search__input {\n    padding: .25rem .5rem;\n    margin-right: .5rem;\n}\n\n.thron-browser .search__locationSelect {\n    margin-right: .5rem;\n}\n\n.thron-browser .search button {\n    margin: 0;\n    padding: .325rem .5rem;\n}\n\n.selected-items-list{\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.selected-items-list-element{\n    display: inline-block;\n}\n";
styleInject(css);

var SEARCH_LOCATION_DEFAULT = {
  type: 'textSearch',
  text: 'Name'
};

function TotalSelected(props) {
  if (props.num === 0) return null;

  return React__default.createElement(
    React__default.Fragment,
    null,
    '(',
    props.max !== -1 ? props.num + "/" + props.max : props.num,
    ')'
  );
}

/**
 *
 * @param {Array} searchLocations
 * @param searchLocationSelect
 * @returns {Object}
 */
function getSelectedSearchLocation(searchLocations, searchLocationSelect) {
  if (searchLocationSelect === null) {
    return searchLocations[0];
  }

  return searchLocations.find(function (location) {
    return location.type === searchLocationSelect.value;
  });
}

var emptySearchResult = {
  contents: [],
  nextPage: null,
  totalContents: 0
};

var ThronBrowser = function (_Component) {
  inherits(ThronBrowser, _Component);

  /**
   * See /examples/src/App.js for an example initialization.
   *
   * clientId The Thron client id
   * rootFolders An array of root folders
   * maxSelection The maximum number of selectable assets, -1 for no limit
   * selectedAssets The selected assets
   * onAssetsSelection Handler called when the user finishes to select the
   *   assets, should also close the browser.
   * searchLocations An array of location where to search, default is textSearch,
   *  other possible values are:
   *  - { type: 'imetadataKeyOp', text: string, options: [{ classificationId: string, key: string }, ...] },
   *
   * @param {{
   *  clientId: string,
   *  rootFolders: {name: string, id: string, appId: string, appKey: string, pKey: string}[],
   *  maxSelection: number,
   *  selectedAssets: {id: string, pKey: string}[],
   *  onAssetsSelection: function(assets),
   *  searchLocations: {type: string, name: string, options: *}[]
   * }} props
   */
  function ThronBrowser(props) {
    classCallCheck(this, ThronBrowser);

    var _this = possibleConstructorReturn(this, (ThronBrowser.__proto__ || Object.getPrototypeOf(ThronBrowser)).call(this, props));

    _this.searchLocationSelect = null;
    _this.searchInput = null;

    _this.onSearchSubmit = function (query, location, rootFolder, currentFolder) {
      var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

      _this.setState({ mode: 'search' });

      ThronManager.searchInFolders(_this.props.clientId, query, location, rootFolder, currentFolder.id, offset).then(function (data) {
        var contents = data.contents.map(function (content) {
          return createAssetByContent(content, _this.state.pKeyTokenPair[rootFolder.pKey], rootFolder.pKey, _this.props.clientId);
        });

        _this.setState(function (state) {
          return {
            loading: false,
            searchResult: {
              contents: state.searchResult.contents.concat(contents),
              nextPage: state.searchResult.contents.length + data.contents.length < data.totalResults ? function () {
                _this.setState({ loading: true });
                _this.onSearchSubmit(query, location, rootFolder, currentFolder, state.searchResult.contents.length + data.contents.length);
              } : null,
              totalContents: data.totalResults
            }
          };
        });
      });
    };

    _this.state = {
      mode: 'browse',
      searchResult: emptySearchResult,

      pKeyTokenPair: {},
      breadcrumbs: [],
      contents: [],
      folders: [],
      totalFolders: null,
      totalContents: null,
      nextPageToken: null,
      selectedContents: [],
      loading: true
    };
    _this.onFolderSelect = _this.onFolderSelect.bind(_this);
    _this.onAssetSelect = _this.onAssetSelect.bind(_this);
    _this.showHomeFolders = _this.showHomeFolders.bind(_this);
    _this.loadMoreFolders = _this.loadMoreFolders.bind(_this);
    _this.loadMoreContents = _this.loadMoreContents.bind(_this);
    _this.onCancel = _this.onCancel.bind(_this);
    _this.onAssetRemove = _this.onAssetRemove.bind(_this);
    _this.showSelectedAssets = _this.showSelectedAssets.bind(_this);
    return _this;
  }

  createClass(ThronBrowser, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var promises = this.props.rootFolders.map(function (folder) {
        // noinspection JSUnresolvedVariable
        return ThronManager.loginApplication(_this2.props.clientId, folder.appId, folder.appKey).then(function (response) {
          return response.json();
        }).then(function (response) {
          return { tokenId: response.appUserTokenId, pKey: folder.pKey };
        });
      });

      Promise.all(promises).then(function (resolved) {
        var pKeyTokenPair = resolved.reduce(function (nextPKeyTokenPair, resolvedPromise) {
          nextPKeyTokenPair[resolvedPromise.pKey] = resolvedPromise.tokenId;
          return nextPKeyTokenPair;
        }, {});

        _this2.setState({ pKeyTokenPair: pKeyTokenPair }, function () {
          _this2.showHomeFolders();
          _this2.showSelectedAssets();
        });
      });
    }
  }, {
    key: 'showSelectedAssets',
    value: function showSelectedAssets() {
      var _this3 = this;

      var promises = this.props.selectedAssets.map(function (selectedAsset) {
        return ThronManager.getSingleContent(_this3.props.clientId, _this3.state.pKeyTokenPair[selectedAsset.pKey], selectedAsset.id).then(function (response) {
          return createAssetByContent(response.contents[0], _this3.state.pKeyTokenPair[selectedAsset.pKey], selectedAsset.pKey, _this3.props.clientId);
        });
      });

      Promise.all(promises).then(function (assets) {
        _this3.setState({ selectedContents: assets });
      });
    }
  }, {
    key: 'showHomeFolders',
    value: function showHomeFolders() {
      var _this4 = this;

      this.setState({ loading: true });

      var promises = this.props.rootFolders.map(function (item) {
        return ThronManager.getCategory(_this4.props.clientId, item.id, _this4.state.pKeyTokenPair[item.pKey]).then(function (response) {
          return response.json();
        }).then(function (data) {
          return createFolderByCategory(data, _this4.state.pKeyTokenPair[item.pKey], item.pKey);
        }).catch(function (error) {
          return undefined;
        });
      });

      Promise.all(promises).then(function (resolved) {
        _this4.setState({
          folders: resolved.filter(function (data) {
            return data !== undefined;
          }),
          loading: false,
          contents: [],
          totalFolders: null,
          totalContents: null,
          breadcrumbs: []
        });
      });
    }
  }, {
    key: 'loadMoreFolders',
    value: function loadMoreFolders(folder) {
      var _this5 = this;

      this.setState({ loading: true });
      ThronManager.getFolderChildren(this.props.clientId, folder, this.state.folders.length).then(function (data) {
        var moreFolders = data.categories.map(function (category) {
          return createFolderByCategory(category, _this5.state.pKeyTokenPair[folder.pKey], folder.pKey);
        });

        _this5.setState({
          folders: _this5.state.folders.concat(moreFolders),
          loading: false,
          totalFolders: data.totalResults
        });
      });
    }
  }, {
    key: 'loadMoreContents',
    value: function loadMoreContents(folder) {
      var _this6 = this;

      this.setState({ loading: true });
      ThronManager.getFolderContents(this.props.clientId, folder, this.state.nextPageToken).then(function (data) {
        var moreContents = data.items.map(function (item) {
          return createSearchItemByContent(item, _this6.state.pKeyTokenPair[folder.pKey], folder.pKey, _this6.props.clientId);
        });

        _this6.setState({
          contents: _this6.state.contents.concat(moreContents),
          loading: false,
          totalContents: data.estimatedTotalResults,
          nextPageToken: data.nextPageToken || null
        });
      });
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      this.setState({ selectedContents: [] });
    }
  }, {
    key: 'onAssetRemove',
    value: function onAssetRemove(asset) {
      this.setState(function (state) {
        return {
          selectedContents: state.selectedContents.filter(function (content) {
            return asset.id !== content.id;
          })
        };
      });
    }
  }, {
    key: 'onAssetSelect',
    value: function onAssetSelect(asset) {
      var maxSelection = this.props.maxSelection;
      var limitReached = maxSelection !== -1 && maxSelection === this.state.selectedContents.length;

      var selectedContents = [].concat(toConsumableArray(this.state.selectedContents));
      var index = selectedContents.findIndex(function (elem) {
        return elem.id === asset.id;
      });
      if (index === -1) {
        if (!limitReached) this.setState({
          selectedContents: [].concat(toConsumableArray(selectedContents), [asset])
        });
      } else {
        selectedContents.splice(index, 1);
        this.setState({ selectedContents: selectedContents });
      }
    }
  }, {
    key: 'assetExist',
    value: function assetExist(asset) {
      return this.state.selectedContents.filter(function (content) {
        return asset.id === content.id;
      }).length;
    }
  }, {
    key: 'onFolderSelect',
    value: function onFolderSelect(folder) {
      var _this7 = this;

      var promises = [];

      this.setState({ loading: true });
      promises.push(ThronManager.getFolderChildren(this.props.clientId, folder).then(function (data) {
        return {
          totalFolders: data['totalResults'],
          folders: data.categories.map(function (category) {
            return createFolderByCategory(category, _this7.state.pKeyTokenPair[folder.pKey], folder.pKey);
          })
        };
      }));

      promises.push(ThronManager.getFolderContents(this.props.clientId, folder).then(function (data) {
        return {
          totalContents: data.estimatedTotalResults,
          nextPageToken: data.nextPageToken || null,
          contents: data.items.map(function (item) {
            return createSearchItemByContent(item, _this7.state.pKeyTokenPair[folder.pKey], folder.pKey, _this7.props.clientId);
          })
        };
      }));

      Promise.all(promises).then(function (resolved) {
        //let [folders, contents] = resolved; ES6 Syntax
        var idx = _this7.state.breadcrumbs.indexOf(folder);
        var breadcrumbs = idx >= 0 ? _this7.state.breadcrumbs.slice(0, idx).concat([folder]) : _this7.state.breadcrumbs.concat([folder]);

        _this7.setState({
          folders: resolved[0].folders,
          contents: resolved[1].contents,
          loading: false,
          breadcrumbs: breadcrumbs,
          totalFolders: resolved[0].totalFolders,
          totalContents: resolved[1].totalContents,
          nextPageToken: resolved[1].nextPageToken,
          parentFolder: folder
        });
      });
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(e, index) {
      this.draggedItem = this.state.selectedContents[index];
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", e.target.parentNode);
      e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(index) {
      var _this8 = this;

      var draggedOverItem = this.state.selectedContents[index];
      if (this.draggedItem === draggedOverItem) {
        return;
      }
      var selectedContents = this.state.selectedContents.filter(function (item) {
        return item !== _this8.draggedItem;
      });
      selectedContents.splice(index, 0, this.draggedItem);
      this.setState({ selectedContents: selectedContents });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      return React__default.createElement(
        'div',
        { className: 'thron-browser' },
        this.state.loading && React__default.createElement('div', { className: 'spinner' }),
        React__default.createElement(
          'div',
          { className: 'search' },
          this.state.breadcrumbs.length > 0 ? React__default.createElement(
            React__default.Fragment,
            null,
            React__default.createElement(
              'div',
              null,
              this.state.mode === 'search' && React__default.createElement(
                'button',
                { type: 'button', className: 'btn-more', onClick: function onClick() {
                    _this9.setState({
                      mode: 'browse',
                      searchResult: emptySearchResult
                    });

                    _this9.searchInput.value = '';
                  } },
                'Go back to ',
                React__default.createElement(
                  'strong',
                  null,
                  this.state.breadcrumbs[this.state.breadcrumbs.length - 1].name
                )
              )
            ),
            React__default.createElement(
              'form',
              { onSubmit: function onSubmit(e) {
                  e.preventDefault();

                  if (_this9.searchInput.value.trim() === '') {
                    return;
                  }

                  var query = _this9.searchInput.value;
                  var location = getSelectedSearchLocation(_this9.props.searchLocations, _this9.searchLocationSelect);

                  var rootFolder = _this9.state.breadcrumbs[0];
                  var currentFolder = _this9.state.breadcrumbs[_this9.state.breadcrumbs.length - 1];

                  _this9.setState({
                    loading: true,
                    searchResult: emptySearchResult
                  }, function () {
                    return _this9.onSearchSubmit(query, location, rootFolder, currentFolder);
                  });
                } },
              this.props.searchLocations.length > 1 && React__default.createElement(
                React__default.Fragment,
                null,
                React__default.createElement(
                  'small',
                  null,
                  'Search by '
                ),
                React__default.createElement(
                  'select',
                  { className: 'search__locationSelect', ref: function ref(_ref) {
                      return _this9.searchLocationSelect = _ref;
                    } },
                  this.props.searchLocations.map(function (location) {
                    return React__default.createElement(
                      'option',
                      { key: location.type, value: location.type },
                      location.text
                    );
                  })
                )
              ),
              React__default.createElement('input', { type: 'text', ref: function ref(_ref2) {
                  return _this9.searchInput = _ref2;
                }, className: 'search__input' }),
              React__default.createElement(
                'button',
                { type: 'submit' },
                'Search'
              )
            )
          ) : React__default.createElement(
            'div',
            { className: 'search-hint' },
            'Select a folder to search'
          )
        ),
        this.state.mode === 'browse' && React__default.createElement(Breadcrumb, {
          onHomeSelect: this.showHomeFolders,
          onFolderSelect: function onFolderSelect(folder) {
            return _this9.onFolderSelect(folder);
          },
          breadcrumbs: this.state.breadcrumbs }),
        React__default.createElement(
          'div',
          { style: { paddingRight: '1rem', paddingLeft: '1rem' } },
          this.state.mode === 'search' && React__default.createElement(
            React__default.Fragment,
            null,
            React__default.createElement(
              'h4',
              null,
              'Files'
            ),
            React__default.createElement(
              'div',
              { className: 'flex-container thron-thumb-container' },
              this.state.searchResult.contents.map(function (asset) {
                return React__default.createElement(Asset, {
                  key: asset.id,
                  asset: asset,
                  selected: _this9.assetExist(asset),
                  onAssetSelect: _this9.onAssetSelect });
              })
            ),
            this.state.searchResult.nextPage !== null && React__default.createElement(LoadMore, {
              numVisible: this.state.searchResult.contents.length,
              numTotal: this.state.searchResult.totalContents,
              handleLoadMore: this.state.searchResult.nextPage })
          ),
          this.state.mode === 'browse' && React__default.createElement(
            React__default.Fragment,
            null,
            React__default.createElement(
              'h4',
              null,
              'Folders'
            ),
            this.state.folders.length === 0 && React__default.createElement(
              'p',
              { style: { color: '#888', fontSize: '.825rem' } },
              'No child folders.'
            ),
            React__default.createElement(
              'div',
              { className: 'flex-container' },
              this.state.folders.map(function (folder) {
                return React__default.createElement(Folder, { key: folder.id, folder: folder, onFolderSelect: function onFolderSelect() {
                    return _this9.onFolderSelect(folder);
                  } });
              })
            ),
            this.state.folders.length < this.state.totalFolders && React__default.createElement(LoadMore, { numVisible: this.state.folders.length, numTotal: this.state.totalFolders, handleLoadMore: function handleLoadMore() {
                return _this9.loadMoreFolders(_this9.state.parentFolder);
              } }),
            React__default.createElement(
              'h4',
              null,
              'Files'
            ),
            React__default.createElement(
              'div',
              { className: 'flex-container' },
              this.state.contents.map(function (asset) {
                return React__default.createElement(Asset, { key: asset.id, asset: asset, selected: _this9.assetExist(asset), onAssetSelect: _this9.onAssetSelect });
              })
            ),
            this.state.nextPageToken !== null && React__default.createElement(LoadMore, {
              numVisible: this.state.contents.length,
              numTotal: this.state.totalContents,
              handleLoadMore: function handleLoadMore() {
                return _this9.loadMoreContents(_this9.state.parentFolder);
              } })
          ),
          React__default.createElement(
            'div',
            { style: { marginTop: '30px', marginBottom: '30px' } },
            React__default.createElement(
              'button',
              { onClick: function onClick() {
                  return _this9.props.onAssetsSelection(_this9.state.selectedContents);
                } },
              'Confirm selection ',
              React__default.createElement(TotalSelected, { num: this.state.selectedContents.length, max: this.props.maxSelection })
            ),
            this.state.selectedContents.length > 0 && React__default.createElement(
              'button',
              { onClick: this.onCancel, className: 'btn-secondary' },
              'Clear selection (',
              this.state.selectedContents.length,
              ')'
            )
          )
        ),
        this.state.selectedContents.length > 0 && React__default.createElement(
          'div',
          { className: 'flex-container selection-panel' },
          React__default.createElement(
            'ul',
            { className: 'selected-items-list' },
            this.state.selectedContents.map(function (asset, index) {
              return React__default.createElement(
                'li',
                { key: asset.id, onDragOver: function onDragOver() {
                    return _this9.onDragOver(index);
                  }, className: 'selected-items-list-element' },
                React__default.createElement(
                  'div',
                  { key: asset.id + 'selection', className: 'thron-thumb thron-thumb-small',
                    draggable: true,
                    onDragStart: function onDragStart(e) {
                      return _this9.onDragStart(e, index);
                    }
                  },
                  React__default.createElement(
                    'div',
                    { className: 'icon-remove', onClick: function onClick() {
                        return _this9.onAssetRemove(asset);
                      } },
                    '\xD7'
                  ),
                  React__default.createElement('div', { className: 'thron-thumb-img thron-thumb-img-small', style: { backgroundImage: 'url("' + asset.thumbUrl + '")' }, title: asset.name })
                )
              );
            })
          )
        )
      );
    }
  }]);
  return ThronBrowser;
}(React.Component);

ThronBrowser.defaultProps = {
  clientId: null,
  rootFolders: [],
  maxSelection: -1,
  selectedAssets: [],
  onAssetsSelection: function onAssetsSelection() {
    return null;
  },
  searchLocations: [SEARCH_LOCATION_DEFAULT]
};

var ThronBrowserModalActionTypes = {
  THRON_BROWSER_MODAL_OPEN: 'THRON_BROWSER_MODAL_OPEN',
  THRON_BROWSER_MODAL_CLOSE: 'THRON_BROWSER_MODAL_CLOSE'
};

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$11(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThronBrowserModalStore = function (_ReduceStore) {
  _inherits$5(ThronBrowserModalStore, _ReduceStore);

  function ThronBrowserModalStore() {
    _classCallCheck$11(this, ThronBrowserModalStore);

    return _possibleConstructorReturn$2(this, (ThronBrowserModalStore.__proto__ || Object.getPrototypeOf(ThronBrowserModalStore)).call(this, Dispatcher$2));
  }

  _createClass$2(ThronBrowserModalStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isVisible: false,
        props: null
      };
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case ThronBrowserModalActionTypes.THRON_BROWSER_MODAL_OPEN:
          return { isVisible: true, props: action.props };

        case ThronBrowserModalActionTypes.THRON_BROWSER_MODAL_CLOSE:
          return this.getInitialState();

        default:
          return state;
      }
    }
  }]);

  return ThronBrowserModalStore;
}(ReduceStore);

var ThronBrowserModalStore$1 = new ThronBrowserModalStore();

function maybeInvoke(props, property) {
  return typeof property === 'function' ? property(props) : property;
}

function themeResponsiveProperty (mobileProperty, tabletProperty) {
  return function (props) {
    if (props.theme === undefined) {
      throw new Error("Property \"theme\" not found in given props. Either provide it or wrap the component in `withTheme()`.");
    }

    switch (true) {
      case props.theme.isMobile:
        return maybeInvoke(props, mobileProperty);
      case props.theme.isTablet:
        return maybeInvoke(props, tabletProperty);
      default:
        return null;
    }
  };
}

var _templateObject$1 = _taggedTemplateLiteral$1(['\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: ', ';\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,.6);\n'], ['\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: ', ';\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0,0,0,.6);\n']),
    _templateObject2$1 = _taggedTemplateLiteral$1(['\n  overflow-y: auto;\n  width: ', ';\n  margin: 1rem;\n  max-height: 90%;\n  padding: 0;\n  background-color: #FFF;\n  border-radius: 0.625rem;\n'], ['\n  overflow-y: auto;\n  width: ', ';\n  margin: 1rem;\n  max-height: 90%;\n  padding: 0;\n  background-color: #FFF;\n  border-radius: 0.625rem;\n']);

function _taggedTemplateLiteral$1(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function handleOverlayClick(event, onClickOutside) {
  if (event.target === event.currentTarget) {
    onClickOutside();
  }
}

/**
 *
 * @param visible
 * @param onClickOutside
 * @param children
 * @param props
 * @returns {*}
 */
var Modal = (function (_ref) {
  var visible = _ref.visible,
      onClickOutside = _ref.onClickOutside,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['visible', 'onClickOutside', 'children']);

  return React__default.createElement(
    Overlay$1,
    { visible: visible, onClick: function onClick(event) {
        return handleOverlayClick(event, onClickOutside);
      } },
    React__default.createElement(
      Inner,
      props,
      children
    )
  );
});

var Overlay$1 = styled__default.div(_templateObject$1, function (props) {
  return props.visible ? 'flex' : 'none';
});

var Inner = styled__default.div(_templateObject2$1, themeResponsiveProperty('90%', '90vw'));

var ThronBrowserModalActions = {
  open: function open(props) {
    Dispatcher$2.dispatch({
      actionType: ThronBrowserModalActionTypes.THRON_BROWSER_MODAL_OPEN,
      props: props
    });
  },
  close: function close() {
    Dispatcher$2.dispatch({
      actionType: ThronBrowserModalActionTypes.THRON_BROWSER_MODAL_CLOSE
    });
  }
};

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$12(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThronBrowserModal = function (_Component) {
  _inherits$6(ThronBrowserModal, _Component);

  function ThronBrowserModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$12(this, ThronBrowserModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref = ThronBrowserModal.__proto__ || Object.getPrototypeOf(ThronBrowserModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false,

      clientId: null,
      rootFolders: [],
      selectedAssets: [],
      onAssetsSelection: console.log,
      maxSelection: undefined
    }, _this.subscriptions = [], _temp), _possibleConstructorReturn$3(_this, _ret);
  }

  _createClass$3(ThronBrowserModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.subscriptions.push(ThronBrowserModalStore$1.addListener(function () {
        var _ThronBrowserModalSto = ThronBrowserModalStore$1.getState(),
            isVisible = _ThronBrowserModalSto.isVisible,
            props = _ThronBrowserModalSto.props;

        _this2.setState(_extends$2({}, props, { isVisible: isVisible }));
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {

      return React__default.createElement(
        Modal,
        { visible: this.state.isVisible, onClickOutside: ThronBrowserModalActions.close },
        this.state.isVisible && React__default.createElement(ThronBrowser, {
          clientId: this.state.clientId,
          searchLocations: [SEARCH_LOCATION_DEFAULT, { type: 'imetadataKeyOp', text: 'SAP-ID', options: [{ classificationId: 'imxqwt', key: 'sapid' }] }],
          rootFolders: this.state.rootFolders,
          selectedAssets: this.state.selectedAssets,
          onAssetsSelection: this.state.onAssetsSelection,
          maxSelection: this.state.maxSelection })
      );
    }
  }]);

  return ThronBrowserModal;
}(React.Component);

var TranslationModalActionTypes = {
  TRANSLATION_MODAL_OPEN: 'TRANSLATION_MODAL_OPEN',
  TRANSLATION_MODAL_CLOSE: 'TRANSLATION_MODAL_CLOSE'
};

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$13(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function noop() {}

var TranslationModalStore = function (_ReduceStore) {
  _inherits$7(TranslationModalStore, _ReduceStore);

  function TranslationModalStore() {
    _classCallCheck$13(this, TranslationModalStore);

    return _possibleConstructorReturn$4(this, (TranslationModalStore.__proto__ || Object.getPrototypeOf(TranslationModalStore)).call(this, Dispatcher$2));
  }

  _createClass$4(TranslationModalStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isVisible: false,
        plain: false,
        originalContent: null,
        foreignContent: null,
        onLanguageChange: noop,
        onContentUpdate: noop
      };
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case TranslationModalActionTypes.TRANSLATION_MODAL_OPEN:
          return {
            isVisible: true,
            plain: action.plain,
            originalContent: action.originalContent,
            foreignContent: action.foreignContent,
            onLanguageChange: action.onLanguageChange,
            onContentUpdate: action.onContentUpdate
          };

        case TranslationModalActionTypes.TRANSLATION_MODAL_CLOSE:
          return _extends$3({}, this.getInitialState());

        default:
          return state;
      }
    }
  }]);

  return TranslationModalStore;
}(ReduceStore);

var TranslationModalStore$1 = new TranslationModalStore();

var TranslationModalActions = {
  open: function open(_ref) {
    var plain = _ref.plain,
        originalContent = _ref.originalContent,
        foreignContent = _ref.foreignContent,
        onLanguageChange = _ref.onLanguageChange,
        onContentUpdate = _ref.onContentUpdate;

    Dispatcher$2.dispatch({
      actionType: TranslationModalActionTypes.TRANSLATION_MODAL_OPEN,
      plain: plain,
      originalContent: originalContent,
      foreignContent: foreignContent,
      onLanguageChange: onLanguageChange,
      onContentUpdate: onContentUpdate
    });
  },
  close: function close() {
    Dispatcher$2.dispatch({
      actionType: TranslationModalActionTypes.TRANSLATION_MODAL_CLOSE
    });
  }
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var immutable = createCommonjsModule(function (module, exports) {
/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
  module.exports = factory();
}(commonjsGlobal, function () {var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); };
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  };

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        };
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value);
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          (ii = reverse ? resolveSize(this) : 0, function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    };
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    };
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    };
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    };
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      };
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    };

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    };
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));
});

var OrderedMap = immutable.OrderedMap;


var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};

var BlockMapBuilder_1 = BlockMapBuilder;

function _classCallCheck$14(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Map$1 = immutable.Map,
    OrderedSet = immutable.OrderedSet,
    Record = immutable.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits$8(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck$14(this, CharacterMetadata);

    return _possibleConstructorReturn$5(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map$1(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map$1([[Map$1(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

var CharacterMetadata_1 = CharacterMetadata;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */

/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

var findRangesImmutable_1 = findRangesImmutable;

function _classCallCheck$15(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var List = immutable.List,
    Map$2 = immutable.Map,
    OrderedSet$1 = immutable.OrderedSet,
    Record$1 = immutable.Record,
    Repeat = immutable.Repeat;


var EMPTY_SET$1 = OrderedSet$1();

var defaultRecord$1 = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map$2()
};

var ContentBlockRecord = Record$1(defaultRecord$1);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata_1.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits$9(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck$15(this, ContentBlock);

    return _possibleConstructorReturn$6(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$1;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

var ContentBlock_1 = ContentBlock;

function _classCallCheck$16(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$10(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var List$1 = immutable.List,
    Map$3 = immutable.Map,
    OrderedSet$2 = immutable.OrderedSet,
    Record$2 = immutable.Record,
    Repeat$1 = immutable.Repeat;


var EMPTY_SET$2 = OrderedSet$2();

var defaultRecord$2 = {
  parent: null,
  characterList: List$1(),
  data: Map$3(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List$1(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle$1 = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity$1 = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList$1 = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List$1(Repeat$1(CharacterMetadata_1.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits$10(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord$2;

    _classCallCheck$16(this, ContentBlockNode);

    return _possibleConstructorReturn$7(this, _Record.call(this, decorateCharacterList$1(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET$2;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualStyle$1, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable_1(this.getCharacterList(), haveEqualEntity$1, filterFn, callback);
  };

  return ContentBlockNode;
}(Record$2(defaultRecord$2));

var ContentBlockNode_1 = ContentBlockNode;

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */

var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};

var DraftFeatureFlagsCore = DraftFeatureFlags;

var DraftFeatureFlags_1 = DraftFeatureFlagsCore;

var Map$4 = immutable.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },

  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map$4([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata_1.applyStyle(current, inlineStyle) : CharacterMetadata_1.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var ContentStateInlineStyle_1 = ContentStateInlineStyle;

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata_1.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set('characterList', characterList);
}

var applyEntityToContentBlock_1 = applyEntityToContentBlock;

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock_1(block, sliceStart, sliceEnd, entityKey);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var applyEntityToContentState_1 = applyEntityToContentState;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */

/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }
      return segment;
    });

    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;

      // Our selection overlaps this segment.
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};

var DraftEntitySegments_1 = DraftEntitySegments;

/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({ start: start, end: end });
  });

  !!!ranges.length ? invariant_1(false) : void 0;

  return ranges;
}

var getRangesForDraftEntity_1 = getRangesForDraftEntity;

/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;

  // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.
  if (mutability === 'MUTABLE') {
    return selectionState;
  }

  // Find the entity range that overlaps with our removal range.
  var entityRanges = getRangesForDraftEntity_1(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });

  !(entityRanges.length == 1) ? invariant_1(false) : void 0;

  var entityRange = entityRanges[0];

  // For `IMMUTABLE` entity types, we will remove the entire entity range.
  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }

  // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments_1.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);

  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

var getCharacterRemovalRange_1 = getCharacterRemovalRange;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */

var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

var generateRandomKey_1 = generateRandomKey;

var OrderedMap$1 = immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap$1(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey_1();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap$1(blockMap.toArray().map(function (block) {
    var key = generateRandomKey_1();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode_1;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

var randomizeBlockMapKeys_1 = randomizeBlockMapKeys;

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable_1(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ? invariant_1(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata_1.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

var removeEntitiesAtEdges_1 = removeEntitiesAtEdges;

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges_1(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys_1(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

var getContentStateFragment_1 = getContentStateFragment;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */

/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}

var insertIntoList_1 = insertIntoList;

var List$2 = immutable.List;


var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList_1(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });

  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */
var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();

  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};

/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */
var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();

  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];

  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    }

    // update the last root block fragment
    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);

    // update the original target next block
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    }

    // update fragment parent links
    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    });

    // update targetBlock parent child links
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();

      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;

      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();

      // insert fragment children
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));

      blockMapState.setIn([targetParentKey, 'children'], List$2(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode_1;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());

  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }

    // Insert fragment blocks after the head and before the tail.
    fragment
    // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });

    // update tail
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });

  var updatedBlockMap = BlockMapBuilder_1.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ? invariant_1(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys_1(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();

  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode_1) {
    !targetBlock.getChildKeys().isEmpty() ? invariant_1(false) : void 0;
  }

  // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

var insertFragmentIntoContentState_1 = insertFragmentIntoContentState;

var Repeat$2 = immutable.Repeat;


function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ? invariant_1(false) : void 0;

  var len = text.length;
  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();

  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList_1(block.getCharacterList(), Repeat$2(characterMetadata, len).toList(), offset)
  });

  var newOffset = offset + len;

  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

var insertTextIntoContentState_1 = insertTextIntoContentState;

var Map$5 = immutable.Map;


function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map$5([[endKey, blockMap.get(endKey)]])).map(operation);

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var modifyBlockForContentState_1 = modifyBlockForContentState;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode_1;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

var getNextDelimiterBlockKey_1 = getNextDelimiterBlockKey;

var List$3 = immutable.List,
    Map$6 = immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */
var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};

/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey_1(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);

    // we do not need to keep checking all root node siblings, just the first occurance
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey_1(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks$1 = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update endblock if its retained
    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update start block parent ancestors
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update start block next - can only happen if startBlock == endBlock
    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });

    // update start block prev
    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update end block next
    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update end block prev
    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });

    // update end block parent ancestors
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update next delimiters all the way to a root delimiter
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);

  // we assume that ContentBlockNode and ContentBlocks are not mixed together
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode_1;

  // used to retain blocks that should not be deleted to avoid orphan children
  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);

    // endBlock has unselected sibblings so we can not remove its ancestors parents
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }

    // endBlock has children so can not remove this block or any of its ancestors
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }

    // we need to retain all ancestors of the next delimiter block
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey_1(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });

  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map$6([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });

  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks$1(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};

/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};

var removeRangeFromContentState_1 = removeRangeFromContentState;

var List$4 = immutable.List,
    Map$7 = immutable.Map;


var transformBlock$1 = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks$2 = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();

    // update block parent
    transformBlock$1(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();

      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);

      return block.merge({
        children: List$4(newChildrenArray)
      });
    });

    // update original next block
    transformBlock$1(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });

    // update original block
    transformBlock$1(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });

    // update below block
    transformBlock$1(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ? invariant_1(false) : void 0;

  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey_1();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode_1;

  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map$7()
  });

  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ? invariant_1(false) : void 0;

    newBlocks = updateBlockMapLinks$2(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

var splitBlockInContentState_1 = splitBlockInContentState;

var OrderedSet$3 = immutable.OrderedSet;

/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState_1(withoutEntities, rangeToReplace);

    var character = CharacterMetadata_1.create({
      style: inlineStyle || OrderedSet$3(),
      entity: entityKey || null
    });

    return insertTextIntoContentState_1(withoutText, withoutText.getSelectionAfter(), text, character);
  },

  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ? invariant_1(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },

  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment_1(contentState, removalRange);

    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');

    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },

  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, targetRange);
    var withoutText = removeRangeFromContentState_1(withoutEntities, targetRange);

    return insertFragmentIntoContentState_1(withoutText, withoutText.getSelectionAfter(), fragment);
  },

  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();

    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);

    // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange_1(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState_1(contentState, _adjustedRemovalRange);
      }
    }
    var adjustedRemovalRange = rangeToRemove;
    if (DraftFeatureFlags_1.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange_1(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges_1(contentState, adjustedRemovalRange);
    return removeRangeFromContentState_1(withoutEntities, adjustedRemovalRange);
  },

  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, selectionState);
    var withoutText = removeRangeFromContentState_1(withoutEntities, selectionState);

    return splitBlockInContentState_1(withoutText, withoutText.getSelectionAfter());
  },

  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle_1.add(contentState, selectionState, inlineStyle);
  },

  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle_1.remove(contentState, selectionState, inlineStyle);
  },

  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState_1(contentState, selectionState, function (block) {
      return block.merge({ type: blockType, depth: 0 });
    });
  },

  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState_1(contentState, selectionState, function (block) {
      return block.merge({ data: blockData });
    });
  },

  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState_1(contentState, selectionState, function (block) {
      return block.merge({ data: block.getData().merge(blockData) });
    });
  },

  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges_1(contentState, selectionState);
    return applyEntityToContentState_1(withoutEntities, selectionState, entityKey);
  }
};

var DraftModifier_1 = DraftModifier;

var List$5 = immutable.List,
    Repeat$3 = immutable.Repeat,
    Record$3 = immutable.Record;


var returnTrue = emptyFunction_1.thatReturnsTrue;

var FINGERPRINT_DELIMITER = '-';

var defaultLeafRange = {
  start: null,
  end: null
};

var LeafRange = Record$3(defaultLeafRange);

var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};

var DecoratorRange = Record$3(defaultDecoratorRange);

var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List$5.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List$5.of(new LeafRange({ start: 0, end: 0 }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List$5(Repeat$3(null, textLength));

    var chars = block.getCharacterList();

    findRangesImmutable_1(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });

    return List$5(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};

/**
 * Generate LeafRange records for a given character list.
 */
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable_1(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List$5(leaves);
}

function areEqual(a, b) {
  return a === b;
}

var BlockTree_1 = BlockTree;

function _classCallCheck$17(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$11(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Record$4 = immutable.Record;


var DraftEntityInstanceRecord = Record$4({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});

/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits$11(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck$17(this, DraftEntityInstance);

    return _possibleConstructorReturn$8(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

var DraftEntityInstance_1 = DraftEntityInstance;

var _extends$4 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */






var Map$8 = immutable.Map;


var instances = Map$8();
var instanceKey = 0;

/**
 * Temporary utility for generating the warnings
 */
function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },

  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance_1({ type: type, mutability: mutability, data: data || {} }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ? invariant_1(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);
    var newData = _extends$4({}, instance.getData(), toMerge);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};

var DraftEntity_1 = DraftEntity;

function _classCallCheck$18(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$12(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Record$5 = immutable.Record;


var defaultRecord$3 = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};

var SelectionStateRecord = Record$5(defaultRecord$3);

var SelectionState = function (_SelectionStateRecord) {
  _inherits$12(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck$18(this, SelectionState);

    return _possibleConstructorReturn$9(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };

  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();

    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

var SelectionState_1 = SelectionState;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */

var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

var sanitizeDraftText_1 = sanitizeDraftText;

function _classCallCheck$19(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$10(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$13(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var List$6 = immutable.List,
    Record$6 = immutable.Record,
    Repeat$4 = immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags_1.draft_tree_data_support;

var defaultRecord$4 = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};

var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode_1 : ContentBlock_1;

var ContentStateRecord = Record$6(defaultRecord$4);

var ContentState = function (_ContentStateRecord) {
  _inherits$13(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck$19(this, ContentState);

    return _possibleConstructorReturn$10(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity_1;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity_1.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__create(type, mutability, data);
    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__mergeData(key, toMerge);
    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__replaceData(key, newData);
    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity_1.__add(instance);
    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity_1.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray(
  // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder_1.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState_1() : SelectionState_1.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity_1,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;

    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText_1(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey_1(),
        text: block,
        type: 'unstyled',
        characterList: List$6(Repeat$4(CharacterMetadata_1.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

var ContentState_1 = ContentState;

var NEUTRAL = 'NEUTRAL'; // No strong direction
var LTR = 'LTR'; // Left-to-Right direction
var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null;

// == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
function getHTMLDir(dir) {
  !isStrong(dir) ? invariant_1(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ? invariant_1(false) : void 0;
  !isStrong(otherDir) ? invariant_1(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}

// == Global Direction ==

/**
 * Set the global direction.
 */
function setGlobalDir(dir) {
  globalDir = dir;
}

/**
 * Initialize the global direction
 */
function initGlobalDir() {
  setGlobalDir(LTR);
}

/**
 * Get the global direction
 */
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ? invariant_1(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};

var UnicodeBidiDirection_1 = UnicodeBidiDirection;

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {

  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',

  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',

  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'

};

var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection_1.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection_1.RTL : UnicodeBidiDirection_1.LTR;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection_1.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection_1.NEUTRAL ? fallback : blockDir;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection_1.getGlobalDir();
  }
  !UnicodeBidiDirection_1.isStrong(strongFallback) ? invariant_1(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}

/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection_1.LTR;
}

/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection_1.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};

var UnicodeBidi_1 = UnicodeBidi;

function _classCallCheck$20(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var UnicodeBidiService = function () {

  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck$20(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection_1.getGlobalDir();
    } else {
      !UnicodeBidiDirection_1.isStrong(defaultDir) ? invariant_1(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }

  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };

  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi_1.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

var UnicodeBidiService_1 = UnicodeBidiService;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

var nullthrows_1 = nullthrows;

var OrderedMap$2 = immutable.OrderedMap;


var bidiService;

var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService_1();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows_1(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap$2(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};

var EditorBidiService_1 = EditorBidiService;

var _extends$5 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$21(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var OrderedSet$4 = immutable.OrderedSet,
    Record$7 = immutable.Record,
    Stack = immutable.Stack;


var defaultRecord$5 = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};

var EditorStateRecord = Record$7(defaultRecord$5);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState_1.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState_1.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends$5({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService_1.getDirectionMap(currentContent)
    });
    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });

    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };

  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
  };

  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };

  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };

  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }
    return updateSelection(editorState, selection, true);
  };

  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();

    return EditorState.acceptSelection(editorState, new SelectionState_1({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };

  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };

  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService_1.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride();

    // Don't discard inline style overrides for the following change types:
    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };

    return EditorState.set(editorState, editorStateChanges);
  };

  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService_1.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };

  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService_1.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };

  /**
   * Not for public consumption.
   */


  function EditorState(immutable$$1) {
    _classCallCheck$21(this, EditorState);

    this._immutable = immutable$$1;
  }

  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();

/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}

/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree_1.generate(contentState, block, decorator);
  }).toOrderedMap();
}

/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree_1.generate(contentState, block, decorator);
  }));
}

/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree_1.generate(content, block, decorator);
  }));
}

/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If there is a character just inside the selection, use its style.
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }

  // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet$4();
}

var EditorState_1 = EditorState;

var OrderedMap$3 = immutable.OrderedMap,
    List$7 = immutable.List;


var transformBlock$2 = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks$3 = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  // possible values of 'insertionMode' are: 'after', 'before'
  var isInsertedAfterTarget = insertionMode === 'after';

  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();

  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock$2(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    });

    // update old prev
    transformBlock$2(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });

    // update old next
    transformBlock$2(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });

    // update new next
    transformBlock$2(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });

    // update new prev
    transformBlock$2(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });

    // update new parent
    transformBlock$2(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);

      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;

      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);

      return block.merge({
        children: List$7(newChildrenArray)
      });
    });

    // update block
    transformBlock$2(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ? invariant_1(false) : void 0;

  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();

  !(blockKey !== targetKey) ? invariant_1(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode_1;

  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey_1(blockToBeMoved, blocks);

      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);

        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });

  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);

  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });

  var newBlocks = OrderedMap$3();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);

    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ? invariant_1(false) : void 0;

    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);

    !(!blockAfter || blockAfter.getKey() !== blockKey) ? invariant_1(false) : void 0;

    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks$3(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

var moveBlockInContentState_1 = moveBlockInContentState;

var _extends$6 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var experimentalTreeDataSupport$1 = DraftFeatureFlags_1.draft_tree_data_support;
var ContentBlockRecord$1 = experimentalTreeDataSupport$1 ? ContentBlockNode_1 : ContentBlock_1;

var List$8 = immutable.List,
    Repeat$5 = immutable.Repeat;


var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var afterRemoval = DraftModifier_1.removeRange(contentState, selectionState, 'backward');

    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier_1.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();

    var asAtomicBlock = DraftModifier_1.setBlockType(afterSplit, insertionTarget, 'atomic');

    var charData = CharacterMetadata_1.create({ entity: entityKey });

    var atomicBlockConfig = {
      key: generateRandomKey_1(),
      type: 'atomic',
      text: character,
      characterList: List$8(Repeat$5(charData, character.length))
    };

    var atomicDividerBlockConfig = {
      key: generateRandomKey_1(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport$1) {
      atomicBlockConfig = _extends$6({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends$6({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord$1(atomicBlockConfig), new ContentBlockRecord$1(atomicDividerBlockConfig)];

    var fragment = BlockMapBuilder_1.createFromArray(fragmentArray);

    var withAtomicBlock = DraftModifier_1.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);

    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState_1.push(editorState, newContent, 'insert-fragment');
  },

  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());

      withMovedAtomicBlock = moveBlockInContentState_1(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier_1.removeRange(contentState, targetRange, 'backward');

      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState_1(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState_1(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier_1.splitBlock(afterRemoval, selectionAfterRemoval);

        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState_1(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState_1.push(editorState, newContent, 'move-block');
  }
};

var AtomicBlockUtils_1 = AtomicBlockUtils;

function _classCallCheck$22(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var List$9 = immutable.List;


var DELIMITER = '.';

/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck$22(this, CompositeDraftDecorator);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback( /*number*/start, /*number*/end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });

    return List$9(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();

/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}

/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

var CompositeDraftDecorator_1 = CompositeDraftDecorator;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }
  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

var cx_1 = cx;

var Map$9 = immutable.Map;





var UL_WRAP = React__default.createElement('ul', { className: cx_1('public/DraftStyleDefault/ul') });
var OL_WRAP = React__default.createElement('ol', { className: cx_1('public/DraftStyleDefault/ol') });
var PRE_WRAP = React__default.createElement('pre', { className: cx_1('public/DraftStyleDefault/pre') });

var DefaultDraftBlockRenderMap = Map$9({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});

var DefaultDraftBlockRenderMap_1 = DefaultDraftBlockRenderMap;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */

var DefaultDraftInlineStyle = {
  BOLD: {
    fontWeight: 'bold'
  },

  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },

  ITALIC: {
    fontStyle: 'italic'
  },

  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },

  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var Keys = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */

/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);

  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);

  return filterKey(contentState.getEntityMap(), entityKey);
}

/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }
  return null;
}

var getEntityKeyForSelection_1 = getEntityKeyForSelection;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */

/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

var isEventHandled_1 = isEventHandled;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */

function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();

  var isAtStart = false;

  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return isAtStart;
}

var isSelectionAtLeafStart_1 = isSelectionAtLeafStart;

/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */
var RESOLVE_DELAY = 20;

/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */
var resolved = false;
var stillComposing = false;
var textInputData = '';

var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';

    var editorState = EditorState_1.set(editor._latestEditorState, {
      inCompositionMode: false
    });

    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection());

    var mustReset = !composedChars || isSelectionAtLeafStart_1(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      if (DraftFeatureFlags_1.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled_1(editor.props.handleBeforeInput(composedChars, editorState))) {
        return;
      }
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier_1.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState_1.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState_1.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};

var DraftEditorCompositionHandler_1 = DraftEditorCompositionHandler;

var uaParser = createCommonjsModule(function (module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.37',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 500;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK    = 'Facebook',
        CHROMIUM_OS = 'Chromium OS',
        MAC_OS  = 'Mac OS';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    if (!regex[j]) { break; }
                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
            ], [VERSION, [NAME, 'Baidu']], [
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 ' + BROWSER]], [
            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [                    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
            ], [VERSION, [NAME, 'Sogou Explorer']], [
            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
            ], [[NAME, 'Sogou Mobile'], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i                        // QQBrowser/2345 Browser
            ], [NAME, VERSION], [
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
            ], [VERSION, [NAME, 'TikTok']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,                                             // Links
            /panasonic;(viera)/i                                                // Panasonic Viera
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
                
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(kobo)\s(ereader|touch)/i,                                         // Kobo
            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2| pro)?)/i                                                // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [
            /(aeobc)\b/i                                                        // Echo Dot
            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
            /\b(libweb)/i
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /windows nt 6\.2; (arm)/i,                                        // Windows RT
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
            ], [VERSION, [NAME, 'watchOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
            ], [[NAME, CHROMIUM_OS], VERSION],[

            // Smart TVs
            /panasonic;(viera)/i,                                               // Panasonic Viera
            /(netrange)mmh/i,                                                   // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
                _browser[NAME] = 'Brave';
            }
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
                _device[TYPE] = MOBILE;
            }
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
                _os[NAME] = _uach.platform  
                                    .replace(/chrome os/i, CHROMIUM_OS)
                                    .replace(/macos/i, MAC_OS);           // backward compatibility
            }
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if ('object' !== UNDEF_TYPE) {
        // nodejs env
        if ('object' !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof(undefined) === FUNC_TYPE && undefined.amd) {
            undefined(function () {
                return UAParser;
            });
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : commonjsGlobal);
});
var uaParser_1 = uaParser.UAParser;

var UNKNOWN = 'Unknown';

var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};

/**
 * Convert from UAParser platform name to what we expect.
 */
function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}

/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }
  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}

/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */
var parser = new uaParser();
var results = parser.getResult();

// Do some conversion first.
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};

var UserAgentData = uaData;

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;

/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}

/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);

  !(expressions.length > 0 && expressions.length <= 2) ? invariant_1(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];

    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ? invariant_1(false) : void 0;

    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}

/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkSimpleExpression(range, version) {
  range = range.trim();
  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);
    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);
    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}

/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}

/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}

/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}

/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}

/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}

/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}

/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ? invariant_1(false) : void 0;

  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}

/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}

/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}

/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}

/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();

  zeroPad(a, b.length);

  // mark "x" and "*" components as equal
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = '0';

      // final "*" greedily zeros all remaining components
      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);

  return [a, b];
}

/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}

/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compare(a, b) {
  !(typeof a === typeof b) ? invariant_1(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};

var VersionRange_1 = VersionRange;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty$2.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

var mapObject_1 = mapObject;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

var memoizeStringOnly_1 = memoizeStringOnly;

/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
function compare$1(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  }

  // check for non-matching names
  if (!query.startsWith(name)) {
    return false;
  }

  // full comparison with version
  var range = query.slice(name.length);
  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange_1.contains(range, version);
  }

  return false;
}

/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}

/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */
var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare$1(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },


  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare$1(UserAgentData.browserArchitecture, null, query);
  },


  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare$1(UserAgentData.deviceName, null, query);
  },


  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare$1(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },


  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare$1(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },


  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare$1(UserAgentData.platformArchitecture, null, query);
  }
};

var UserAgent_1 = mapObject_1(UserAgent, memoizeStringOnly_1);

function _classCallCheck$23(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$11(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$14(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.
var useNewlineChar = UserAgent_1.isBrowser('IE <= 11');

/**
 * Check whether the node should be considered a newline.
 */
function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}

/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */
var NEWLINE_A = useNewlineChar ? React__default.createElement(
  'span',
  { key: 'A', 'data-text': 'true' },
  '\n'
) : React__default.createElement('br', { key: 'A', 'data-text': 'true' });

var NEWLINE_B = useNewlineChar ? React__default.createElement(
  'span',
  { key: 'B', 'data-text': 'true' },
  '\n'
) : React__default.createElement('br', { key: 'B', 'data-text': 'true' });

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = function (_React$Component) {
  _inherits$14(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck$23(this, DraftEditorTextNode);

    // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.
    var _this = _possibleConstructorReturn$11(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = _reactDom__default.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ? invariant_1(false) : void 0;
    if (shouldBeNewline) {
      return !isNewline(node);
    }
    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }
    return React__default.createElement(
      'span',
      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
      this.props.children
    );
  };

  return DraftEditorTextNode;
}(React__default.Component);

var DraftEditorTextNode_react = DraftEditorTextNode;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */

var DraftJsDebugLogging = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var isNode_1 = isNode;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode_1(object) && object.nodeType == 3;
}

var isTextNode_1 = isTextNode;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode_1(outerNode)) {
    return false;
  } else if (isTextNode_1(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

var containsNode_1 = containsNode;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

var getActiveElement_1 = getActiveElement;

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ? invariant_1(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;
  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode_1(document.documentElement, node)) {
    return;
  }

  var selection = commonjsGlobal.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();

  // IE doesn't support backward selection. Swap key/offset pairs.
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;

  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;

  // If the selection is entirely bound within this node, set the selection
  // and be done.
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }

    // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }

    // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;

      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}

/**
 * Extend selection towards focus point.
 */
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement_1();
  if (selection.extend && containsNode_1(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.

    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({ offset: offset }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    // logging to catch bug that is being reported in t18110632
    var nodeWasFocus = node === selection.focusNode;
    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];
          if (n === activeElement) {
            labels.push('active element');
          }
          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }
          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      // allow the error to be thrown -
      // better than continuing in a broken state
      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange();
  // logging to catch bug that is being reported in t16250795
  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({ offset: offset }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }
  range.setStart(node, offset);
  selection.addRange(range);
}

var setDraftEditorSelection_1 = setDraftEditorSelection;

function _classCallCheck$24(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$12(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$15(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = function (_React$Component) {
  _inherits$15(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck$24(this, DraftEditorLeaf);

    return _possibleConstructorReturn$12(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection;

    // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;

    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }

    // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.
    var node = _reactDom__default.findDOMNode(this);
    !node ? invariant_1(false) : void 0;
    var child = node.firstChild;
    !child ? invariant_1(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ? invariant_1(false) : void 0;
    }

    setDraftEditorSelection_1(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */

  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = _reactDom__default.findDOMNode(this.leaf);
    !leafNode ? invariant_1(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text;

    // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;

    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return objectAssign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = objectAssign(styleObj, newStyles);
    }

    return React__default.createElement(
      'span',
      {
        'data-offset-key': offsetKey,
        ref: function ref(_ref) {
          return _this2.leaf = _ref;
        },
        style: styleObj },
      React__default.createElement(
        DraftEditorTextNode_react,
        null,
        text
      )
    );
  };

  return DraftEditorLeaf;
}(React__default.Component);

var DraftEditorLeaf_react = DraftEditorLeaf;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */

var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

var DraftOffsetKey_1 = DraftOffsetKey;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}

/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */

var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ?
    // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};

var Scroll_1 = Scroll;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

var camelize_1 = camelize;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */




function asString(value) /*?string*/{
  return value == null ? value : String(value);
}

function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
  var computedStyle = void 0;

  // W3C Standard
  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate_1(name)));
    }
  }
  // Safari
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    // A Safari bug causes this to return null for `display: none` elements.
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate_1(name)));
    }
    if (name === 'display') {
      return 'none';
    }
  }
  // Internet Explorer
  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize_1(name)]);
  }
  return asString(node.style && node.style[camelize_1(name)]);
}

var getStyleProperty_1 = getStyleProperty;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}

/**
 * Utilities for querying and mutating style properties.
 */
var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty_1,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }

};

var Style_1 = Style;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement;

  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.
  if (!('getBoundingClientRect' in elem) || !containsNode_1(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode
  var rect = elem.getBoundingClientRect();

  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

var getElementRect_1 = getElementRect;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
function getElementPosition(element) {
  var rect = getElementRect_1(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

var getElementPosition_1 = getElementPosition;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;

/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getDocumentScrollElement(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

var getDocumentScrollElement_1 = getDocumentScrollElement;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

var getUnboundedScrollPosition_1 = getUnboundedScrollPosition;

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement_1(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition_1(scrollable);

  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;

  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;

  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));

  return scrollPosition;
}

var getScrollPosition_1 = getScrollPosition;

function getViewportWidth() {
  var width = void 0;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
} /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks
   */

function getViewportHeight() {
  var height = void 0;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}

/**
 * Gets the viewport dimensions including any scrollbars.
 */
function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}

/**
 * Gets the viewport dimensions excluding any scrollbars.
 */
getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

var getViewportDimensions_1 = getViewportDimensions;

var _extends$7 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$25(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$13(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$16(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};

/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */

var DraftEditorBlock = function (_React$Component) {
  _inherits$16(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck$25(this, DraftEditorBlock);

    return _possibleConstructorReturn$13(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };

  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = _reactDom__default.findDOMNode(this);
    var scrollParent = Style_1.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition_1(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition_1(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions_1().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ? invariant_1(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll_1.setTop(scrollParent, Scroll_1.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);

    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey_1.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React__default.createElement(DraftEditorLeaf_react, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      var decoratorKey = leafSet.get('decoratorKey');
      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows_1(_this2.props.decorator);

      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey_1.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));

      // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
      var dir = UnicodeBidiDirection_1.getHTMLDirIfDifferent(UnicodeBidi_1.getDirection(decoratedText), _this2.props.direction);

      return React__default.createElement(
        DecoratorComponent,
        _extends$7({}, decoratorProps, {
          contentState: _this2.props.contentState,
          decoratedText: decoratedText,
          dir: dir,
          key: decoratorOffsetKey,
          entityKey: block.getEntityAt(leafSet.get('start')),
          offsetKey: decoratorOffsetKey }),
        leaves
      );
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;

    var className = cx_1({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });

    return React__default.createElement(
      'div',
      { 'data-offset-key': offsetKey, className: className },
      this._renderChildren()
    );
  };

  return DraftEditorBlock;
}(React__default.Component);

var DraftEditorBlock_react = DraftEditorBlock;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */

/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass = void 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

var joinClasses_1 = joinClasses;

var _extends$8 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$26(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$14(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$17(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx_1({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */

var DraftEditorContents = function (_React$Component) {
  _inherits$17(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck$26(this, DraftEditorContents);

    return _possibleConstructorReturn$14(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;

    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap();

    // Text direction has changed for one or more blocks. We must re-render.
    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();

    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode();

    // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.
    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;


    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows_1(editorState.getDirectionMap());

    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];

    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];
      var key = _block.getKey();
      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;
      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey_1.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };

      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;

      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();
      var className = '';
      if (blockStyleFn) {
        className = blockStyleFn(_block);
      }

      // List items are special snowflakes, since we handle nesting and
      // counters manually.
      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses_1(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock_react;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };
      if (customEditable !== undefined) {
        childProps = _extends$8({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React__default.createElement(Element, childProps, React__default.createElement(Component, componentProps));

      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }
      lastWrapperTemplate = wrapperTemplate;
    }

    // Group contiguous runs of blocks that have the same wrapperTemplate
    var outputBlocks = [];
    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];
      if (info.wrapperTemplate) {
        var blocks = [];
        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
        var wrapperElement = React__default.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React__default.createElement(
      'div',
      { 'data-contents': 'true' },
      outputBlocks
    );
  };

  return DraftEditorContents;
}(React__default.Component);

var DraftEditorContentsCore_react = DraftEditorContents;

var DraftEditorContents_react = DraftEditorContentsCore_react;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && (
    // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

var PhotosMimeType_1 = PhotosMimeType;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? invariant_1(false) : void 0;

  !(typeof length === 'number') ? invariant_1(false) : void 0;

  !(length === 0 || length - 1 in obj) ? invariant_1(false) : void 0;

  !(typeof obj.callee !== 'function') ? invariant_1(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

var createArrayFromMixed_1 = createArrayFromMixed;

function _classCallCheck$27(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */






var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';

var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};

/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck$27(this, DataTransfer);

    this.data = data;

    // Types could be DOMStringList or array
    this.types = data.types ? createArrayFromMixed_1(data.types) : [];
  }

  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    }

    // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.
    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };

  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };

  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };

  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };

  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }
      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };

  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;
      if (!PhotosMimeType_1.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };

  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction_1.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };

  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

var DataTransfer_1 = DataTransfer;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */

/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}

var getSelectionOffsetKeyForNode_1 = getSelectionOffsetKeyForNode;

/**
 * Get the key from the node's nearest offset-aware ancestor.
 */
function findAncestorOffsetKey(node) {
  var searchNode = node;
  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode_1(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}

var findAncestorOffsetKey_1 = findAncestorOffsetKey;

var TEXT_CLIPPING_REGEX = /\.textClipping$/;

var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
};

// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
var TEXT_SIZE_UPPER_BOUND = 5000;

/**
 * Extract the text content from a file list.
 */
function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function ( /*blob*/file) {
    readFile(file, function ( /*string*/text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}

/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
function readFile(file, callback) {
  if (!commonjsGlobal.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = '';
    // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }
    callback(contents);
    return;
  }

  var reader = new FileReader();
  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ? invariant_1(false) : void 0;
    callback(result);
  };
  reader.onerror = function () {
    callback('');
  };
  reader.readAsText(file);
}

var getTextContentFromFiles_1 = getTextContentFromFiles;

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows_1(editorState.getSelection());

  var anchorPath = DraftOffsetKey_1.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);

  var focusPath = DraftOffsetKey_1.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');

  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;

  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

var getUpdatedSelectionState_1 = getUpdatedSelectionState;

/**
 * Get a SelectionState for the supplied mouse event.
 */
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows_1(node);
  offset = nullthrows_1(offset);
  var offsetKey = nullthrows_1(findAncestorOffsetKey_1(node));

  return getUpdatedSelectionState_1(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer_1(e.nativeEvent.dataTransfer);

    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);

    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();
    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled_1(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles_1(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';
    if (editor.props.handleDrop && isEventHandled_1(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier_1.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState_1.push(editorState, newContentState, 'insert-fragment');
}

/**
 * Insert text at a specified selection.
 */
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier_1.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState_1.push(editorState, newContentState, 'insert-fragment');
}

var DraftEditorDragHandler_1 = DraftEditorDragHandler;

(function (global, undefined) {

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof commonjsGlobal === "undefined" ? commonjsGlobal : commonjsGlobal : self));

// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.


var setImmediate$1 = commonjsGlobal.setImmediate;

// When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent_1.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}

/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier_1.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState_1.push(editorState, contentState, 'insert-characters');
}

/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;

  var chars = e.data;

  // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.
  if (!chars) {
    return;
  }

  // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.
  if (editor.props.handleBeforeInput && isEventHandled_1(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  }

  // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();

    // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.
    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
    if (chars === currentlySelectedChars) {
      editor.update(EditorState_1.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())));
    }
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection()));

  // Bunch of different cases follow where we need to prevent native insertion.
  var mustPreventNative = false;
  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart_1(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = commonjsGlobal.getSelection();
    // Selection is necessarily collapsed at this point due to earlier check.
    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }
  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree_1.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree_1.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows_1(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows_1(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  }

  // We made it all the way! Let the browser do its thing and insert the char.
  newEditorState = EditorState_1.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate$1(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

var editOnBeforeInput_1 = editOnBeforeInput;

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement_1() === document.body) {
    var _selection = commonjsGlobal.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode_1(editorNode, _selection.anchorNode) && containsNode_1(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState_1.acceptSelection(editorState, selection));
}

var editOnBlur_1 = editOnBlur;

/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState_1.set(editor._latestEditorState, { inCompositionMode: true }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

var editOnCompositionStart_1 = editOnCompositionStart;

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment_1(editorState.getCurrentContent(), selectionState);
}

var getFragmentFromSelection_1 = getFragmentFromSelection;

/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();

  // No selection, so there's nothing to copy.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection_1(editor._latestEditorState));
}

var editOnCopy_1 = editOnCopy;

/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0;

  // No selection, so there's nothing to cut.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.
  if (element instanceof Node) {
    scrollPosition = getScrollPosition_1(Style_1.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection_1(editorState);
  editor.setClipboard(fragment);

  // Set `cut` mode to disable all event handling temporarily.
  editor.setMode('cut');

  // Let native `cut` behavior occur, then recover control.
  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier_1.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState_1.push(editorState, newContent, 'remove-range');
}

var editOnCut_1 = editOnCut;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */

/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

var editOnDragOver_1 = editOnDragOver;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */

/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

var editOnDragStart_1 = editOnDragStart;

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e);

  // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.
  if (UserAgent_1.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState_1.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState_1.acceptSelection(editorState, selection));
  }
}

var editOnFocus_1 = editOnFocus;

var isGecko = UserAgent_1.isEngine('Gecko');

var DOUBLE_NEWLINE = '\n\n';

/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = commonjsGlobal.getSelection();

  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;

  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

  if (DraftFeatureFlags_1.draft_killswitch_allow_nontextnodes) {
    if (isNotTextNode) {
      return;
    }
  } else {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows_1(findAncestorOffsetKey_1(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey_1.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);

  // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }

  // No change -- the DOM is up to date. Nothing to do here.
  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection();

  // We'll replace the entire leaf with the text content of the target.
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });

  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE';

  // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.
  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';

  var newContent = DraftModifier_1.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);

  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();

    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }

  // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
  });

  editor.update(EditorState_1.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

var editOnInput_1 = editOnInput;

var isOSX = UserAgent_1.isPlatform('Mac OS X');

var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },

  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },

  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};

var KeyBindingUtil_1 = KeyBindingUtil;

var clipboard = null;

/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */
var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows_1(targetRange);
    clipboard = getContentStateFragment_1(content, targetRange);

    var afterRemoval = DraftModifier_1.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState_1.push(editorState, afterRemoval, 'remove-range');
  },

  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier_1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);

    return EditorState_1.push(editorState, newContent, 'insert-fragment');
  }
};

var SecondaryClipboard_1 = SecondaryClipboard;

// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.
var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;

/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}

/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ? invariant_1(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}

/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}

/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}

/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}

/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0;

  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }

  // Obvious cases
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return '';
  }

  // Find the actual starting position
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }

  // Find the actual ending position
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}

/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}

/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};

var UnicodeUtils_1 = UnicodeUtils;

var isChrome = UserAgent_1.isBrowser('Chrome');

// In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437
/* eslint-disable consistent-return */
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }

  invariant_1(false);
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */
var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};

var getRangeClientRects_1 = getRangeClientRects;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */






/**
 * Return the computed line height, in pixels, for the provided element.
 */
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';

  var documentBody = document.body;
  !documentBody ? invariant_1(false) : void 0;

  // forced layout here
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);

  return rect.height;
}

/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}

/**
 * Return the length of a node, as used by Range offsets.
 */
function getNodeLength$1(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}

/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
function expandRangeToStartOfLine(range) {
  !range.collapsed ? invariant_1(false) : void 0;
  range = range.cloneRange();

  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);

  // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects_1(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ? invariant_1(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  }

  // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.

  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils_1.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects_1(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength$1(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

var expandRangeToStartOfLine_1 = expandRangeToStartOfLine;

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;

  // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState_1(editorState, nullthrows_1(findAncestorOffsetKey_1(anchorNode)), anchorOffset, nullthrows_1(findAncestorOffsetKey_1(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;

  // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows_1(findAncestorOffsetKey_1(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows_1(findAncestorOffsetKey_1(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);

    // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState_1(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}

/**
 * Identify the first leaf descendant for the given node.
 */
function getFirstLeaf(node) {
  while (node.firstChild && (
  // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode_1(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Identify the last leaf descendant for the given node.
 */
function getLastLeaf(node) {
  while (node.lastChild && (
  // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode_1(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey_1(node);

  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ? invariant_1(false) : void 0;

  // If the editorRoot is the selection, step downward into the content
  // wrapper.
  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ? invariant_1(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }

  // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows_1(getSelectionOffsetKeyForNode_1(firstLeaf));
    }
    return { key: key, offset: 0 };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode_1(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows_1(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows_1(getSelectionOffsetKeyForNode_1(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}

/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

var getDraftEditorSelectionWithNodes_1 = getDraftEditorSelectionWithNodes;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */

/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();

  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

var moveSelectionBackward_1 = moveSelectionBackward;

/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier_1.removeRange(content, target, direction);
}

var removeTextWithStrategy_1 = removeTextWithStrategy;

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward_1(strategyState, 1);
    }

    var domSelection = commonjsGlobal.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine_1(range);

    return getDraftEditorSelectionWithNodes_1(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState_1.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandBackspaceToStartOfLine_1 = keyCommandBackspaceToStartOfLine;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */

// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';

var TokenizeUtil = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

var punctuation = TokenizeUtil.getPunctuation();

// The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.
var CHAMELEON_CHARS = '[\'\u2018\u2019]';

// Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.
var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;

var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);

var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },

  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};

var DraftRemovableWord_1 = DraftRemovableWord;

/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    // If there are no words before the cursor, remove the preceding newline.
    if (offset === 0) {
      return moveSelectionBackward_1(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord_1.getBackward(text);
    return moveSelectionBackward_1(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState_1.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandBackspaceWord_1 = keyCommandBackspaceWord;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */

/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();

  var focusKey = key;
  var focusOffset;

  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
}

var moveSelectionForward_1 = moveSelectionForward;

/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord_1.getForward(text);

    // If there are no words in front of the cursor, remove the newline.
    return moveSelectionForward_1(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState_1.push(editorState, afterRemoval, 'remove-range');
}

var keyCommandDeleteWord_1 = keyCommandDeleteWord;

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier_1.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState_1.push(editorState, contentState, 'split-block');
}

var keyCommandInsertNewline_1 = keyCommandInsertNewline;

/**
 * See comment for `moveSelectionToStartOfBlock`.
 */
function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState_1.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

var keyCommandMoveSelectionToEndOfBlock_1 = keyCommandMoveSelectionToEndOfBlock;

/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState_1.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

var keyCommandMoveSelectionToStartOfBlock_1 = keyCommandMoveSelectionToStartOfBlock;

/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward_1(strategyState, charBehind ? UnicodeUtils_1.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState_1.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

var keyCommandPlainBackspace_1 = keyCommandPlainBackspace;

/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy_1(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward_1(strategyState, charAhead ? UnicodeUtils_1.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();

  return EditorState_1.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

var keyCommandPlainDelete_1 = keyCommandPlainDelete;

/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();

  // Nothing to transpose if there aren't two characters.
  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  }

  // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.
  var movedFragment = getContentStateFragment_1(content, removalRange);
  var afterRemoval = DraftModifier_1.removeRange(content, removalRange, 'backward');

  // After the removal, the insertion target is one character back.
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });

  var afterInsert = DraftModifier_1.replaceWithFragment(afterRemoval, targetRange, movedFragment);

  var newEditorState = EditorState_1.push(editorState, afterInsert, 'insert-fragment');

  return EditorState_1.acceptSelection(newEditorState, finalSelection);
}

var keyCommandTransposeCharacters_1 = keyCommandTransposeCharacters;

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState_1.undo(editorState);

  // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.
  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState_1.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
    return;
  }

  // Otheriwse, manage the undo behavior manually.
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }

  // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.
  updateFn(EditorState_1.set(editorState, { nativelyRenderedContent: null }));

  // Wait to ensure that the re-render has occurred before performing
  // the undo action.
  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

var keyCommandUndo_1 = keyCommandUndo;

var isOptionKeyCommand = KeyBindingUtil_1.isOptionKeyCommand;

var isChrome$1 = UserAgent_1.isBrowser('Chrome');

/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState_1.redo(editorState);
    case 'delete':
      return keyCommandPlainDelete_1(editorState);
    case 'delete-word':
      return keyCommandDeleteWord_1(editorState);
    case 'backspace':
      return keyCommandPlainBackspace_1(editorState);
    case 'backspace-word':
      return keyCommandBackspaceWord_1(editorState);
    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine_1(editorState);
    case 'split-block':
      return keyCommandInsertNewline_1(editorState);
    case 'transpose-characters':
      return keyCommandTransposeCharacters_1(editorState);
    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock_1(editorState);
    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock_1(editorState);
    case 'secondary-cut':
      return SecondaryClipboard_1.cut(editorState);
    case 'secondary-paste':
      return SecondaryClipboard_1.paste(editorState);
    default:
      return editorState;
  }
}

/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault();
      // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.
      if (editor.props.handleReturn && isEventHandled_1(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;
    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;
    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;
    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;
    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;
    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;
    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome$1 && isOptionKeyCommand(e)) {
        e.preventDefault();
        // Insert a nbsp into the editor.
        var contentState = DraftModifier_1.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState_1.push(editorState, contentState, 'insert-characters'));
        return;
      }
  }

  var command = editor.props.keyBindingFn(e);

  // If no command is specified, allow keydown event to continue.
  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo_1(e, editorState, editor.update);
    return;
  }

  // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.
  e.preventDefault();

  // Allow components higher up the tree to handle the command first.
  if (editor.props.handleKeyCommand && isEventHandled_1(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);
  if (newState !== editorState) {
    editor.update(newState);
  }
}

var editOnKeyDown_1 = editOnKeyDown;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function _classCallCheck$28(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URI = function () {
  function URI(uri) {
    _classCallCheck$28(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

var URI_1 = URI;

var isOldIE = UserAgent_1.isBrowser('IE <= 9');

// Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null;
  // Provides a safe context
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ? invariant_1(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }
  return root;
}

var getSafeBodyFromHTML_1 = getSafeBodyFromHTML;

var _extends$9 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _knownListItemDepthCl;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var _require = immutable,
    Set = _require.Set;









var experimentalTreeDataSupport$2 = DraftFeatureFlags_1.draft_tree_data_support;

var List$10 = immutable.List,
    OrderedSet$5 = immutable.OrderedSet;


var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g');

// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx_1('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);

var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];

var imgAttr = ['alt', 'className', 'height', 'src', 'width'];

var lastBlock = void 0;

var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};

var EMPTY_BLOCK = {
  children: List$10(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }
  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set([]);

  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });

  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
};

// custom element conversions
var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);
    if (matchType) {
      return matchType;
    }
  }
  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort();

  // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type
  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';
    case 1:
      return matchedTypes[0];
    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }
      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }
  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks
  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};

/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ? invariant_1(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return _extends$9({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet$5()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends$9({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet$5()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends$9({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    text: '\r',
    inlines: [OrderedSet$5()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey_1(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};

/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */
var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
  var chunk = _extends$9({}, EMPTY_CHUNK);
  var newChunk = null;
  var blockKey = void 0;

  // Base Case
  if (nodeName === '#text') {
    var _text = node.textContent;
    var nodeTextContent = _text.trim();

    // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items
    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();
      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return { chunk: _extends$9({}, EMPTY_CHUNK), entityMap: entityMap };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
    }
    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    }

    // save the last block so we can use it later
    lastBlock = nodeName;

    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  }

  // save the last block so we can use it later
  lastBlock = nodeName;

  // BR tags
  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }
    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
  }

  // IMG tags
  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};

    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.
    node.textContent = '\uD83D\uDCF7';

    // TODO: update this when we remove DraftEntity entirely
    inEntity = DraftEntity_1.__create('IMAGE', 'MUTABLE', entityConfig || {});
  }

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport$2 && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport$2) && blockTags.indexOf(nodeName) !== -1;

  // Block Tags
  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport$2;
  }

  // this is required so that we can handle 'ul' and 'ol'
  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  }

  // Recurse through children
  var child = node.firstChild;
  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};

        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);
          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });

        entityConfig.url = new URI_1(anchor.href).toString();
        // TODO: update this when we remove DraftEntity completely
        entityId = DraftEntity_1.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport$2 ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;

    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport$2);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');

  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  lastBlock = null;

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.
  var fragment = genFragment(entityMap, safeBody, OrderedSet$5(), 'ul', null, workingBlocks, -1, blockRenderMap);

  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap;

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends$9({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };

  var start = 0;

  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;


  var BlockNodeRecord = experimentalTreeDataSupport$2 ? ContentBlockNode_1 : ContentBlock_1;

  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText_1(textBlock);

    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List$10(inlines.map(function (style, index) {
      var data = { style: style, entity: null };
      if (entities[index]) {
        data.entity = entities[index];
      }
      return CharacterMetadata_1.create(data);
    }));
    start = end + 1;

    var depth = block.depth,
        type = block.type,
        parent = block.parent;


    var key = block.key || generateRandomKey_1();
    var parentTextNodeKey = null; // will be used to store container text nodes

    // childrens add themselves to their parents since we are iterating in order
    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex];

      // if parent has text we need to split it into a separate unstyled element
      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey_1();

        var textNode = new ContentBlockNode_1({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });

        acc.contentBlocks.push(textNode);

        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List$10()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    });

    // insert node
    acc.contentBlocks.push(blockNode);

    // cache ref for building links
    acc.cacheRef[blockNode.key] = index;

    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML_1;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap_1;

  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  // TODO: replace DraftEntity with an OrderedMap here
  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity_1);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;

  var contentBlocks = convertChunkToContentBlocks(chunk);

  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

var convertFromHTMLToContentBlocks = convertFromHTMLtoContentBlocks;

var _extends$10 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var List$11 = immutable.List,
    Repeat$6 = immutable.Repeat;


var experimentalTreeDataSupport$3 = DraftFeatureFlags_1.draft_tree_data_support;
var ContentBlockRecord$2 = experimentalTreeDataSupport$3 ? ContentBlockNode_1 : ContentBlock_1;

var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML_1, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText_1(textLine);
      var key = generateRandomKey_1();

      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List$11(Repeat$6(character, textLine.length))
      };

      // next block updates previous block
      if (experimentalTreeDataSupport$3 && index !== 0) {
        var prevSiblingIndex = index - 1;
        // update previous block
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _extends$10({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord$2(blockNodeConfig));

      return acc;
    }, []);
  }
};

var DraftPasteProcessor_1 = DraftPasteProcessor;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */

function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });

  blockMap = blockMap.merge(blocks);

  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

var adjustBlockDepthForContentState_1 = adjustBlockDepthForContentState;

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },

  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },

  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return { url: uri.toString() };
  },

  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);
      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },

  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier_1.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);

    var newEditorState = EditorState_1.push(editorState, contentState, 'insert-characters');

    return EditorState_1.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }

    // First, try to remove a preceding atomic block.
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState_1.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    }

    // If that doesn't succeed, try to remove the current block style.
    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState_1.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },

  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();

    // The cursor is somewhere within the text. Behave normally.
    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });

    var withoutAtomicBlock = DraftModifier_1.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState_1.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },

  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();
    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();

    // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.
    var blockAbove = content.getBlockBefore(key);
    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();
    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);

    var withAdjustment = adjustBlockDepthForContentState_1(content, selection, event.shiftKey ? -1 : 1, maxDepth);

    return EditorState_1.push(editorState, withAdjustment, 'adjust-depth');
  },

  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;

    // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows_1(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;

    return EditorState_1.push(editorState, DraftModifier_1.setBlockType(content, target, typeToSet), 'change-block-type');
  },

  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();

    // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.
    if (selection.isCollapsed()) {
      return EditorState_1.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }

    // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.
    var content = editorState.getCurrentContent();
    var newContent;

    // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier_1.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier_1.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState_1.push(editorState, newContent, 'change-inline-style');
  },

  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier_1.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);

    return EditorState_1.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);

      var firstBlock = content.getFirstBlock();
      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier_1.setBlockType(content, selection, 'unstyled');
      }
    }
    return null;
  }
};

var RichTextEditorUtil_1 = RichTextEditorUtil;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */

var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

var splitTextIntoTextBlocks_1 = splitTextIntoTextBlocks;

/**
 * Paste content.
 */
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer_1(e.clipboardData);

  // Get files, unless this is likely to be a string the user wants inline.
  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();
    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled_1(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles_1(files, function ( /*string*/fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks_1(fileText);
        var character = CharacterMetadata_1.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil_1.getCurrentBlockType(editorState);

        var text = DraftPasteProcessor_1.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder_1.createFromArray(text);

        var withInsertedText = DraftModifier_1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);

        editor.update(EditorState_1.push(editorState, withInsertedText, 'insert-fragment'));
      });

      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled_1(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks_1(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();
    if (data.isRichText() && internalClipboard) {
      if (
      // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 ||
      // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment$1(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment$1(editor._latestEditorState, internalClipboard));
      return;
    }

    // If there is html paste data, try to parse that.
    if (html) {
      var htmlFragment = DraftPasteProcessor_1.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder_1.createFromArray(contentBlocks);
          editor.update(insertFragment$1(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }

    // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.
    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata_1.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection_1(editorState.getCurrentContent(), editorState.getSelection())
    });

    var currentBlockType = RichTextEditorUtil_1.getCurrentBlockType(editorState);

    var textFragment = DraftPasteProcessor_1.processText(textBlocks, character, currentBlockType);

    var textMap = BlockMapBuilder_1.createFromArray(textFragment);
    editor.update(insertFragment$1(editor._latestEditorState, textMap));
  }
}

function insertFragment$1(editorState, fragment, entityMap) {
  var newContent = DraftModifier_1.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState_1.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

var editOnPaste_1 = editOnPaste;

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelection(editorState, root) {
  var selection = commonjsGlobal.getSelection();

  // No active selection.
  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes_1(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

var getDraftEditorSelection_1 = getDraftEditorSelection;

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = _reactDom__default.findDOMNode(editor.editorContainer);
  !editorNode ? invariant_1(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ? invariant_1(false) : void 0;
  var documentSelection = getDraftEditorSelection_1(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState_1.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState_1.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}

var editOnSelect_1 = editOnSelect;

var DraftEditorEditHandler = {
  onBeforeInput: editOnBeforeInput_1,
  onBlur: editOnBlur_1,
  onCompositionStart: editOnCompositionStart_1,
  onCopy: editOnCopy_1,
  onCut: editOnCut_1,
  onDragOver: editOnDragOver_1,
  onDragStart: editOnDragStart_1,
  onFocus: editOnFocus_1,
  onInput: editOnInput_1,
  onKeyDown: editOnKeyDown_1,
  onPaste: editOnPaste_1,
  onSelect: editOnSelect_1
};

var DraftEditorEditHandler_1 = DraftEditorEditHandler;

function _classCallCheck$29(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$15(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$18(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = function (_React$Component) {
  _inherits$18(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck$29(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn$15(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();

    var className = cx_1({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });

    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };

    return React__default.createElement(
      'div',
      { className: className },
      React__default.createElement(
        'div',
        {
          className: cx_1('public/DraftEditorPlaceholder/inner'),
          id: this.props.accessibilityID,
          style: contentStyle },
        this.props.text
      )
    );
  };

  return DraftEditorPlaceholder;
}(React__default.Component);

var DraftEditorPlaceholder_react = DraftEditorPlaceholder;

var isOSX$1 = UserAgent_1.isPlatform('Mac OS X');
var isWindows = UserAgent_1.isPlatform('Windows');

// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.
var shouldFixFirefoxMovement = isOSX$1 && UserAgent_1.isBrowser('Firefox < 29');

var hasCommandModifier = KeyBindingUtil_1.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil_1.isCtrlKeyCommand;


function shouldRemoveWord(e) {
  return isOSX$1 && e.altKey || isCtrlKeyCommand(e);
}

/**
 * Get the appropriate undo/redo command for a Z key command.
 */
function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }
  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX$1) {
    return 'backspace-to-start-of-line';
  }
  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}

/**
 * Retrieve a bound key command for the given event.
 */
function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;
    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;
    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;
    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;
    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;
    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 84:
      // T
      return isOSX$1 && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;
    case 87:
      // W
      return isOSX$1 && isCtrlKeyCommand(e) ? 'backspace-word' : null;
    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }
      return null;
    case 90:
      // Z
      return getZCommand(e) || null;
    case Keys.RETURN:
      return 'split-block';
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
    default:
      return null;
  }
}

var getDefaultKeyBinding_1 = getDefaultKeyBinding;

var _extends$11 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$30(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$16(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$19(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var isIE = UserAgent_1.isBrowser('IE');

// IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.
var allowSpellCheck = !isIE;

// Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.
var handlerMap = {
  edit: DraftEditorEditHandler_1,
  composite: DraftEditorCompositionHandler_1,
  drag: DraftEditorDragHandler_1,
  cut: null,
  render: null
};

/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */
var DraftEditor = function (_React$Component) {
  _inherits$19(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck$30(this, DraftEditor);

    var _this = _possibleConstructorReturn$16(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;

      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = _reactDom__default.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style_1.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition_1(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ? invariant_1(false) : void 0;
      editorNode.focus();

      // Restore scroll position
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll_1.setTop(scrollParent, y);
      }

      // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.
      if (!alreadyHasFocus) {
        _this.update(EditorState_1.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = _reactDom__default.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ? invariant_1(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey_1();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;

    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    // See `restoreEditorDOM()`.
    _this.state = { contentsKey: 0 };
    return _this;
  }

  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows_1(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };

      return React__default.createElement(DraftEditorPlaceholder_react, placeHolderProps);
    }
    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;


    var rootClass = cx_1({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });

    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    };

    // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.
    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;

    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends$11({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };

    return React__default.createElement(
      'div',
      { className: rootClass },
      this._renderPlaceholder(),
      React__default.createElement(
        'div',
        {
          className: cx_1('DraftEditor/editorContainer'),
          ref: function ref(_ref3) {
            return _this3.editorContainer = _ref3;
          } },
        React__default.createElement(
          'div',
          {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx_1({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex },
          React__default.createElement(DraftEditorContents_react, editorContentsProps)
        )
      )
    );
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');

    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };

  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };

  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */


  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */


  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */


  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */


  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */


  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React__default.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap_1,
  blockRendererFn: emptyFunction_1.thatReturnsNull,
  blockStyleFn: emptyFunction_1.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding_1,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};


var DraftEditor_react = DraftEditor;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */

var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },

  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};

var DraftStringKey_1 = DraftStringKey;

var strlen$1 = UnicodeUtils_1.strlen;

/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function ( /*number*/start, /*number*/end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen$1(text.slice(0, start)),
      length: strlen$1(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey_1.stringify(key)])
    });
  });
  return encoded;
}

var encodeEntityRanges_1 = encodeEntityRanges;

var areEqual$1 = function areEqual(a, b) {
  return a === b;
};
var isTruthy = function isTruthy(a) {
  return !!a;
};
var EMPTY_ARRAY = [];

/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];

  // Obtain an array with ranges for only the specified style.
  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();

  findRangesImmutable_1(filteredInlines, areEqual$1,
  // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils_1.strlen(text.slice(0, start)),
      length: UnicodeUtils_1.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });

  return ranges;
}

/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });

  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

var encodeInlineStyleRanges_1 = encodeInlineStyleRanges;

var _extends$12 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges_1(block),
    entityRanges: encodeEntityRanges_1(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock_1) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode_1) ? invariant_1(false) : void 0;

  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _extends$12({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;


  var rawBlocks = [];

  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;

  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start);
      // Stringify to maintain order of otherwise numeric keys.
      var stringifiedEntityKey = DraftStringKey_1.stringify(entityKey);
      // This makes this function resilient to two entities
      // erroneously having the same key
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode
      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });

    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });

  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
};

// Flip storage map so that our storage keys map to global
// DraftEntity keys.
var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;


  var rawEntityMap = {};

  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey_1.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });

  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };

  // add blocks
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);

  // add entities
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);

  return rawDraftContentState;
};

var convertFromDraftStateToRaw_1 = convertFromDraftStateToRaw;

var _extends$13 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();

    fn(_block);

    var children = _block.children;

    !Array.isArray(children) ? invariant_1(false) : void 0;

    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type = block.type;

  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends$13({}, child, { depth: (block.depth || 0) + 1 }) : child;
    });
  }
};

/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */
var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;

    var transformedBlocks = [];

    !Array.isArray(blocks) ? invariant_1(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends$13({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;

      transformedBlocks.push(newBlock);
    });

    draftTreeState.blocks = transformedBlocks;

    return _extends$13({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },


  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];

    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _extends$13({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      }

      // update our depth cache reference path
      lastListDepthCacheRef[depth] = treeBlock;

      // if we are greater than zero we must have seen a parent already
      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];

        !parent ? invariant_1(false) : void 0;

        // push nested list blocks
        parent.children.push(treeBlock);
        return;
      }

      // push root list blocks
      transformedBlocks.push(treeBlock);
    });

    return _extends$13({}, draftState, {
      blocks: transformedBlocks
    });
  }
};

var DraftTreeAdapter_1 = DraftTreeAdapter;

var List$12 = immutable.List;


function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata_1.create({ style: style, entity: entity });
  });
  return List$12(characterArray);
}

var createCharacterList_1 = createCharacterList;

var substr$1 = UnicodeUtils_1.substr;

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr$1(text, 0, range.offset).length;
      var end = start + substr$1(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}

var decodeEntityRanges_1 = decodeEntityRanges;

var OrderedSet$6 = immutable.OrderedSet;



var substr$2 = UnicodeUtils_1.substr;


var EMPTY_SET$3 = OrderedSet$6();

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */
function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET$3);
  if (ranges) {
    ranges.forEach(function ( /*object*/range) {
      var cursor = substr$2(text, 0, range.offset).length;
      var end = cursor + substr$2(text, range.offset, range.length).length;
      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles;
}

var decodeInlineStyleRanges_1 = decodeInlineStyleRanges;

var _extends$14 = objectAssign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















var experimentalTreeDataSupport$4 = DraftFeatureFlags_1.draft_tree_data_support;

var List$13 = immutable.List,
    Map$10 = immutable.Map,
    OrderedMap$4 = immutable.OrderedMap;


var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;


  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey_1(),
    data: Map$10(data),
    characterList: decodeCharacterList(block, entityMap)
  };

  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;


  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];

  // Translate entity range keys to the DraftEntity map.
  return createCharacterList_1(decodeInlineStyleRanges_1(text, inlineStyleRanges), decodeEntityRanges_1(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends$14({}, range, { key: entityMap[range.key] });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends$14({}, block, {
    key: block.key || generateRandomKey_1()
  });
};

/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */
var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends$14({}, block, {
      parentRef: parentRef
    });
  });

  // since we pop nodes from the stack we need to insert them in reverse
  return stack.concat(nodesWithParentRef.reverse());
};

/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */
var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks
  // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ? invariant_1(false) : void 0;

    // ensure children have valid keys to enable sibling links
    var children = block.children.map(addKeyIfMissing);

    // root level nodes
    var contentBlockNode = new ContentBlockNode_1(_extends$14({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List$13(children.map(function (child) {
        return child.key;
      }))
    }));

    // push root node to blockMap
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);

    // this stack is used to ensure we visit all nodes respecting depth ordering
    var stack = updateNodeStack([], children, contentBlockNode);

    // start computing children nodes
    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop();

      // parentRef already points to a converted ContentBlockNode
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ? invariant_1(false) : void 0;
        break;
      }

      // ensure children have valid keys to enable sibling links
      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode_1(_extends$14({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List$13(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));

      // push node to blockMap
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);

      // this stack is used to ensure we visit all nodes respecting depth ordering
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap$4());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap$4(blocks.map(function (block) {
    var contentBlock = new ContentBlock_1(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = experimentalTreeDataSupport$4 && !isTreeRawBlock ? DraftTreeAdapter_1.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport$4) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter_1.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;

  var entityMap = {};

  // TODO: Update this once we completely remove DraftEntity
  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data;

    // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity_1.__create(type, mutability, data || {});
  });

  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ? invariant_1(false) : void 0;

  // decode entities
  var entityMap = decodeRawEntityMap(rawState);

  // decode blockMap
  var blockMap = decodeRawBlocks(rawState, entityMap);

  // create initial selection
  var selectionState = blockMap.isEmpty() ? new SelectionState_1() : SelectionState_1.createEmpty(blockMap.first().getKey());

  return new ContentState_1({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

var convertFromRawToDraftState_1 = convertFromRawToDraftState;

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects_1(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

var getRangeBoundingClientRect_1 = getRangeBoundingClientRect;

/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
function getVisibleSelectionRect(global) {
  var selection = global.getSelection();
  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect_1(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left;

  // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

var getVisibleSelectionRect_1 = getVisibleSelectionRect;

var DraftPublic = {
  Editor: DraftEditor_react,
  EditorBlock: DraftEditorBlock_react,
  EditorState: EditorState_1,

  CompositeDecorator: CompositeDraftDecorator_1,
  Entity: DraftEntity_1,
  EntityInstance: DraftEntityInstance_1,

  BlockMapBuilder: BlockMapBuilder_1,
  CharacterMetadata: CharacterMetadata_1,
  ContentBlock: ContentBlock_1,
  ContentState: ContentState_1,
  SelectionState: SelectionState_1,

  AtomicBlockUtils: AtomicBlockUtils_1,
  KeyBindingUtil: KeyBindingUtil_1,
  Modifier: DraftModifier_1,
  RichUtils: RichTextEditorUtil_1,

  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap_1,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,

  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState_1,
  convertToRaw: convertFromDraftStateToRaw_1,
  genKey: generateRandomKey_1,
  getDefaultKeyBinding: getDefaultKeyBinding_1,
  getVisibleSelectionRect: getVisibleSelectionRect_1
};

var Draft = DraftPublic;
var Draft_1 = Draft.CompositeDecorator;

var constants = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Some of the constants which are used throughout this project instead of
directly using string.
*/

var Block = exports.Block = {
  UNSTYLED: 'unstyled',
  PARAGRAPH: 'unstyled',
  OL: 'ordered-list-item',
  UL: 'unordered-list-item',
  H1: 'header-one',
  H2: 'header-two',
  H3: 'header-three',
  H4: 'header-four',
  H5: 'header-five',
  H6: 'header-six',
  CODE: 'code-block',
  BLOCKQUOTE: 'blockquote',
  PULLQUOTE: 'pullquote',
  ATOMIC: 'atomic',
  BLOCKQUOTE_CAPTION: 'block-quote-caption',
  CAPTION: 'caption',
  TODO: 'todo',
  IMAGE: 'atomic:image',
  BREAK: 'atomic:break'
};

var Inline = exports.Inline = {
  BOLD: 'BOLD',
  CODE: 'CODE',
  ITALIC: 'ITALIC',
  STRIKETHROUGH: 'STRIKETHROUGH',
  UNDERLINE: 'UNDERLINE',
  HIGHLIGHT: 'HIGHLIGHT'
};

var Entity = exports.Entity = {
  LINK: 'LINK'
};

var HYPERLINK = exports.HYPERLINK = 'hyperlink';
var HANDLED = exports.HANDLED = 'handled';
var NOT_HANDLED = exports.NOT_HANDLED = 'not_handled';

var KEY_COMMANDS = exports.KEY_COMMANDS = {
  addNewBlock: function addNewBlock() {
    return 'add-new-block';
  },
  changeType: function changeType() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return 'changetype:' + type;
  },
  showLinkInput: function showLinkInput() {
    return 'showlinkinput';
  },
  unlink: function unlink() {
    return 'unlink';
  },
  toggleInline: function toggleInline() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return 'toggleinline:' + type;
  },
  deleteBlock: function deleteBlock() {
    return 'delete-block';
  }
};

exports.default = {
  Block: Block,
  Inline: Inline,
  Entity: Entity
};
});

unwrapExports(constants);
var constants_1 = constants.Block;
var constants_2 = constants.Inline;
var constants_3 = constants.Entity;
var constants_4 = constants.HYPERLINK;
var constants_5 = constants.HANDLED;
var constants_6 = constants.NOT_HANDLED;
var constants_7 = constants.KEY_COMMANDS;

var stylebutton = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyleButton = function (_React$Component) {
  _inherits(StyleButton, _React$Component);

  function StyleButton(props) {
    _classCallCheck(this, StyleButton);

    var _this = _possibleConstructorReturn(this, (StyleButton.__proto__ || Object.getPrototypeOf(StyleButton)).call(this, props));

    _this.onToggle = function (e) {
      var _this$props = _this.props,
          onToggle = _this$props.onToggle,
          onClick = _this$props.onClick,
          style = _this$props.style;


      if (onClick) {
        onClick(e);
      }

      if (style) {
        e.preventDefault();
        onToggle(style);
      }
    };
    return _this;
  }

  _createClass(StyleButton, [{
    key: 'render',
    value: function render() {
      if (this.props.style === constants.HYPERLINK) {
        return null;
      }
      var className = 'md-RichEditor-styleButton';
      if (this.props.active) {
        className += ' md-RichEditor-activeButton';
      }
      className += ' md-RichEditor-styleButton-' + this.props.style.toLowerCase();
      return _react2.default.createElement(
        'span',
        {
          className: className + ' hint--top',
          onMouseDown: this.onToggle,
          'aria-label': this.props.description
        },
        this.props.icon ? _react2.default.createElement('i', { className: 'fa fa-' + this.props.icon }) : this.props.label
      );
    }
  }]);

  return StyleButton;
}(_react2.default.Component);

exports.default = StyleButton;


StyleButton.propTypes = {
  onToggle: _propTypes2.default.func,
  style: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.object]),
  description: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
});

unwrapExports(stylebutton);

var blocktoolbar = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





var _stylebutton2 = _interopRequireDefault(stylebutton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockToolbar = function BlockToolbar(props) {
  if (props.buttons.length < 1) {
    return null;
  }
  var editorState = props.editorState;

  var blockType = Draft.RichUtils.getCurrentBlockType(editorState);
  return _react2.default.createElement(
    'div',
    { className: 'md-RichEditor-controls md-RichEditor-controls-block' },
    props.buttons.map(function (type) {
      var iconLabel = {};
      iconLabel.label = type.label;
      return _react2.default.createElement(_stylebutton2.default, _extends({}, iconLabel, {
        key: type.style,
        active: type.style === blockType,
        onToggle: props.onToggle,
        style: type.style,
        description: type.description,
        onClick: type.onClick
      }));
    })
  );
};

BlockToolbar.propTypes = {
  buttons: _propTypes2.default.array,
  editorState: _propTypes2.default.object.isRequired,
  onToggle: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};

exports.default = BlockToolbar;
});

unwrapExports(blocktoolbar);

var inlinetoolbar = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);



var _stylebutton2 = _interopRequireDefault(stylebutton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineToolbar = function InlineToolbar(props) {
  if (props.buttons.length < 1) {
    return null;
  }
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return _react2.default.createElement(
    'div',
    { className: 'md-RichEditor-controls md-RichEditor-controls-inline' },
    props.buttons.map(function (type) {
      var iconLabel = {};
      iconLabel.label = type.label;
      return _react2.default.createElement(_stylebutton2.default, _extends({}, iconLabel, {
        key: type.style,
        active: currentStyle.has(type.style),
        onToggle: props.onToggle,
        style: type.style,
        description: type.description,
        onClick: type.onClick
      }));
    })
  );
};

InlineToolbar.propTypes = {
  buttons: _propTypes2.default.array,
  editorState: _propTypes2.default.object.isRequired,
  onToggle: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};

exports.default = InlineToolbar;
});

unwrapExports(inlinetoolbar);

var util = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Returns the `boundingClientRect` of the passed selection.
*/
var getSelectionRect = exports.getSelectionRect = function getSelectionRect(selected) {
  var _rect = selected.getRangeAt(0).getBoundingClientRect();
  // selected.getRangeAt(0).getBoundingClientRect()
  var rect = _rect && _rect.top ? _rect : selected.getRangeAt(0).getClientRects()[0];
  if (!rect) {
    if (selected.anchorNode && selected.anchorNode.getBoundingClientRect) {
      rect = selected.anchorNode.getBoundingClientRect();
      rect.isEmptyline = true;
    } else {
      return null;
    }
  }
  return rect;
};

/*
Returns the native selection node.
*/
var getSelection = exports.getSelection = function getSelection(root) {
  var t = null;
  if (root.getSelection) {
    t = root.getSelection();
  } else if (root.document.getSelection) {
    t = root.document.getSelection();
  } else if (root.document.selection) {
    t = root.document.selection.createRange().text;
  }
  return t;
};

/*
Recursively finds the DOM Element of the block where the cursor is currently present.
If not found, returns null.
*/
var getSelectedBlockNode = exports.getSelectedBlockNode = function getSelectedBlockNode(root) {
  var selection = root.getSelection();
  if (selection.rangeCount === 0) {
    return null;
  }
  var node = selection.getRangeAt(0).startContainer;
  // console.log(node);
  do {
    if (node.getAttribute && node.getAttribute('data-block') === 'true') {
      return node;
    }
    node = node.parentNode;
    // console.log(node);
  } while (node !== null);
  return null;
};
});

unwrapExports(util);
var util_1 = util.getSelectionRect;
var util_2 = util.getSelection;
var util_3 = util.getSelectedBlockNode;

var model = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCursorBetweenLink = exports.addNewBlockAt = exports.updateDataOfBlock = exports.resetBlockWithType = exports.addNewBlock = exports.getCurrentBlock = exports.getDefaultBlockData = undefined;







/*
Returns default block-level metadata for various block type. Empty object otherwise.
*/
var getDefaultBlockData = exports.getDefaultBlockData = function getDefaultBlockData(blockType) {
  var initialData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (blockType) {
    case constants.Block.TODO:
      return { checked: false };
    default:
      return initialData;
  }
};

/*
Get currentBlock in the editorState.
*/
var getCurrentBlock = exports.getCurrentBlock = function getCurrentBlock(editorState) {
  var selectionState = editorState.getSelection();
  var contentState = editorState.getCurrentContent();
  var block = contentState.getBlockForKey(selectionState.getStartKey());
  return block;
};

/*
Adds a new block (currently replaces an empty block) at the current cursor position
of the given `newType`.
*/
var addNewBlock = exports.addNewBlock = function addNewBlock(editorState) {
  var newType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants.Block.UNSTYLED;
  var initialData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var selectionState = editorState.getSelection();
  if (!selectionState.isCollapsed()) {
    return editorState;
  }
  var contentState = editorState.getCurrentContent();
  var key = selectionState.getStartKey();
  var blockMap = contentState.getBlockMap();
  var currentBlock = getCurrentBlock(editorState);
  if (!currentBlock) {
    return editorState;
  }
  if (currentBlock.getLength() === 0) {
    if (currentBlock.getType() === newType) {
      return editorState;
    }
    var newBlock = currentBlock.merge({
      type: newType,
      data: getDefaultBlockData(newType, initialData)
    });
    var newContentState = contentState.merge({
      blockMap: blockMap.set(key, newBlock),
      selectionAfter: selectionState
    });
    return Draft.EditorState.push(editorState, newContentState, 'change-block-type');
  }
  return editorState;
};

/*
Changes the block type of the current block.
*/
var resetBlockWithType = exports.resetBlockWithType = function resetBlockWithType(editorState) {
  var newType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants.Block.UNSTYLED;
  var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var contentState = editorState.getCurrentContent();
  var selectionState = editorState.getSelection();
  var key = selectionState.getStartKey();
  var blockMap = contentState.getBlockMap();
  var block = blockMap.get(key);
  var newBlock = block.mergeDeep(overrides, {
    type: newType,
    data: getDefaultBlockData(newType)
  });
  var newContentState = contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: 0,
      focusOffset: 0
    })
  });
  return Draft.EditorState.push(editorState, newContentState, 'change-block-type');
};

/*
Update block-level metadata of the given `block` to the `newData`/
*/
var updateDataOfBlock = exports.updateDataOfBlock = function updateDataOfBlock(editorState, block, newData) {
  var contentState = editorState.getCurrentContent();
  var newBlock = block.merge({
    data: newData
  });
  var newContentState = contentState.merge({
    blockMap: contentState.getBlockMap().set(block.getKey(), newBlock)
  });
  return Draft.EditorState.push(editorState, newContentState, 'change-block-data');
};

// const BEFORE = -1;
// const AFTER = 1;

/*
Used from [react-rte](https://github.com/sstur/react-rte/blob/master/src/lib/insertBlockAfter.js)
by [sstur](https://github.com/sstur)
*/
var addNewBlockAt = exports.addNewBlockAt = function addNewBlockAt(editorState, pivotBlockKey) {
  var newBlockType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : constants.Block.UNSTYLED;
  var initialData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var content = editorState.getCurrentContent();
  var blockMap = content.getBlockMap();
  var block = blockMap.get(pivotBlockKey);
  if (!block) {
    throw new Error('The pivot key - ' + pivotBlockKey + ' is not present in blockMap.');
  }
  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === block;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === block;
  }).rest();
  var newBlockKey = (0, Draft.genKey)();

  var newBlock = new Draft.ContentBlock({
    key: newBlockKey,
    type: newBlockType,
    text: '',
    characterList: (0, immutable.List)(),
    depth: 0,
    data: (0, immutable.Map)(getDefaultBlockData(newBlockType, initialData))
  });

  var newBlockMap = blocksBefore.concat([[pivotBlockKey, block], [newBlockKey, newBlock]], blocksAfter).toOrderedMap();

  var selection = editorState.getSelection();

  var newContent = content.merge({
    blockMap: newBlockMap,
    selectionBefore: selection,
    selectionAfter: selection.merge({
      anchorKey: newBlockKey,
      anchorOffset: 0,
      focusKey: newBlockKey,
      focusOffset: 0,
      isBackward: false
    })
  });
  return Draft.EditorState.push(editorState, newContent, 'split-block');
};

/**
 * Check whether the cursor is between entity of type LINK
 */
var isCursorBetweenLink = exports.isCursorBetweenLink = function isCursorBetweenLink(editorState) {
  var ret = null;
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var currentBlock = getCurrentBlock(editorState);
  if (!currentBlock) {
    return ret;
  }
  var entityKey = null;
  var blockKey = null;
  if (currentBlock.getType() !== constants.Block.ATOMIC && selection.isCollapsed()) {
    if (currentBlock.getLength() > 0) {
      if (selection.getAnchorOffset() > 0) {
        entityKey = currentBlock.getEntityAt(selection.getAnchorOffset() - 1);
        blockKey = currentBlock.getKey();
        if (entityKey !== null) {
          var entity = content.getEntity(entityKey);
          if (entity.getType() === constants.Entity.LINK) {
            ret = {
              entityKey: entityKey,
              blockKey: blockKey,
              url: entity.getData().url
            };
          }
        }
      }
    }
  }
  return ret;
};
});

unwrapExports(model);
var model_1 = model.isCursorBetweenLink;
var model_2 = model.addNewBlockAt;
var model_3 = model.updateDataOfBlock;
var model_4 = model.resetBlockWithType;
var model_5 = model.addNewBlock;
var model_6 = model.getCurrentBlock;
var model_7 = model.getDefaultBlockData;

var toolbar = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INLINE_BUTTONS = exports.BLOCK_BUTTONS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(_reactDom__default);



var _blocktoolbar2 = _interopRequireDefault(blocktoolbar);



var _inlinetoolbar2 = _interopRequireDefault(inlinetoolbar);







function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import './toolbar.scss';

var Toolbar = function (_React$Component) {
  _inherits(Toolbar, _React$Component);

  function Toolbar(props) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, props));

    _this.state = {
      showURLInput: false,
      urlInputValue: ''
    };

    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.handleLinkInput = _this.handleLinkInput.bind(_this);
    _this.hideLinkInput = _this.hideLinkInput.bind(_this);
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var editorState = newProps.editorState;

      if (!newProps.editorEnabled) {
        return;
      }
      var selectionState = editorState.getSelection();
      if (selectionState.isCollapsed()) {
        if (this.state.showURLInput) {
          this.setState({
            showURLInput: false,
            urlInputValue: ''
          });
        }
        return;
      }
    }

    // shouldComponentUpdate(newProps, newState) {
    //   console.log(newState, this.state);
    //   if (newState.showURLInput !== this.state.showURLInput && newState.urlInputValue !== this.state.urlInputValue) {
    //     return true;
    //   }
    //   return false;
    // }

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.props.editorEnabled || this.state.showURLInput) {
        return;
      }
      var selectionState = this.props.editorState.getSelection();
      if (selectionState.isCollapsed()) {
        return;
      }
      // eslint-disable-next-line no-undef
      var nativeSelection = (0, util.getSelection)(window);
      if (!nativeSelection.rangeCount) {
        return;
      }
      var selectionBoundary = (0, util.getSelectionRect)(nativeSelection);

      // eslint-disable-next-line react/no-find-dom-node
      var toolbarNode = _reactDom2.default.findDOMNode(this);
      var toolbarBoundary = toolbarNode.getBoundingClientRect();

      // eslint-disable-next-line react/no-find-dom-node
      var parent = _reactDom2.default.findDOMNode(this.props.editorNode);
      var parentBoundary = parent.getBoundingClientRect();

      /*
      * Main logic for setting the toolbar position.
      */
      toolbarNode.style.top = selectionBoundary.top - parentBoundary.top - toolbarBoundary.height - 5 + 'px';
      toolbarNode.style.width = toolbarBoundary.width + 'px';

      // The left side of the tooltip should be:
      // center of selection relative to parent - half width of toolbar
      var selectionCenter = selectionBoundary.left + selectionBoundary.width / 2 - parentBoundary.left;
      var left = selectionCenter - toolbarBoundary.width / 2;
      var screenLeft = parentBoundary.left + left;
      if (screenLeft < 0) {
        // If the toolbar would be off-screen
        // move it as far left as it can without going off-screen
        left = -parentBoundary.left;
      }
      toolbarNode.style.left = left + 'px';
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (e.which === 13) {
        e.preventDefault();
        e.stopPropagation();
        this.props.setLink(this.state.urlInputValue);
        this.hideLinkInput();
      } else if (e.which === 27) {
        this.hideLinkInput();
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        urlInputValue: e.target.value
      });
    }
  }, {
    key: 'handleLinkInput',
    value: function handleLinkInput(e) {
      var _this2 = this;

      var direct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (direct !== true) {
        e.preventDefault();
        e.stopPropagation();
      }
      var editorState = this.props.editorState;

      var selection = editorState.getSelection();
      if (selection.isCollapsed()) {
        this.props.focus();
        return;
      }
      var currentBlock = (0, model.getCurrentBlock)(editorState);
      var selectedEntity = '';
      var linkFound = false;
      currentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        selectedEntity = entityKey;
        return entityKey !== null && editorState.getCurrentContent().getEntity(entityKey).getType() === constants.Entity.LINK;
      }, function (start, end) {
        var selStart = selection.getAnchorOffset();
        var selEnd = selection.getFocusOffset();
        if (selection.getIsBackward()) {
          selStart = selection.getFocusOffset();
          selEnd = selection.getAnchorOffset();
        }
        if (start === selStart && end === selEnd) {
          linkFound = true;

          var _editorState$getCurre = editorState.getCurrentContent().getEntity(selectedEntity).getData(),
              url = _editorState$getCurre.url;

          _this2.setState({
            showURLInput: true,
            urlInputValue: url
          }, function () {
            setTimeout(function () {
              _this2.urlinput.focus();
              _this2.urlinput.select();
            }, 0);
          });
        }
      });
      if (!linkFound) {
        this.setState({
          showURLInput: true
        }, function () {
          setTimeout(function () {
            _this2.urlinput.focus();
          }, 0);
        });
      }
    }
  }, {
    key: 'hideLinkInput',
    value: function hideLinkInput() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (e !== null) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.setState({
        showURLInput: false,
        urlInputValue: ''
      }, this.props.focus);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          editorState = _props.editorState,
          editorEnabled = _props.editorEnabled,
          inlineButtons = _props.inlineButtons;
      var _state = this.state,
          showURLInput = _state.showURLInput,
          urlInputValue = _state.urlInputValue;

      var isOpen = true;
      if (!editorEnabled || editorState.getSelection().isCollapsed()) {
        isOpen = false;
      }
      if (showURLInput) {
        var className = 'md-editor-toolbar' + (isOpen ? ' md-editor-toolbar--isopen' : '');
        className += ' md-editor-toolbar--linkinput';
        return _react2.default.createElement(
          'div',
          {
            className: className
          },
          _react2.default.createElement(
            'div',
            {
              className: 'md-RichEditor-controls md-RichEditor-show-link-input',
              style: { display: 'block' }
            },
            _react2.default.createElement(
              'span',
              { className: 'md-url-input-close', onClick: this.hideLinkInput },
              '\xD7'
            ),
            _react2.default.createElement('input', {
              ref: function ref(node) {
                _this3.urlinput = node;
              },
              type: 'text',
              className: 'md-url-input',
              onKeyDown: this.onKeyDown,
              onChange: this.onChange,
              placeholder: 'Press ENTER or ESC',
              value: urlInputValue
            })
          )
        );
      }
      var hasHyperLink = false;
      var hyperlinkLabel = '#';
      var hyperlinkDescription = 'Add a link';
      for (var cnt = 0; cnt < inlineButtons.length; cnt++) {
        if (inlineButtons[cnt].style === constants.HYPERLINK) {
          hasHyperLink = true;
          if (inlineButtons[cnt].label) {
            hyperlinkLabel = inlineButtons[cnt].label;
          }
          if (inlineButtons[cnt].description) {
            hyperlinkDescription = inlineButtons[cnt].description;
          }
          break;
        }
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'md-editor-toolbar' + (isOpen ? ' md-editor-toolbar--isopen' : '')
        },
        this.props.blockButtons.length > 0 ? _react2.default.createElement(_blocktoolbar2.default, {
          editorState: editorState,
          onToggle: this.props.toggleBlockType,
          buttons: this.props.blockButtons
        }) : null,
        this.props.inlineButtons.length > 0 ? _react2.default.createElement(_inlinetoolbar2.default, {
          editorState: editorState,
          onToggle: this.props.toggleInlineStyle,
          buttons: this.props.inlineButtons
        }) : null,
        hasHyperLink && _react2.default.createElement(
          'div',
          { className: 'md-RichEditor-controls' },
          _react2.default.createElement(
            'span',
            {
              className: 'md-RichEditor-styleButton md-RichEditor-linkButton hint--top',
              onClick: this.handleLinkInput,
              'aria-label': hyperlinkDescription
            },
            hyperlinkLabel
          )
        )
      );
    }
  }]);

  return Toolbar;
}(_react2.default.Component);

Toolbar.propTypes = {
  editorEnabled: _propTypes2.default.bool,
  editorState: _propTypes2.default.object,
  toggleBlockType: _propTypes2.default.func,
  toggleInlineStyle: _propTypes2.default.func,
  inlineButtons: _propTypes2.default.arrayOf(_propTypes2.default.object),
  blockButtons: _propTypes2.default.arrayOf(_propTypes2.default.object),
  editorNode: _propTypes2.default.object,
  setLink: _propTypes2.default.func,
  focus: _propTypes2.default.func
};
Toolbar.defaultProps = {
  blockButtons: BLOCK_BUTTONS,
  inlineButtons: INLINE_BUTTONS
};
exports.default = Toolbar;
var BLOCK_BUTTONS = exports.BLOCK_BUTTONS = [{
  label: 'H3',
  style: 'header-three',
  icon: 'header',
  description: 'Heading 3'
}, {
  label: _react2.default.createElement(
    'svg',
    { width: '10.83', height: '10', viewBox: '0 0 13 12' },
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'g',
        { transform: 'translate(-357.000000, -255.000000)', fill: '#FFFFFF' },
        _react2.default.createElement(
          'g',
          { transform: 'translate(260.000000, 165.000000)' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(0.000000, 75.000000)' },
            _react2.default.createElement(
              'g',
              { transform: 'translate(19.000000, 0.000000)' },
              _react2.default.createElement('path', { d: 'M90.500768,15 L91,15.56 C88.9631235,17.0533408 87.9447005,18.666658 87.9447005,20.4 C87.9447005,21.8800074 88.75012,23.1466614 90.3609831,24.2 L87.5453149,27 C85.9211388,25.7866606 85.109063,24.346675 85.109063,22.68 C85.109063,20.3199882 86.90628,17.7600138 90.500768,15 Z M83.3917051,15 L83.890937,15.56 C81.8540605,17.0533408 80.8356375,18.666658 80.8356375,20.4 C80.8356375,21.8800074 81.6344006,23.1466614 83.2319508,24.2 L80.4362519,27 C78.8120759,25.7866606 78,24.346675 78,22.68 C78,20.3199882 79.7972171,17.7600138 83.3917051,15 Z' })
            )
          )
        )
      )
    )
  ),
  style: 'blockquote',
  icon: 'quote-right',
  description: 'Blockquote'
}, {
  label: 'UL',
  style: 'unordered-list-item',
  icon: 'list-ul',
  description: 'Unordered List'
}, {
  label: 'OL',
  style: 'ordered-list-item',
  icon: 'list-ol',
  description: 'Ordered List'
}, {
  label: '✓',
  style: 'todo',
  description: 'Todo List'
}];

var INLINE_BUTTONS = exports.INLINE_BUTTONS = [{
  label: 'B',
  style: 'BOLD',
  icon: 'bold',
  description: 'Bold'
}, {
  label: 'I',
  style: 'ITALIC',
  icon: 'italic',
  description: 'Italic'
}, {
  label: 'U',
  style: 'UNDERLINE',
  icon: 'underline',
  description: 'Underline'
}, {
  label: 'Hi',
  style: 'HIGHLIGHT',
  description: 'Highlight selection'
}, {
  label: _react2.default.createElement(
    'svg',
    { width: '20', height: '15', viewBox: '0 0 14 14' },
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'g',
        { transform: 'translate(-468.000000, -254.000000)', stroke: '#FFFFFF' },
        _react2.default.createElement(
          'g',
          { transform: 'translate(260.000000, 165.000000)' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(0.000000, 75.000000)' },
            _react2.default.createElement(
              'g',
              { transform: 'translate(19.000000, 0.000000)' },
              _react2.default.createElement(
                'g',
                { transform: 'translate(196.424621, 21.424621) rotate(45.000000) translate(-196.424621, -21.424621) translate(193.424621, 13.924621)' },
                _react2.default.createElement('path', { d: 'M0.5,5.69098301 L0.5,2 C0.5,1.82069363 0.550664909,1.51670417 0.697213595,1.2236068 C0.927818928,0.762396132 1.32141313,0.5 2,0.5 L4,0.5 C4.67858687,0.5 5.07218107,0.762396132 5.3027864,1.2236068 C5.44933509,1.51670417 5.5,1.82069363 5.5,2 L5.5,6 C5.5,6.67858687 5.23760387,7.07218107 4.7763932,7.3027864 C4.53586606,7.42304998 4.28800365,7.47874077 4.1077327,7.49484936 L0.5,5.69098301 Z' }),
                _react2.default.createElement('path', { d: 'M0.5,12.690983 L0.5,9 C0.5,8.82069363 0.550664909,8.51670417 0.697213595,8.2236068 C0.927818928,7.76239613 1.32141313,7.5 2,7.5 L4,7.5 C4.67858687,7.5 5.07218107,7.76239613 5.3027864,8.2236068 C5.44933509,8.51670417 5.5,8.82069363 5.5,9 L5.5,13 C5.5,13.6785869 5.23760387,14.0721811 4.7763932,14.3027864 C4.53586606,14.42305 4.28800365,14.4787408 4.1077327,14.4948494 L0.5,12.690983 Z', transform: 'translate(3.000000, 11.000000) scale(-1, -1) translate(-3.000000, -11.000000) ' })
              )
            )
          )
        )
      )
    )
  ),
  style: constants.HYPERLINK,
  icon: 'link',
  description: 'Add a link'
}];
});

unwrapExports(toolbar);
var toolbar_1 = toolbar.INLINE_BUTTONS;
var toolbar_2 = toolbar.BLOCK_BUTTONS;

function isSoftNewlineEvent(e) {
  return e.which === Keys.RETURN && (e.getModifierState('Shift') || e.getModifierState('Alt') || e.getModifierState('Control'));
}

var isSoftNewlineEvent_1 = isSoftNewlineEvent;

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(interopRequireDefault);

var hasClass_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];
});

unwrapExports(hasClass_1);

var addClass_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = addClass;

var _hasClass = interopRequireDefault(hasClass_1);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];
});

unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}


var _reactLifecyclesCompat = Object.freeze({
	polyfill: polyfill
});

var PropTypes = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes$$1 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape = null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = null;
exports.classNamesShape = classNamesShape;
});

unwrapExports(PropTypes);
var PropTypes_1 = PropTypes.classNamesShape;
var PropTypes_2 = PropTypes.timeoutsShape;

var Transition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes$$1 = _interopRequireWildcard(_propTypes);

var _react = _interopRequireDefault(React__default);

var _reactDom$$1 = _interopRequireDefault(_reactDom__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom$$1.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes$$1.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes = {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;
});

unwrapExports(Transition_1);
var Transition_2 = Transition_1.EXITING;
var Transition_3 = Transition_1.ENTERED;
var Transition_4 = Transition_1.ENTERING;
var Transition_5 = Transition_1.EXITED;
var Transition_6 = Transition_1.UNMOUNTED;

var CSSTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var PropTypes$$1 = _interopRequireWildcard(_propTypes);

var _addClass = _interopRequireDefault(addClass_1);

var _removeClass = _interopRequireDefault(removeClass);

var _react = _interopRequireDefault(React__default);

var _Transition = _interopRequireDefault(Transition_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass$$1 = function removeClass$$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass$$1(node, className);
    activeClassName && removeClass$$1(node, activeClassName);
    doneClassName && removeClass$$1(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(CSSTransition_1);

var ChildMapping = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, React__default.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React__default.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, React__default.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, React__default.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, React__default.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, React__default.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, React__default.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, React__default.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, React__default.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
});

unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping;
var ChildMapping_2 = ChildMapping.mergeChildMappings;
var ChildMapping_3 = ChildMapping.getInitialChildMapping;
var ChildMapping_4 = ChildMapping.getNextChildMapping;

var TransitionGroup_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes$$1 = _interopRequireDefault(_propTypes);

var _react = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes$$1.default.object.isRequired
};
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(TransitionGroup_1);

var ReplaceTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes$$1 = _interopRequireDefault(_propTypes);

var _react = _interopRequireDefault(React__default);



var _TransitionGroup = _interopRequireDefault(TransitionGroup_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom__default.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes = {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(ReplaceTransition_1);

var reactTransitionGroup = createCommonjsModule(function (module) {

var _CSSTransition = _interopRequireDefault(CSSTransition_1);

var _ReplaceTransition = _interopRequireDefault(ReplaceTransition_1);

var _TransitionGroup = _interopRequireDefault(TransitionGroup_1);

var _Transition = _interopRequireDefault(Transition_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};
});

unwrapExports(reactTransitionGroup);
var reactTransitionGroup_1 = reactTransitionGroup.Transition;
var reactTransitionGroup_2 = reactTransitionGroup.TransitionGroup;
var reactTransitionGroup_3 = reactTransitionGroup.ReplaceTransition;
var reactTransitionGroup_4 = reactTransitionGroup.CSSTransition;

var addbutton = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import './addbutton.scss';

/**
 * Implementation of the medium-link side `+` button to insert various rich blocks
 * like Images/Embeds/Videos.
 */
var AddButton = function (_React$Component) {
  _inherits(AddButton, _React$Component);

  function AddButton(props) {
    _classCallCheck(this, AddButton);

    var _this = _possibleConstructorReturn(this, (AddButton.__proto__ || Object.getPrototypeOf(AddButton)).call(this, props));

    _this.state = {
      style: {},
      visible: false,
      isOpen: false
    };
    _this.node = null;
    _this.blockKey = '';
    _this.blockType = '';
    _this.blockLength = -1;

    _this.findNode = _this.findNode.bind(_this);
    _this.hideBlock = _this.hideBlock.bind(_this);
    _this.openToolbar = _this.openToolbar.bind(_this);
    return _this;
  }

  // To show + button only when text length == 0


  _createClass(AddButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var editorState = newProps.editorState;

      var contentState = editorState.getCurrentContent();
      var selectionState = editorState.getSelection();
      if (!selectionState.isCollapsed() || selectionState.anchorKey !== selectionState.focusKey || contentState.getBlockForKey(selectionState.getAnchorKey()).getType().indexOf('atomic') >= 0) {
        // console.log('no sel');
        this.hideBlock();
        return;
      }
      var block = contentState.getBlockForKey(selectionState.anchorKey);
      var bkey = block.getKey();
      if (block.getLength() > 0) {
        this.hideBlock();
        return;
      }
      if (block.getType() !== this.blockType) {
        this.blockType = block.getType();
        if (block.getLength() === 0) {
          setTimeout(this.findNode, 0);
        }
        this.blockKey = bkey;
        return;
      }
      if (this.blockKey === bkey) {
        // console.log('block exists');
        if (block.getLength() > 0) {
          this.hideBlock();
        } else {
          this.setState({
            visible: true
          });
        }
        return;
      }
      this.blockKey = bkey;
      if (block.getLength() > 0) {
        // console.log('no len');
        this.hideBlock();
        return;
      }
      setTimeout(this.findNode, 0);
    }
  }, {
    key: 'hideBlock',
    value: function hideBlock() {
      if (this.state.visible) {
        this.setState({
          visible: false,
          isOpen: false
        });
      }
    }
  }, {
    key: 'openToolbar',
    value: function openToolbar() {
      var _this2 = this;

      this.setState({
        isOpen: !this.state.isOpen
      }, function () {
        // callback function
        // save page state
        var x = window.scrollX || window.pageXOffset;
        var y = window.scrollY || window.pageYOffset;
        // do focus
        _this2.props.focus();
        // back previous window state
        window.scrollTo(x, y);
      });
    }
  }, {
    key: 'findNode',
    value: function findNode() {
      // eslint-disable-next-line no-undef
      var node = (0, util.getSelectedBlockNode)(window);
      if (node === this.node) {
        // console.log('Node exists');
        return;
      }
      if (!node) {
        // console.log('no node');
        this.setState({
          visible: false,
          isOpen: false
        });
        return;
      }
      // const rect = node.getBoundingClientRect();
      this.node = node;
      this.setState({
        visible: true,
        style: {
          top: node.offsetTop - 3
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.state.visible) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'md-side-toolbar', style: this.state.style },
        _react2.default.createElement(
          'button',
          {
            onClick: this.openToolbar,
            className: 'md-sb-button md-add-button' + (this.state.isOpen ? ' md-open-button' : ''),
            type: 'button'
          },
          _react2.default.createElement(
            'svg',
            { viewBox: '0 0 8 8', height: '14', width: '14' },
            _react2.default.createElement('path', { d: 'M3 0v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2z' })
          )
        ),
        this.state.isOpen ? _react2.default.createElement(
          reactTransitionGroup.TransitionGroup,
          null,
          this.props.sideButtons.map(function (button) {
            var Button = button.component;
            var extraProps = button.props ? button.props : {};
            return _react2.default.createElement(
              reactTransitionGroup.CSSTransition,
              {
                key: button.title,
                classNames: 'md-add-btn-anim',
                appear: true,
                timeout: {
                  enter: 200,
                  exit: 100,
                  appear: 100
                }
              },
              _react2.default.createElement(Button, _extends({}, extraProps, {
                getEditorState: _this3.props.getEditorState,
                setEditorState: _this3.props.setEditorState,
                close: _this3.openToolbar
              }))
            );
          })
        ) : null
      );
    }
  }]);

  return AddButton;
}(_react2.default.Component);

exports.default = AddButton;


AddButton.propTypes = {
  focus: _propTypes2.default.func,
  getEditorState: _propTypes2.default.func.isRequired,
  setEditorState: _propTypes2.default.func.isRequired,
  sideButtons: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
});

unwrapExports(addbutton);

var LinkEditComponent_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(_propTypes);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getRelativeParent = function getRelativeParent(element) {
  if (!element) {
    return null;
  }

  var position = window.getComputedStyle(element).getPropertyValue('position');
  if (position !== 'static') {
    return element;
  }

  return getRelativeParent(element.parentElement);
};

var LinkEditComponent = function (_React$Component) {
  _inherits(LinkEditComponent, _React$Component);

  function LinkEditComponent(props) {
    _classCallCheck(this, LinkEditComponent);

    var _this = _possibleConstructorReturn(this, (LinkEditComponent.__proto__ || Object.getPrototypeOf(LinkEditComponent)).call(this, props));

    _this.hasPosition = function (position) {
      if (Object.keys(_this.state.position).length === 0) {
        return false;
      }
      var _this$state$position = _this.state.position,
          top = _this$state$position.top,
          left = _this$state$position.left;

      return position.top === top && position.left === left;
    };

    _this.calculatePosition = function () {
      if (!_this.toolbar) {
        return;
      }
      var relativeParent = getRelativeParent(_this.toolbar.parentElement);
      var relativeRect = relativeParent ? relativeParent.getBoundingClientRect() : window.document.body.getBoundingClientRect();
      var selectionRect = (0, Draft.getVisibleSelectionRect)(window);
      if (!selectionRect) {
        return;
      }
      var position = {
        top: selectionRect.top - relativeRect.top + 35,
        left: selectionRect.left - relativeRect.left + selectionRect.width / 2,
        transform: 'translate(-50%) scale(1)'
      };
      _this.setState({ position: position });
    };

    _this.removeLink = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.props.removeLink(_this.props.blockKey, _this.props.entityKey);
    };

    _this.editLink = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.props.editLink(_this.props.blockKey, _this.props.entityKey);
    };

    _this.state = {
      position: {}
    };
    _this.renderedOnce = false;
    return _this;
  }

  _createClass(LinkEditComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.calculatePosition, 0);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.renderedOnce) {
        var _props = this.props,
            blockKey = _props.blockKey,
            entityKey = _props.entityKey;

        var ret = !this.hasPosition(nextState.position) || blockKey !== nextProps.blockKey || entityKey !== nextProps.entityKey;
        if (ret) {
          this.renderedOnce = false;
        }
        return ret;
      }
      this.renderedOnce = true;
      return true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      setTimeout(this.calculatePosition, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var url = this.props.url;
      if (url.length > 30) {
        url = url.slice(0, 30) + '...';
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'md-editor-toolbar md-editor-toolbar--isopen md-editor-toolbar-edit-link',
          style: this.state.position,
          ref: function ref(element) {
            _this2.toolbar = element;
          }
        },
        _react2.default.createElement(
          'a',
          { href: this.props.url, title: this.props.url, target: '_blank', rel: 'noopener noreferrer' },
          url
        ),
        _react2.default.createElement(
          'button',
          { className: 'md-editor-toolbar-unlink-button', onClick: this.removeLink },
          'Unlink'
        ),
        _react2.default.createElement(
          'button',
          { className: 'md-editor-toolbar-edit-button', onClick: this.editLink },
          'Edit'
        )
      );
    }
  }]);

  return LinkEditComponent;
}(_react2.default.Component);

LinkEditComponent.propTypes = {
  editorState: _propTypes2.default.object.isRequired,
  url: _propTypes2.default.string.isRequired,
  blockKey: _propTypes2.default.string.isRequired,
  entityKey: _propTypes2.default.string.isRequired,
  removeLink: _propTypes2.default.func.isRequired,
  editLink: _propTypes2.default.func.isRequired
};
exports.default = LinkEditComponent;
});

unwrapExports(LinkEditComponent_1);

var blockquotecaption = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './blockquotecaption.scss';

exports.default = function (props) {
  return _react2.default.createElement(
    'cite',
    null,
    _react2.default.createElement(Draft.EditorBlock, props)
  );
};
});

unwrapExports(blockquotecaption);

var caption = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './caption.scss';

exports.default = function (props) {
  return _react2.default.createElement(Draft.EditorBlock, props);
};
});

unwrapExports(caption);

var atomic = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtomicBlock = function AtomicBlock(props) {
  var content = props.getEditorState().getCurrentContent();
  var entity = content.getEntity(props.block.getEntityAt(0));
  var data = entity.getData();
  var type = entity.getType();
  if (type === 'image') {
    return _react2.default.createElement(
      'div',
      { className: 'md-block-atomic-wrapper' },
      _react2.default.createElement('img', { role: 'presentation', src: data.src }),
      _react2.default.createElement(
        'div',
        { className: 'md-block-atomic-controls' },
        _react2.default.createElement(
          'button',
          null,
          '\xD7'
        )
      )
    );
  }
  return _react2.default.createElement(
    'p',
    null,
    'No supported block for ',
    type
  );
};
// import './atomic.scss';

AtomicBlock.propTypes = {
  block: _propTypes2.default.object,
  getEditorState: _propTypes2.default.func
};

exports.default = AtomicBlock;
});

unwrapExports(atomic);

var todo = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import './todo.scss';

var TodoBlock = function (_React$Component) {
  _inherits(TodoBlock, _React$Component);

  function TodoBlock(props) {
    _classCallCheck(this, TodoBlock);

    var _this = _possibleConstructorReturn(this, (TodoBlock.__proto__ || Object.getPrototypeOf(TodoBlock)).call(this, props));

    _this.updateData = _this.updateData.bind(_this);
    return _this;
  }

  _createClass(TodoBlock, [{
    key: 'updateData',
    value: function updateData() {
      var _props = this.props,
          block = _props.block,
          blockProps = _props.blockProps;
      var setEditorState = blockProps.setEditorState,
          getEditorState = blockProps.getEditorState;

      var data = block.getData();
      var checked = data.has('checked') && data.get('checked') === true;
      var newData = data.set('checked', !checked);
      setEditorState((0, model.updateDataOfBlock)(getEditorState(), block, newData));
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.block.getData();
      var checked = data.get('checked') === true;
      return _react2.default.createElement(
        'div',
        { className: checked ? 'block-todo-completed' : '' },
        _react2.default.createElement(
          'span',
          { contentEditable: false },
          _react2.default.createElement('input', { type: 'checkbox', checked: checked, onChange: this.updateData })
        ),
        _react2.default.createElement(Draft.EditorBlock, this.props)
      );
    }
  }]);

  return TodoBlock;
}(_react2.default.Component);

exports.default = TodoBlock;


TodoBlock.propTypes = {
  block: _propTypes2.default.object,
  blockProps: _propTypes2.default.object
};
});

unwrapExports(todo);

var image = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageBlock = function (_React$Component) {
  _inherits(ImageBlock, _React$Component);

  function ImageBlock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageBlock.__proto__ || Object.getPrototypeOf(ImageBlock)).call.apply(_ref, [this].concat(args))), _this), _this.focusBlock = function () {
      var _this$props = _this.props,
          block = _this$props.block,
          blockProps = _this$props.blockProps;
      var getEditorState = blockProps.getEditorState,
          setEditorState = blockProps.setEditorState;

      var key = block.getKey();
      var editorState = getEditorState();
      var currentblock = (0, model.getCurrentBlock)(editorState);
      if (currentblock.getKey() === key) {
        return;
      }
      var newSelection = new Draft.SelectionState({
        anchorKey: key,
        focusKey: key,
        anchorOffset: 0,
        focusOffset: 0
      });
      setEditorState(Draft.EditorState.forceSelection(editorState, newSelection));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          blockProps = _props.blockProps,
          block = _props.block;

      var data = block.getData();
      var src = data.get('src');
      var showPlaceholder = block.getLength() === 0 && blockProps.placeholder;

      if (src !== null) {
        var extraProps = {};

        if (showPlaceholder) {
          extraProps['data-placeholder'] = blockProps.placeholder;
          extraProps.className = 'md-block-image-caption--empty';
        }

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'md-block-image-inner-container', onClick: this.focusBlock },
            _react2.default.createElement('img', { role: 'presentation', src: src })
          ),
          _react2.default.createElement(
            'figcaption',
            extraProps,
            _react2.default.createElement(Draft.EditorBlock, this.props)
          )
        );
      }
      return _react2.default.createElement(Draft.EditorBlock, this.props);
    }
  }]);

  return ImageBlock;
}(_react2.default.Component);

ImageBlock.propTypes = {
  block: _propTypes2.default.object,
  blockProps: _propTypes2.default.object
};
exports.default = ImageBlock;
});

unwrapExports(image);

var _break = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement("hr", { className: "md-block-hr" });
};
});

unwrapExports(_break);

var customrenderer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _blockquotecaption2 = _interopRequireDefault(blockquotecaption);



var _caption2 = _interopRequireDefault(caption);



var _atomic2 = _interopRequireDefault(atomic);



var _todo2 = _interopRequireDefault(todo);



var _image2 = _interopRequireDefault(image);



var _break2 = _interopRequireDefault(_break);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (setEditorState, getEditorState, extraProps) {
  return function (contentBlock) {
    // console.log(editorState, onChange);
    var type = contentBlock.getType();
    switch (type) {
      case constants.Block.BLOCKQUOTE_CAPTION:
        return {
          component: _blockquotecaption2.default
        };
      case constants.Block.CAPTION:
        return {
          component: _caption2.default
        };
      case constants.Block.ATOMIC:
        return {
          component: _atomic2.default,
          editable: false,
          props: {
            getEditorState: getEditorState
          }
        };
      case constants.Block.TODO:
        return {
          component: _todo2.default,
          props: {
            setEditorState: setEditorState,
            getEditorState: getEditorState
          }
        };
      case constants.Block.IMAGE:
        return {
          component: _image2.default,
          props: {
            setEditorState: setEditorState,
            getEditorState: getEditorState,
            placeholder: extraProps ? extraProps.imageCaptionPlaceholder : ''
          }
        };
      case constants.Block.BREAK:
        return {
          component: _break2.default,
          editable: false
        };
      default:
        return null;
    }
  };
};
});

unwrapExports(customrenderer);

var customstylemap = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customStyleMap;



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Custom style map for custom entities like Hihglight.
*/
var customStyleMap = (_customStyleMap = {}, _defineProperty(_customStyleMap, constants.Inline.HIGHLIGHT, {
  backgroundColor: 'yellow'
}), _defineProperty(_customStyleMap, constants.Inline.CODE, {
  fontFamily: 'Consolas, "Liberation Mono", Menlo, Courier, monospace',
  margin: '4px 0',
  fontSize: '0.9em',
  padding: '1px 3px',
  color: '#555',
  backgroundColor: '#fcfcfc',
  border: '1px solid #ccc',
  borderBottomColor: '#bbb',
  borderRadius: 3,
  boxShadow: 'inset 0 -1px 0 #bbb'
}), _customStyleMap);

exports.default = customStyleMap;
});

unwrapExports(customstylemap);

var rendermap = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map;







function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Mapping that returns containers for the various block types.
*/
var RenderMap = (0, immutable.Map)((_Map = {}, _defineProperty(_Map, constants.Block.CAPTION, {
  element: 'cite'
}), _defineProperty(_Map, constants.Block.BLOCKQUOTE_CAPTION, {
  element: 'blockquote'
}), _defineProperty(_Map, constants.Block.TODO, {
  element: 'div'
}), _defineProperty(_Map, constants.Block.IMAGE, {
  element: 'figure'
}), _defineProperty(_Map, constants.Block.BREAK, {
  element: 'div'
}), _Map)).merge(Draft.DefaultDraftBlockRenderMap);

exports.default = RenderMap;
});

unwrapExports(rendermap);

var keybinding = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});





var changeType = constants.KEY_COMMANDS.changeType,
    showLinkInput = constants.KEY_COMMANDS.showLinkInput,
    unlink = constants.KEY_COMMANDS.unlink;

/*
Emits various key commands to be used by `handleKeyCommand` in `Editor` based
on various key combos.
*/

exports.default = function (e) {
  if (Draft.KeyBindingUtil.hasCommandModifier(e) && e.which === 75) {
    if (e.shiftKey) {
      return unlink();
    }
    return showLinkInput();
  }
  if (e.altKey === true && !e.ctrlKey) {
    if (e.shiftKey === true) {
      switch (e.which) {
        // Alt + Shift + A
        // case 65: return addNewBlock();
        default:
          return (0, Draft.getDefaultKeyBinding)(e);
      }
    }
    switch (e.which) {
      // 1
      case 49:
        return changeType('ordered-list-item');
      // @
      case 50:
        return showLinkInput();
      // #
      case 51:
        return changeType('header-three');
      // *
      case 56:
        return changeType('unordered-list-item');
      // <
      case 188:
        return changeType('caption');
      // // -
      // case 189: return 'changetype:caption';
      // >
      case 190:
        return changeType('unstyled');
      // "
      case 222:
        return changeType('blockquote');
      default:
        return (0, Draft.getDefaultKeyBinding)(e);
    }
  }
  // if (e.keyCode === 46 && !e.ctrlKey) {
  //   return KEY_COMMANDS.deleteBlock();
  // }
  return (0, Draft.getDefaultKeyBinding)(e);
};
});

unwrapExports(keybinding);

var beforeinput = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringToTypeMap = undefined;





/*
This is a key value pair where the key is the string that is input while typing.
While typing in an empty block, if the entered text matches any of the keys in
this dictionary, that particular block's type will be changed to the value
associated with that key.
*/
var StringToTypeMap = exports.StringToTypeMap = {
  '--': constants.Block.BLOCKQUOTE + ':' + constants.Block.BLOCKQUOTE_CAPTION + ':' + constants.Block.CAPTION,
  '> ': constants.Block.BLOCKQUOTE,
  '*.': constants.Block.UL,
  '* ': constants.Block.UL,
  '- ': constants.Block.UL,
  '1.': constants.Block.OL,
  '# ': constants.Block.H1,
  '##': constants.Block.H2,
  '==': constants.Block.UNSTYLED,
  '[]': constants.Block.TODO
};

/*
This function is called before text is input in a block in `draft-js`. It checks
whether the input string (first 2 cahracters only) is present in the `StringToTypeMap`
mapping or not. If present, it converts the current block's type and called the `editor`'s
`onChange` function. Otherwise, does nothing. By defualt, the above key-value mapping
is passed. In custom implementation, users can pass their own mapping or extend
the current one.
*/
var beforeInput = function beforeInput(editorState, inputString, onChange) {
  var mapping = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : StringToTypeMap;

  var selection = editorState.getSelection();
  var block = (0, model.getCurrentBlock)(editorState);
  var blockType = block.getType();
  if (blockType.indexOf(constants.Block.ATOMIC) === 0) {
    return constants.NOT_HANDLED;
  }
  var blockLength = block.getLength();
  if (selection.getAnchorOffset() > 1 || blockLength > 1) {
    return constants.NOT_HANDLED;
  }
  var blockTo = mapping[block.getText()[0] + inputString];
  if (!blockTo) {
    return constants.NOT_HANDLED;
  }
  var finalType = blockTo.split(':');
  if (finalType.length < 1 || finalType.length > 3) {
    return constants.NOT_HANDLED;
  }
  var fType = finalType[0];
  if (finalType.length === 1) {
    if (blockType === finalType[0]) {
      return constants.NOT_HANDLED;
    }
  } else if (finalType.length === 2) {
    if (blockType === finalType[1]) {
      return constants.NOT_HANDLED;
    }
    if (blockType === finalType[0]) {
      fType = finalType[1];
    }
  } else if (finalType.length === 3) {
    if (blockType === finalType[2]) {
      return constants.NOT_HANDLED;
    }
    if (blockType === finalType[0]) {
      fType = finalType[1];
    } else {
      fType = finalType[2];
    }
  }
  onChange((0, model.resetBlockWithType)(editorState, fType, {
    text: ''
  }));
  return constants.HANDLED;
};

exports.default = beforeInput;
});

unwrapExports(beforeinput);
var beforeinput_1 = beforeinput.StringToTypeMap;

var blockStyleFn = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



/*
Get custom classnames for each of the different block types supported.
*/

var BASE_BLOCK_CLASS = 'md-block';

exports.default = function (block) {
  switch (block.getType()) {
    case constants.Block.BLOCKQUOTE:
      return BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-quote md-RichEditor-blockquote';
    case constants.Block.UNSTYLED:
      return BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-paragraph';
    case constants.Block.ATOMIC:
      return BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-atomic';
    case constants.Block.CAPTION:
      return BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-caption';
    case constants.Block.TODO:
      {
        var data = block.getData();
        var checkedClass = data.get('checked') === true ? BASE_BLOCK_CLASS + '-todo-checked' : BASE_BLOCK_CLASS + '-todo-unchecked';
        var finalClass = BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-paragraph ';
        finalClass += BASE_BLOCK_CLASS + '-todo ' + checkedClass;
        return finalClass;
      }
    case constants.Block.IMAGE:
      return BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-image';
    case constants.Block.BLOCKQUOTE_CAPTION:
      {
        var cls = BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-quote';
        return cls + ' md-RichEditor-blockquote ' + BASE_BLOCK_CLASS + '-quote-caption';
      }
    case constants.Block.CODE:
      return BASE_BLOCK_CLASS + ' ' + BASE_BLOCK_CLASS + '-code-block';
    default:
      return BASE_BLOCK_CLASS;
  }
};
});

unwrapExports(blockStyleFn);

var image$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageButton = function (_React$Component) {
  _inherits(ImageButton, _React$Component);

  function ImageButton(props) {
    _classCallCheck(this, ImageButton);

    var _this = _possibleConstructorReturn(this, (ImageButton.__proto__ || Object.getPrototypeOf(ImageButton)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(ImageButton, [{
    key: 'onClick',
    value: function onClick() {
      this.input.value = null;
      this.input.click();
    }

    /*
    This is an example of how an image button can be added
    on the side control. This Button handles the image addition locally
    by creating an object url. You can override this method to upload
    images to your server first, then get the image url in return and then
    add to the editor.
    */

  }, {
    key: 'onChange',
    value: function onChange(e) {
      // e.preventDefault();
      var file = e.target.files[0];
      if (file.type.indexOf('image/') === 0) {
        // console.log(this.props.getEditorState());
        // eslint-disable-next-line no-undef
        var src = URL.createObjectURL(file);
        this.props.setEditorState((0, model.addNewBlock)(this.props.getEditorState(), constants.Block.IMAGE, {
          src: src
        }));
      }
      this.props.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'button',
        {
          className: 'md-sb-button md-sb-img-button',
          type: 'button',
          onClick: this.onClick,
          title: 'Add an Image'
        },
        _react2.default.createElement('i', { className: 'fa fa-image' }),
        _react2.default.createElement('input', {
          type: 'file',
          accept: 'image/*',
          ref: function ref(c) {
            _this2.input = c;
          },
          onChange: this.onChange,
          style: { display: 'none' }
        })
      );
    }
  }]);

  return ImageButton;
}(_react2.default.Component);

ImageButton.propTypes = {
  setEditorState: _propTypes2.default.func,
  getEditorState: _propTypes2.default.func,
  close: _propTypes2.default.func
};
exports.default = ImageButton;
});

unwrapExports(image$2);

var editor = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





var _isSoftNewlineEvent2 = _interopRequireDefault(isSoftNewlineEvent_1);





var _addbutton2 = _interopRequireDefault(addbutton);



var _toolbar2 = _interopRequireDefault(toolbar);



var _LinkEditComponent2 = _interopRequireDefault(LinkEditComponent_1);



var _customrenderer2 = _interopRequireDefault(customrenderer);



var _customstylemap2 = _interopRequireDefault(customstylemap);



var _rendermap2 = _interopRequireDefault(rendermap);



var _keybinding2 = _interopRequireDefault(keybinding);





var _beforeinput2 = _interopRequireDefault(beforeinput);



var _blockStyleFn2 = _interopRequireDefault(blockStyleFn);





var _image2 = _interopRequireDefault(image$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
A wrapper over `draft-js`'s default **Editor** component which provides
some built-in customisations like custom blocks (todo, caption, etc) and
some key handling for ease of use so that users' mouse usage is minimum.
*/
var MediumDraftEditor = function (_React$Component) {
  _inherits(MediumDraftEditor, _React$Component);

  function MediumDraftEditor(props) {
    _classCallCheck(this, MediumDraftEditor);

    var _this = _possibleConstructorReturn(this, (MediumDraftEditor.__proto__ || Object.getPrototypeOf(MediumDraftEditor)).call(this, props));

    _this.onUpArrow = function (e) {
      if (_this.props.onUpArrow) {
        _this.props.onUpArrow(e);
        return;
      }

      var editorState = _this.props.editorState;

      var content = editorState.getCurrentContent();
      var selection = editorState.getSelection();
      var key = selection.getAnchorKey();
      var currentBlock = content.getBlockForKey(key);
      var firstBlock = content.getFirstBlock();
      if (firstBlock.getKey() === key) {
        if (firstBlock.getType().indexOf(constants.Block.ATOMIC) === 0) {
          e.preventDefault();
          var newBlock = new Draft.ContentBlock({
            type: constants.Block.UNSTYLED,
            key: (0, Draft.genKey)()
          });
          var newBlockMap = (0, immutable.OrderedMap)([[newBlock.getKey(), newBlock]]).concat(content.getBlockMap());
          var newContent = content.merge({
            blockMap: newBlockMap,
            selectionAfter: selection.merge({
              anchorKey: newBlock.getKey(),
              focusKey: newBlock.getKey(),
              anchorOffset: 0,
              focusOffset: 0,
              isBackward: false
            })
          });
          _this.onChange(Draft.EditorState.push(editorState, newContent, 'insert-characters'));
        }
      } else if (currentBlock.getType().indexOf(constants.Block.ATOMIC) === 0) {
        var blockBefore = content.getBlockBefore(key);
        if (!blockBefore) {
          return;
        }
        e.preventDefault();
        var newSelection = selection.merge({
          anchorKey: blockBefore.getKey(),
          focusKey: blockBefore.getKey(),
          anchorOffset: blockBefore.getLength(),
          focusOffset: blockBefore.getLength(),
          isBackward: false
        });
        _this.onChange(Draft.EditorState.forceSelection(editorState, newSelection));
      }
    };

    _this.onDownArrow = function (e) {
      if (_this.props.onDownArrow) {
        _this.props.onDownArrow(e);
      }
    };

    _this.removeLink = function (blockKey, entityKey) {
      var editorState = _this.props.editorState;

      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(blockKey);
      var oldSelection = editorState.getSelection();
      block.findEntityRanges(function (character) {
        var eKey = character.getEntity();
        return eKey === entityKey;
      }, function (start, end) {
        var selection = new Draft.SelectionState({
          anchorKey: blockKey,
          focusKey: blockKey,
          anchorOffset: start,
          focusOffset: end
        });
        var newEditorState = Draft.EditorState.forceSelection(Draft.RichUtils.toggleLink(editorState, selection, null), oldSelection);
        _this.onChange(newEditorState, _this.focus);
      });
    };

    _this.editLinkAfterSelection = function (blockKey) {
      var entityKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (entityKey === null) {
        return;
      }
      var editorState = _this.props.editorState;

      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(blockKey);
      block.findEntityRanges(function (character) {
        var eKey = character.getEntity();
        return eKey === entityKey;
      }, function (start, end) {
        var selection = new Draft.SelectionState({
          anchorKey: blockKey,
          focusKey: blockKey,
          anchorOffset: start,
          focusOffset: end
        });
        var newEditorState = Draft.EditorState.forceSelection(editorState, selection);
        _this.onChange(newEditorState);
        setTimeout(function () {
          if (_this.toolbar) {
            _this.toolbar.handleLinkInput(null, true);
          }
        }, 100);
      });
    };

    _this.handlePastedText = function (text, html, es) {
      var currentBlock = (0, model.getCurrentBlock)(_this.props.editorState);
      if (currentBlock.getType() === constants.Block.IMAGE) {
        var editorState = _this.props.editorState;

        var content = editorState.getCurrentContent();
        _this.onChange(Draft.EditorState.push(editorState, Draft.Modifier.insertText(content, editorState.getSelection(), text)));
        return constants.HANDLED;
      }
      if (_this.props.handlePastedText && _this.props.handlePastedText(text, html, es) === constants.HANDLED) {
        return constants.HANDLED;
      }
      return constants.NOT_HANDLED;
    };

    _this.focus = function () {
      return _this._editorNode.focus();
    };
    _this.onChange = function (editorState, cb) {
      _this.props.onChange(editorState, cb);
    };

    _this.getEditorState = function () {
      return _this.props.editorState;
    };

    _this.onTab = _this.onTab.bind(_this);
    _this.onUpArrow = _this.onUpArrow.bind(_this);
    _this.onDownArrow = _this.onDownArrow.bind(_this);
    _this.handleKeyCommand = _this.handleKeyCommand.bind(_this);
    _this.handleBeforeInput = _this.handleBeforeInput.bind(_this);
    _this.handleReturn = _this.handleReturn.bind(_this);
    _this.toggleBlockType = _this._toggleBlockType.bind(_this);
    _this.toggleInlineStyle = _this._toggleInlineStyle.bind(_this);
    _this.setLink = _this.setLink.bind(_this);
    _this.blockRendererFn = _this.props.rendererFn(_this.onChange, _this.getEditorState, _this.props);
    return _this;
  }

  /**
   * Implemented to provide nesting of upto 2 levels in ULs or OLs.
   */


  _createClass(MediumDraftEditor, [{
    key: 'onTab',
    value: function onTab(e) {
      if (this.props.onTab) {
        this.props.onTab(e);
        return;
      }
      var editorState = this.props.editorState;

      var newEditorState = Draft.RichUtils.onTab(e, editorState, 2);
      if (newEditorState !== editorState) {
        this.onChange(newEditorState);
      }
    }
  }, {
    key: 'setLink',


    /*
    Adds a hyperlink on the selected text with some basic checks.
    */
    value: function setLink(url) {
      var editorState = this.props.editorState;

      var selection = editorState.getSelection();
      var content = editorState.getCurrentContent();
      var entityKey = null;
      var newUrl = url;
      if (this.props.processURL) {
        newUrl = this.props.processURL(url);
      } else if (url.indexOf('http') !== 0 && url.indexOf('mailto:') !== 0) {
        if (url.indexOf('@') >= 0) {
          newUrl = 'mailto:' + newUrl;
        } else {
          newUrl = 'http://' + newUrl;
        }
      }
      if (newUrl !== '') {
        var contentWithEntity = content.createEntity(constants.Entity.LINK, 'MUTABLE', { url: newUrl });
        editorState = Draft.EditorState.push(editorState, contentWithEntity, 'create-entity');
        entityKey = contentWithEntity.getLastCreatedEntityKey();
      }
      this.onChange(Draft.RichUtils.toggleLink(editorState, selection, entityKey), this.focus);
    }

    /**
     * Override which text modifications are available according BLOCK_BUTTONS style property.
     * Defaults all of them if no toolbarConfig.block passed:
     *   block: ['ordered-list-item', 'unordered-list-item', 'blockquote', 'header-three', 'todo'],
     * Example parameter: toolbarConfig = {
     *   block: ['ordered-list-item', 'unordered-list-item'],
     *   inline: ['BOLD', 'ITALIC', 'UNDERLINE', 'hyperlink'],
     * };
     */

  }, {
    key: 'configureToolbarBlockOptions',
    value: function configureToolbarBlockOptions(toolbarConfig) {
      var blockButtons = this.props.blockButtons;

      return toolbarConfig && toolbarConfig.block ? toolbarConfig.block.map(function (type) {
        return blockButtons.find(function (button) {
          return button.style === type;
        });
      }).filter(function (button) {
        return button !== undefined;
      }) : blockButtons;
    }

    /**
     * Override which text modifications are available according INLINE_BUTTONS style property.
     * CASE SENSITIVE. Would be good clean up to lowercase inline styles consistently.
     * Defaults all of them if no toolbarConfig.inline passed:
     *   inline: ['BOLD', 'ITALIC', 'UNDERLINE', 'hyperlink', 'HIGHLIGHT'],
     * Example parameter: toolbarConfig = {
     *   block: ['ordered-list-item', 'unordered-list-item'],
     *   inline: ['BOLD', 'ITALIC', 'UNDERLINE', 'hyperlink'],
     * };
     */

  }, {
    key: 'configureToolbarInlineOptions',
    value: function configureToolbarInlineOptions(toolbarConfig) {
      var inlineButtons = this.props.inlineButtons;

      return toolbarConfig && toolbarConfig.inline ? toolbarConfig.inline.map(function (type) {
        return inlineButtons.find(function (button) {
          return button.style === type;
        });
      }).filter(function (button) {
        return button !== undefined;
      }) : inlineButtons;
    }

    /*
    Handles custom commands based on various key combinations. First checks
    for some built-in commands. If found, that command's function is apllied and returns.
    If not found, it checks whether parent component handles that command or not.
    Some of the internal commands are:
     - showlinkinput -> Opens up the link input tooltip if some text is selected.
    - add-new-block -> Adds a new block at the current cursor position.
    - changetype:block-type -> If the command starts with `changetype:` and
      then succeeded by the block type, the current block will be converted to that particular type.
    - toggleinline:inline-type -> If the command starts with `toggleinline:` and
      then succeeded by the inline type, the current selection's inline type will be
      togglled.
    */

  }, {
    key: 'handleKeyCommand',
    value: function handleKeyCommand(command) {
      // console.log(command);
      var editorState = this.props.editorState;

      if (this.props.handleKeyCommand) {
        var behaviour = this.props.handleKeyCommand(command);
        if (behaviour === constants.HANDLED || behaviour === true) {
          return constants.HANDLED;
        }
      }
      if (command === constants.KEY_COMMANDS.showLinkInput()) {
        if (!this.props.disableToolbar && this.toolbar) {
          // For some reason, scroll is jumping sometimes for the below code.
          // Debug and fix it later.
          var isCursorLink = (0, model.isCursorBetweenLink)(editorState);
          if (isCursorLink) {
            this.editLinkAfterSelection(isCursorLink.blockKey, isCursorLink.entityKey);
            return constants.HANDLED;
          }
          this.toolbar.handleLinkInput(null, true);
          return constants.HANDLED;
        }
        return constants.NOT_HANDLED;
      } else if (command === constants.KEY_COMMANDS.unlink()) {
        var _isCursorLink = (0, model.isCursorBetweenLink)(editorState);
        if (_isCursorLink) {
          this.removeLink(_isCursorLink.blockKey, _isCursorLink.entityKey);
          return constants.HANDLED;
        }
      }
      /* else if (command === KEY_COMMANDS.addNewBlock()) {
        const { editorState } = this.props;
        this.onChange(addNewBlock(editorState, Block.BLOCKQUOTE));
        return HANDLED;
      } */
      var block = (0, model.getCurrentBlock)(editorState);
      var currentBlockType = block.getType();
      // if (command === KEY_COMMANDS.deleteBlock()) {
      //   if (currentBlockType.indexOf(Block.ATOMIC) === 0 && block.getText().length === 0) {
      //     this.onChange(resetBlockWithType(editorState, Block.UNSTYLED, { text: '' }));
      //     return HANDLED;
      //   }
      //   return NOT_HANDLED;
      // }
      if (command.indexOf('' + constants.KEY_COMMANDS.changeType()) === 0) {
        var newBlockType = command.split(':')[1];
        // const currentBlockType = block.getType();
        if (currentBlockType === constants.Block.ATOMIC) {
          return constants.HANDLED;
        }
        if (currentBlockType === constants.Block.BLOCKQUOTE && newBlockType === constants.Block.CAPTION) {
          newBlockType = constants.Block.BLOCKQUOTE_CAPTION;
        } else if (currentBlockType === constants.Block.BLOCKQUOTE_CAPTION && newBlockType === constants.Block.CAPTION) {
          newBlockType = constants.Block.BLOCKQUOTE;
        }
        this.onChange(Draft.RichUtils.toggleBlockType(editorState, newBlockType));
        return constants.HANDLED;
      } else if (command.indexOf('' + constants.KEY_COMMANDS.toggleInline()) === 0) {
        var inline = command.split(':')[1];
        this._toggleInlineStyle(inline);
        return constants.HANDLED;
      }
      var newState = Draft.RichUtils.handleKeyCommand(editorState, command);
      if (newState) {
        this.onChange(newState);
        return constants.HANDLED;
      }
      return constants.NOT_HANDLED;
    }

    /*
    This function is responsible for emitting various commands based on various key combos.
    */

  }, {
    key: 'handleBeforeInput',
    value: function handleBeforeInput(str) {
      return this.props.beforeInput(this.props.editorState, str, this.onChange, this.props.stringToTypeMap);
    }

    /*
    By default, it handles return key for inserting soft breaks (BRs in HTML) and
    also instead of inserting a new empty block after current empty block, it first check
    whether the current block is of a type other than `unstyled`. If yes, current block is
    simply converted to an unstyled empty block. If RETURN is pressed on an unstyled block
    default behavior is executed.
    */

  }, {
    key: 'handleReturn',
    value: function handleReturn(e) {
      if (this.props.handleReturn) {
        var behavior = this.props.handleReturn(e);
        if (behavior === constants.HANDLED || behavior === true) {
          return constants.HANDLED;
        }
      }
      var editorState = this.props.editorState;

      if ((0, _isSoftNewlineEvent2.default)(e)) {
        this.onChange(Draft.RichUtils.insertSoftNewline(editorState));
        return constants.HANDLED;
      }
      if (!e.altKey && !e.metaKey && !e.ctrlKey) {
        var currentBlock = (0, model.getCurrentBlock)(editorState);
        var blockType = currentBlock.getType();

        if (blockType.indexOf(constants.Block.ATOMIC) === 0) {
          this.onChange((0, model.addNewBlockAt)(editorState, currentBlock.getKey()));
          return constants.HANDLED;
        }

        if (currentBlock.getLength() === 0) {
          switch (blockType) {
            case constants.Block.UL:
            case constants.Block.OL:
            case constants.Block.BLOCKQUOTE:
            case constants.Block.BLOCKQUOTE_CAPTION:
            case constants.Block.CAPTION:
            case constants.Block.TODO:
            case constants.Block.H2:
            case constants.Block.H3:
            case constants.Block.H1:
              this.onChange((0, model.resetBlockWithType)(editorState, constants.Block.UNSTYLED));
              return constants.HANDLED;
            default:
              return constants.NOT_HANDLED;
          }
        }

        var selection = editorState.getSelection();

        if (selection.isCollapsed() && currentBlock.getLength() === selection.getStartOffset()) {
          if (this.props.continuousBlocks.indexOf(blockType) < 0) {
            this.onChange((0, model.addNewBlockAt)(editorState, currentBlock.getKey()));
            return constants.HANDLED;
          }
          return constants.NOT_HANDLED;
        }
        return constants.NOT_HANDLED;
      }
      return constants.NOT_HANDLED;
    }

    /*
    The function documented in `draft-js` to be used to toggle block types (mainly
    for some key combinations handled by default inside draft-js).
    */

  }, {
    key: '_toggleBlockType',
    value: function _toggleBlockType(blockType) {
      var type = Draft.RichUtils.getCurrentBlockType(this.props.editorState);
      if (type.indexOf(constants.Block.ATOMIC + ':') === 0) {
        return;
      }
      this.onChange(Draft.RichUtils.toggleBlockType(this.props.editorState, blockType));
    }

    /*
    The function documented in `draft-js` to be used to toggle inline styles of selection (mainly
    for some key combinations handled by default inside draft-js).
    */

  }, {
    key: '_toggleInlineStyle',
    value: function _toggleInlineStyle(inlineStyle) {
      this.onChange(Draft.RichUtils.toggleInlineStyle(this.props.editorState, inlineStyle));
    }

    /**
     * Handle pasting when cursor is in an image block. Paste the text as the
     * caption. Otherwise, let Draft do its thing.
     */

  }, {
    key: 'render',


    /*
    Renders the `Editor`, `Toolbar` and the side `AddButton`.
    */
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          editorState = _props.editorState,
          editorEnabled = _props.editorEnabled,
          disableToolbar = _props.disableToolbar,
          showLinkEditToolbar = _props.showLinkEditToolbar,
          toolbarConfig = _props.toolbarConfig;

      var showAddButton = editorEnabled;
      var editorClass = 'md-RichEditor-editor' + (!editorEnabled ? ' md-RichEditor-readonly' : '');
      var isCursorLink = false;
      if (editorEnabled && showLinkEditToolbar) {
        isCursorLink = (0, model.isCursorBetweenLink)(editorState);
      }
      var blockButtons = this.configureToolbarBlockOptions(toolbarConfig);
      var inlineButtons = this.configureToolbarInlineOptions(toolbarConfig);
      return _react2.default.createElement(
        'div',
        { className: 'md-RichEditor-root' },
        _react2.default.createElement(
          'div',
          { className: editorClass },
          _react2.default.createElement(Draft.Editor, _extends({
            ref: function ref(node) {
              _this2._editorNode = node;
            }
          }, this.props, {
            editorState: editorState,
            blockRendererFn: this.blockRendererFn,
            blockStyleFn: this.props.blockStyleFn,
            onChange: this.onChange,
            onTab: this.onTab,
            onUpArrow: this.onUpArrow,
            onDownArrow: this.onDownArrow,
            blockRenderMap: this.props.blockRenderMap,
            handleKeyCommand: this.handleKeyCommand,
            handleBeforeInput: this.handleBeforeInput,
            handleReturn: this.handleReturn,
            handlePastedText: this.handlePastedText,
            customStyleMap: this.props.customStyleMap,
            readOnly: !editorEnabled,
            keyBindingFn: this.props.keyBindingFn,
            placeholder: this.props.placeholder,
            spellCheck: editorEnabled && this.props.spellCheck
          })),
          this.props.sideButtons.length > 0 && showAddButton && _react2.default.createElement(_addbutton2.default, {
            editorState: editorState,
            getEditorState: this.getEditorState,
            setEditorState: this.onChange,
            focus: this.focus,
            sideButtons: this.props.sideButtons
          }),
          !disableToolbar && _react2.default.createElement(_toolbar2.default, {
            ref: function ref(c) {
              _this2.toolbar = c;
            },
            editorNode: this._editorNode,
            editorState: editorState,
            toggleBlockType: this.toggleBlockType,
            toggleInlineStyle: this.toggleInlineStyle,
            editorEnabled: editorEnabled,
            setLink: this.setLink,
            focus: this.focus,
            blockButtons: blockButtons,
            inlineButtons: inlineButtons
          }),
          isCursorLink && _react2.default.createElement(_LinkEditComponent2.default, _extends({}, isCursorLink, {
            editorState: editorState,
            removeLink: this.removeLink,
            editLink: this.editLinkAfterSelection
          }))
        )
      );
    }
  }]);

  return MediumDraftEditor;
}(_react2.default.Component);

MediumDraftEditor.propTypes = {
  beforeInput: _propTypes2.default.func,
  keyBindingFn: _propTypes2.default.func,
  customStyleMap: _propTypes2.default.object,
  blockStyleFn: _propTypes2.default.func,
  rendererFn: _propTypes2.default.func,
  editorEnabled: _propTypes2.default.bool,
  spellCheck: _propTypes2.default.bool,
  stringToTypeMap: _propTypes2.default.object,
  blockRenderMap: _propTypes2.default.object,
  blockButtons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.object]),
    style: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    description: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  })),
  inlineButtons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.object]),
    style: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string,
    description: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  })),
  placeholder: _propTypes2.default.string,
  imageCaptionPlaceholder: _propTypes2.default.string,
  continuousBlocks: _propTypes2.default.arrayOf(_propTypes2.default.string),
  sideButtons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired,
    component: _propTypes2.default.func
  })),
  editorState: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onTab: _propTypes2.default.func,
  onUpArrow: _propTypes2.default.func,
  onDownArrow: _propTypes2.default.func,
  handleKeyCommand: _propTypes2.default.func,
  handleReturn: _propTypes2.default.func,
  handlePastedText: _propTypes2.default.func,
  disableToolbar: _propTypes2.default.bool,
  showLinkEditToolbar: _propTypes2.default.bool,
  toolbarConfig: _propTypes2.default.object,
  processURL: _propTypes2.default.func
};
MediumDraftEditor.defaultProps = {
  beforeInput: _beforeinput2.default,
  keyBindingFn: _keybinding2.default,
  customStyleMap: _customstylemap2.default,
  blockStyleFn: _blockStyleFn2.default,
  rendererFn: _customrenderer2.default,
  editorEnabled: true,
  spellCheck: true,
  stringToTypeMap: beforeinput.StringToTypeMap,
  blockRenderMap: _rendermap2.default,
  blockButtons: toolbar.BLOCK_BUTTONS,
  inlineButtons: toolbar.INLINE_BUTTONS,
  placeholder: 'Write your story...',
  imageCaptionPlaceholder: 'Add image caption...',
  continuousBlocks: [constants.Block.UNSTYLED, constants.Block.BLOCKQUOTE, constants.Block.OL, constants.Block.UL, constants.Block.CODE, constants.Block.TODO],
  sideButtons: [{
    title: 'Image',
    component: _image2.default
  }],
  disableToolbar: false,
  showLinkEditToolbar: true,
  toolbarConfig: {}
};
exports.default = MediumDraftEditor;
});

unwrapExports(editor);

var link = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findLinkEntities = undefined;



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findLinkEntities = exports.findLinkEntities = function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === constants.Entity.LINK;
  }, callback);
};

var Link = function Link(props) {
  var contentState = props.contentState,
      entityKey = props.entityKey;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      url = _contentState$getEnti.url;

  return _react2.default.createElement(
    'a',
    {
      className: 'md-link',
      href: url,
      rel: 'noopener noreferrer',
      target: '_blank',
      'aria-label': url
    },
    props.children
  );
};

Link.propTypes = {
  children: _propTypes2.default.node,
  entityKey: _propTypes2.default.string,
  contentState: _propTypes2.default.object.isRequired
};

exports.default = Link;
});

unwrapExports(link);
var link_1 = link.findLinkEntities;

var content = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});





var _link2 = _interopRequireDefault(link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultDecorators = new Draft.CompositeDecorator([{
  strategy: link.findLinkEntities,
  component: _link2.default
}]);

var createEditorState = function createEditorState() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var decorators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDecorators;

  if (content === null) {
    return Draft.EditorState.createEmpty(decorators);
  }
  var contentState = null;
  if (typeof content === 'string') {
    contentState = Draft.ContentState.createFromText(content);
  } else {
    contentState = (0, Draft.convertFromRaw)(content);
  }
  return Draft.EditorState.createWithContent(contentState, decorators);
};

exports.default = createEditorState;
});

unwrapExports(content);

var _break$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _propTypes2 = _interopRequireDefault(_propTypes);



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BreakButton = function (_React$Component) {
  _inherits(BreakButton, _React$Component);

  function BreakButton(props) {
    _classCallCheck(this, BreakButton);

    var _this = _possibleConstructorReturn(this, (BreakButton.__proto__ || Object.getPrototypeOf(BreakButton)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(BreakButton, [{
    key: 'onClick',
    value: function onClick() {
      this.props.setEditorState((0, model.addNewBlock)(this.props.getEditorState(), constants.Block.BREAK));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        { className: 'md-sb-button', onClick: this.onClick, type: 'button' },
        _react2.default.createElement('i', { className: 'fa fa-minus' })
      );
    }
  }]);

  return BreakButton;
}(_react2.default.Component);

exports.default = BreakButton;


BreakButton.propTypes = {
  setEditorState: _propTypes2.default.func,
  getEditorState: _propTypes2.default.func,
  close: _propTypes2.default.func
};
});

unwrapExports(_break$2);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreakSideButton = exports.ImageSideButton = exports.BreakBlock = exports.ImageBlock = exports.TodoBlock = exports.AtomicBlock = exports.CaptionBlock = exports.QuoteCaptionBlock = exports.rendererFn = exports.keyBindingFn = exports.customStyleMap = exports.beforeInput = exports.findLinkEntities = exports.Link = exports.RenderMap = exports.StringToTypeMap = exports.createEditorState = exports.Editor = exports.addNewBlockAt = exports.updateDataOfBlock = exports.resetBlockWithType = exports.addNewBlock = exports.getCurrentBlock = exports.getDefaultBlockData = exports.INLINE_BUTTONS = exports.BLOCK_BUTTONS = exports.NOT_HANDLED = exports.HANDLED = exports.Entity = exports.Inline = exports.Block = undefined;



Object.defineProperty(exports, 'Block', {
  enumerable: true,
  get: function get() {
    return constants.Block;
  }
});
Object.defineProperty(exports, 'Inline', {
  enumerable: true,
  get: function get() {
    return constants.Inline;
  }
});
Object.defineProperty(exports, 'Entity', {
  enumerable: true,
  get: function get() {
    return constants.Entity;
  }
});
Object.defineProperty(exports, 'HANDLED', {
  enumerable: true,
  get: function get() {
    return constants.HANDLED;
  }
});
Object.defineProperty(exports, 'NOT_HANDLED', {
  enumerable: true,
  get: function get() {
    return constants.NOT_HANDLED;
  }
});



Object.defineProperty(exports, 'BLOCK_BUTTONS', {
  enumerable: true,
  get: function get() {
    return toolbar.BLOCK_BUTTONS;
  }
});
Object.defineProperty(exports, 'INLINE_BUTTONS', {
  enumerable: true,
  get: function get() {
    return toolbar.INLINE_BUTTONS;
  }
});



Object.defineProperty(exports, 'getDefaultBlockData', {
  enumerable: true,
  get: function get() {
    return model.getDefaultBlockData;
  }
});
Object.defineProperty(exports, 'getCurrentBlock', {
  enumerable: true,
  get: function get() {
    return model.getCurrentBlock;
  }
});
Object.defineProperty(exports, 'addNewBlock', {
  enumerable: true,
  get: function get() {
    return model.addNewBlock;
  }
});
Object.defineProperty(exports, 'resetBlockWithType', {
  enumerable: true,
  get: function get() {
    return model.resetBlockWithType;
  }
});
Object.defineProperty(exports, 'updateDataOfBlock', {
  enumerable: true,
  get: function get() {
    return model.updateDataOfBlock;
  }
});
Object.defineProperty(exports, 'addNewBlockAt', {
  enumerable: true,
  get: function get() {
    return model.addNewBlockAt;
  }
});



var _editor2 = _interopRequireDefault(editor);



var _beforeinput2 = _interopRequireDefault(beforeinput);



var _rendermap2 = _interopRequireDefault(rendermap);



var _link2 = _interopRequireDefault(link);



var _keybinding2 = _interopRequireDefault(keybinding);



var _customrenderer2 = _interopRequireDefault(customrenderer);



var _customstylemap2 = _interopRequireDefault(customstylemap);



var _content2 = _interopRequireDefault(content);



var _blockquotecaption2 = _interopRequireDefault(blockquotecaption);



var _caption2 = _interopRequireDefault(caption);



var _atomic2 = _interopRequireDefault(atomic);



var _todo2 = _interopRequireDefault(todo);



var _image2 = _interopRequireDefault(image);



var _break2 = _interopRequireDefault(_break);



var _image4 = _interopRequireDefault(image$2);



var _break4 = _interopRequireDefault(_break$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-undef
// export const _version = __VERSION__;

exports.Editor = _editor2.default;
exports.createEditorState = _content2.default;
exports.StringToTypeMap = beforeinput.StringToTypeMap;
exports.RenderMap = _rendermap2.default;
exports.Link = _link2.default;
exports.findLinkEntities = link.findLinkEntities;
exports.beforeInput = _beforeinput2.default;
exports.customStyleMap = _customstylemap2.default;
exports.keyBindingFn = _keybinding2.default;
exports.rendererFn = _customrenderer2.default;
exports.QuoteCaptionBlock = _blockquotecaption2.default;
exports.CaptionBlock = _caption2.default;
exports.AtomicBlock = _atomic2.default;
exports.TodoBlock = _todo2.default;
exports.ImageBlock = _image2.default;
exports.BreakBlock = _break2.default;
exports.ImageSideButton = _image4.default;
exports.BreakSideButton = _break4.default;
exports.default = _editor2.default;
});

unwrapExports(lib);
var lib_1 = lib.BreakSideButton;
var lib_2 = lib.ImageSideButton;
var lib_3 = lib.BreakBlock;
var lib_4 = lib.ImageBlock;
var lib_5 = lib.TodoBlock;
var lib_6 = lib.AtomicBlock;
var lib_7 = lib.CaptionBlock;
var lib_8 = lib.QuoteCaptionBlock;
var lib_9 = lib.rendererFn;
var lib_10 = lib.keyBindingFn;
var lib_11 = lib.customStyleMap;
var lib_12 = lib.beforeInput;
var lib_13 = lib.findLinkEntities;
var lib_14 = lib.Link;
var lib_15 = lib.RenderMap;
var lib_16 = lib.StringToTypeMap;
var lib_17 = lib.createEditorState;
var lib_18 = lib.Editor;
var lib_19 = lib.addNewBlockAt;
var lib_20 = lib.updateDataOfBlock;
var lib_21 = lib.resetBlockWithType;
var lib_22 = lib.addNewBlock;
var lib_23 = lib.getCurrentBlock;
var lib_24 = lib.getDefaultBlockData;
var lib_25 = lib.INLINE_BUTTONS;
var lib_26 = lib.BLOCK_BUTTONS;
var lib_27 = lib.NOT_HANDLED;
var lib_28 = lib.HANDLED;
var lib_29 = lib.Entity;
var lib_30 = lib.Inline;
var lib_31 = lib.Block;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = "production";

var invariant$1 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$1 = invariant$1;

function r(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var u="function"===typeof Symbol&&Symbol.for,ba=u?Symbol.for("react.portal"):60106,v=u?Symbol.for("react.fragment"):60107,ca=u?Symbol.for("react.strict_mode"):60108,da=u?Symbol.for("react.profiler"):60114,w=u?Symbol.for("react.provider"):60109,ea=u?Symbol.for("react.context"):60110,fa=u?Symbol.for("react.concurrent_mode"):60111,ha=u?Symbol.for("react.forward_ref"):60112,B=u?Symbol.for("react.suspense"):60113,ia=u?Symbol.for("react.suspense_list"):60120,ja=u?Symbol.for("react.memo"):60115,ka=u?Symbol.for("react.lazy"):
60116,la=u?Symbol.for("react.block"):60121,ma=u?Symbol.for("react.fundamental"):60117,na=u?Symbol.for("react.scope"):60119;function oa(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default, a._status=1, a._result=c);},function(c){0===a._status&&(a._status=2, a._result=c);});}}
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case v:return"Fragment";case ba:return"Portal";case da:return"Profiler";case ca:return"StrictMode";case B:return"Suspense";case ia:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ea:return"Context.Consumer";case w:return"Context.Provider";case ha:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ja:return C(a.type);case la:return C(a.render);case ka:if(a=1===a._status?a._result:null)return C(a)}return null}var D=React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var pa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2, a._threadCount=c+1;}
function qa(a,b,c,d){if(d&&(d=a.contextType, "object"===typeof d&&null!==d))return E(d,c), d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c;}else b=pa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var ra=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,sa=Object.prototype.hasOwnProperty,ta={},ua={};
function va(a){if(sa.call(ua,a))return!0;if(sa.call(ta,a))return!1;if(ra.test(a))return ua[a]=!0;ta[a]=!0;return!1}function wa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function xa(a,b,c,d){if(null===b||"undefined"===typeof b||wa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,h){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=h;}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1);});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1);});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1);});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1);});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1);});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1);});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1);});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1);});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0);});var ya=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ya.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b;}a=f!==d?c+a.substring(f,d):c;}return a}
function za(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||xa(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return va(a)?a+'="'+(N(b)+'"'):""}function Aa(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Ba="function"===typeof Object.is?Object.is:Aa,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(r(321));return O}function Ca(){if(0<V)throw Error(r(312));return{memoizedState:null,queue:null,next:null}}function Da(){null===Q?null===P?(R=!1, P=Q=Ca()):(R=!0, Q=P):null===Q.next?(R=!1, Q=Q.next=Ca()):(R=!0, Q=Q.next);return Q}function Ea(a,b,c,d){for(;S;)S=!1, V+=1, Q=null, c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Fa(a,b){return"function"===typeof b?b(a):b}
function Ga(a,b,c){O=W();Q=Da();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d), void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action), c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Fa?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ha.bind(null,O,a);return[Q.memoizedState,a]}
function Ha(a,b,c){if(!(25>V))throw Error(r(301));if(a===O)if(S=!0, a={action:c,next:null}, null===U&&(U=new Map), c=U.get(b), void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a;}}function Ia(){}
var X=0,Ja={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Da();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Ba(b[f],d[f])){d=!1;break a}d=!0;}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ga,useRef:function(a){O=W();Q=Da();var b=Q.memoizedState;return null===b?(a={current:a}, Q.memoizedState=
a):b},useState:function(a){return Ga(Fa,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ia,useEffect:Ia,useDebugValue:Ia,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a();},!1]}},Ka={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function La(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Ma={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Na=objectAssign({menuitem:!0},Ma),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Oa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Oa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a];});});
var Pa=/([A-Z])/g,Qa=/^ms-/,Z=React__default.Children.toArray,Ra=D.ReactCurrentDispatcher,Sa={listing:!0,pre:!0,textarea:!0},Ta=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ua={},Va={};function Wa(a){if(void 0===a||null===a)return a;var b="";React__default.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}var Xa=Object.prototype.hasOwnProperty,Ya={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Za(a,b){if(void 0===a)throw Error(r(152,C(b)||"Component"));}
function $a(a,b,c){function d(d,h){var e=h.prototype&&h.prototype.isReactComponent,f=qa(h,b,c,e),p=[],g=!1,l={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===p)return null},enqueueReplaceState:function(a,c){g=!0;p=[c];},enqueueSetState:function(a,c){if(null===p)return null;p.push(c);}};if(e){if(e=new h(d.props,f,l), "function"===typeof h.getDerivedStateFromProps){var x=h.getDerivedStateFromProps.call(null,d.props,e.state);null!=x&&(e.state=objectAssign({},e.state,x));}}else if(O={}, e=h(d.props,
f,l), e=Ea(h,d.props,e,f), null==e||null==e.render){a=e;Za(a,h);return}e.props=d.props;e.context=f;e.updater=l;l=e.state;void 0===l&&(e.state=l=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.componentWillMount(), "function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(), p.length){l=p;var t=
g;p=null;g=!1;if(t&&1===l.length)e.state=l[0];else{x=t?l[0]:e.state;var y=!0;for(t=t?1:0;t<l.length;t++){var q=l[t];q="function"===typeof q?q.call(e,x,d.props,f):q;null!=q&&(y?(y=!1, x=objectAssign({},x,q)):objectAssign(x,q));}e.state=x;}}else p=null;a=e.render();Za(a,h);if("function"===typeof e.getChildContext&&(d=h.childContextTypes, "object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(r(108,C(h)||"Unknown",T));}A&&(b=objectAssign({},b,A));}for(;React__default.isValidElement(a);){var f=a,h=f.type;if("function"!==
typeof h)break;d(f,h);}return{child:a,context:b}}
var ab=function(){function a(a,b){React__default.isValidElement(a)?a.type!==v?a=[a]:(a=a.props.children, a=React__default.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ka.html,children:a,childIndex:0,context:pa,footer:""};var c=F[0];if(0===c){var d=F;c=d.length;var p=2*c;if(!(65536>=p))throw Error(r(304));var g=new Uint16Array(p);g.set(d);F=g;F[0]=c+1;for(d=c;d<p-1;d++)F[d]=d+1;F[p-1]=0;}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[];}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a;}};b.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,h=this.threadID;E(c,h);var p=c[h];this.contextStack[b]=c;this.contextValueStack[b]=p;c[h]=a.props.value;};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f;};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a];};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ra.current;Ra.current=Ja;try{for(var h=[""],p=!1;h[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var g=this.threadID;F[g]=F[0];F[0]=g;break}var e=this.stack[this.stack.length-1];if(p||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=h.pop();if(p){p=!1;var n=e.fallbackFrame;if(!n)throw Error(r(303));this.stack.push(n);h[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else h[this.suspenseDepth]+=G;}h[this.suspenseDepth]+=I;}else{var l=e.children[e.childIndex++],
x="";try{x+=this.render(l,e.context,e.domNamespace);}catch(t){if(null!=t&&"function"===typeof t.then)throw Error(r(294));throw t;}finally{}h.length<=this.suspenseDepth&&h.push("");h[this.suspenseDepth]+=x;}}return h[0]}finally{Ra.current=c, X=b;}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=$a(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!React__default.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===ba)throw Error(r(257));throw Error(r(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ca:case fa:case da:case ia:case v:return a=Z(a.props.children), this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}), "";case B:throw Error(r(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case ha:O={};var d=c.render(a.props,a.ref);d=Ea(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ja:return a=[React__default.createElement(c.type,objectAssign({ref:a.ref},a.props))], this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}), "";case w:return c=Z(a.props.children), f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""}, this.pushProvider(a), this.stack.push(f), "";case ea:c=a.type;d=a.props;var g=this.threadID;E(c,g);c=Z(d.children(c[g]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ma:throw Error(r(338));case ka:switch(c=a.type, oa(c), c._status){case 1:return a=[React__default.createElement(c._result,objectAssign({ref:a.ref},a.props))], this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}), "";case 2:throw c._result;default:throw Error(r(295));
}case na:throw Error(r(343));}throw Error(r(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();if(!Ua.hasOwnProperty(c)){if(!Ta.test(c))throw Error(r(65,c));Ua[c]=!0;}var d=a.props;if("input"===c)d=objectAssign({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var g=d.value;if(null==g){g=d.defaultValue;var e=d.children;if(null!=e){if(null!=
g)throw Error(r(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(r(93));e=e[0];}g=""+e;}null==g&&(g="");}d=objectAssign({},d,{value:void 0,children:""+g});}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue, d=objectAssign({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Wa(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;g=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){g=!0;break}}else g=""+e===G;d=objectAssign({selected:void 0,children:void 0},
d,{selected:g,children:I});}}if(g=d){if(Na[c]&&(null!=g.children||null!=g.dangerouslySetInnerHTML))throw Error(r(137,c,""));if(null!=g.dangerouslySetInnerHTML){if(null!=g.children)throw Error(r(60));if(!("object"===typeof g.dangerouslySetInnerHTML&&"__html"in g.dangerouslySetInnerHTML))throw Error(r(61));}if(null!=g.style&&"object"!==typeof g.style)throw Error(r(62,""));}g=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in g)if(Xa.call(g,z)){var l=g[z];if(null!=l){if("style"===
z){n=void 0;var x="",t="";for(n in l)if(l.hasOwnProperty(n)){var y=0===n.indexOf("--"),q=l[n];if(null!=q){if(y)var A=n;else if(A=n, Va.hasOwnProperty(A))A=Va[A];else{var T=A.replace(Pa,"-$1").toLowerCase().replace(Qa,"-ms-");A=Va[A]=T;}x+=t+A+":";t=n;y=null==q||"boolean"===typeof q||""===q?"":y||"number"!==typeof q||0===q||Y.hasOwnProperty(t)&&Y[t]?(""+q).trim():q+"px";x+=y;t=";";}}l=x||null;}n=null;b:if(y=c, q=g, -1===y.indexOf("-"))y="string"===typeof q.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0;}y?Ya.hasOwnProperty(z)||(n=z, n=va(n)&&null!=l?n+'="'+(N(l)+'"'):""):n=za(z,l);n&&(G+=" "+n);}}e||I&&(G+=' data-reactroot=""');var z=G;g="";Ma.hasOwnProperty(c)?z+="/>":(z+=">", g="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children, "string"===typeof e||"number"===typeof e){e=N(e);break a}e=null;}null!=e?(d=[], Sa.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"), z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?La(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:g});this.previousWasTextNode=!1;return z};return a}();function bb(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a;a.__proto__=b;}
var cb=function(a){function b(b,c){var d=a.call(this,{})||this;d.partialRenderer=new ab(b,c);return d}bb(b,a);var c=b.prototype;c._destroy=function(a,b){this.partialRenderer.destroy();b(a);};c._read=function(a){try{this.push(this.partialRenderer.read(a));}catch(f){this.destroy(f);}};return b}(stream.Readable),db={renderToString:function(a){a=new ab(a,!1);try{return a.read(Infinity)}finally{a.destroy();}},renderToStaticMarkup:function(a){a=new ab(a,!0);try{return a.read(Infinity)}finally{a.destroy();}},renderToNodeStream:function(a){return new cb(a,
!1)},renderToStaticNodeStream:function(a){return new cb(a,!0)},version:"16.14.0"};var reactDomServer_node_production_min=db.default||db;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var reactDomServer_node_development = createCommonjsModule(function (module) {
});

var server_node = createCommonjsModule(function (module) {

{
  module.exports = reactDomServer_node_production_min;
}
});

var server = server_node;

var updateMutation_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateMutation;

function updateMutation(mutation, originalOffset, originalLength, newLength, prefixLength, suffixLength) {
  // three cases we can reasonably adjust - disjoint mutations that
  // happen later on where the offset will need to be changed,
  // mutations that completely contain the new one where we can adjust
  // the length, and mutations that occur partially within the new one.
  var lengthDiff = newLength - originalLength;
  var mutationAfterChange = originalOffset + originalLength <= mutation.offset;

  if (mutationAfterChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + lengthDiff
    });
  }

  var mutationContainsChange = originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length;

  if (mutationContainsChange) {
    return Object.assign({}, mutation, {
      length: mutation.length + lengthDiff
    });
  }

  var mutationWithinPrefixChange = mutation.offset >= originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && prefixLength > 0;

  if (mutationWithinPrefixChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength
    });
  }

  var mutationContainsPrefix = mutation.offset < originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && mutation.offset + mutation.length > originalOffset && prefixLength > 0;

  if (mutationContainsPrefix) {
    return [Object.assign({}, mutation, {
      length: originalOffset - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + prefixLength,
      length: mutation.offset - originalOffset + mutation.length
    })];
  }

  var mutationContainsSuffix = mutation.offset >= originalOffset && mutation.offset + mutation.length > originalOffset + originalLength && originalOffset + originalLength > mutation.offset && suffixLength > 0;

  if (mutationContainsSuffix) {
    return [Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength,
      length: originalOffset + originalLength - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + originalLength + prefixLength + suffixLength,
      length: mutation.offset + mutation.length - (originalOffset + originalLength)
    })];
  }

  return mutation;
}
});

unwrapExports(updateMutation_1);

var rangeSort = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(r1, r2) {
  if (r1.offset === r2.offset) {
    return r2.length - r1.length;
  }

  return r1.offset - r2.offset;
};

exports["default"] = _default;
});

unwrapExports(rangeSort);

var encodeBlock = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _updateMutation = _interopRequireDefault(updateMutation_1);

var _rangeSort = _interopRequireDefault(rangeSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var ENTITY_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '\n': '<br/>'
};

var _default = function _default(block) {
  var blockText = _toConsumableArray(block.text);

  var entities = block.entityRanges.sort(_rangeSort["default"]);
  var styles = block.inlineStyleRanges.sort(_rangeSort["default"]);
  var resultText = '';

  var _loop = function _loop(index) {
    var _char = blockText[index];

    if (ENTITY_MAP[_char] !== undefined) {
      var encoded = ENTITY_MAP[_char];

      var resultIndex = _toConsumableArray(resultText).length;

      resultText += encoded;

      var updateForChar = function updateForChar(mutation) {
        return (0, _updateMutation["default"])(mutation, resultIndex, _char.length, encoded.length, 0, 0);
      };

      entities = entities.map(updateForChar);
      styles = styles.map(updateForChar);
    } else {
      resultText += _char;
    }
  };

  for (var index = 0; index < blockText.length; index++) {
    _loop(index);
  }

  return Object.assign({}, block, {
    text: resultText,
    inlineStyleRanges: styles,
    entityRanges: entities
  });
};

exports["default"] = _default;
});

unwrapExports(encodeBlock);

var splitReactElement_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = splitReactElement;

var _invariant = _interopRequireDefault(invariant_1$1);

var _react = _interopRequireDefault(React__default);

var _server = _interopRequireDefault(server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// see http://w3c.github.io/html/syntax.html#writing-html-documents-elements
var VOID_TAGS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

function splitReactElement(element) {
  if (VOID_TAGS.indexOf(element.type) !== -1) {
    return _server["default"].renderToStaticMarkup(element);
  }

  var tags = _server["default"].renderToStaticMarkup(_react["default"].cloneElement(element, {}, '\r')).split('\r');

  (0, _invariant["default"])(tags.length > 1, "convertToHTML: Element of type ".concat(element.type, " must render children"));
  (0, _invariant["default"])(tags.length < 3, "convertToHTML: Element of type ".concat(element.type, " cannot use carriage return character"));
  return {
    start: tags[0],
    end: tags[1]
  };
}
});

unwrapExports(splitReactElement_1);

var getElementHTML_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getElementHTML;

var _invariant = _interopRequireDefault(invariant_1$1);

var _react = _interopRequireDefault(React__default);

var _server = _interopRequireDefault(server);

var _splitReactElement = _interopRequireDefault(splitReactElement_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function hasChildren(element) {
  return _react["default"].isValidElement(element) && _react["default"].Children.count(element.props.children) > 0;
}

function getElementHTML(element) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (element === undefined || element === null) {
    return element;
  }

  if (typeof element === 'string') {
    return element;
  }

  if (_react["default"].isValidElement(element)) {
    if (hasChildren(element)) {
      return _server["default"].renderToStaticMarkup(element);
    }

    var tags = (0, _splitReactElement["default"])(element);

    if (text !== null && _typeof(tags) === 'object') {
      var start = tags.start,
          end = tags.end;
      return start + text + end;
    }

    return tags;
  }

  (0, _invariant["default"])(Object.prototype.hasOwnProperty.call(element, 'start') && Object.prototype.hasOwnProperty.call(element, 'end'), 'convertToHTML: received conversion data without either an HTML string, ReactElement or an object with start/end tags');

  if (text !== null) {
    var _start = element.start,
        _end = element.end;
    return _start + text + _end;
  }

  return element;
}
});

unwrapExports(getElementHTML_1);

var getElementTagLength_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React__default);

var _splitReactElement = _interopRequireDefault(splitReactElement_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var getElementTagLength = function getElementTagLength(element) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';

  if (_react["default"].isValidElement(element)) {
    var splitElement = (0, _splitReactElement["default"])(element);

    if (typeof splitElement === 'string') {
      return 0;
    }

    var length = splitElement[type].length;

    var child = _react["default"].Children.toArray(element.props.children)[0];

    return length + (child && _react["default"].isValidElement(child) ? getElementTagLength(child, type) : 0);
  }

  if (_typeof(element) === 'object') {
    return element[type] ? element[type].length : 0;
  }

  return 0;
};

var _default = getElementTagLength;
exports["default"] = _default;
});

unwrapExports(getElementTagLength_1);

var blockEntities = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _updateMutation = _interopRequireDefault(updateMutation_1);

var _rangeSort = _interopRequireDefault(rangeSort);

var _getElementHTML = _interopRequireDefault(getElementHTML_1);

var _getElementTagLength = _interopRequireDefault(getElementTagLength_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var converter = function converter() {
  var originalText = arguments.length > 1 ? arguments[1] : undefined;
  return originalText;
};

var _default = function _default(block, entityMap) {
  var entityConverter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : converter;

  var resultText = _toConsumableArray(block.text);

  var getEntityHTML = entityConverter;

  if (entityConverter.__isMiddleware) {
    getEntityHTML = entityConverter(converter);
  }

  if (Object.prototype.hasOwnProperty.call(block, 'entityRanges') && block.entityRanges.length > 0) {
    var entities = block.entityRanges.sort(_rangeSort["default"]);
    var styles = block.inlineStyleRanges;

    var _loop = function _loop(index) {
      var entityRange = entities[index];
      var entity = entityMap[entityRange.key];
      var originalText = resultText.slice(entityRange.offset, entityRange.offset + entityRange.length).join('');
      var entityHTML = getEntityHTML(entity, originalText);

      var converted = _toConsumableArray((0, _getElementHTML["default"])(entityHTML, originalText) || originalText);

      var prefixLength = (0, _getElementTagLength["default"])(entityHTML, 'start');
      var suffixLength = (0, _getElementTagLength["default"])(entityHTML, 'end');

      var updateLaterMutation = function updateLaterMutation(mutation, mutationIndex) {
        if (mutationIndex > index || Object.prototype.hasOwnProperty.call(mutation, 'style')) {
          return (0, _updateMutation["default"])(mutation, entityRange.offset, entityRange.length, converted.length, prefixLength, suffixLength);
        }

        return mutation;
      };

      var updateLaterMutations = function updateLaterMutations(mutationList) {
        return mutationList.reduce(function (acc, mutation, mutationIndex) {
          var updatedMutation = updateLaterMutation(mutation, mutationIndex);

          if (Array.isArray(updatedMutation)) {
            return acc.concat(updatedMutation);
          }

          return acc.concat([updatedMutation]);
        }, []);
      };

      entities = updateLaterMutations(entities);
      styles = updateLaterMutations(styles);
      resultText = [].concat(_toConsumableArray(resultText.slice(0, entityRange.offset)), _toConsumableArray(converted), _toConsumableArray(resultText.slice(entityRange.offset + entityRange.length)));
    };

    for (var index = 0; index < entities.length; index++) {
      _loop(index);
    }

    return Object.assign({}, block, {
      text: resultText.join(''),
      inlineStyleRanges: styles,
      entityRanges: entities
    });
  }

  return block;
};

exports["default"] = _default;
});

unwrapExports(blockEntities);

var styleObjectFunction = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
};

exports["default"] = _default;
});

unwrapExports(styleObjectFunction);

var accumulateFunction = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(newFn, rest) {
  return function () {
    var newResult = newFn.apply(void 0, arguments);

    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(void 0, arguments);
  };
};

exports["default"] = _default;
});

unwrapExports(accumulateFunction);

var defaultInlineHTML_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultInlineHTML;

var _react = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function defaultInlineHTML(style) {
  switch (style) {
    case 'BOLD':
      return _react["default"].createElement("strong", null);

    case 'ITALIC':
      return _react["default"].createElement("em", null);

    case 'UNDERLINE':
      return _react["default"].createElement("u", null);

    case 'CODE':
      return _react["default"].createElement("code", null);

    default:
      return {
        start: '',
        end: ''
      };
  }
}
});

unwrapExports(defaultInlineHTML_1);

var blockInlineStyles = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _invariant = _interopRequireDefault(invariant_1$1);

var _styleObjectFunction = _interopRequireDefault(styleObjectFunction);

var _accumulateFunction = _interopRequireDefault(accumulateFunction);

var _getElementHTML = _interopRequireDefault(getElementHTML_1);

var _rangeSort = _interopRequireDefault(rangeSort);

var _defaultInlineHTML = _interopRequireDefault(defaultInlineHTML_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var subtractStyles = function subtractStyles(original, toRemove) {
  return original.filter(function (el) {
    return !toRemove.some(function (elToRemove) {
      return elToRemove.style === el.style;
    });
  });
};

var popEndingStyles = function popEndingStyles(styleStack, endingStyles) {
  return endingStyles.reduceRight(function (stack, style) {
    var styleToRemove = stack[stack.length - 1];
    (0, _invariant["default"])(styleToRemove.style === style.style, "Style ".concat(styleToRemove.style, " to be removed doesn't match expected ").concat(style.style));
    return stack.slice(0, -1);
  }, styleStack);
};

var characterStyles = function characterStyles(offset, ranges) {
  return ranges.filter(function (range) {
    return offset >= range.offset && offset < range.offset + range.length;
  });
};

var rangeIsSubset = function rangeIsSubset(firstRange, secondRange) {
  // returns true if the second range is a subset of the first
  var secondStartWithinFirst = firstRange.offset <= secondRange.offset;
  var secondEndWithinFirst = firstRange.offset + firstRange.length >= secondRange.offset + secondRange.length;
  return secondStartWithinFirst && secondEndWithinFirst;
};

var latestStyleLast = function latestStyleLast(s1, s2) {
  // make sure longer-lasting styles are added first
  var s2endIndex = s2.offset + s2.length;
  var s1endIndex = s1.offset + s1.length;
  return s2endIndex - s1endIndex;
};

var getStylesToReset = function getStylesToReset(remainingStyles, newStyles) {
  var i = 0;

  while (i < remainingStyles.length) {
    if (newStyles.every(rangeIsSubset.bind(null, remainingStyles[i]))) {
      i++;
    } else {
      return remainingStyles.slice(i);
    }
  }

  return [];
};

var appendStartMarkup = function appendStartMarkup(inlineHTML, string, styleRange) {
  return string + (0, _getElementHTML["default"])(inlineHTML(styleRange.style)).start;
};

var prependEndMarkup = function prependEndMarkup(inlineHTML, string, styleRange) {
  return (0, _getElementHTML["default"])(inlineHTML(styleRange.style)).end + string;
};

var defaultCustomInlineHTML = function defaultCustomInlineHTML(next) {
  return function (style) {
    return next(style);
  };
};

defaultCustomInlineHTML.__isMiddleware = true;

var _default = function _default(rawBlock) {
  var customInlineHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomInlineHTML;
  (0, _invariant["default"])(rawBlock !== null && rawBlock !== undefined, 'Expected raw block to be non-null');
  var inlineHTML;

  if (customInlineHTML.__isMiddleware === true) {
    inlineHTML = customInlineHTML(_defaultInlineHTML["default"]);
  } else {
    inlineHTML = (0, _accumulateFunction["default"])((0, _styleObjectFunction["default"])(customInlineHTML), (0, _styleObjectFunction["default"])(_defaultInlineHTML["default"]));
  }

  var result = '';
  var styleStack = [];
  var sortedRanges = rawBlock.inlineStyleRanges.sort(_rangeSort["default"]);

  var originalTextArray = _toConsumableArray(rawBlock.text);

  for (var i = 0; i < originalTextArray.length; i++) {
    var styles = characterStyles(i, sortedRanges);
    var endingStyles = subtractStyles(styleStack, styles);
    var newStyles = subtractStyles(styles, styleStack);
    var remainingStyles = subtractStyles(styleStack, endingStyles); // reset styles: look for any already existing styles that will need to
    // end before styles that are being added on this character. to solve this
    // close out those current tags and all nested children,
    // then open new ones nested within the new styles.

    var resetStyles = getStylesToReset(remainingStyles, newStyles);
    var openingStyles = resetStyles.concat(newStyles).sort(latestStyleLast);
    var openingStyleTags = openingStyles.reduce(appendStartMarkup.bind(null, inlineHTML), '');
    var endingStyleTags = endingStyles.concat(resetStyles).reduce(prependEndMarkup.bind(null, inlineHTML), '');
    result += endingStyleTags + openingStyleTags + originalTextArray[i];
    styleStack = popEndingStyles(styleStack, resetStyles.concat(endingStyles));
    styleStack = styleStack.concat(openingStyles);
    (0, _invariant["default"])(styleStack.length === styles.length, "Character ".concat(i, ": ").concat(styleStack.length - styles.length, " styles left on stack that should no longer be there"));
  }

  result = styleStack.reduceRight(function (res, openStyle) {
    return res + (0, _getElementHTML["default"])(inlineHTML(openStyle.style)).end;
  }, result);
  return result;
};

exports["default"] = _default;
});

unwrapExports(blockInlineStyles);

var blockTypeObjectFunction = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(typeObject) {
  return function (block) {
    if (typeof typeObject === 'function') {
      // handle case where typeObject is already a function
      return typeObject(block);
    }

    return typeObject[block.type];
  };
};

exports["default"] = _default;
});

unwrapExports(blockTypeObjectFunction);

var getBlockTags_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getBlockTags;

var _invariant = _interopRequireDefault(invariant_1$1);

var _react = _interopRequireDefault(React__default);

var _server = _interopRequireDefault(server);

var _splitReactElement = _interopRequireDefault(splitReactElement_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function hasChildren(element) {
  return _react["default"].isValidElement(element) && _react["default"].Children.count(element.props.children) > 0;
}

function getBlockTags(blockHTML) {
  (0, _invariant["default"])(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (typeof blockHTML === 'string') {
    return blockHTML;
  }

  if (_react["default"].isValidElement(blockHTML)) {
    if (hasChildren(blockHTML)) {
      return _server["default"].renderToStaticMarkup(blockHTML);
    }

    return (0, _splitReactElement["default"])(blockHTML);
  }

  if (Object.prototype.hasOwnProperty.call(blockHTML, 'element') && _react["default"].isValidElement(blockHTML.element)) {
    return Object.assign({}, blockHTML, (0, _splitReactElement["default"])(blockHTML.element));
  }

  (0, _invariant["default"])(Object.prototype.hasOwnProperty.call(blockHTML, 'start') && Object.prototype.hasOwnProperty.call(blockHTML, 'end'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
  return blockHTML;
}
});

unwrapExports(getBlockTags_1);

var getNestedBlockTags_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNestedBlockTags;

var _invariant = _interopRequireDefault(invariant_1$1);

var _react = _interopRequireDefault(React__default);

var _splitReactElement2 = _interopRequireDefault(splitReactElement_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getNestedBlockTags(blockHTML) {
  (0, _invariant["default"])(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (_react["default"].isValidElement(blockHTML.nest)) {
    var _splitReactElement = (0, _splitReactElement2["default"])(blockHTML.nest),
        start = _splitReactElement.start,
        end = _splitReactElement.end;

    return Object.assign({}, blockHTML, {
      nestStart: start,
      nestEnd: end
    });
  }

  (0, _invariant["default"])(Object.prototype.hasOwnProperty.call(blockHTML, 'nestStart') && Object.prototype.hasOwnProperty.call(blockHTML, 'nestEnd'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');
  return blockHTML;
}
});

unwrapExports(getNestedBlockTags_1);

var defaultBlockHTML = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  unstyled: _react["default"].createElement("p", null),
  paragraph: _react["default"].createElement("p", null),
  'header-one': _react["default"].createElement("h1", null),
  'header-two': _react["default"].createElement("h2", null),
  'header-three': _react["default"].createElement("h3", null),
  'header-four': _react["default"].createElement("h4", null),
  'header-five': _react["default"].createElement("h5", null),
  'header-six': _react["default"].createElement("h6", null),
  blockquote: _react["default"].createElement("blockquote", null),
  'unordered-list-item': {
    element: _react["default"].createElement("li", null),
    nest: _react["default"].createElement("ul", null)
  },
  'ordered-list-item': {
    element: _react["default"].createElement("li", null),
    nest: _react["default"].createElement("ol", null)
  },
  media: _react["default"].createElement("figure", null),
  atomic: _react["default"].createElement("figure", null)
};
exports["default"] = _default;
});

unwrapExports(defaultBlockHTML);

var convertToHTML_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _invariant = _interopRequireDefault(invariant_1$1);

var _react = _interopRequireDefault(React__default);

var _server = _interopRequireDefault(server);



var _encodeBlock = _interopRequireDefault(encodeBlock);

var _blockEntities = _interopRequireDefault(blockEntities);

var _blockInlineStyles = _interopRequireDefault(blockInlineStyles);

var _accumulateFunction = _interopRequireDefault(accumulateFunction);

var _blockTypeObjectFunction = _interopRequireDefault(blockTypeObjectFunction);

var _getBlockTags = _interopRequireDefault(getBlockTags_1);

var _getNestedBlockTags = _interopRequireDefault(getNestedBlockTags_1);

var _defaultBlockHTML = _interopRequireDefault(defaultBlockHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import Immutable from 'immutable'; // eslint-disable-line no-unused-vars
var defaultEntityToHTML = function defaultEntityToHTML(entity, originalText) {
  return originalText;
};

var convertToHTML = function convertToHTML(_ref) {
  var _ref$styleToHTML = _ref.styleToHTML,
      styleToHTML = _ref$styleToHTML === void 0 ? {} : _ref$styleToHTML,
      _ref$blockToHTML = _ref.blockToHTML,
      blockToHTML = _ref$blockToHTML === void 0 ? {} : _ref$blockToHTML,
      _ref$entityToHTML = _ref.entityToHTML,
      entityToHTML = _ref$entityToHTML === void 0 ? defaultEntityToHTML : _ref$entityToHTML;
  return function (contentState) {
    (0, _invariant["default"])(contentState !== null && contentState !== undefined, 'Expected contentState to be non-null');
    var getBlockHTML;

    if (blockToHTML.__isMiddleware === true) {
      getBlockHTML = blockToHTML((0, _blockTypeObjectFunction["default"])(_defaultBlockHTML["default"]));
    } else {
      getBlockHTML = (0, _accumulateFunction["default"])((0, _blockTypeObjectFunction["default"])(blockToHTML), (0, _blockTypeObjectFunction["default"])(_defaultBlockHTML["default"]));
    }

    var rawState = (0, Draft.convertToRaw)(contentState);
    var listStack = [];
    var result = rawState.blocks.map(function (block) {
      var type = block.type,
          depth = block.depth;
      var closeNestTags = '';
      var openNestTags = '';
      var blockHTMLResult = getBlockHTML(block);

      if (!blockHTMLResult) {
        throw new Error("convertToHTML: missing HTML definition for block with type ".concat(block.type));
      }

      if (!blockHTMLResult.nest) {
        // this block can't be nested, so reset all nesting if necessary
        closeNestTags = listStack.reduceRight(function (string, nestedBlock) {
          return string + (0, _getNestedBlockTags["default"])(getBlockHTML(nestedBlock)).nestEnd;
        }, '');
        listStack = [];
      } else {
        while (depth + 1 !== listStack.length || type !== listStack[depth].type) {
          if (depth + 1 === listStack.length) {
            // depth is right but doesn't match type
            var blockToClose = listStack[depth];
            closeNestTags += (0, _getNestedBlockTags["default"])(getBlockHTML(blockToClose)).nestEnd;
            openNestTags += (0, _getNestedBlockTags["default"])(getBlockHTML(block)).nestStart;
            listStack[depth] = block;
          } else if (depth + 1 < listStack.length) {
            var _blockToClose = listStack[listStack.length - 1];
            closeNestTags += (0, _getNestedBlockTags["default"])(getBlockHTML(_blockToClose)).nestEnd;
            listStack = listStack.slice(0, -1);
          } else {
            openNestTags += (0, _getNestedBlockTags["default"])(getBlockHTML(block)).nestStart;
            listStack.push(block);
          }
        }
      }

      var innerHTML = (0, _blockInlineStyles["default"])((0, _blockEntities["default"])((0, _encodeBlock["default"])(block), rawState.entityMap, entityToHTML), styleToHTML);
      var blockHTML = (0, _getBlockTags["default"])(getBlockHTML(block));
      var html;

      if (typeof blockHTML === 'string') {
        html = blockHTML;
      } else {
        html = blockHTML.start + innerHTML + blockHTML.end;
      }

      if (innerHTML.length === 0 && Object.prototype.hasOwnProperty.call(blockHTML, 'empty')) {
        if (_react["default"].isValidElement(blockHTML.empty)) {
          html = _server["default"].renderToStaticMarkup(blockHTML.empty);
        } else {
          html = blockHTML.empty;
        }
      }

      return closeNestTags + openNestTags + html;
    }).join('');
    result = listStack.reduce(function (res, nestBlock) {
      return res + (0, _getNestedBlockTags["default"])(getBlockHTML(nestBlock)).nestEnd;
    }, result);
    return result;
  };
};

var _default = function _default() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1 && Object.prototype.hasOwnProperty.call(args[0], '_map') && args[0].getBlockMap != null) {
    // skip higher-order function and use defaults
    return convertToHTML({}).apply(void 0, args);
  }

  return convertToHTML.apply(void 0, args);
};

exports["default"] = _default;
});

unwrapExports(convertToHTML_1);

var parseHTML_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseHTML;

var fallback = function fallback(html) {
  var doc = document.implementation.createHTMLDocument('');
  doc.documentElement.innerHTML = html;
  return doc;
};

function parseHTML(html) {
  var doc;

  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');

    if (doc === null || doc.body === null) {
      doc = fallback(html);
    }
  } else {
    doc = fallback(html);
  }

  return doc.body;
}
});

unwrapExports(parseHTML_1);

var convertFromHTML_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;





var _parseHTML = _interopRequireDefault(parseHTML_1);

var _rangeSort = _interopRequireDefault(rangeSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the /src directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
var NBSP = '&nbsp;';
var SPACE = ' '; // Arbitrary max indent

var MAX_DEPTH = 4; // used for replacing characters in HTML

/* eslint-disable no-control-regex */

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
/* eslint-enable no-control-regex */
// Block tag flow is different because LIs do not have
// a deterministic style ;_;

var blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'blockquote', 'pre'];
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var handleMiddleware = function handleMiddleware(maybeMiddleware, base) {
  if (maybeMiddleware && maybeMiddleware.__isMiddleware === true) {
    return maybeMiddleware(base);
  }

  return maybeMiddleware;
};

var defaultHTMLToBlock = function defaultHTMLToBlock(nodeName, node, lastList) {
  return undefined;
};

var defaultHTMLToStyle = function defaultHTMLToStyle(nodeName, node, currentStyle) {
  return currentStyle;
};

var defaultHTMLToEntity = function defaultHTMLToEntity(nodeName, node) {
  return undefined;
};

var defaultTextToEntity = function defaultTextToEntity(text) {
  return [];
};

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error('Got unexpected null or undefined');
};

var sanitizeDraftText = function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
};

function getEmptyChunk() {
  return {
    text: '',
    inlines: [],
    entities: [],
    blocks: []
  };
}

function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);

  if (inEntity) {
    entities[0] = inEntity;
  }

  return {
    text: SPACE,
    inlines: [(0, immutable.OrderedSet)()],
    entities: entities,
    blocks: []
  };
}

function getSoftNewlineChunk(block, depth) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, immutable.Map)();

  if (flat === true) {
    return {
      text: '\r',
      inlines: [(0, immutable.OrderedSet)()],
      entities: new Array(1),
      blocks: [{
        type: block,
        data: data,
        depth: Math.max(0, Math.min(MAX_DEPTH, depth))
      }],
      isNewline: true
    };
  }

  return {
    text: '\n',
    inlines: [(0, immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: []
  };
}

function getBlockDividerChunk(block, depth) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, immutable.Map)();
  return {
    text: '\r',
    inlines: [(0, immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: [{
      type: block,
      data: data,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    }]
  };
}

function getBlockTypeForTag(tag, lastList) {
  switch (tag) {
    case 'h1':
      return 'header-one';

    case 'h2':
      return 'header-two';

    case 'h3':
      return 'header-three';

    case 'h4':
      return 'header-four';

    case 'h5':
      return 'header-five';

    case 'h6':
      return 'header-six';

    case 'li':
      if (lastList === 'ol') {
        return 'ordered-list-item';
      }

      return 'unordered-list-item';

    case 'blockquote':
      return 'blockquote';

    case 'pre':
      return 'code-block';

    case 'div':
    case 'p':
      return 'unstyled';

    default:
      return null;
  }
}

function baseCheckBlockType(nodeName, node, lastList) {
  return getBlockTypeForTag(nodeName, lastList);
}

function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];

  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      if (htmlElement.style.fontWeight === 'bold') {
        style.add('BOLD');
      }

      if (htmlElement.style.fontStyle === 'italic') {
        style.add('ITALIC');
      }

      if (htmlElement.style.textDecoration === 'underline') {
        style.add('UNDERLINE');
      }

      if (htmlElement.style.textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }

  return currentStyle;
}

function baseProcessInlineTag(tag, node) {
  var inlineStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, immutable.OrderedSet)();
  return processInlineTag(tag, node, inlineStyles);
}

function joinChunks(A, B) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var firstInB = B.text.slice(0, 1);
  var lastInA = A.text.slice(-1);
  var adjacentDividers = lastInA === '\r' && firstInB === '\r';
  var isJoiningBlocks = A.text !== '\r' && B.text !== '\r'; // when joining two full blocks like this we want to pop one divider

  var addingNewlineToEmptyBlock = A.text === '\r' && !A.isNewline && B.isNewline; // when joining a newline to an empty block we want to remove the newline

  if (adjacentDividers && (isJoiningBlocks || addingNewlineToEmptyBlock)) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  } // Kill whitespace after blocks if flat mode is on


  if (A.text.slice(-1) === '\r' && flat === true) {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  var isNewline = A.text.length === 0 && B.isNewline;
  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks),
    isNewline: isNewline
  };
}
/*
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */


function containsSemanticBlockMarkup(html) {
  return blockTags.some(function (tag) {
    return html.indexOf("<".concat(tag)) !== -1;
  });
}

function genFragment(node, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, inEntity) {
  var nodeName = node.nodeName.toLowerCase();
  var newBlock = false;
  var nextBlockType = 'unstyled'; // Base Case

  if (nodeName === '#text') {
    var text = node.textContent;

    if (text.trim() === '' && inBlock === null) {
      return getEmptyChunk();
    }

    if (text.trim() === '' && inBlock !== 'code-block') {
      return getWhitespaceChunk(inEntity);
    }

    if (inBlock !== 'code-block') {
      // Can't use empty string because MSWord
      text = text.replace(REGEX_LF, SPACE);
    }

    var entities = Array(text.length).fill(inEntity);
    var offsetChange = 0;
    var textEntities = checkEntityText(text, createEntity, getEntity, mergeEntityData, replaceEntityData).sort(_rangeSort["default"]);
    textEntities.forEach(function (_ref) {
      var entity = _ref.entity,
          offset = _ref.offset,
          length = _ref.length,
          result = _ref.result;
      var adjustedOffset = offset + offsetChange;

      if (result === null || result === undefined) {
        result = text.substr(adjustedOffset, length);
      }

      var textArray = text.split('');
      textArray.splice.bind(textArray, adjustedOffset, length).apply(textArray, result.split(''));
      text = textArray.join('');
      entities.splice.bind(entities, adjustedOffset, length).apply(entities, Array(result.length).fill(entity));
      offsetChange += result.length - length;
    });
    return {
      text: text,
      inlines: Array(text.length).fill(inlineStyle),
      entities: entities,
      blocks: []
    };
  } // BR tags


  if (nodeName === 'br') {
    var _blockType = inBlock;

    if (_blockType === null) {
      //  BR tag is at top level, treat it as an unstyled block
      return getSoftNewlineChunk('unstyled', depth, true);
    }

    return getSoftNewlineChunk(_blockType || 'unstyled', depth, options.flat);
  }

  var chunk = getEmptyChunk();
  var newChunk = null; // Inline tags

  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
  inlineStyle = processCustomInlineStyles(nodeName, node, inlineStyle); // Handle lists

  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }

    lastList = nodeName;
    inBlock = null;
  } // Block Tags


  var blockInfo = checkBlockType(nodeName, node, lastList, inBlock);
  var blockType;
  var blockDataMap;

  if (blockInfo === false) {
    return getEmptyChunk();
  }

  blockInfo = blockInfo || {};

  if (typeof blockInfo === 'string') {
    blockType = blockInfo;
    blockDataMap = (0, immutable.Map)();
  } else {
    blockType = typeof blockInfo === 'string' ? blockInfo : blockInfo.type;
    blockDataMap = blockInfo.data ? (0, immutable.Map)(blockInfo.data) : (0, immutable.Map)();
  }

  if (!inBlock && (fragmentBlockTags.indexOf(nodeName) !== -1 || blockType)) {
    chunk = getBlockDividerChunk(blockType || getBlockTypeForTag(nodeName, lastList), depth, blockDataMap);
    inBlock = blockType || getBlockTypeForTag(nodeName, lastList);
    newBlock = true;
  } else if (lastList && (inBlock === 'ordered-list-item' || inBlock === 'unordered-list-item') && nodeName === 'li') {
    var listItemBlockType = getBlockTypeForTag(nodeName, lastList);
    chunk = getBlockDividerChunk(listItemBlockType, depth);
    inBlock = listItemBlockType;
    newBlock = true;
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  } else if (inBlock && inBlock !== 'atomic' && blockType === 'atomic') {
    inBlock = blockType;
    newBlock = true;
    chunk = getSoftNewlineChunk(blockType, depth, true, // atomic blocks within non-atomic blocks must always be split out
    blockDataMap);
  } // Recurse through children


  var child = node.firstChild; // hack to allow conversion of atomic blocks from HTML (e.g. <figure><img
  // src="..." /></figure>). since metadata must be stored on an entity text
  // must exist for the entity to apply to. the way chunks are joined strips
  // whitespace at the end so it cannot be a space character.

  if (child == null && inEntity && (blockType === 'atomic' || inBlock === 'atomic')) {
    child = document.createTextNode('a');
  }

  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    entityId = checkEntityNode(nodeName, child, createEntity, getEntity, mergeEntityData, replaceEntityData);
    newChunk = genFragment(child, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, entityId || inEntity);
    chunk = joinChunks(chunk, newChunk, options.flat);
    var sibling = child.nextSibling; // Put in a newline to break up blocks inside blocks

    if (sibling && fragmentBlockTags.indexOf(nodeName) >= 0 && inBlock) {
      var newBlockInfo = checkBlockType(nodeName, child, lastList, inBlock);
      var newBlockType = void 0;
      var newBlockData = void 0;

      if (newBlockInfo !== false) {
        newBlockInfo = newBlockInfo || {};

        if (typeof newBlockInfo === 'string') {
          newBlockType = newBlockInfo;
          newBlockData = (0, immutable.Map)();
        } else {
          newBlockType = newBlockInfo.type || getBlockTypeForTag(nodeName, lastList);
          newBlockData = newBlockInfo.data ? (0, immutable.Map)(newBlockInfo.data) : (0, immutable.Map)();
        }

        chunk = joinChunks(chunk, getSoftNewlineChunk(newBlockType, depth, options.flat, newBlockData), options.flat);
      }
    }

    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }

    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, (0, immutable.Map)()), options.flat);
  }

  return chunk;
}

function getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);
  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.


  var workingBlocks = containsSemanticBlockMarkup(html) ? blockTags.concat(['div']) : ['div']; // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to sta rt with.

  var chunk = genFragment(safeBody, (0, immutable.OrderedSet)(), 'ul', null, workingBlocks, -1, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options); // join with previous block to prevent weirdness on paste

  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  } // Kill block delimiter at the end


  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  } // If we saw no block tags, put an unstyled one in


  if (chunk.blocks.length === 0) {
    chunk.blocks.push({
      type: 'unstyled',
      data: (0, immutable.Map)(),
      depth: 0
    });
  } // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content


  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({
      type: 'unstyled',
      data: (0, immutable.Map)(),
      depth: 0
    });
  }

  return chunk;
}

function convertFromHTMLtoContentBlocks(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey) {
  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  var chunk = getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey);

  if (chunk == null) {
    return [];
  }

  var start = 0;
  return chunk.text.split('\r').map(function (textBlock, blockIndex) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);
    var end = start + textBlock.length;
    var inlines = nullthrows(chunk).inlines.slice(start, end);
    var entities = nullthrows(chunk).entities.slice(start, end);
    var characterList = (0, immutable.List)(inlines.map(function (style, entityIndex) {
      var data = {
        style: style,
        entity: null
      };

      if (entities[entityIndex]) {
        data.entity = entities[entityIndex];
      }

      return Draft.CharacterMetadata.create(data);
    }));
    start = end + 1;
    return new Draft.ContentBlock({
      key: generateKey(),
      type: nullthrows(chunk).blocks[blockIndex].type,
      data: nullthrows(chunk).blocks[blockIndex].data,
      depth: nullthrows(chunk).blocks[blockIndex].depth,
      text: textBlock,
      characterList: characterList
    });
  });
}

var convertFromHTML = function convertFromHTML(_ref2) {
  var _ref2$htmlToStyle = _ref2.htmlToStyle,
      htmlToStyle = _ref2$htmlToStyle === void 0 ? defaultHTMLToStyle : _ref2$htmlToStyle,
      _ref2$htmlToEntity = _ref2.htmlToEntity,
      htmlToEntity = _ref2$htmlToEntity === void 0 ? defaultHTMLToEntity : _ref2$htmlToEntity,
      _ref2$textToEntity = _ref2.textToEntity,
      textToEntity = _ref2$textToEntity === void 0 ? defaultTextToEntity : _ref2$textToEntity,
      _ref2$htmlToBlock = _ref2.htmlToBlock,
      htmlToBlock = _ref2$htmlToBlock === void 0 ? defaultHTMLToBlock : _ref2$htmlToBlock;
  return function (html) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      flat: false
    };
    var DOMBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _parseHTML["default"];
    var generateKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Draft.genKey;

    var contentState = Draft.ContentState.createFromText('');

    var createEntityWithContentState = function createEntityWithContentState() {
      if (contentState.createEntity) {
        var _contentState;

        contentState = (_contentState = contentState).createEntity.apply(_contentState, arguments);
        return contentState.getLastCreatedEntityKey();
      }

      return Draft.Entity.create.apply(Draft.Entity, arguments);
    };

    var getEntityWithContentState = function getEntityWithContentState() {
      if (contentState.getEntity) {
        var _contentState2;

        return (_contentState2 = contentState).getEntity.apply(_contentState2, arguments);
      }

      return Draft.Entity.get.apply(Draft.Entity, arguments);
    };

    var mergeEntityDataWithContentState = function mergeEntityDataWithContentState() {
      if (contentState.mergeEntityData) {
        var _contentState3;

        contentState = (_contentState3 = contentState).mergeEntityData.apply(_contentState3, arguments);
        return;
      }

      Draft.Entity.mergeData.apply(Draft.Entity, arguments);
    };

    var replaceEntityDataWithContentState = function replaceEntityDataWithContentState() {
      if (contentState.replaceEntityData) {
        var _contentState4;

        contentState = (_contentState4 = contentState).replaceEntityData.apply(_contentState4, arguments);
        return;
      }

      Draft.Entity.replaceData.apply(Draft.Entity, arguments);
    };

    var contentBlocks = convertFromHTMLtoContentBlocks(html, handleMiddleware(htmlToStyle, baseProcessInlineTag), handleMiddleware(htmlToEntity, defaultHTMLToEntity), handleMiddleware(textToEntity, defaultTextToEntity), handleMiddleware(htmlToBlock, baseCheckBlockType), createEntityWithContentState, getEntityWithContentState, mergeEntityDataWithContentState, replaceEntityDataWithContentState, options, DOMBuilder, generateKey);

    var blockMap = Draft.BlockMapBuilder.createFromArray(contentBlocks);

    var firstBlockKey = contentBlocks[0].getKey();
    return contentState.merge({
      blockMap: blockMap,
      selectionBefore: Draft.SelectionState.createEmpty(firstBlockKey),
      selectionAfter: Draft.SelectionState.createEmpty(firstBlockKey)
    });
  };
};

var _default = function _default() {
  if (arguments.length >= 1 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
    return convertFromHTML({}).apply(void 0, arguments);
  }

  return convertFromHTML.apply(void 0, arguments);
};

exports["default"] = _default;
});

unwrapExports(convertFromHTML_1);

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "convertToHTML", {
  enumerable: true,
  get: function get() {
    return _convertToHTML["default"];
  }
});
Object.defineProperty(exports, "convertFromHTML", {
  enumerable: true,
  get: function get() {
    return _convertFromHTML["default"];
  }
});
Object.defineProperty(exports, "parseHTML", {
  enumerable: true,
  get: function get() {
    return _parseHTML["default"];
  }
});

var _convertToHTML = _interopRequireDefault(convertToHTML_1);

var _convertFromHTML = _interopRequireDefault(convertFromHTML_1);

var _parseHTML = _interopRequireDefault(parseHTML_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
});

unwrapExports(lib$1);

var exporter = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRenderOptions = exports.options = exports.entityToHTML = exports.blockToHTML = exports.styleToHTML = undefined;



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleToHTML = exports.styleToHTML = function styleToHTML(style) {
  switch (style) {
    case constants.Inline.ITALIC:
      return _react2.default.createElement('em', { className: 'md-inline-' + style.toLowerCase() });
    case constants.Inline.BOLD:
      return _react2.default.createElement('strong', { className: 'md-inline-' + style.toLowerCase() });
    case constants.Inline.STRIKETHROUGH:
      return _react2.default.createElement('strike', { className: 'md-inline-' + style.toLowerCase() });
    case constants.Inline.UNDERLINE:
      return _react2.default.createElement('u', { className: 'md-inline-' + style.toLowerCase() });
    case constants.Inline.HIGHLIGHT:
      return _react2.default.createElement('span', { className: 'md-inline-' + style.toLowerCase() });
    case constants.Inline.CODE:
      return _react2.default.createElement('code', { className: 'md-inline-' + style.toLowerCase() });
    default:
      return null;
  }
};

var blockToHTML = exports.blockToHTML = function blockToHTML(block) {
  var blockType = block.type;
  var blockClass = blockType.toLowerCase();

  switch (blockType) {
    case constants.Block.H1:
      // eslint-disable-next-line jsx-a11y/heading-has-content
      return _react2.default.createElement('h1', { className: 'md-block-' + blockClass });
    case constants.Block.H2:
      // eslint-disable-next-line jsx-a11y/heading-has-content
      return _react2.default.createElement('h2', { className: 'md-block-' + blockClass });
    case constants.Block.H3:
      // eslint-disable-next-line jsx-a11y/heading-has-content
      return _react2.default.createElement('h3', { className: 'md-block-' + blockClass });
    case constants.Block.H4:
      // eslint-disable-next-line jsx-a11y/heading-has-content
      return _react2.default.createElement('h4', { className: 'md-block-' + blockClass });
    case constants.Block.H5:
      // eslint-disable-next-line jsx-a11y/heading-has-content
      return _react2.default.createElement('h5', { className: 'md-block-' + blockClass });
    case constants.Block.H6:
      // eslint-disable-next-line jsx-a11y/heading-has-content
      return _react2.default.createElement('h6', { className: 'md-block-' + blockClass });
    case constants.Block.BLOCKQUOTE_CAPTION:
    case constants.Block.CAPTION:
      return {
        start: '<p class="md-block-' + blockClass + '"><caption>',
        end: '</caption></p>'
      };
    case constants.Block.IMAGE:
      {
        var imgData = block.data;
        var text = block.text;
        var extraClass = text.length > 0 ? ' md-block-image-has-caption' : '';
        return {
          start: '<figure class="md-block-image' + extraClass + '"><img src="' + imgData.src + '" alt="' + block.text + '" /><figcaption class="md-block-image-caption">',
          end: '</figcaption></figure>'
        };
      }
    case constants.Block.ATOMIC:
      return {
        start: '<figure class="md-block-' + blockClass + '">',
        end: '</figure>'
      };
    case constants.Block.TODO:
      {
        var checked = block.data.checked || false;
        var inp = '';
        var containerClass = '';
        if (checked) {
          inp = '<input type=checkbox disabled checked="checked" />';
          containerClass = 'md-block-todo-checked';
        } else {
          inp = '<input type=checkbox disabled />';
          containerClass = 'md-block-todo-unchecked';
        }
        return {
          start: '<div class="md-block-' + blockType + ' ' + containerClass + '">' + inp + '<p>',
          end: '</p></div>'
        };
      }
    case constants.Block.BREAK:
      return _react2.default.createElement('hr', { className: 'md-block-' + blockType });
    case constants.Block.BLOCKQUOTE:
      return _react2.default.createElement('blockquote', { className: 'md-block-' + blockType });
    case constants.Block.OL:
      return {
        element: _react2.default.createElement('li', null),
        nest: _react2.default.createElement('ol', { className: 'md-block-' + blockType })
      };
    case constants.Block.UL:
      return {
        element: _react2.default.createElement('li', null),
        nest: _react2.default.createElement('ul', { className: 'md-block-' + blockType })
      };
    case constants.Block.UNSTYLED:
      if (block.text.length < 1) {
        return _react2.default.createElement(
          'p',
          { className: 'md-block-' + blockType },
          _react2.default.createElement('br', null)
        );
      }
      return _react2.default.createElement('p', { className: 'md-block-' + blockType });
    case constants.Block.CODE:
      return {
        element: _react2.default.createElement('pre', { className: 'md-block-' + blockType }),
        nest: _react2.default.createElement('div', { className: 'md-block-code-container' })
      };
    default:
      return null;
  }
};

var entityToHTML = exports.entityToHTML = function entityToHTML(entity, originalText) {
  if (entity.type === constants.Entity.LINK) {
    return _react2.default.createElement('a', {
      className: 'md-inline-link',
      href: entity.data.url,
      target: '_blank',
      rel: 'noopener noreferrer'
    });
  }
  return originalText;
};

var options = exports.options = {
  styleToHTML: styleToHTML,
  blockToHTML: blockToHTML,
  entityToHTML: entityToHTML
};

var setRenderOptions = exports.setRenderOptions = function setRenderOptions() {
  var htmlOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options;
  return (0, lib$1.convertToHTML)(htmlOptions);
};

exports.default = function (contentState) {
  var htmlOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : options;
  return (0, lib$1.convertToHTML)(htmlOptions)(contentState);
};
});

var mediumDraftExporter = unwrapExports(exporter);
var exporter_1 = exporter.setRenderOptions;
var exporter_2 = exporter.options;
var exporter_3 = exporter.entityToHTML;
var exporter_4 = exporter.blockToHTML;
var exporter_5 = exporter.styleToHTML;

var importer = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setImportOptions = exports.options = exports.htmlToBlock = exports.htmlToEntity = exports.htmlToStyle = undefined;





var htmlToStyle = exports.htmlToStyle = function htmlToStyle(nodeName, node, currentStyle) {
  switch (nodeName) {
    case 'em':
      return currentStyle.add(constants.Inline.ITALIC);
    case 'strong':
      return currentStyle.add(constants.Inline.BOLD);
    case 'strike':
      return currentStyle.add(constants.Inline.STRIKETHROUGH);
    case 'u':
      return currentStyle.add(constants.Inline.UNDERLINE);
    case 'span':
      if (node.className === 'md-inline-' + constants.Inline.HIGHLIGHT.toLowerCase()) {
        return currentStyle.add(constants.Inline.HIGHLIGHT);
      }
      break;
    case 'code':
      return currentStyle.add(constants.Inline.CODE);
    default:
      break;
  }

  return currentStyle;
};

var htmlToEntity = exports.htmlToEntity = function htmlToEntity(nodeName, node, createEntity) {
  if (nodeName === 'a') {
    return createEntity(constants.Entity.LINK, 'MUTABLE', { url: node.href });
  }
  return undefined;
};

var htmlToBlock = exports.htmlToBlock = function htmlToBlock(nodeName, node) {
  if (nodeName === 'h1') {
    return {
      type: constants.Block.H1,
      data: {}
    };
  } else if (nodeName === 'h2') {
    return {
      type: constants.Block.H2,
      data: {}
    };
  } else if (nodeName === 'h3') {
    return {
      type: constants.Block.H3,
      data: {}
    };
  } else if (nodeName === 'h4') {
    return {
      type: constants.Block.H4,
      data: {}
    };
  } else if (nodeName === 'h5') {
    return {
      type: constants.Block.H5,
      data: {}
    };
  } else if (nodeName === 'h6') {
    return {
      type: constants.Block.H6,
      data: {}
    };
  } else if (nodeName === 'p' && (node.className === 'md-block-' + constants.Block.CAPTION.toLowerCase() || node.className === 'md-block-' + constants.Block.BLOCKQUOTE_CAPTION.toLowerCase())) {
    return {
      type: constants.Block.BLOCKQUOTE_CAPTION,
      data: {}
    };
  } else if (nodeName === 'figure') {
    if (node.className.match(/^md-block-image/)) {
      var imageNode = node.querySelector('img');
      return {
        type: constants.Block.IMAGE,
        data: {
          src: imageNode && imageNode.src
        }
      };
    } else if (node.className === 'md-block-' + constants.Block.ATOMIC.toLowerCase()) {
      return {
        type: constants.Block.ATOMIC,
        data: {}
      };
    }
    return undefined;
  } else if (nodeName === 'div' && node.className && node.className.match(/^md-block-todo/)) {
    var inputNode = node.querySelector('input');
    return {
      type: constants.Block.TODO,
      data: {
        checked: inputNode && inputNode.checked
      }
    };
  } else if (nodeName === 'hr') {
    return {
      type: constants.Block.BREAK,
      data: {}
    };
  } else if (nodeName === 'blockquote') {
    return {
      type: constants.Block.BLOCKQUOTE,
      data: {}
    };
  } else if (nodeName === 'p') {
    return {
      type: constants.Block.UNSTYLED,
      data: {}
    };
  } else if (['div', 'pre'].includes(nodeName) && node.className === 'md-block-code-container') {
    return {
      type: constants.Block.CODE,
      data: {}
    };
  }

  return undefined;
};

var options = exports.options = {
  htmlToStyle: htmlToStyle,
  htmlToEntity: htmlToEntity,
  htmlToBlock: htmlToBlock
};

var setImportOptions = exports.setImportOptions = function setImportOptions() {
  var htmlOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options;
  return (0, lib$1.convertFromHTML)(htmlOptions);
};

exports.default = function (rawHTML) {
  var htmlOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : options;
  return (0, lib$1.convertFromHTML)(htmlOptions)(rawHTML);
};
});

var mediumDraftImporter = unwrapExports(importer);
var importer_1 = importer.setImportOptions;
var importer_2 = importer.options;
var importer_3 = importer.htmlToBlock;
var importer_4 = importer.htmlToEntity;
var importer_5 = importer.htmlToStyle;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

function styleInject$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css$1 = "/*!\n * medium-draft\n * Version - 0.5.18\n * Author - Brijesh Bittu <brijeshb42@gmail.com> (http://bitwiser.in/)\n */\n.DraftEditor-editorContainer,.DraftEditor-root,.public-DraftEditor-content{height:inherit;text-align:initial}.public-DraftEditor-content[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.DraftEditor-root{position:relative}.DraftEditor-editorContainer{background-color:hsla(0,0%,100%,0);border-left:.1px solid transparent;position:relative;z-index:1}.public-DraftEditor-block{position:relative}.DraftEditor-alignLeft .public-DraftStyleDefault-block{text-align:left}.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root{left:0;text-align:left}.DraftEditor-alignCenter .public-DraftStyleDefault-block{text-align:center}.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root{margin:0 auto;text-align:center;width:100%}.DraftEditor-alignRight .public-DraftStyleDefault-block{text-align:right}.DraftEditor-alignRight .public-DraftEditorPlaceholder-root{right:0;text-align:right}.public-DraftEditorPlaceholder-root{color:#9197a3;position:absolute;z-index:1}.public-DraftEditorPlaceholder-hasFocus{color:#bdc1c9}.DraftEditorPlaceholder-hidden{display:none}.public-DraftStyleDefault-block{position:relative;white-space:pre-wrap}.public-DraftStyleDefault-ltr{direction:ltr;text-align:left}.public-DraftStyleDefault-rtl{direction:rtl;text-align:right}.public-DraftStyleDefault-listLTR{direction:ltr}.public-DraftStyleDefault-listRTL{direction:rtl}.public-DraftStyleDefault-ol,.public-DraftStyleDefault-ul{margin:16px 0;padding:0}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) \". \";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) \". \";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) \". \";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) \". \";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) \". \";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}/*! Hint.css - v2.5.0 - 2017-04-23\n* http://kushagragour.in/lab/hint/\n* Copyright (c) 2017 Kushagra Gour */[class*=hint--]{position:relative;display:inline-block}[class*=hint--]:after,[class*=hint--]:before{position:absolute;transform:translateZ(0);visibility:hidden;opacity:0;z-index:1000000;pointer-events:none;transition:.3s ease;transition-delay:0s}[class*=hint--]:hover:after,[class*=hint--]:hover:before{visibility:visible;opacity:1;transition-delay:.1s}[class*=hint--]:before{content:\"\";position:absolute;background:0 0;border:6px solid transparent;z-index:1000001}[class*=hint--]:after{background:#383838;color:#fff;padding:8px 10px;font-size:12px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;line-height:12px;white-space:nowrap;text-shadow:0 -1px 0 #000;box-shadow:4px 4px 8px rgba(0,0,0,.3)}[class*=hint--][aria-label]:after{content:attr(aria-label)}[class*=hint--][data-hint]:after{content:attr(data-hint)}[aria-label=\"\"]:after,[aria-label=\"\"]:before,[data-hint=\"\"]:after,[data-hint=\"\"]:before{display:none!important}.hint--top-left:before,.hint--top-right:before,.hint--top:before{border-top-color:#383838}.hint--bottom-left:before,.hint--bottom-right:before,.hint--bottom:before{border-bottom-color:#383838}.hint--top:after,.hint--top:before{bottom:100%;left:50%}.hint--top:before{margin-bottom:-11px;left:calc(50% - 6px)}.hint--top:after{transform:translateX(-50%)}.hint--top:hover:before{transform:translateY(-8px)}.hint--top:hover:after{transform:translateX(-50%) translateY(-8px)}.hint--bottom:after,.hint--bottom:before{top:100%;left:50%}.hint--bottom:before{margin-top:-11px;left:calc(50% - 6px)}.hint--bottom:after{transform:translateX(-50%)}.hint--bottom:hover:before{transform:translateY(8px)}.hint--bottom:hover:after{transform:translateX(-50%) translateY(8px)}.hint--right:before{border-right-color:#383838;margin-left:-11px;margin-bottom:-6px}.hint--right:after{margin-bottom:-14px}.hint--right:after,.hint--right:before{left:100%;bottom:50%}.hint--right:hover:after,.hint--right:hover:before{transform:translateX(8px)}.hint--left:before{border-left-color:#383838;margin-right:-11px;margin-bottom:-6px}.hint--left:after{margin-bottom:-14px}.hint--left:after,.hint--left:before{right:100%;bottom:50%}.hint--left:hover:after,.hint--left:hover:before{transform:translateX(-8px)}.hint--top-left:after,.hint--top-left:before{bottom:100%;left:50%}.hint--top-left:before{margin-bottom:-11px;left:calc(50% - 6px)}.hint--top-left:after{transform:translateX(-100%);margin-left:12px}.hint--top-left:hover:before{transform:translateY(-8px)}.hint--top-left:hover:after{transform:translateX(-100%) translateY(-8px)}.hint--top-right:after,.hint--top-right:before{bottom:100%;left:50%}.hint--top-right:before{margin-bottom:-11px;left:calc(50% - 6px)}.hint--top-right:after{transform:translateX(0);margin-left:-12px}.hint--top-right:hover:after,.hint--top-right:hover:before{transform:translateY(-8px)}.hint--bottom-left:after,.hint--bottom-left:before{top:100%;left:50%}.hint--bottom-left:before{margin-top:-11px;left:calc(50% - 6px)}.hint--bottom-left:after{transform:translateX(-100%);margin-left:12px}.hint--bottom-left:hover:before{transform:translateY(8px)}.hint--bottom-left:hover:after{transform:translateX(-100%) translateY(8px)}.hint--bottom-right:after,.hint--bottom-right:before{top:100%;left:50%}.hint--bottom-right:before{margin-top:-11px;left:calc(50% - 6px)}.hint--bottom-right:after{transform:translateX(0);margin-left:-12px}.hint--bottom-right:hover:after,.hint--bottom-right:hover:before{transform:translateY(8px)}.hint--large:after,.hint--medium:after,.hint--small:after{white-space:normal;line-height:1.4em;word-wrap:break-word}.hint--small:after{width:80px}.hint--medium:after{width:150px}.hint--large:after{width:300px}.hint--error:after{background-color:#b34e4d;text-shadow:0 -1px 0 #592726}.hint--error.hint--top-left:before,.hint--error.hint--top-right:before,.hint--error.hint--top:before{border-top-color:#b34e4d}.hint--error.hint--bottom-left:before,.hint--error.hint--bottom-right:before,.hint--error.hint--bottom:before{border-bottom-color:#b34e4d}.hint--error.hint--left:before{border-left-color:#b34e4d}.hint--error.hint--right:before{border-right-color:#b34e4d}.hint--warning:after{background-color:#c09854;text-shadow:0 -1px 0 #6c5328}.hint--warning.hint--top-left:before,.hint--warning.hint--top-right:before,.hint--warning.hint--top:before{border-top-color:#c09854}.hint--warning.hint--bottom-left:before,.hint--warning.hint--bottom-right:before,.hint--warning.hint--bottom:before{border-bottom-color:#c09854}.hint--warning.hint--left:before{border-left-color:#c09854}.hint--warning.hint--right:before{border-right-color:#c09854}.hint--info:after{background-color:#3986ac;text-shadow:0 -1px 0 #1a3c4d}.hint--info.hint--top-left:before,.hint--info.hint--top-right:before,.hint--info.hint--top:before{border-top-color:#3986ac}.hint--info.hint--bottom-left:before,.hint--info.hint--bottom-right:before,.hint--info.hint--bottom:before{border-bottom-color:#3986ac}.hint--info.hint--left:before{border-left-color:#3986ac}.hint--info.hint--right:before{border-right-color:#3986ac}.hint--success:after{background-color:#458746;text-shadow:0 -1px 0 #1a321a}.hint--success.hint--top-left:before,.hint--success.hint--top-right:before,.hint--success.hint--top:before{border-top-color:#458746}.hint--success.hint--bottom-left:before,.hint--success.hint--bottom-right:before,.hint--success.hint--bottom:before{border-bottom-color:#458746}.hint--success.hint--left:before{border-left-color:#458746}.hint--success.hint--right:before{border-right-color:#458746}.hint--always:after,.hint--always:before{opacity:1;visibility:visible}.hint--always.hint--top:before{transform:translateY(-8px)}.hint--always.hint--top:after{transform:translateX(-50%) translateY(-8px)}.hint--always.hint--top-left:before{transform:translateY(-8px)}.hint--always.hint--top-left:after{transform:translateX(-100%) translateY(-8px)}.hint--always.hint--top-right:after,.hint--always.hint--top-right:before{transform:translateY(-8px)}.hint--always.hint--bottom:before{transform:translateY(8px)}.hint--always.hint--bottom:after{transform:translateX(-50%) translateY(8px)}.hint--always.hint--bottom-left:before{transform:translateY(8px)}.hint--always.hint--bottom-left:after{transform:translateX(-100%) translateY(8px)}.hint--always.hint--bottom-right:after,.hint--always.hint--bottom-right:before{transform:translateY(8px)}.hint--always.hint--left:after,.hint--always.hint--left:before{transform:translateX(-8px)}.hint--always.hint--right:after,.hint--always.hint--right:before{transform:translateX(8px)}.hint--rounded:after{border-radius:4px}.hint--no-animate:after,.hint--no-animate:before{transition-duration:0s}.hint--bounce:after,.hint--bounce:before{transition:opacity .3s ease,visibility .3s ease,transform .3s cubic-bezier(.71,1.7,.77,1.24)}.md-RichEditor-root{background:#fff;box-sizing:border-box;padding:15px 30px;position:relative;line-height:1.4em}.md-RichEditor-editor{cursor:text;margin-top:10px;position:relative;margin:0 auto}.md-RichEditor-editor h3{font-size:1.3em;margin:1.2em 0}.md-RichEditor-editor .public-DraftEditor-content,.md-RichEditor-editor .public-DraftEditorPlaceholder-root{margin:0 -15px -15px;padding:15px}.md-RichEditor-editor .public-DraftEditor-content{min-height:100px}.md-RichEditor-hidePlaceholder .public-DraftEditorPlaceholder-root{display:none}.md-RichEditor-editor .md-RichEditor-blockquote{border-left:5px solid #4ca8de;color:#555;font-size:1.2em;margin:0;padding:10px 0 10px 20px;background-color:#e2f2ff}.md-RichEditor-blockquote a{text-decoration:underline}.public-DraftEditor-content .md-block:first-child{margin-top:0;padding-top:0}.md-RichEditor-editor .public-DraftStyleDefault-pre{background-color:rgba(0,0,0,.05);font-size:16px;padding:20px}.public-DraftStyleDefault-orderedListItem,.public-DraftStyleDefault-unorderedListItem{margin-bottom:10px}.md-editor-action{position:fixed;top:5px;left:5px}.md-editor-action button{display:block}.md-side-toolbar{display:flex;position:absolute;z-index:1;left:-35px;top:0;transition:all .2s ease}.md-sb-button{background:none;border:1px solid #5b5b5b;color:#6d6d6d;cursor:pointer;height:30px;width:30px;border-radius:15px;font-weight:700;font-size:20px;margin-right:2px;text-align:center;transition:all .2s ease}.md-sb-button:focus{outline:none;border-color:#08c;color:#08c}.md-sb-button:hover{color:green}.md-sb-button.md-sb-img-button{background:none;background-color:#fff}.md-sb-button svg path{stroke-width:0;fill:#545454}.md-add-button.md-open-button{transform:rotate(45deg)}.md-add-btn-anim-appear{transform:translate3d(-38px,0,0);opacity:0}.md-add-btn-anim-appear.md-add-btn-anim-appear-active{transform:translateZ(0);opacity:1;transition:all .5s ease-in}.md-add-btn-anim-enter{transform:translate3d(-38px,0,0);opacity:0}.md-add-btn-anim-enter.md-add-btn-anim-enter-active{opacity:1;transform:translateZ(0);transition:all .5s ease-in}.md-add-btn-anim-exit{opacity:1}.md-add-btn-anim-exit.md-add-btn-anim-exit-active{opacity:.01;transition:opacity .3s ease-in}@keyframes pop-upwards{0%{transform:matrix(.97,0,0,1,0,12);opacity:0}20%{transform:matrix(.99,0,0,1,0,2);opacity:.7}40%{transform:matrix(1,0,0,1,0,-1);opacity:1}70%{transform:matrix(1,0,0,1,0,0);opacity:1}to{transform:matrix(1,0,0,1,0,0);opacity:1}}@keyframes pop-downwards{0%{transform:matrix(.97,0,0,1,0,-12);opacity:0}20%{transform:matrix(.99,0,0,1,0,-2);opacity:.7}40%{transform:matrix(1,0,0,1,0,1);opacity:1}70%{transform:matrix(1,0,0,1,0,0);opacity:1}to{transform:matrix(1,0,0,1,0,0);opacity:1}}.md-editor-toolbar{background:#323845;color:#fff;cursor:auto;border-radius:5px;z-index:2;position:absolute;transition:all .1s ease;visibility:hidden;box-shadow:0 1px 3px 0 #747171}.md-editor-toolbar.md-editor-toolbar--isopen{visibility:visible}.md-editor-toolbar.md-editor-toolbar--linkinput{animation:pop-downwards .2s forwards linear}.md-editor-toolbar:after{content:\"\";position:absolute;bottom:-5px;left:50%;margin-left:-5px;border-top:5px solid #323845;border-right:5px solid transparent;border-left:5px solid transparent}.md-editor-toolbar .md-url-input{box-sizing:border-box;border-radius:2px;display:block;width:100%;padding:5px;padding-right:11px;border:none;background:#323845;color:#fff;font-size:.9em;font-weight:100}.md-editor-toolbar .md-url-input:focus{outline:none}.md-editor-toolbar .md-url-input-close{position:absolute;right:8px;top:2.5px;font-size:20px;cursor:pointer}.md-editor-toolbar-edit-link{padding:4px 5px;font-size:.8em;width:320px}.md-editor-toolbar-edit-link a{color:#fff;text-decoration:none}.md-editor-toolbar-edit-link:after{bottom:auto;top:-5px;transform:rotate(180deg)}.md-editor-toolbar-edit-link button{background:none;border:none;color:#fff;float:right;display:inline-block;padding:0 5px;margin:5px 0;cursor:pointer}.md-editor-toolbar-edit-link button.md-editor-toolbar-edit-button{border-right:1px solid #fff}.md-RichEditor-controls{font-family:Helvetica,sans-serif;font-size:14px;display:inline-block;border-right:1px solid #555;position:relative}.md-RichEditor-controls.md-RichEditor-show-link-input{padding:6px 10px}.md-RichEditor-controls:last-child{border-right:none}.md-RichEditor-controls .md-RichEditor-linkButton{padding:0 5px;color:#fff;text-decoration:none}.md-RichEditor-styleButton{color:#fff;cursor:pointer;display:inline-block;padding:6px 10px}.md-RichEditor-styleButton:hover{color:#ff0}.md-RichEditor-styleButton:last-child{margin-right:0}.md-RichEditor-styleButton.md-RichEditor-styleButton-bold{font-weight:700}.md-RichEditor-styleButton.md-RichEditor-styleButton-italic{font-style:italic}.md-RichEditor-styleButton.md-RichEditor-styleButton-underline{text-decoration:underline}.md-RichEditor-styleButton.md-RichEditor-styleButton-strikethrough{text-decoration:line-through}.md-RichEditor-activeButton{color:#50ff4d;background:#242933}.md-RichEditor-activeButton:hover{color:#08c}.md-RichEditor-controls-block .md-RichEditor-styleButton:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.public-DraftEditor-content .md-block-paragraph{margin:20px 0}.public-DraftEditor-content .md-block-paragraph:first-child{margin-top:0}.public-DraftEditor-content .md-block-paragraph:last-child{margin-bottom:0}.md-block-checkbox input[type=checkbox]{float:left;margin-right:10px}.md-block-atomic{margin:0}.md-block-atomic img{width:100%;border:1px solid #eee;box-sizing:border-box}.md-block-atomic-wrapper{position:relative}.md-block-atomic-controls{display:none;position:absolute;top:0;right:0;transition:all .2s ease}.md-block-atomic-controls button{display:inline-block;background-color:#eaeaea;border:none;color:#6d6d6d;cursor:pointer;height:22px;width:22px;border-radius:11px;position:absolute;z-index:1;left:-27px;font-weight:700;text-align:center;transition:all .2s ease}.md-block-atomic-controls button:focus{outline:none;border-color:#08c;color:#08c}.md-block-quote cite{display:block;margin:0}.md-block-quote cite:before{content:\"\\2013\";color:#999;float:left;font-weight:700;display:inline;margin-right:10px}.md-block-caption{display:block;position:relative;font-style:normal;padding:10px 0;font-family:Hoefler Text,Georgia,serif;margin:0 0 20px;background-color:#f7f7f7;border-radius:5px;line-height:1.2em}.md-block-caption:before{content:\"\\201C\";color:#c6dfff;display:inline;position:absolute;left:-25px;top:-5px;font-size:3em}.md-block-caption .public-DraftStyleDefault-ltr{text-align:center}.md-block-todo input[type=checkbox]{cursor:pointer;float:left;position:relative;top:4px;left:-4px}.md-block-todo .public-DraftStyleDefault-block{margin-left:18px}.md-block-todo .md-block-todo-completed{color:#949494;text-decoration:line-through}figure.md-block-image{margin:10px 0;background:#fbfbfb}figure.md-block-image img{cursor:default;max-width:100%;border:1px solid #eee;box-sizing:border-box}figure.md-block-image img.is-selected{box-shadow:0 0 0 3px #02b875}figure.md-block-image figcaption{display:block;font-size:14px;line-height:1.4;color:rgba(0,0,0,.6);letter-spacing:0;font-weight:300;font-style:normal;text-align:center;padding:5px 0}figure.md-block-image figcaption .public-DraftStyleDefault-block{text-align:center}figure.md-block-image figcaption.md-block-image-caption--empty{position:relative}figure.md-block-image figcaption.md-block-image-caption--empty:before{position:absolute;content:attr(data-placeholder);left:0;opacity:.5}figure.md-block-image .md-block-image-inner-container{position:relative}figure.md-block-image .md-block-image-toolbar-container{position:absolute;top:0;right:10px;cursor:pointer}";
styleInject$1(css$1);

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CUSTOM_STYLE_MAP;

function _classCallCheck$31(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$17(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$20(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EXPORT_VALUE_DEBOUNCE_WAIT = 100;

var convertToRaw = Draft.convertToRaw,
    getDefaultKeyBinding$1 = Draft.getDefaultKeyBinding,
    KeyBindingUtil$1 = Draft.KeyBindingUtil;
var hasCommandModifier$1 = KeyBindingUtil$1.hasCommandModifier;


var KEY_CODE_B = 66;
var KEY_CODE_I = 73;
var KEY_CODE_U = 85;

var INLINE_STYLE_FONT_SIZE_1 = 'FONT_SIZE_1';
var INLINE_STYLE_FONT_SIZE_2 = 'FONT_SIZE_2';
var INLINE_STYLE_FONT_SIZE_3 = 'FONT_SIZE_3';

var quoteIcon = React__default.createElement(
  'svg',
  { width: '10.83', height: '10', viewBox: '0 0 13 12' },
  React__default.createElement(
    'g',
    { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
    React__default.createElement(
      'g',
      { transform: 'translate(-357.000000, -255.000000)', fill: '#FFFFFF' },
      React__default.createElement(
        'g',
        { transform: 'translate(260.000000, 165.000000)' },
        React__default.createElement(
          'g',
          { transform: 'translate(0.000000, 75.000000)' },
          React__default.createElement(
            'g',
            { transform: 'translate(19.000000, 0.000000)' },
            React__default.createElement('path', { d: 'M90.500768,15 L91,15.56 C88.9631235,17.0533408 87.9447005,18.666658 87.9447005,20.4 C87.9447005,21.8800074 88.75012,23.1466614 90.3609831,24.2 L87.5453149,27 C85.9211388,25.7866606 85.109063,24.346675 85.109063,22.68 C85.109063,20.3199882 86.90628,17.7600138 90.500768,15 Z M83.3917051,15 L83.890937,15.56 C81.8540605,17.0533408 80.8356375,18.666658 80.8356375,20.4 C80.8356375,21.8800074 81.6344006,23.1466614 83.2319508,24.2 L80.4362519,27 C78.8120759,25.7866606 78,24.346675 78,22.68 C78,20.3199882 79.7972171,17.7600138 83.3917051,15 Z' })
          )
        )
      )
    )
  )
);

var BLOCK_BUTTONS = [{
  label: quoteIcon,
  style: 'blockquote',
  icon: 'quote-right',
  description: 'Blockquote'
}, {
  label: 'UL',
  style: 'unordered-list-item',
  icon: 'list-ul',
  description: 'Unordered List'
}];

var INLINE_BUTTONS = [{
  label: '125%',
  style: INLINE_STYLE_FONT_SIZE_1,
  description: 'Font size 1'
}, {
  label: '150%',
  style: INLINE_STYLE_FONT_SIZE_2,
  description: 'Font size 2'
}, {
  label: '200%',
  style: INLINE_STYLE_FONT_SIZE_3,
  description: 'Font size 3'
}, {
  label: '™',
  style: 'CODE',
  description: 'Product code'
}, {
  label: 'B',
  style: 'BOLD',
  icon: 'bold',
  description: 'Bold'
}, {
  label: 'I',
  style: 'ITALIC',
  icon: 'italic',
  description: 'Italic'
}, {
  label: 'U',
  style: 'UNDERLINE',
  icon: 'underline',
  description: 'Underline'
}];

var CUSTOM_STYLE_MAP = (_CUSTOM_STYLE_MAP = {}, _defineProperty$1(_CUSTOM_STYLE_MAP, INLINE_STYLE_FONT_SIZE_1, {
  fontSize: '1.25em'
}), _defineProperty$1(_CUSTOM_STYLE_MAP, INLINE_STYLE_FONT_SIZE_2, {
  fontSize: '1.5em'
}), _defineProperty$1(_CUSTOM_STYLE_MAP, INLINE_STYLE_FONT_SIZE_3, {
  fontSize: '2em'
}), _defineProperty$1(_CUSTOM_STYLE_MAP, constants_2.CODE, {
  fontFamily: 'monospace',
  fontSize: '1.125em',
  letterSpacing: '0.0625em',
  textTransform: 'uppercase'
}), _CUSTOM_STYLE_MAP);

var importerOptions = {
  htmlToStyle: function htmlToStyle(nodeName, node, currentStyle) {
    switch (nodeName) {
      case 'em':
        return currentStyle.add(constants_2.ITALIC);

      case 'strong':
        return currentStyle.add(constants_2.BOLD);

      case 'u':
        return currentStyle.add(constants_2.UNDERLINE);

      case 'span':
        if (node.className === 'md-inline-' + INLINE_STYLE_FONT_SIZE_1.toLowerCase()) {
          return currentStyle.add(INLINE_STYLE_FONT_SIZE_1);
        } else if (node.className === 'md-inline-' + INLINE_STYLE_FONT_SIZE_2.toLowerCase()) {
          return currentStyle.add(INLINE_STYLE_FONT_SIZE_2);
        } else if (node.className === 'md-inline-' + INLINE_STYLE_FONT_SIZE_3.toLowerCase()) {
          return currentStyle.add(INLINE_STYLE_FONT_SIZE_3);
        }

        return currentStyle;

      case 'code':
        return currentStyle.add(constants_2.CODE);

      default:
        return currentStyle;
    }
  }
};

function highlightStrategyFactory(highlight) {
  return function (contentBlock, callback) {
    if (highlight.length === 0) {
      return;
    }

    var text = contentBlock.getText().toLowerCase();
    var searchQuery = highlight.toLowerCase();

    var start = void 0;
    var end = 0;

    while ((start = text.indexOf(searchQuery, end)) !== -1) {
      end = start + searchQuery.length;
      callback(start, end);
    }
  };
}

function createEditorStateFromValue(value, highlight) {
  var content = value;

  if (content !== null) {
    content = convertToRaw(mediumDraftImporter(value, importerOptions));
  } else {
    // @see https://github.com/facebook/draft-js/issues/2332#issuecomment-761573306
    content = '';
  }

  var decorators = [];

  if (highlight !== undefined) {
    decorators.push({
      strategy: highlightStrategyFactory(highlight),
      component: function component(_ref) {
        var children = _ref.children;
        return React__default.createElement(
          'span',
          { className: 'md-decoration-highlight' },
          children
        );
      }
    });
  }

  // @see https://github.com/brijeshb42/medium-draft/blob/c5350bb76489fd4f2f90f1dc69db92224138d20a/src/model/content.js#L19
  return lib_17(content, new Draft_1(decorators));
}

function exportEditorStateFromValue(value) {
  return mediumDraftExporter(value.getCurrentContent(), {
    styleToHTML: function styleToHTML(style) {
      switch (style) {
        case constants_2.ITALIC:
          return React__default.createElement('em', { className: 'md-inline-' + style.toLowerCase() });
        case constants_2.BOLD:
          return React__default.createElement('strong', { className: 'md-inline-' + style.toLowerCase() });
        case constants_2.UNDERLINE:
          return React__default.createElement('u', { className: 'md-inline-' + style.toLowerCase() });
        case constants_2.CODE:
          return React__default.createElement('code', { className: 'md-inline-' + style.toLowerCase() });
        case INLINE_STYLE_FONT_SIZE_1:
        case INLINE_STYLE_FONT_SIZE_2:
        case INLINE_STYLE_FONT_SIZE_3:
          return React__default.createElement('span', { className: 'md-inline-' + style.toLowerCase() });
        default:
          return null;
      }
    }
  });
}

var Text = function (_Component) {
  _inherits$20(Text, _Component);

  function Text() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$31(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$17(this, (_ref2 = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      value: createEditorStateFromValue(_this.props.value, _this.props.highlight),
      enabled: _this.props.enabled,
      placeholder: _this.props.placeholder === null ? _this.props.enabled : _this.props.placeholder
    }, _this.onChangeDebounced = lodash_debounce(function (value) {
      return _this.props.onBlur(exportEditorStateFromValue(value));
    }, EXPORT_VALUE_DEBOUNCE_WAIT), _this.onChange = function (value) {
      _this.setState({ value: value });
      _this.onChangeDebounced(value);
    }, _this.handlePlainModeKeyBinding = function (e) {
      if (_this.props.plain && hasCommandModifier$1(e) && (e.keyCode === KEY_CODE_B || e.keyCode === KEY_CODE_I || e.keyCode === KEY_CODE_U)) {
        return 'plain';
      }

      return getDefaultKeyBinding$1(e);
    }, _temp), _possibleConstructorReturn$17(_this, _ret);
  }

  // editorReference = null;
  // isInFocus = false;

  _createClass$5(Text, [{
    key: 'render',


    // handleFocus = () => {
    //   this.isInFocus = true;
    // };

    // Called because of onClickOutside (see the export below)
    // noinspection JSUnusedGlobalSymbols
    // handleClickOutside = () => {
    //   if (this.isInFocus) {
    //     this.isInFocus = false;
    //     this.editorReference.toggleInlineStyle();
    //     this.props.onBlur(exportEditorStateFromValue(this.state.value));
    //   }
    // };

    value: function render() {
      return (/*this.state.enabled ? */React__default.createElement(lib_18
        // ref={this.setEditorReference}
        , { sideButtons: [],
          blockButtons: BLOCK_BUTTONS,
          inlineButtons: INLINE_BUTTONS,
          customStyleMap: CUSTOM_STYLE_MAP,
          stringToTypeMap: {},
          placeholder: this.state.placeholder ? this.props.placeholderText : null,
          disableToolbar: this.props.plain,
          editorEnabled: this.state.enabled,
          editorState: this.state.value,
          keyBindingFn: this.handlePlainModeKeyBinding
          // onFocus={this.handleFocus}
          , onChange: this.onChange })
      ); /* : (
          <Static dangerouslySetInnerHTML={{ __html: this.props.value }}/>
         )*/
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      var state = {
        enabled: nextProps.enabled,
        placeholder: nextProps.placeholder === null ? nextProps.enabled : nextProps.placeholder
      };

      if (!nextProps.enabled) {
        state.value = createEditorStateFromValue(nextProps.value, nextProps.highlight);
      }

      // This was needed to update the Text state when a new translation is
      // created for this <Text ... />. This breaks everything not allowing
      // to edit the value.
      // Because nextProps.value is not the updated value but rather the last
      // value that the consumer Component has gotten from the onBlur callback.
      // if (nextProps.value !== prevState.value) {
      //   state.value = createEditorStateFromValue(nextProps.value);
      // }

      return state;
    }

    // setEditorReference = ref => {
    //   this.editorReference = ref;
    // };

    /**
     * Disable keyboard shortcuts (doesn't cover all shortcuts).
     *
     * @param e
     * @returns {string}
     */

  }]);

  return Text;
}(React.Component);

// export default onClickOutside(Text);


Text.defaultProps = {
  value: null,
  plain: false,
  onBlur: function onBlur(value) {
    return null;
  },
  enabled: false,
  placeholder: null,
  placeholderText: __('Text…'),
  highlight: ''
};

// const Static = styled.span`
//
//   p {
//     margin-top: 0;
//     // Use em instead of rem to be relative to the element font size
//     margin-bottom: 1.5em;
//
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }
// `;

var _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// @todo 2019-02-07 options should be `options = null`
function setContentValue(content, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return _extends$15({}, content, { value: value, options: options });
}

var _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$6 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$32(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$18(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$21(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TranslationModal = function (_Component) {
  _inherits$21(TranslationModal, _Component);

  function TranslationModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$32(this, TranslationModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$18(this, (_ref = TranslationModal.__proto__ || Object.getPrototypeOf(TranslationModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = TranslationModalStore$1.getState(), _this.subscriptions = [], _this.onForeignTextBlur = function (value) {
      _this.setState({ foreignContent: setContentValue(_this.state.foreignContent, value) });
    }, _this.onSave = function () {
      var content = _extends$16({}, _this.state.foreignContent, {
        id: _this.state.originalContent.id
      });

      _this.state.onContentUpdate(content).then(function (foreignContent) {
        return _this.setState({ foreignContent: foreignContent });
      }).catch(console.error);

      TranslationModalActions.close();
    }, _temp), _possibleConstructorReturn$18(_this, _ret);
  }

  _createClass$6(TranslationModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.subscriptions.push(TranslationModalStore$1.addListener(function () {
        _this2.setState(TranslationModalStore$1.getState());
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        Modal,
        { visible: this.state.isVisible, onClickOutside: TranslationModalActions.close },
        this.state.isVisible && React__default.createElement(
          React__default.Fragment,
          null,
          React__default.createElement(
            'div',
            { style: { padding: '2rem' } },
            React__default.createElement(
              'button',
              { onClick: this.onSave },
              'Save'
            ),
            React__default.createElement(
              'p',
              null,
              'Translating from ',
              React__default.createElement(
                'strong',
                null,
                __(this.state.originalContent.language)
              ),
              ' to ',
              React__default.createElement(
                'strong',
                null,
                __(this.state.foreignContent.language)
              ),
              '.'
            )
          ),
          React__default.createElement(
            'div',
            { style: { display: 'flex', width: '100%', paddingLeft: '1rem', paddingRight: '1rem' } },
            React__default.createElement(
              'div',
              { style: { flex: '1 1 50%' } },
              React__default.createElement(
                'div',
                { style: { margin: '1rem', padding: '1rem', border: '1px solid #bbb', background: '#eee', color: '#333' } },
                React__default.createElement(Text, {
                  plain: this.state.plain,
                  enabled: false,
                  value: this.state.originalContent.value })
              )
            ),
            React__default.createElement(
              'div',
              { style: { flex: '1 1 50%' } },
              React__default.createElement(
                'div',
                { style: { margin: '1rem', padding: '1rem', border: '1px solid #999' } },
                this.state.foreignContent ? React__default.createElement(Text, {
                  plain: this.state.plain,
                  enabled: true,
                  value: this.state.foreignContent.value,
                  onBlur: this.onForeignTextBlur }) : React__default.createElement(
                  'i',
                  null,
                  'No content to show yet'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TranslationModal;
}(React.Component);

var LanguageSwitcherActionTypes = {
  LANGUAGE_SWITCHER_INITIALISE: 'LANGUAGE_SWITCHER_INITIALISE',
  LANGUAGE_SWITCHER_SWITCH_TO: 'LANGUAGE_SWITCHER_SWITCH_TO'
};

var _createClass$7 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$33(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$19(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$22(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageSwitcherStore = function (_ReduceStore) {
  _inherits$22(LanguageSwitcherStore, _ReduceStore);

  function LanguageSwitcherStore() {
    _classCallCheck$33(this, LanguageSwitcherStore);

    return _possibleConstructorReturn$19(this, (LanguageSwitcherStore.__proto__ || Object.getPrototypeOf(LanguageSwitcherStore)).call(this, Dispatcher$2));
  }

  _createClass$7(LanguageSwitcherStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        available: [],
        current: this.getDefaultLanguage()
      };
    }
  }, {
    key: 'getDefaultLanguage',
    value: function getDefaultLanguage() {
      return 'en_UK';
    }
  }, {
    key: 'getAvailableLanguages',
    value: function getAvailableLanguages() {
      return this.getState().available;
    }
  }, {
    key: 'getCurrentLanguage',
    value: function getCurrentLanguage() {
      return this.getState().current;
    }

    /**
     *
     * @param {{ available: Array, current: null|string }} state
     * @param action
     * @returns {*}
     */

  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case LanguageSwitcherActionTypes.LANGUAGE_SWITCHER_INITIALISE:
          return { available: action.available, current: action.current };

        case LanguageSwitcherActionTypes.LANGUAGE_SWITCHER_SWITCH_TO:
          return { available: state.available, current: action.language };

        default:
          return state;
      }
    }
  }]);

  return LanguageSwitcherStore;
}(ReduceStore);

var LanguageSwitcherStore$1 = new LanguageSwitcherStore();

var LanguageSwitcherActions = {
  initialise: function initialise(available, current) {
    Dispatcher$2.dispatch({
      actionType: LanguageSwitcherActionTypes.LANGUAGE_SWITCHER_INITIALISE,
      available: available,
      current: current
    });
  },
  switchTo: function switchTo(language) {
    Dispatcher$2.dispatch({
      actionType: LanguageSwitcherActionTypes.LANGUAGE_SWITCHER_SWITCH_TO,
      language: language
    });
  }
};

var _createClass$8 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$2 = _taggedTemplateLiteral$2(['\n  margin: .125rem;\n  padding: .25rem .25rem;\n  cursor: pointer;\n  \n  ', ';\n\t\n\tbox-shadow: 1px 1px 4px rgba(0,0,0,.2);\n'], ['\n  margin: .125rem;\n  padding: .25rem .25rem;\n  cursor: pointer;\n  \n  ', ';\n\t\n\tbox-shadow: 1px 1px 4px rgba(0,0,0,.2);\n']),
    _templateObject2$2 = _taggedTemplateLiteral$2(['\n    background-color: #323334;\n    color: #fff;\n    border: 1px solid #222;\n  '], ['\n    background-color: #323334;\n    color: #fff;\n    border: 1px solid #222;\n  ']),
    _templateObject3$1 = _taggedTemplateLiteral$2(['\n    background-color: #ddd;\n    color: #000;\n    border: 1px solid #d4d4d4;\n  '], ['\n    background-color: #ddd;\n    color: #000;\n    border: 1px solid #d4d4d4;\n  ']);

function _taggedTemplateLiteral$2(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$34(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$20(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$23(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageSwitcher = function (_Component) {
  _inherits$23(LanguageSwitcher, _Component);

  function LanguageSwitcher() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$34(this, LanguageSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$20(this, (_ref = LanguageSwitcher.__proto__ || Object.getPrototypeOf(LanguageSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      languages: LanguageSwitcherStore$1.getAvailableLanguages(),
      currentLanguage: LanguageSwitcherStore$1.getCurrentLanguage()
    }, _this.subscriptions = [], _temp), _possibleConstructorReturn$20(_this, _ret);
  }

  _createClass$8(LanguageSwitcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.subscriptions.push(LanguageSwitcherStore$1.addListener(function () {
        _this2.setState({
          languages: LanguageSwitcherStore$1.getAvailableLanguages(),
          currentLanguage: LanguageSwitcherStore$1.getCurrentLanguage()
        });
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        'div',
        { style: {
            padding: '2rem 3rem',
            borderBottom: '.125rem solid #ccc'
          } },
        React__default.createElement(
          'h1',
          { style: {
              marginTop: 0,
              fontWeight: 'normal'
            } },
          __('Translate')
        ),
        React__default.createElement(
          'p',
          null,
          __('Select the language, then click on the text contents to translate.')
        ),
        this.state.languages.map(function (language) {
          return React__default.createElement(
            Button,
            {
              key: language,
              onClick: function onClick() {
                return LanguageSwitcherActions.switchTo(language);
              },
              active: _this3.state.currentLanguage === language },
            __(language)
          );
        })
      );
    }
  }]);

  return LanguageSwitcher;
}(React.Component);

var Button = styled__default.button(_templateObject$2, function (_ref2) {
  var active = _ref2.active;
  return active ? styled.css(_templateObject2$2) : styled.css(_templateObject3$1);
});

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_throttle = throttle;

// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}

var supportsPassive$1 = supportsPassive;

/**
 *
 * @param {Element} element
 * @returns {{offsetTop: number, top: number, bottom: number, height: number}}
 */
function getElementSizePosition(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top,
      bottom = _element$getBoundingC.bottom,
      height = _element$getBoundingC.height;

  var elementOffsetTop = element.offsetTop;

  var offsetTop = Math.round(-1 * (top - elementOffsetTop));

  return {
    offsetTop: offsetTop,
    top: top,
    bottom: bottom,
    height: height
  };
}

var ScreenSizeActionTypes = {
  SCREEN_SIZE_UPDATE: 'SCREEN_SIZE_UPDATE'
};

var _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$9 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$35(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$21(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$24(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScreenSizeStore = function (_ReduceStore) {
  _inherits$24(ScreenSizeStore, _ReduceStore);

  function ScreenSizeStore() {
    _classCallCheck$35(this, ScreenSizeStore);

    return _possibleConstructorReturn$21(this, (ScreenSizeStore.__proto__ || Object.getPrototypeOf(ScreenSizeStore)).call(this, Dispatcher$2));
  }

  _createClass$9(ScreenSizeStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
  }, {
    key: 'getWidth',
    value: function getWidth() {
      return this.getState().width;
    }

    /**
     * @return {number}
     */

  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this.getState().height;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case ScreenSizeActionTypes.SCREEN_SIZE_UPDATE:
          return _extends$17({}, state, { width: action.width, height: action.height });

        default:
          return state;
      }
    }
  }]);

  return ScreenSizeStore;
}(ReduceStore);

var ScreenSizeStore$1 = new ScreenSizeStore();

var _createClass$10 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$36(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$22(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$25(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SCREEN_REFRESH_RATE = 60;
var NOTIFY_SUBSCRIBERS_THROTTLE_WAIT = 1000 / SCREEN_REFRESH_RATE;

var eventOptions = supportsPassive$1 ? { passive: true, capture: false } : false;

var defaultCalculateProgressOptions = {
  leading: false,
  trailing: false
};

function calculateProgress(top, height, screenHeight) {
  var userOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultCalculateProgressOptions;

  var options = _extends$18({}, defaultCalculateProgressOptions, userOptions);

  if (options.leading === false && options.trailing === false) {
    return -1 * top / (height - screenHeight);
  } else if (options.leading === true && options.trailing === false) {
    return -1 * (top - screenHeight) / height;
  } else if (options.leading === false && options.trailing === true) {
    return -1 * top / height;
  } else if (options.leading === true && options.trailing === true) {
    return -1 * (top - screenHeight) / height + screenHeight;
  }
}

var ReactStickyContainer = function (_PureComponent) {
  _inherits$25(ReactStickyContainer, _PureComponent);

  function ReactStickyContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$36(this, ReactStickyContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$22(this, (_ref = ReactStickyContainer.__proto__ || Object.getPrototypeOf(ReactStickyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.events = ['load', 'scroll'], _this.subscribers = [], _this.framePending = false, _this.rafHandle = null, _this.wasActive = false, _this.isActive = false, _this.state = {
      shouldRender: true,
      height: null
    }, _this.subscribe = function (handler) {
      _this.subscribers = _this.subscribers.concat(handler);
    }, _this.unsubscribe = function (handler) {
      _this.subscribers = _this.subscribers.filter(function (current) {
        return current !== handler;
      });
    }, _this.notifySubscribers = function () {
      if (_this.framePending) {
        return;
      }

      _this.framePending = true;

      _this.rafHandle = requestAnimationFrame(function () {
        _this.framePending = false;

        if (_this.node === null) {
          return;
        }

        var _getElementSizePositi = getElementSizePosition(_this.node),
            offsetTop = _getElementSizePositi.offsetTop,
            height = _getElementSizePositi.height,
            top = _getElementSizePositi.top;

        var screenHeight = ScreenSizeStore$1.getHeight();

        var progress = calculateProgress(top, height, screenHeight, {
          leading: _this.props.leading,
          trailing: _this.props.trailing
        });

        _this.wasActive = _this.isActive;

        _this.isActive = progress > 0 && progress < 1;

        var isEntering = _this.isActive !== _this.wasActive && _this.isActive;
        var isLeaving = _this.isActive !== _this.wasActive && !_this.isActive;

        var scrollY = -1 * (top - offsetTop);

        var shouldNotifySubscribers = scrollY > offsetTop - screenHeight && scrollY < offsetTop + height;

        if (shouldNotifySubscribers) {
          _this.setState({ shouldRender: true, height: null });
          _this.subscribers.forEach(function (handler) {
            return handler({ progress: progress, isEntering: isEntering, isLeaving: isLeaving });
          });
        } else {
          _this.setState({
            shouldRender: false,
            height: height
          });
        }

        if (isEntering) {
          _this.props.onEnter && _this.props.onEnter(_this.props.identifier);
        }

        if (isLeaving) {
          _this.props.onLeave && _this.props.onLeave(_this.props.identifier);
        }
      });
    }, _this.notifySubscribersThrottled = lodash_throttle(_this.notifySubscribers, NOTIFY_SUBSCRIBERS_THROTTLE_WAIT), _this.getParent = function () {
      return _this.node;
    }, _temp), _possibleConstructorReturn$22(_this, _ret);
  }

  _createClass$10(ReactStickyContainer, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
        getParent: this.getParent
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.events.forEach(function (event) {
        return window.addEventListener(event, _this2.notifySubscribersThrottled, eventOptions);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this.rafHandle) {
        cancelAnimationFrame(this.rafHandle);
        this.rafHandle = null;
      }

      this.events.forEach(function (event) {
        return window.removeEventListener(event, _this3.notifySubscribersThrottled, eventOptions);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          leading = _props.leading,
          trailing = _props.trailing,
          forwardedRef = _props.forwardedRef,
          props = _objectWithoutProperties$1(_props, ['onEnter', 'onLeave', 'leading', 'trailing', 'forwardedRef']);

      return React__default.createElement(
        'div',
        _extends$18({}, props, {
          ref: function ref(_ref2) {
            _this4.node = _ref2;

            if (typeof forwardedRef === 'function') {
              forwardedRef(_ref2);
            }
          },
          onScroll: this.notifySubscribersThrottled }),
        this.state.shouldRender ? props.children : React__default.createElement('div', { style: { height: this.state.height } })
      );
    }
  }]);

  return ReactStickyContainer;
}(React.PureComponent);

ReactStickyContainer.defaultProps = {
  // When true will begin with progress = 0 as soon as the element becomes
  // visible in the viewport. Otherwise it must reach the top of the viewport.
  leading: false,
  // When true will finish with progress = 1 when the element leaves the
  // screen entirely. Otherwise as soon as part of it leaves the viewport.
  trailing: false,
  onEnter: undefined,
  onLeave: undefined,
  identifier: null
};
ReactStickyContainer.childContextTypes = {
  subscribe: function subscribe() {
    return null;
  },
  unsubscribe: function unsubscribe() {
    return null;
  },
  getParent: function getParent() {
    return null;
  }
};


var ReactStickyContainer$1 = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(ReactStickyContainer, _extends$18({}, props, { forwardedRef: ref }));
});

// Useful inside styled components styles to generate flex-basis from an array
// of sizes.
// Usage: <Component columns={['25%', '75%']} ...
var flexColumns = (function (columns) {
  return columns.map(function (column, index) {
    return "\n  > div:nth-child(" + (index + 1) + ") {\n    flex: 0 0 " + column + ";\n  }\n";
  });
});

var _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$11 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$3 = _taggedTemplateLiteral$3(['\n  0% { background-color: rgba(255,12,0,0.4); }\n  50% { background-color: rgb(255,255,255,.4); }\n  100% { background-color: rgb(255,12,0,.4); }\n'], ['\n  0% { background-color: rgba(255,12,0,0.4); }\n  50% { background-color: rgb(255,255,255,.4); }\n  100% { background-color: rgb(255,12,0,.4); }\n']),
    _templateObject2$3 = _taggedTemplateLiteral$3(['\n  position: relative;\n\n  ', '\n\n  ', '\n\n  /* The Sticky div, cannot be styled directly */\n  > div {\n    position: relative;\n    height: 100%;\n    width: 100%;\n  }\n\n  // When the "columns" props is defined on the StickyContainer element, we can\n  // use it to define a flex-basis for the columns.\n  // Example: <StickyContainer columns={[\'33%\', \'66%\']} ...\n  ', '\n'], ['\n  position: relative;\n\n  ', '\n\n  ', '\n\n  /* The Sticky div, cannot be styled directly */\n  > div {\n    position: relative;\n    height: 100%;\n    width: 100%;\n  }\n\n  // When the "columns" props is defined on the StickyContainer element, we can\n  // use it to define a flex-basis for the columns.\n  // Example: <StickyContainer columns={[\'33%\', \'66%\']} ...\n  ', '\n']),
    _templateObject3$2 = _taggedTemplateLiteral$3(['\n    height: ', 'px;\n  '], ['\n    height: ', 'px;\n  ']),
    _templateObject4$1 = _taggedTemplateLiteral$3(['\n    &:before {\n      content: "";\n      z-index: 99;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      width: .5rem;\n      animation: ', ' 3s linear infinite;\n    }\n  '], ['\n    &:before {\n      content: "";\n      z-index: 99;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      width: .5rem;\n      animation: ', ' 3s linear infinite;\n    }\n  ']);

function _taggedTemplateLiteral$3(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$37(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$23(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$26(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StickyContainer = function (_Component) {
  _inherits$26(StickyContainer, _Component);

  function StickyContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$37(this, StickyContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$23(this, (_ref = StickyContainer.__proto__ || Object.getPrototypeOf(StickyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayMode: _this.props.displayMode
    }, _temp), _possibleConstructorReturn$23(_this, _ret);
  }

  _createClass$11(StickyContainer, [{
    key: 'render',
    value: function render() {
      // Ignore displayMode when passing props to the <Container />
      var _props = this.props,
          displayMode = _props.displayMode,
          leading = _props.leading,
          trailing = _props.trailing,
          props = _objectWithoutProperties$2(_props, ['displayMode', 'leading', 'trailing']);

      return React__default.createElement(
        Container$1,
        _extends$19({}, props, {
          ref: props.forwardedRef,
          mode: this.state.displayMode,
          leading: leading,
          trailing: trailing
        }),
        this.props.children
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(_ref2) {
      var displayMode = _ref2.displayMode;

      return { displayMode: displayMode };
    }
  }]);

  return StickyContainer;
}(React.Component);

StickyContainer.defaultProps = {
  height: null,
  columns: [],
  displayMode: null
};


var StickyContainer$1 = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(StickyContainer, _extends$19({}, props, { forwardedRef: ref }));
});

var backgroundPulse = styled.keyframes(_templateObject$3);

var Container$1 = styled__default(ReactStickyContainer$1)(_templateObject2$3, function (props) {
  return props.height && styled.css(_templateObject3$2, props.height);
}, function (props) {
  return props.mode === DISPLAY_MODE_EDIT && styled.css(_templateObject4$1, backgroundPulse);
}, function (props) {
  return flexColumns(props.columns);
});

var _createClass$12 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$38(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$24(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$27(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noop$1 = function noop() {
  return null;
};

var Sticky = function (_Component) {
  _inherits$27(Sticky, _Component);

  function Sticky() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$38(this, Sticky);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$24(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.progress = 0, _this.isEntering = false, _this.isLeaving = false, _this.onProgressChangeHandler = noop$1, _this.onEnterHandler = noop$1, _this.onLeaveHandler = noop$1, _this.handleContainerEvent = function (_ref2) {
      var progress = _ref2.progress,
          isEntering = _ref2.isEntering,
          isLeaving = _ref2.isLeaving;

      if (_this.progress !== progress) {
        _this.progress = progress;
        _this.onProgressChangeHandler(progress);
      }

      if (_this.isEntering !== isEntering || _this.isLeaving !== isLeaving) {
        _this.isEntering = isEntering;
        _this.isLeaving = isLeaving;

        if (isEntering) {
          _this.onEnterHandler();
        } else if (isLeaving) {
          _this.onLeaveHandler();
        }
      }
    }, _temp), _possibleConstructorReturn$24(_this, _ret);
  }

  _createClass$12(Sticky, [{
    key: "componentWillMount",


    // @todo 2018-07-17
    // @deprecated
    value: function componentWillMount() {
      if (!this.context.subscribe) {
        throw new TypeError("Expected ReactSticky to be mounted within ReactStickyContainer");
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.subscribe(this.handleContainerEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.unsubscribe(this.handleContainerEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        "div",
        null,
        this.props.children({
          setProgressChangeHandler: function setProgressChangeHandler(callback) {
            return _this2.onProgressChangeHandler = callback;
          },
          setOnEnterHandler: function setOnEnterHandler(callback) {
            return _this2.onEnterHandler = callback;
          },
          setOnLeaveHandler: function setOnLeaveHandler(callback) {
            return _this2.onLeaveHandler = callback;
          }
        })
      );
    }
  }]);

  return Sticky;
}(React.Component);

Sticky.defaultProps = {
  topOffset: 0,
  bottomOffset: 0
};
Sticky.contextTypes = {
  subscribe: function subscribe() {
    return null;
  },
  unsubscribe: function unsubscribe() {
    return null;
  },
  getParent: function getParent() {
    return null;
  }
};

/**
 * Restrict {number} to be greater than {min} and smaller than {max}.
 *
 * @param {number} number
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
function clamp(number, min, max) {
  return Math.max(min, Math.min(max, number));
}

var _extends$20 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$13 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$3(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$39(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$25(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$28(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function computeScrollableHeight(reference) {
  return reference.offsetHeight + reference.offsetTop;
}

var StickyContent = function (_Component) {
  _inherits$28(StickyContent, _Component);

  function StickyContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$39(this, StickyContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$25(this, (_ref = StickyContent.__proto__ || Object.getPrototypeOf(StickyContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollableHeight: ScreenSizeStore$1.getHeight()
    }, _this.scrollableReference = null, _this.subscriptions = [], _this.onProgressChange = function (progress) {
      _this.props.onProgressChange(progress, _this.props.identifier);

      // If the scrollableHeight is greater than the screenHeight, we
      // translate the scrollable element as the progress changes.
      // This is to give a slower scroll effect and keep the text for the
      // entire duration of the chapter.
      if (_this.state.scrollableHeight > ScreenSizeStore$1.getHeight()) {
        _this.scrollableReference.style.willChange = 'transform';

        requestAnimationFrame(function () {
          if (_this.scrollableReference !== null) {
            var translateY = (_this.state.scrollableHeight - ScreenSizeStore$1.getHeight()) * clamp(progress, 0, 1);
            _this.scrollableReference.style.transform = 'translate3d(0, -' + translateY + 'px, 0)';

            requestAnimationFrame(function () {
              if (_this.scrollableReference !== null) {
                // See comment in GalleryScroll about the commented "willChange"
                // property.
                // this.scrollableReference.style.willChange = null;
              }
            });
          }
        });
      }
    }, _this.onEnter = function () {
      _this.props.onEnter(_this.props.identifier);

      // We make sure the scrollable height is correct on enter.
      requestAnimationFrame(function () {
        return _this.updateScrollableHeight();
      });
    }, _this.onLeave = function () {
      _this.props.onLeave(_this.props.identifier);
    }, _temp), _possibleConstructorReturn$25(_this, _ret);
  }

  _createClass$13(StickyContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.updateScrollableHeight();
      });

      this.subscriptions.push(LanguageSwitcherStore$1.addListener(function () {
        return (
          // Recompute the height every time the language changes (very likely to
          // change the height of the StickyContent too).
          requestAnimationFrame(function () {
            return _this2.updateScrollableHeight();
          })
        );
      }));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var _this3 = this;

      // Recompute the height every time the props changes (very likely to change
      // the height of the StickyContent too).
      requestAnimationFrame(function () {
        return _this3.updateScrollableHeight();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'updateScrollableHeight',
    value: function updateScrollableHeight() {
      if (this.scrollableReference !== null) {
        this.setState({ scrollableHeight: computeScrollableHeight(this.scrollableReference) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          _props$disableHardwar = _props.disableHardwareAcceleration,
          disableHardwareAcceleration = _props$disableHardwar === undefined ? true : _props$disableHardwar,
          props = _objectWithoutProperties$3(_props, ['disableHardwareAcceleration']);

      return React__default.createElement(
        Sticky,
        { disableHardwareAcceleration: disableHardwareAcceleration },
        function (_ref2) {
          var setProgressChangeHandler = _ref2.setProgressChangeHandler,
              setOnEnterHandler = _ref2.setOnEnterHandler,
              setOnLeaveHandler = _ref2.setOnLeaveHandler;

          setProgressChangeHandler(_this4.onProgressChange);
          setOnEnterHandler(_this4.onEnter);
          setOnLeaveHandler(_this4.onLeave);

          var willChange = disableHardwareAcceleration ? null : 'transform';

          return React__default.createElement(
            'div',
            { className: 'theme-builder-sticky', style: props.style },
            React__default.createElement(
              'div',
              { style: { width: '100%', willChange: willChange }, ref: function ref(_ref3) {
                  _this4.scrollableReference = _ref3;

                  // requestAnimationFrame(() => (
                  _this4.setState(function (state) {
                    if (_ref3 === null || state.scrollableHeight === computeScrollableHeight(_ref3)) {
                      return null;
                    }

                    return _extends$20({}, state, { scrollableHeight: computeScrollableHeight(_ref3) });
                  });
                  // ));
                } },
              props.children
            )
          );
        }
      );
    }
  }]);

  return StickyContent;
}(React.Component);

StickyContent.defaultProps = {
  onProgressChange: function onProgressChange(progress) {
    return null;
  },
  onEnter: function onEnter(id) {
    return null;
  },
  onLeave: function onLeave(id) {
    return null;
  },
  identifier: null
};

function validOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (options === null) {
    return null;
  }

  return Object.keys(options).length > 0 ? options : null;
}

var ContentManager = {
  make: function make(content) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (type === null) {
      throw new Error("Content type can't be [null].");
    }

    return {
      id: content.id,
      type: type,
      value: content.value,
      options: validOptions(content.options),
      language: content.language
    };
  }
};

var _templateObject$4 = _taggedTemplateLiteral$4(['\n\n  ', '\n'], ['\n\n  ', '\n']);

function _taggedTemplateLiteral$4(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Title = styled__default.div(_templateObject$4, function (props) {
  return props.absolute ? '\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 9;\n    margin: 1rem 0;\n  ' : null;
});

var _templateObject$5 = _taggedTemplateLiteral$5(['\n  margin-top: 0;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n\n  ', '\n'], ['\n  margin-top: 0;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n\n  ', '\n']);

function _taggedTemplateLiteral$5(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TitleText = styled__default.h1(_templateObject$5, function (props) {
  return props.inline ? '\n    padding-left: 4rem;\n    padding-top: .125rem;\n    padding-bottom: .125rem;\n  ' : null;
});

var _templateObject$6 = _taggedTemplateLiteral$6(['\n  margin-top: 0;\n  margin-bottom: 0;\n  color: ', ';\n  line-height: 1;\n  font-size: ', 'rem;\n  font-weight: ', ';\n  white-space: nowrap;\n'], ['\n  margin-top: 0;\n  margin-bottom: 0;\n  color: ', ';\n  line-height: 1;\n  font-size: ', 'rem;\n  font-weight: ', ';\n  white-space: nowrap;\n']);

function _taggedTemplateLiteral$6(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$4(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BigChapterNumber = (function (props) {
  var number = props.number,
      rest = _objectWithoutProperties$4(props, ['number']);

  return React__default.createElement(
    Number$1,
    rest,
    ('00' + number).slice(-2)
  );
});

var Number$1 = styled__default.h1(_templateObject$6, function (props) {
  return props.color || themeResponsiveProperty('#b2b2b2', '#000')(props);
}, function (props) {
  return props.small ? themeResponsiveProperty(3.125, 4)(props) : 7.5;
}, themeResponsiveProperty(500, 700));

var THRON_ASSET_TYPE_IMAGE = 'IMAGE';
var THRON_ASSET_TYPE_VIDEO = 'VIDEO';

function isValidOptions(options) {
  return (
    // @todo 2018-06-26
    // This breaks when options === undefined. It happened once and I am not
    // sure it even has to be "fixed". No options should never the "undefined"
    // for a thron image, but rather "null" for no options.
    options !== null && options.id !== undefined && options.pKey !== undefined
  );
}

function thronImage(props) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var size = width * window.devicePixelRatio + 'x' + height * window.devicePixelRatio;

  if (isValidOptions(props.options)) {
    var method = props.options.type === THRON_ASSET_TYPE_IMAGE ? 'image' : 'thumbnail';

    return '//valentino-cdn.thron.com/delivery/public/' + method + '/valentino/' + props.options.id + '/' + props.options.pKey + '/std/' + size + '/' + props.options.id + '?quality=60';
  }

  if (props.src !== null) {
    return props.src.replace('0x0', size);
  }

  console.log("Invalid image: [src, options]:", [props.src, props.options]);

  return null;
}

var _extends$21 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$14 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$40(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$26(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$29(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This is how a Thron asset is represented throughout the application.
 *
 * @param asset
 * @returns {{src: string, options: {id: string, tokenId: string, pKey: string}}}
 */
function exportAsset(asset) {
  var id = asset.id,
      pKey = asset.pKey,
      type = asset.type;


  return {
    src: thronImage({ src: null, options: asset }),
    options: { id: id, pKey: pKey, type: type }
  };
}

function validAsset(asset) {
  return asset && asset.id && asset.pKey;
}

var ThronBrowserTriggerer = function (_Component) {
  _inherits$29(ThronBrowserTriggerer, _Component);

  function ThronBrowserTriggerer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$40(this, ThronBrowserTriggerer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$26(this, (_ref = ThronBrowserTriggerer.__proto__ || Object.getPrototypeOf(ThronBrowserTriggerer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedAssets: _this.props.selectedAssets,
      shouldOpenThronBrowser: false
    }, _this.handleMediaSelectClick = function () {
      if (!_this.state.shouldOpenThronBrowser) {
        return;
      }

      ThronBrowserModalActions.open({
        clientId: 'valentino',
        rootFolders: [{
          name: "APP TRAINING 2018",
          id: 'd3b5484d-85e5-40ae-9686-9ab838e5451c',
          appId: 'CS-R61VGV',
          appKey: '46Lofr45SJs1GxDk4VyweLedHx4aRpdQohpPsKiZFpgtTMOdJH3GPVujeyJBFd9s',
          pKey: 'VB12I8F'
        }, {
          name: "APP LOOKBOOK",
          id: "7ec0d0d6-68b9-4d2b-8d76-704d20cf824f",
          appId: 'CS-FYGEXR',
          appKey: 'ETNROd1eoXdJVvmQFgY1H2LClin07tdMRWbQmxagpOCAmARpO1PCeT4rOUMU0tED',
          pKey: 'VB09I2A'
        }, {
          name: "APP - XPRESS",
          id: "e47024b5-0da2-4f1e-ad77-7d8cdfbf7b74",
          appId: 'CS-HIQBU0',
          appKey: 'WvJ3lmmN5xMSJZFMPMvu1rj8NdwDVDEofJfmj4QTUsthI6ZwbksLnYh8M4OLJNmz',
          pKey: 'VB09I5C'
        }],
        selectedAssets: _this.state.selectedAssets.filter(validAsset),
        onAssetsSelection: function onAssetsSelection(assets) {
          _this.props.onThronBrowserSelectionChange(assets.map(exportAsset));
          ThronBrowserModalActions.close();
        },
        maxSelection: _this.props.singleSelection ? 1 : _this.props.limit
      });
    }, _temp), _possibleConstructorReturn$26(_this, _ret);
  }

  _createClass$14(ThronBrowserTriggerer, [{
    key: 'render',
    value: function render() {
      var style = _extends$21({
        cursor: this.state.shouldOpenThronBrowser ? 'pointer' : null
      }, this.props.style);

      return React__default.createElement(
        'div',
        { ref: this.props.innerRef, onClick: this.handleMediaSelectClick, style: style },
        this.props.children
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        selectedAssets: nextProps.selectedAssets,
        shouldOpenThronBrowser: nextProps.shouldOpenThronBrowser
      };
    }
  }]);

  return ThronBrowserTriggerer;
}(React.Component);

ThronBrowserTriggerer.defaultProps = {
  innerRef: function innerRef(ref) {
    return null;
  },
  singleSelection: false,
  limit: undefined,
  selectedAssets: [],
  shouldOpenThronBrowser: false,
  onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
    return null;
  }
};

var MediaZoomActionTypes = {
  MEDIA_ZOOM_REQUEST_ZOOM: 'MEDIA_ZOOM_REQUEST_ZOOM'
};

var MediaZoomActions = {
  requestZoom: function requestZoom(source, options) {
    Dispatcher$2.dispatch({
      actionType: MediaZoomActionTypes.MEDIA_ZOOM_REQUEST_ZOOM,
      payload: { source: source, options: options }
    });
  }
};

var _createClass$15 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$7 = _taggedTemplateLiteral$7(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2$4 = _taggedTemplateLiteral$7(['\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateY(-50%) translateX(-50%);\n    font-size: 0;\n    cursor: pointer;\n'], ['\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateY(-50%) translateX(-50%);\n    font-size: 0;\n    cursor: pointer;\n']);

function _taggedTemplateLiteral$7(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$41(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$27(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$30(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Scale down the width or height (size) of an image. Thron luckily has a
 * minimum value, so asking for a 10x10 image gets us a very small image with
 * its ratio preserved (when scaling it up it'll occupy the same space as the
 * full resolution image).
 *
 * @param size
 * @returns {number}
 */
function lowResolution(size) {
  return 10;
}

var ThronAssetZoom = function (_Component) {
  _inherits$30(ThronAssetZoom, _Component);

  function ThronAssetZoom() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$41(this, ThronAssetZoom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$27(this, (_ref = ThronAssetZoom.__proto__ || Object.getPrototypeOf(ThronAssetZoom)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      shouldHandleZoom: _this.props.shouldHandleZoom,
      src: thronImage({ src: _this.props.src, options: _this.props.options }, lowResolution(_this.props.width), lowResolution(_this.props.height)),
      isLowResolution: true,
      // These are not updated on window resize. Would be too expensive.
      clientWidth: undefined,
      clientHeight: undefined
    }, _this.handleClick = function () {
      if (_this.state.shouldHandleZoom()) {
        MediaZoomActions.requestZoom(_this.state.src, _this.props.options);
      }
    }, _this.handleThronImageLoad = function (event) {
      var _event$target = event.target,
          clientWidth = _event$target.clientWidth,
          clientHeight = _event$target.clientHeight;


      if (_this.state.isLowResolution) {
        var nextSrc = thronImage({ src: _this.props.src, options: _this.props.options }, clientWidth, clientHeight);

        _this.setState({
          src: nextSrc,
          isLowResolution: false,
          clientWidth: clientWidth,
          clientHeight: clientHeight
        });
      } else {
        _this.props.image.onLoad && _this.props.image.onLoad(event);
      }
    }, _temp), _possibleConstructorReturn$27(_this, _ret);
  }

  _createClass$15(ThronAssetZoom, [{
    key: 'render',
    value: function render() {
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          ImageWrapper,
          {
            style: this.props.wrapperStyle,
            options: this.props.options,
            onClick: this.handleClick },
          this.props.src === null ? React__default.createElement('img', {
            className: 'tci_impression_load_click',
            src: this.state.src,
            onLoad: this.handleThronImageLoad,
            style: this.props.image.style }) : React__default.createElement('img', {
            className: 'tci_impression_load_click',
            src: this.state.src,
            onLoad: this.props.image.onLoad,
            style: this.props.image.style }),
          this.props.options !== null && this.props.options.type === THRON_ASSET_TYPE_VIDEO && React__default.createElement(
            ImageOverlayIcon,
            null,
            React__default.createElement(
              'svg',
              { viewBox: '0 0 26 26', style: { width: '3.25rem', height: '3.25rem' } },
              React__default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd' },
                React__default.createElement('path', { stroke: '#979797', strokeWidth: .5, fillOpacity: .83, fill: '#272727', d: 'M.25.25h25.5v25.5H.25z' }),
                React__default.createElement('path', { fill: '#FFF', d: 'M16.073 12.934L10.4 17.046V8.82z' })
              )
            )
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextState = {};

      var nextSrc = thronImage({ src: nextProps.src, options: nextProps.options }, prevState.isLowResolution ? lowResolution(nextProps.width) : prevState.clientWidth, prevState.isLowResolution ? lowResolution(nextProps.height) : prevState.clientHeight);

      if (prevState.shouldHandleZoom !== nextProps.shouldHandleZoom) {
        nextState.shouldHandleZoom = nextProps.shouldHandleZoom;
      }

      if (nextSrc !== prevState.src) {
        nextState.src = nextSrc;
      }

      return Object.keys(nextState).length === 0 ? null : nextState;
    }
  }]);

  return ThronAssetZoom;
}(React.Component);

ThronAssetZoom.defaultProps = {
  shouldReplaceImage: true,
  shouldHandleZoom: function shouldHandleZoom() {
    return true;
  },
  src: null,
  options: null,
  wrapperStyle: undefined
};

var ImageWrapper = styled__default.div(_templateObject$7);

var ImageOverlayIcon = styled__default.div(_templateObject2$4);

var _extends$22 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$5(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Image = (function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      imageContainerStyle = _ref.imageContainerStyle,
      wrapperStyle = _ref.wrapperStyle,
      props = _objectWithoutProperties$5(_ref, ['width', 'height', 'imageContainerStyle', 'wrapperStyle']);

  var hasChildren = props.children !== undefined;

  var ImageContainer = React.useMemo(function () {
    return hasChildren ? function (_ref2) {
      var style = _ref2.style,
          props = _objectWithoutProperties$5(_ref2, ['style']);

      return React__default.createElement('div', _extends$22({ style: _extends$22({ position: 'relative', maxHeight: '100%' }, style) }, props));
    } : function (_ref3) {
      var key = _ref3.key,
          children = _ref3.children;
      return React__default.createElement(React__default.Fragment, { key: key, children: children });
    };
  }, [hasChildren]);

  return React__default.createElement(
    ImageContainer,
    { style: imageContainerStyle },
    React__default.createElement(ThronAssetZoom, {
      shouldReplaceImage: false,
      shouldHandleZoom: function shouldHandleZoom() {
        return props.shouldHandleZoom;
      },
      src: props.options !== null ? null : props.src,
      options: props.options,
      wrapperStyle: wrapperStyle,
      width: width,
      height: height,
      image: {
        onLoad: props.onLoad,
        style: _extends$22({
          display: 'block',
          width: '100%',
          height: '100%',
          cursor: props.shouldHandleZoom ? 'zoom-in' : null
        }, props.style)
      }
    }),
    props.children
  );
});

var _extends$23 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$16 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$42(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$28(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$31(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Media = function (_Component) {
  _inherits$31(Media, _Component);

  function Media() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$42(this, Media);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$28(this, (_ref = Media.__proto__ || Object.getPrototypeOf(Media)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      src: _this.props.src,
      options: _this.props.options,
      shouldOpenThronBrowser: _this.props.shouldOpenThronBrowser
    }, _this.onThronBrowserSelectionChange = function (assets) {
      var asset = assets[0];

      if (asset !== undefined) {
        _this.props.onChange({ value: asset.src, options: asset.options });
      }
    }, _temp), _possibleConstructorReturn$28(_this, _ret);
  }

  _createClass$16(Media, [{
    key: 'render',
    value: function render() {
      return React__default.createElement(
        ThronBrowserTriggerer,
        {
          style: this.props.style,
          singleSelection: true,
          selectedAssets: [this.state.options],
          shouldOpenThronBrowser: this.state.shouldOpenThronBrowser,
          onThronBrowserSelectionChange: this.onThronBrowserSelectionChange },
        React__default.createElement(Image, {
          width: this.props.width,
          height: this.props.height,
          imageContainerStyle: this.props.imageContainerStyle,
          wrapperStyle: this.props.wrapperStyle,
          src: this.state.src,
          options: this.state.options,
          onLoad: this.props.onLoad,
          shouldHandleZoom: !this.state.shouldOpenThronBrowser,
          style: imageStyle(this.props),
          children: this.props.children
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        src: nextProps.src,
        options: nextProps.options,
        shouldOpenThronBrowser: nextProps.shouldOpenThronBrowser,
        shouldZoom: nextProps.shouldZoom === null ? !nextProps.shouldOpenThronBrowser : nextProps.shouldZoom
      };
    }
  }]);

  return Media;
}(React.Component);

Media.defaultProps = {
  src: null,
  options: null,
  shouldOpenThronBrowser: false,
  shouldZoom: null,
  onChange: function onChange(id) {
    return null;
  },
  onLoad: function onLoad(e) {
    return null;
  },

  width: undefined,
  height: undefined,
  wrapperStyle: undefined
};

var imageStyle = function imageStyle(props) {
  return _extends$23({
    /*
     * I am not sure this works in every occasion. Consider passing height|width
     * from props.
     */
    height: null,
    boxShadow: props.shadow ? 'rgba(0, 0, 0, 0.16) -3px -1px 8px' : null
  }, props.style);
};

var _extends$24 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function makeContent(type) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return _extends$24({}, { id: null, value: value, type: type, language: 'en_UK', options: options });
}

var _extends$25 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$17 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$8 = _taggedTemplateLiteral$8(['\n  display: inline;\n\n  .md-RichEditor-root {\n    display: flex;\n  }\n\n  // @todo 2018-05-21 Not really a fan of that, but might be fine.\n  .md-RichEditor-editor {\n    cursor: ', ';\n    flex: 1;\n  }\n'], ['\n  display: inline;\n\n  .md-RichEditor-root {\n    display: flex;\n  }\n\n  // @todo 2018-05-21 Not really a fan of that, but might be fine.\n  .md-RichEditor-editor {\n    cursor: ', ';\n    flex: 1;\n  }\n']);

function _taggedTemplateLiteral$8(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$43(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$29(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$32(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isContentEqual(content1, content2) {
  return content1.id === content2.id && content1.language === content2.language;
}

function isEditorValueEmpty(content) {
  // @todo 2018-05-24 This is a really weak check, but should do.
  return content === null || content.value === null || content.value === '<p></p>';
}

var TextTranslatable = function (_Component) {
  _inherits$32(TextTranslatable, _Component);

  function TextTranslatable(props) {
    _classCallCheck$43(this, TextTranslatable);

    var _this = _possibleConstructorReturn$29(this, (TextTranslatable.__proto__ || Object.getPrototypeOf(TextTranslatable)).call(this, props));

    _this.subscriptions = [];
    _this.originalContent = null;
    _this.state = {
      displayMode: _this.props.displayMode,
      currentLanguage: LanguageSwitcherStore$1.getCurrentLanguage(),
      content: _this.props.content
    };

    _this.handleLanguageSwitcherStoreChange = function () {
      _this.setState({ currentLanguage: LanguageSwitcherStore$1.getCurrentLanguage() }, function () {
        _this.props.onLanguageChange(_this.originalContent.id, _this.state.currentLanguage).then(function (content) {
          // If we couldn't find a translation of the content, we crate a new
          // content with the current language. We are then able to show a
          // "translate me" placeholder.
          var nextContent = content !== null ? content : _extends$25({}, makeContent('text'), { id: _this.originalContent.id, language: _this.state.currentLanguage });

          _this.setState({ content: nextContent });
        }).catch(console.error);
      });
    };

    _this.shouldTranslate = function () {
      return _this.state.displayMode === DISPLAY_MODE_TRANSLATE && _this.state.content.language !== _this.originalContent.language && !isEditorValueEmpty(_this.originalContent.value);
    };

    _this.shouldShowPlaceholder = function () {
      return _this.state.displayMode === DISPLAY_MODE_EDIT || _this.state.displayMode === DISPLAY_MODE_TRANSLATE && !isEditorValueEmpty(_this.originalContent.value);
    };

    _this.onContentUpdate = function (content) {
      // We could use the callback (.then(content => ...) on the onContentUpdate
      // call below. But it could be asynchronous, making it unsuitable for what
      // we are trying to do here: we need to update the <Text ... /> as soon as
      // the translation modal is closed. The asynchronous call could update the
      // this.state.content after we've switched language (switching language
      // replaces the this.state.content value), which would destroy the integrity
      // of our state.
      if (isContentEqual(content, _this.state.content)) {
        _this.setState({ content: content });
      }

      return _this.props.onContentUpdate(content);
    };

    _this.onBlur = function (value) {
      _this.setState({ content: setContentValue(_this.state.content, value) });
      _this.props.onBlur(value);
    };

    _this.handleOnWrapperClick = function () {
      if (!_this.shouldTranslate()) {
        return;
      }

      TranslationModalActions.open({
        plain: _this.props.plain,
        originalContent: _this.originalContent,
        foreignContent: _this.state.content,
        onLanguageChange: _this.props.onLanguageChange,
        onContentUpdate: _this.onContentUpdate
      });
    };

    _this.originalContent = props.content;
    return _this;
  }

  _createClass$17(TextTranslatable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.subscriptions.push(LanguageSwitcherStore$1.addListener(this.handleLanguageSwitcherStoreChange));

      if (LanguageSwitcherStore$1.getDefaultLanguage() !== LanguageSwitcherStore$1.getCurrentLanguage()) {
        this.handleLanguageSwitcherStoreChange();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (isEditorValueEmpty(this.originalContent) && this.state.displayMode === DISPLAY_MODE_TRANSLATE) {
        return null;
      }

      return React__default.createElement(
        Wrapper,
        { clickable: this.shouldTranslate(), onClick: this.handleOnWrapperClick },
        React__default.createElement(Text, {
          plain: this.props.plain,
          highlight: this.props.highlight,
          enabled: this.state.displayMode === DISPLAY_MODE_EDIT,
          placeholder: this.shouldShowPlaceholder(),
          placeholderText: this.state.displayMode === DISPLAY_MODE_TRANSLATE ? __('Translate…') : undefined,
          value: this.state.content.value,
          onBlur: this.onBlur })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.displayMode !== prevState.displayMode) {
        return { displayMode: nextProps.displayMode };
      }

      return null;
    }
  }]);

  return TextTranslatable;
}(React.Component);

TextTranslatable.defaultProps = {
  displayMode: DISPLAY_MODE_PREVIEW,
  plain: false,
  highlight: undefined,
  content: null,
  onLanguageChange: function onLanguageChange(id, language) {
    return null;
  },
  onContentUpdate: function onContentUpdate(content) {
    return null;
  },
  onBlur: function onBlur(contentValue) {
    return null;
  }
};

var Wrapper = styled__default.div(_templateObject$8, function (props) {
  return props.clickable ? 'pointer' : null;
});

function _objectWithoutProperties$6(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TemplateControl = (function (props) {
  var displayMode = props.displayMode,
      children = props.children,
      rest = _objectWithoutProperties$6(props, ['displayMode', 'children']);

  if (displayMode === DISPLAY_MODE_EDIT || displayMode === DISPLAY_MODE_PREVIEW) {
    return React__default.createElement(
      'div',
      rest,
      children
    );
  }

  return null;
});

var _templateObject$9 = _taggedTemplateLiteral$9(['\n\tmargin: .125rem;\n  padding: .25rem .25rem;\n\tcursor: pointer;\n\t\n\t', ';\n\n\tfont-size: .625rem;\n\tbox-shadow: 1px 1px 4px rgba(0,0,0,.2);\n\t\n\t&[disabled] {\n\t\tcursor: default;\n\t\tcolor: #eee;\n\t\tbackground-color: #333;\n\t\tborder: 1px solid #222;\n\t\tfont-style: italic;\n\t}\n'], ['\n\tmargin: .125rem;\n  padding: .25rem .25rem;\n\tcursor: pointer;\n\t\n\t', ';\n\n\tfont-size: .625rem;\n\tbox-shadow: 1px 1px 4px rgba(0,0,0,.2);\n\t\n\t&[disabled] {\n\t\tcursor: default;\n\t\tcolor: #eee;\n\t\tbackground-color: #333;\n\t\tborder: 1px solid #222;\n\t\tfont-style: italic;\n\t}\n']),
    _templateObject2$5 = _taggedTemplateLiteral$9(['\n    background-color: #323334;\n    color: #fff;\n    border: 1px solid #222;\n  '], ['\n    background-color: #323334;\n    color: #fff;\n    border: 1px solid #222;\n  ']),
    _templateObject3$3 = _taggedTemplateLiteral$9(['\n    background-color: #ddd;\n    color: #000;\n    border: 1px solid #d4d4d4;\n  '], ['\n    background-color: #ddd;\n    color: #000;\n    border: 1px solid #d4d4d4;\n  ']);

function _taggedTemplateLiteral$9(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TemplateControlButton = styled__default.button(_templateObject$9, function (_ref) {
	var active = _ref.active;
	return active ? styled.css(_templateObject2$5) : styled.css(_templateObject3$3);
});

var TemplateControlDefaultButtons = (function (_ref) {
  var displayMode = _ref.displayMode,
      remove = _ref.remove,
      moveUp = _ref.moveUp,
      moveDown = _ref.moveDown,
      handleDisplayModeSwitch = _ref.handleDisplayModeSwitch;
  return React__default.createElement(
    React__default.Fragment,
    null,
    React__default.createElement(
      TemplateControlButton,
      { onClick: remove },
      'Remove'
    ),
    React__default.createElement(
      TemplateControlButton,
      { onClick: moveUp },
      'Up'
    ),
    React__default.createElement(
      TemplateControlButton,
      { onClick: moveDown },
      'Down'
    ),
    React__default.createElement(
      TemplateControlButton,
      { onClick: handleDisplayModeSwitch },
      'Edit'
    )
  );
});

var OverallProgressActionTypes = {
  OVERALL_PROGRESS_SET_CURRENT_TEMPLATE: 'OVERALL_PROGRESS_SET_CURRENT_TEMPLATE'
};

var OverallProgressActions = {
  setCurrentTemplate: function setCurrentTemplate(index) {
    /** @var TPayload payload */
    var payload = {
      actionType: OverallProgressActionTypes.OVERALL_PROGRESS_SET_CURRENT_TEMPLATE,
      index: index
    };

    // @todo 2018-07-12 Refactor this and understand why we need the setTimeout
    // Fixes:
    // warning.js:33 Warning: Cannot update during an existing state transition
    // (such as within `render` or another component's constructor). Render
    // methods should be a pure function of props and state; constructor
    // side-effects are an anti-pattern, but can be moved to
    // `componentWillMount`.
    setTimeout(function () {
      return Dispatcher$2.dispatch(payload);
    }, 0);
  }
};

var _extends$26 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$18 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$7(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$44(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$30(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$33(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getOppositeDisplayMode(mode) {
  if (mode === DISPLAY_MODE_TRANSLATE) {
    return DISPLAY_MODE_TRANSLATE;
  }

  return mode === DISPLAY_MODE_EDIT ? DISPLAY_MODE_PREVIEW : DISPLAY_MODE_EDIT;
}

function asTemplate(templateName, Template, blueprintCallback, backgroundColor) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits$33(AsTemplate, _Component);

    function AsTemplate() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$44(this, AsTemplate);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$30(this, (_ref = AsTemplate.__proto__ || Object.getPrototypeOf(AsTemplate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        screenHeight: ScreenSizeStore$1.getHeight(),
        screenWidth: ScreenSizeStore$1.getWidth(),
        displayMode: _this.props.displayMode
      }, _this.subscriptions = [], _this.handleDisplayModeSwitch = function () {
        _this.setState({ displayMode: getOppositeDisplayMode(_this.state.displayMode) });
      }, _this.handleOnEnter = function (index, backgroundColor) {
        OverallProgressActions.setCurrentTemplate(index);

        if (_this.props.containerReference !== null) {
          // this.props.containerReference.style.willChange = 'background-color';
          // this.props.containerReference.style.transition = 'background-color 300ms ease';
          // this.props.containerReference.style.backgroundColor = backgroundColor !== undefined
          //   ? backgroundColor
          //   : '';
        }
      }, _this.handleOnLeave = function (backgroundColor) {
        if (_this.props.containerReference !== null) {
          // this.props.containerReference.style.willChange = 'background-color';
          // this.props.containerReference.style.transition = '';
          // this.props.containerReference.style.backgroundColor = '';
        }
      }, _temp), _possibleConstructorReturn$30(_this, _ret);
    }

    _createClass$18(AsTemplate, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.subscriptions.push(ScreenSizeStore$1.addListener(function () {
          _this2.setState({
            screenHeight: ScreenSizeStore$1.getHeight(),
            screenWidth: ScreenSizeStore$1.getWidth()
          });
        }));
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.subscriptions.forEach(function (subscription) {
          return subscription.remove();
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            onContentLanguageChange = _props.onContentLanguageChange,
            containerReference = _props.containerReference,
            buttons = _props.buttons,
            index = _props.index,
            language = _props.language,
            highlightWord = _props.highlightWord,
            rest = _objectWithoutProperties$7(_props, ['onContentLanguageChange', 'containerReference', 'buttons', 'index', 'language', 'highlightWord']);

        return React__default.createElement(Template, _extends$26({}, rest, {
          index: index,
          buttons: buttons.map(function (Button, index) {
            return function (contentId) {
              return React.cloneElement(Button, {
                key: index,
                chapter: _this3.props.content,
                contentId: contentId,
                displayMode: _this3.state.displayMode
              });
            };
          }),
          templateName: templateName,
          language: language,
          highlightWord: highlightWord,
          screenHeight: this.state.screenHeight,
          screenWidth: this.state.screenWidth,
          displayMode: this.state.displayMode,
          onEnter: function onEnter() {
            return _this3.handleOnEnter(index, backgroundColor);
          },
          onLeave: function onLeave() {
            return _this3.handleOnLeave(backgroundColor);
          },
          onContentLanguageChange: onContentLanguageChange,
          handleDisplayModeSwitch: this.handleDisplayModeSwitch }));
      }
    }], [{
      key: 'blueprint',
      value: function blueprint() {
        return _extends$26({}, blueprintCallback(templateName));
      }
    }]);

    return AsTemplate;
  }(React.Component), _class.TEMPLATE_NAME = templateName, _temp2;
}

// https://stackoverflow.com/a/42769683

/**
 * Memoize document fontSize
 */
// let fontSize;

/**
 *
 * @param {number} rem
 * @returns {number}
 */
function remToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);

  // return rem * (
  //   fontSize !== undefined
  //     ? fontSize
  //     : (fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize))
  // );
}

var ButtonList = (function (_ref) {
  var displayMode = _ref.displayMode,
      buttons = _ref.buttons,
      content = _ref.content;

  if (displayMode === DISPLAY_MODE_EDIT && content.id === null) {
    return React__default.createElement(
      TemplateControlButton,
      { disabled: true, type: 'button' },
      '(disabled) Click the save button first'
    );
  }

  if (content.id !== null) {
    return buttons.map(function (button) {
      return button(content.id);
    });
  }

  return null;
});

var _extends$27 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties$8(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Scrollable(_ref) {
  var _ref$innerPaddingTop = _ref.innerPaddingTop,
      innerPaddingTop = _ref$innerPaddingTop === undefined ? 0 : _ref$innerPaddingTop,
      _ref$innerPaddingBott = _ref.innerPaddingBottom,
      innerPaddingBottom = _ref$innerPaddingBott === undefined ? 0 : _ref$innerPaddingBott,
      onProgressCallback = _ref.onProgressCallback,
      _ref$fade = _ref.fade,
      fade = _ref$fade === undefined ? false : _ref$fade,
      _ref$fadeColor = _ref.fadeColor,
      fadeColor = _ref$fadeColor === undefined ? ['#000', 'rgb(0 0 0 / 0)'] : _ref$fadeColor,
      style = _ref.style,
      children = _ref.children,
      props = _objectWithoutProperties$8(_ref, ['innerPaddingTop', 'innerPaddingBottom', 'onProgressCallback', 'fade', 'fadeColor', 'style', 'children']);

  var containerReference = React.useRef(null);
  var innerReference = React.useRef(null);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldFadeContent = _useState2[0],
      setShouldFadeContent = _useState2[1];

  React.useEffect(function () {
    function callback(progress) {
      if (containerReference.current === null || innerReference.current === null) {
        return;
      }

      var containerHeight = containerReference.current.offsetHeight;

      var scrollableHeight = innerReference.current.offsetHeight + innerReference.current.offsetTop;

      var scrollableHeightWithoutFade = scrollableHeight -
      // we ignore the padding that may be present because of
      // shouldFadeContent
      parseInt(innerReference.current.style.paddingBottom, 10);

      if (scrollableHeightWithoutFade <= containerHeight) {
        setShouldFadeContent(false);
        return;
      }

      setShouldFadeContent(fade);

      containerReference.current.scrollTop = clamp(progress, 0, 1) * (scrollableHeight - containerHeight);
    }

    callback(0);
    onProgressCallback(callback);
  }, [containerReference, innerReference, onProgressCallback]);

  // @todo 2021-07-22
  //   Not sure if needed. Might cause unexpected results when fade is toggled.
  var WrapperComponent = React__default.useMemo(function () {
    return shouldFadeContent === true ? function (_ref2) {
      var style = _ref2.style,
          props = _objectWithoutProperties$8(_ref2, ['style']);

      return React__default.createElement('div', _extends$27({ style: _extends$27({
          overflow: 'hidden',
          position: shouldFadeContent === true ? 'relative' : null,
          width: '100%'
        }, style) }, props));
    } : React__default.Fragment;
  }, [shouldFadeContent]);

  return React__default.createElement(
    WrapperComponent,
    null,
    React__default.createElement(
      'div',
      _extends$27({}, props, { ref: containerReference, style: _extends$27({ overflowY: 'auto', width: '100%' }, style) }),
      React__default.createElement(
        'div',
        {
          ref: innerReference,
          style: {
            paddingTop: innerPaddingTop,
            paddingBottom:
            // we make sure to add some padding to correctly show the entire
            // content without covering it with the fade effect. If the user
            // supplies a value for innerPaddingBottom we respect it.
            shouldFadeContent && innerPaddingBottom === 0 ? '4rem' : innerPaddingBottom
          }
        },
        children
      )
    ),
    shouldFadeContent === true && React__default.createElement('div', { style: {
        zIndex: 1,
        position: 'absolute',
        right: 0,
        bottom: 0,
        left: 0,
        height: '4rem',
        background: 'linear-gradient(0deg, ' + fadeColor[0] + ' 0%, ' + fadeColor[1] + ' 100%)'
      } })
  );
}

var _extends$28 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$19 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$45(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$31(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$34(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Intro = function (_Component) {
  _inherits$34(Intro, _Component);

  function Intro() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$45(this, Intro);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$31(this, (_ref = Intro.__proto__ || Object.getPrototypeOf(Intro)).call.apply(_ref, [this].concat(args))), _this), _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$28({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.handleSaveChapterClick = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$28({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                media: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$31(_this, _ret);
  }

  _createClass$19(Intro, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        media: chapter.media
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          onEnter: this.props.onEnter,
          height: this.state.screenHeight * 2
        },
        React__default.createElement(
          StickyContent,
          {
            onProgressChange: function onProgressChange(progress) {
              if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                _this3.textScrollableCallback(progress);
              }
            },
            style: {
              height: this.state.screenHeight
            }
          },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '.5rem', right: '.5rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                paddingTop: '3rem'
              } },
            React__default.createElement(Media, {
              src: this.state.media.value,
              options: this.state.media.options,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              onChange: this.onMediaChange })
          ),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '1.5rem',
                left: '1rem'
              } },
            React__default.createElement(BigChapterNumber, { small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                position: 'absolute',
                right: '1.5rem',
                bottom: '1.5rem',
                left: '1.5rem',
                padding: '0 1.25rem',
                color: '#fff',
                background: '#000'
              } },
            React__default.createElement(
              Scrollable,
              {
                innerPaddingTop: '1.25rem',
                innerPaddingBottom: '4rem',
                fade: true,
                onProgressCallback: function onProgressCallback(callback) {
                  return _this3.textScrollableCallback = callback;
                },
                style: {
                  pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                  height: this.state.screenHeight * .625 - remToPixels(1.5)
                }
              },
              React__default.createElement(
                Title,
                null,
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: {
                  // minWidth: '1.375rem',
                  // marginLeft: '.5rem',
                  paddingBottom: '1rem',
                  paddingTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                } },
              React__default.createElement('div', null),
              React__default.createElement(
                'div',
                { style: {
                    fontSize: 0,
                    textAlign: 'end'
                  } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.text
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 1.5,
          onEnter: this.props.onEnter,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          {
            disableHardwareAcceleration: true,
            style: {
              display: 'flex',
              alignItems: 'center',
              height: this.state.screenHeight,
              paddingLeft: '3.5rem',
              zIndex: this.state.displayMode === DISPLAY_MODE_EDIT ? 1 : 2
            } },
          React__default.createElement(Media, {
            width: remToPixels(28.5),
            src: this.state.media.value,
            options: this.state.media.options,
            shadow: true,
            shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
            onChange: this.onMediaChange }),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '7.5rem',
                right: '2.75rem'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(0,0,0,0.7)', number: this.state.index + 1 })
          )
        ),
        React__default.createElement(
          StickyContent,
          { style: { zIndex: this.state.displayMode === DISPLAY_MODE_EDIT ? 2 : 1, padding: '6.5rem 5rem 0 0', height: this.state.screenHeight } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', left: '0', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { position: 'relative', padding: '3.125rem', color: '#fff', background: '#000' } },
            React__default.createElement('div', { style: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '-3.125rem',
                width: '3.125rem',
                backgroundColor: '#000'
              } }),
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(
              'div',
              null,
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: { zIndex: 1, position: 'absolute', top: 0, right: '1rem', minWidth: '1rem', height: '2rem' } },
              React__default.createElement(ButtonList, {
                displayMode: this.state.displayMode,
                buttons: this.props.buttons,
                content: this.state.text })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Intro;
}(React.Component);

var blueprint = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/700x500')
  };
};

var Intro$1 = styled.withTheme(asTemplate('Intro', Intro, blueprint));

var DIRECTION_UP = 'DIRECTION_UP';
var DIRECTION_RIGHT = 'DIRECTION_RIGHT';
var DIRECTION_DOWN = 'DIRECTION_DOWN';
var DIRECTION_LEFT = 'DIRECTION_LEFT';

function isHorizontal(direction) {
  return direction === DIRECTION_RIGHT || direction === DIRECTION_LEFT;
}

function isVertical(direction) {
  return direction === DIRECTION_UP || direction === DIRECTION_DOWN;
}

var ThronAsset = (function (props) {
  return React__default.createElement(Image, props);
});

var _extends$29 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$20 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$46(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$32(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$35(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThronAssetTranslatable = function (_Component) {
  _inherits$35(ThronAssetTranslatable, _Component);

  function ThronAssetTranslatable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$46(this, ThronAssetTranslatable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$32(this, (_ref = ThronAssetTranslatable.__proto__ || Object.getPrototypeOf(ThronAssetTranslatable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      asset: _this.props.asset,
      displayMode: _this.props.displayMode,
      currentLanguage: LanguageSwitcherStore$1.getCurrentLanguage()
    }, _this.subscriptions = [], _this.originalContent = _this.props.asset, _this.handleLanguageSwitcherStoreChange = function () {
      _this.setState({ currentLanguage: LanguageSwitcherStore$1.getCurrentLanguage() }, function () {
        _this.props.onLanguageChange(_this.originalContent.id, _this.state.currentLanguage).then(_this._handleOnLanguageChange).catch(console.error);
      });
    }, _this._handleOnLanguageChange = function (asset) {
      if (asset !== null) {
        _this.setState({ asset: asset });
        return;
      }

      // if we do not find a translate asset, we request the original one. We
      // cannot use originalContent because it might have changed since we
      // mounted this component.
      _this.props.onLanguageChange(_this.originalContent.id, _this.originalContent.language).then(function (asset) {
        // We override the language property to make it look like this asset is
        // of the currently active language and match the render condition:
        // this.state.currentLanguage === this.state.asset.language.
        // This is needed to avoid requesting the original language asset on
        // page load as well as the translated asset once the currentLanguage is
        // updated.
        var nextAsset = _extends$29({}, asset, { language: _this.state.currentLanguage });
        _this.setState({ asset: nextAsset });
      });
    }, _this.onContentChange = function (assets) {
      var asset = assets[0];

      var content = _extends$29({}, _this.originalContent, {
        value: asset.src,
        options: asset.options,
        language: _this.state.currentLanguage
      });

      _this.setState({ asset: content });

      _this.props.onContentUpdate(content);
    }, _this.shouldTranslate = function () {
      return _this.props.canTranslateAsset && _this.state.displayMode === DISPLAY_MODE_TRANSLATE && _this.state.asset.language !== _this.originalContent.language;
    }, _temp), _possibleConstructorReturn$32(_this, _ret);
  }

  _createClass$20(ThronAssetTranslatable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.subscriptions.push(LanguageSwitcherStore$1.addListener(this.handleLanguageSwitcherStoreChange));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'shouldRenderAsset',
    value: function shouldRenderAsset() {
      return true;

      // @todo 2018-12-08 Disabled, it prevents the render of the default images.
      // return ((
      //   // If we are not in static (what the end user sees) nor translate we
      //   // just show the asset, otherwise the currentLanguage must match the
      //   // asset language. This check is needed to avoid loading both the
      //   // default language asset and the localised one.
      //   this.state.displayMode !== DISPLAY_MODE_STATIC &&
      //   this.state.displayMode !== DISPLAY_MODE_TRANSLATE
      // ) || this.state.currentLanguage === this.state.asset.language);
    }
  }, {
    key: 'render',
    value: function render() {
      // we use the asset.value as src and the originalContent.options for options
      // because the content translations don't have "options", therefore we use
      // the original language content's options.
      return React__default.createElement(
        ThronBrowserTriggerer,
        {
          style: this.props.wrapperStyle,
          selectedAssets: [this.state.asset.options],
          singleSelection: true,
          shouldOpenThronBrowser: this.shouldTranslate(),
          onThronBrowserSelectionChange: this.onContentChange },
        this.shouldRenderAsset() && React__default.createElement(ThronAsset, _extends$29({}, this.props, {
          shouldHandleZoom: this.state.displayMode !== DISPLAY_MODE_EDIT && !this.shouldTranslate(),
          src: this.state.asset.value,
          options: this.state.asset.options }))
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextState = {};

      // We only want to use the parent asset value when we are in edit mode, in
      // every other case the asset value is managed by the handleLanguageSwitcherStoreChange
      // function. Might be in need of a refactor.
      if (nextProps.displayMode === DISPLAY_MODE_EDIT) {
        if (nextProps.asset !== prevState.asset) {
          nextState.asset = nextProps.asset;
        }
      }

      if (nextProps.displayMode !== prevState.displayMode) {
        nextState.displayMode = nextProps.displayMode;
      }

      return Object.keys(nextState).length > 0 ? nextState : null;
    }
  }]);

  return ThronAssetTranslatable;
}(React.Component);

var _createClass$21 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$30 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$9(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$47(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$33(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$36(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function seekValue(progress, end) {
  return progress / 1 * end;
}

/**
 *
 * @param progress
 * @param direction
 * @param containerReference
 * @param innerReference
 * @returns {string|null}
 */
var transitionFactory = function transitionFactory(progress, direction, containerReference, innerReference) {
  var innerScrollHeight = 0;
  var innerScrollWidth = 0;
  var containerOffsetHeight = 0;
  var containerOffsetWidth = 0;

  switch (direction) {
    case DIRECTION_UP:
    case DIRECTION_DOWN:
      innerScrollHeight = innerReference.scrollHeight;
      containerOffsetHeight = containerReference.offsetHeight;

      // 1. Preventively return if the inner reference is smaller than the
      // container, which means we do not need to translate (scroll) the content
      // on progress change.
      if (innerScrollHeight - containerOffsetHeight < 0) {
        return null;
      }

      break;

    case DIRECTION_RIGHT:
    case DIRECTION_LEFT:
      innerScrollWidth = innerReference.scrollWidth;
      containerOffsetWidth = containerReference.offsetWidth;

      // 1.
      if (innerScrollWidth - containerOffsetWidth < 0) {
        return null;
      }

      break;

    default:
    //
  }

  switch (direction) {
    case DIRECTION_UP:
      return 'translate3d(0, ' + seekValue(progress, -1 * (innerScrollHeight - containerOffsetHeight)) + 'px, 0)';

    case DIRECTION_RIGHT:
      return 'translate3d(-' + (innerScrollWidth - containerOffsetWidth - seekValue(progress, innerScrollWidth - containerOffsetWidth)) + 'px, 0, 0)';

    case DIRECTION_DOWN:
      return 'translate3d(0, -' + (innerScrollHeight - containerOffsetHeight - seekValue(progress, innerScrollHeight - containerOffsetHeight)) + 'px, 0)';

    case DIRECTION_LEFT:
      return 'translate3d(' + seekValue(progress, -1 * (innerScrollWidth - containerOffsetWidth)) + 'px, 0, 0)';

    default:
    //
  }
};

function createSeekCallback(direction, containerReference, containerInnerReference) {
  return function (progress) {
    if (containerInnerReference === null) {
      return;
    }

    var transform = transitionFactory(progress, direction, containerReference, containerInnerReference);

    if (transform === null) {
      return;
    }

    containerInnerReference.style.willChange = 'transform';

    requestAnimationFrame(function () {
      containerInnerReference.style.transform = transform;

      requestAnimationFrame(function () {
        // toggling the willChange property forces the browser to render the
        // same element even if it doesn't change. We will comment it out, the
        // downside is that the moving element will retain the "willChange"
        // property indefinitely.
        // containerInnerReference.style.willChange = null;
      });
    });
  };
}

function renderThronAsset(state, props, asset, index) {
  var common = {
    key: index,
    width: isVertical(props.direction) ? props.width : undefined,
    height: isHorizontal(props.direction) ? props.height : undefined,
    shadow: props.shadow,
    direction: props.direction,
    style: imageStyle$1({ direction: props.direction, shadow: props.shadow }),
    wrapperStyle: {
      display: 'inline-block',
      verticalAlign: 'top',
      width: isVertical(props.direction) ? '100%' : null,
      height: isHorizontal(props.direction) ? '100%' : null
    }
  };

  return React__default.createElement(ThronAssetTranslatable, _extends$30({}, common, {
    asset: asset,
    displayMode: state.displayMode,
    onLanguageChange: props.onLanguageChange,
    canTranslateAsset: props.canTranslateAsset,
    onContentUpdate: props.onContentUpdate }));
}

var GalleryScroll = function (_Component) {
  _inherits$36(GalleryScroll, _Component);

  function GalleryScroll() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$47(this, GalleryScroll);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$33(this, (_ref = GalleryScroll.__proto__ || Object.getPrototypeOf(GalleryScroll)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayMode: _this.props.displayMode,
      shouldOpenThronBrowser: _this.props.shouldOpenThronBrowser,
      width: _this.props.width,
      height: _this.props.height
    }, _this.containerReference = null, _this.containerInnerReference = null, _this.handleThronBrowserSelectionChange = function (assets) {
      var mapAssets = function mapAssets(assets) {
        return assets.map(function (asset) {
          return {
            value: asset.src,
            options: asset.options
          };
        });
      };

      _this.props.onChange(mapAssets(assets));
    }, _temp), _possibleConstructorReturn$33(_this, _ret);
  }

  _createClass$21(GalleryScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onAnimationReady({
        seek: createSeekCallback(this.props.direction, this.containerReference, this.containerInnerReference)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // @todo 2018-12-08 Consider a refactor to remove this obnoxious thing
      var _props = this.props,
          style = _props.style,
          width = _props.width,
          height = _props.height,
          direction = _props.direction,
          offsetStart = _props.offsetStart,
          offsetEnd = _props.offsetEnd,
          shadow = _props.shadow,
          assets = _props.assets,
          shouldOpenThronBrowser = _props.shouldOpenThronBrowser,
          onAnimationReady = _props.onAnimationReady,
          displayMode = _props.displayMode,
          onLanguageChange = _props.onLanguageChange,
          canTranslateAsset = _props.canTranslateAsset,
          onContentUpdate = _props.onContentUpdate,
          props = _objectWithoutProperties$9(_props, ['style', 'width', 'height', 'direction', 'offsetStart', 'offsetEnd', 'shadow', 'assets', 'shouldOpenThronBrowser', 'onAnimationReady', 'displayMode', 'onLanguageChange', 'canTranslateAsset', 'onContentUpdate']);

      return React__default.createElement(
        'div',
        _extends$30({}, props, {
          ref: function ref(_ref2) {
            return _this2.containerReference = _ref2;
          },
          style: containerStyle(style, height) }),
        React__default.createElement(
          ThronBrowserTriggerer,
          {
            innerRef: function innerRef(ref) {
              return _this2.containerInnerReference = ref;
            },
            selectedAssets: assets.map(function (asset) {
              return asset.options;
            }),
            shouldOpenThronBrowser: this.state.shouldOpenThronBrowser &&
            // We do not open the thron browser while in translate-mode because
            // each asset will open its own thron browser.
            this.state.displayMode !== DISPLAY_MODE_TRANSLATE,
            onThronBrowserSelectionChange: this.handleThronBrowserSelectionChange,
            style: thronBrowserTriggererStyle(direction, shadow) },
          assets.length === 0 ? React__default.createElement(
            'button',
            null,
            __('Select gallery images')
          ) : React__default.createElement(
            React__default.Fragment,
            null,
            React__default.createElement('div', { style: {
                display: isHorizontal(this.props.direction) ? 'inline-block' : 'block',
                width: isHorizontal(this.props.direction) ? this.props.offsetStart : '100%',
                height: isVertical(this.props.direction) ? this.props.offsetStart : '100%'
              } }),
            assets.map(function (asset, index) {
              return renderThronAsset(_this2.state, _this2.props, asset, index);
            }),
            React__default.createElement('div', { style: {
                display: isHorizontal(this.props.direction) ? 'inline-block' : 'block',
                width: isHorizontal(this.props.direction) ? this.props.offsetEnd : '100%',
                height: isVertical(this.props.direction) ? this.props.offsetEnd : '100%'
              } })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextState = {};

      if (nextProps.displayMode !== prevState.displayMode) {
        nextState.displayMode = nextProps.displayMode;
      }

      return _extends$30({}, nextState, {
        shouldOpenThronBrowser: nextProps.shouldOpenThronBrowser,
        width: nextProps.width,
        height: nextProps.height
      });
    }
  }]);

  return GalleryScroll;
}(React.Component);

GalleryScroll.defaultProps = {
  onAnimationReady: function onAnimationReady(animation) {
    return null;
  },
  assets: [],
  onChange: function onChange(assets) {
    return null;
  },
  shouldOpenThronBrowser: false,
  direction: DIRECTION_LEFT,
  offsetStart: 0,
  offsetEnd: 0,
  shadow: false,
  style: null,

  width: undefined,
  height: undefined
};

function containerStyle(style, height) {
  return _extends$30({}, style, {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: height
  });
}

function thronBrowserTriggererStyle(direction, shadow) {
  return {
    position: 'absolute',
    top: 0,
    bottom: isHorizontal(direction) ? 0 : null,
    // display: 'flex',
    // flexDirection: isHorizontal(direction) ? 'row' : 'column',
    whiteSpace: isHorizontal(direction) ? 'nowrap' : null,
    width: isVertical(direction) ? '100%' : null,
    height: '100%',
    padding: shadow ? isHorizontal(direction) ? '1rem 0' : '0 1rem' : null
  };
}

var imageStyle$1 = function imageStyle(props) {
  return {
    width: isHorizontal(props.direction) ? null : '100%',
    height: isVertical(props.direction) ? null : '100%',
    boxShadow: props.shadow ? '0 6px 15px rgba(0,0,0,.16)' : null,
    margin: props.shadow ? isHorizontal(props.direction) ? '0 1rem' : '1rem 0' : isHorizontal(props.direction) ? '0 0.125rem' : '0.125rem 0'
  };
};

var _extends$31 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$22 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$1(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$48(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$34(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$37(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StreetCulture = function (_Component) {
  _inherits$37(StreetCulture, _Component);

  function StreetCulture() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$48(this, StreetCulture);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$34(this, (_ref = StreetCulture.__proto__ || Object.getPrototypeOf(StreetCulture)).call.apply(_ref, [this].concat(args))), _this), _this.progress = 0, _this.animation = null, _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$31({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onGalleryChange = function (assets) {
      _this.setState({ gallery: assets.map(function (asset) {
          return makeContent('thron-asset', asset.value, asset.options);
        }) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$1( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$31({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return Promise.all(_this.state.gallery.map(function (media) {
                return save(ContentManager.make(media, 'thron-asset'));
              }));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                gallery: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$34(_this, _ret);
  }

  _createClass$22(StreetCulture, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        gallery: chapter.gallery
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: Math.max(this.state.gallery.length * this.state.screenHeight / 1.25, this.state.screenHeight * 1.5),
          onEnter: this.props.onEnter,
          onLeave: this.props.onLeave
        },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight },
            onProgressChange: function onProgressChange(progress) {
              _this3.progress = progress;
              _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));

              if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                _this3.textScrollableCallback(progress);
              }
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, right: '1rem', top: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(GalleryScroll, {
            displayMode: this.state.displayMode,
            onLanguageChange: this.props.onContentLanguageChange,
            canTranslateAsset: this.props.canTranslateAsset,
            onContentUpdate: this.props.onContentUpdate,

            assets: this.state.gallery,
            onChange: this.onGalleryChange,
            shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
            height: this.state.screenHeight / 2,
            style: {
              marginTop: '3rem'
            },
            direction: DIRECTION_LEFT,
            onAnimationReady: function onAnimationReady(animation) {
              _this3.animation = animation;
              _this3.animation && _this3.animation.seek(clamp(_this3.progress, 0, 1));
            }
          }),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '1.5rem',
                left: '1rem'
              } },
            React__default.createElement(BigChapterNumber, { small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                marginRight: '.5rem',
                marginLeft: '.5rem',
                padding: '0 1rem'
              } },
            React__default.createElement(
              Scrollable,
              {
                innerPaddingTop: '1rem',
                innerPaddingBottom: '4rem',
                fade: true,
                fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                onProgressCallback: function onProgressCallback(callback) {
                  return _this3.textScrollableCallback = callback;
                },
                style: {
                  pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                  height: this.state.screenHeight / 2 - remToPixels(3)
                }
              },
              React__default.createElement(
                Title,
                null,
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: {
                  // minWidth: '1.375rem',
                  // marginLeft: '.5rem',
                  paddingBottom: '1rem',
                  paddingTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                } },
              React__default.createElement('div', null),
              React__default.createElement(
                'div',
                { style: {
                    fontSize: 0,
                    textAlign: 'end'
                  } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.text
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          columns: ['63%', '37%'],
          height: Math.max(this.state.gallery.length * this.state.screenHeight / 1.25, this.state.screenHeight * 1.5),
          onEnter: this.props.onEnter,
          onLeave: this.props.onLeave,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight, display: 'flex', alignItems: 'center', backgroundColor: '#353637' },
            onProgressChange: function onProgressChange(progress) {
              _this3.progress = progress;
              _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, left: '1rem', top: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { position: 'relative' } },
            React__default.createElement('div', { style: {
                position: 'absolute',
                top: '-2.5rem',
                right: '9.375rem',
                bottom: '-2.5rem',
                left: 0,
                backgroundColor: '#000',
                zIndex: 2
              } }),
            React__default.createElement(
              'div',
              { style: {
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: '-6rem',
                  right: '1.3rem',
                  zIndex: 1
                } },
              React__default.createElement(BigChapterNumber, { color: 'rgba(155,155,155,0.46)', number: this.state.index + 1 })
            ),
            React__default.createElement(GalleryScroll, {
              displayMode: this.state.displayMode,
              onLanguageChange: this.props.onContentLanguageChange,
              canTranslateAsset: this.props.canTranslateAsset,
              onContentUpdate: this.props.onContentUpdate,

              style: { zIndex: 3 },
              assets: this.state.gallery,
              onChange: this.onGalleryChange,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              height: remToPixels(31.25),
              shadow: true,
              direction: DIRECTION_LEFT,
              onAnimationReady: function onAnimationReady(animation) {
                _this3.animation = animation;
                _this3.animation && _this3.animation.seek(clamp(_this3.progress, 0, 1));
              } })
          )
        ),
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight, backgroundColor: '#fff' } },
          React__default.createElement(
            'div',
            { style: { padding: '5rem 6.5rem 10rem 2.5rem' } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(TextTranslatable, {
              highlight: this.props.highlightWord,
              onLanguageChange: this.props.onContentLanguageChange,
              onContentUpdate: this.props.onContentUpdate,
              displayMode: this.state.displayMode,
              content: this.state.text,
              onBlur: this.onTextBlur }),
            React__default.createElement(
              'div',
              { style: { zIndex: 1, position: 'absolute', bottom: '4rem', minWidth: '1rem' } },
              React__default.createElement(ButtonList, {
                displayMode: this.state.displayMode,
                buttons: this.props.buttons,
                content: this.state.text })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return StreetCulture;
}(React.Component);

var blueprint$1 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  };
};

var StreetCulture$1 = styled.withTheme(asTemplate('StreetCulture', StreetCulture, blueprint$1, 'rgb(53,54,55)'));

var _extends$32 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$23 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$2(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$49(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$35(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$38(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getChapterHeight(screenHeight, gallery) {
  return Math.max(gallery.length * screenHeight, screenHeight * 1.5);
}

var AdvertisingCampaign = function (_Component) {
  _inherits$38(AdvertisingCampaign, _Component);

  function AdvertisingCampaign() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$49(this, AdvertisingCampaign);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$35(this, (_ref = AdvertisingCampaign.__proto__ || Object.getPrototypeOf(AdvertisingCampaign)).call.apply(_ref, [this].concat(args))), _this), _this.progress = 0, _this.animation = null, _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$32({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onGalleryChange = function (assets) {
      _this.setState({
        gallery: assets.map(function (asset) {
          return makeContent('thron-asset', asset.value, asset.options);
        })
      });
    }, _this.handleSaveChapterClick = _asyncToGenerator$2( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$32({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return Promise.all(_this.state.gallery.map(function (media) {
                return save(ContentManager.make(media, 'thron-asset'));
              }));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                gallery: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$35(_this, _ret);
  }

  _createClass$23(AdvertisingCampaign, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        gallery: chapter.gallery
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              null,
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            displayMode: this.state.displayMode,
            height: getChapterHeight(this.state.screenHeight, this.state.gallery),
            onEnter: this.props.onEnter,
            style: { display: 'flex' } },
          React__default.createElement(
            StickyContent,
            {
              style: { height: this.state.screenHeight, zIndex: 3 },
              onProgressChange: function onProgressChange(progress) {
                _this3.progress = progress;
                _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));

                if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                  _this3.textScrollableCallback(progress);
                }
              }
            },
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              )
            ),
            React__default.createElement(
              'div',
              { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start' } },
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    left: 0,
                    height: this.state.screenHeight * .65
                  } },
                React__default.createElement(GalleryScroll, {
                  displayMode: this.state.displayMode,
                  onLanguageChange: this.props.onContentLanguageChange,
                  canTranslateAsset: this.props.canTranslateAsset,
                  onContentUpdate: this.props.onContentUpdate,

                  assets: this.state.gallery,
                  onChange: this.onGalleryChange,
                  height: this.state.screenHeight * .65,
                  direction: DIRECTION_UP,
                  shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                  onAnimationReady: function onAnimationReady(animation) {
                    _this3.animation = animation;
                    _this3.animation.seek(clamp(_this3.progress, 0, 1));
                  }
                })
              ),
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    position: 'absolute',
                    top: this.state.screenHeight * .65,
                    right: '1.5rem',
                    left: '1.5rem'
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      flex: 1,
                      display: 'flex'
                    } },
                  React__default.createElement(
                    Scrollable,
                    {
                      innerPaddingTop: '1rem',
                      innerPaddingBottom: '4rem',
                      fade: true,
                      fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                      onProgressCallback: function onProgressCallback(callback) {
                        return _this3.textScrollableCallback = callback;
                      },
                      style: {
                        pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                        height: this.state.screenHeight * .35
                      }
                    },
                    React__default.createElement(TextTranslatable, {
                      highlight: this.props.highlightWord,
                      onLanguageChange: this.props.onContentLanguageChange,
                      onContentUpdate: this.props.onContentUpdate,
                      displayMode: this.state.displayMode,
                      content: this.state.text,
                      onBlur: this.onTextBlur })
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        // minWidth: '1.375rem',
                        // marginLeft: '.5rem',
                        paddingBottom: '1rem',
                        paddingTop: '1rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        justifyContent: 'space-between'
                      } },
                    React__default.createElement('div', null),
                    React__default.createElement(
                      'div',
                      { style: {
                          fontSize: 0,
                          textAlign: 'end'
                        } },
                      React__default.createElement(ButtonList, {
                        displayMode: this.state.displayMode,
                        buttons: this.props.buttons,
                        content: this.state.text
                      })
                    )
                  )
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          columns: ['33.333333%', '66.666666%'],
          height: Math.max(this.state.gallery.length * this.state.screenHeight, this.state.screenHeight * 1.5),
          onEnter: this.props.onEnter,
          onLeave: this.props.onLeave,
          style: { display: 'flex', backgroundColor: '#000' } },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight } },
          React__default.createElement(
            'div',
            { style: { padding: '7rem 4.5rem 7rem', color: '#fff', zIndex: 2 } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(TextTranslatable, {
              highlight: this.props.highlightWord,
              onLanguageChange: this.props.onContentLanguageChange,
              onContentUpdate: this.props.onContentUpdate,
              displayMode: this.state.displayMode,
              content: this.state.text,
              onBlur: this.onTextBlur }),
            React__default.createElement(
              'div',
              { style: { zIndex: 1, position: 'absolute', bottom: '4rem', minWidth: '1rem', height: '2rem' } },
              React__default.createElement(ButtonList, {
                displayMode: this.state.displayMode,
                buttons: this.props.buttons,
                content: this.state.text })
            )
          )
        ),
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight, display: 'flex', alignItems: 'center' },
            onProgressChange: function onProgressChange(progress) {
              _this3.progress = progress;
              _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', left: '-1rem', transform: 'translateX(-100%)', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '8.5rem',
                left: 0,
                transform: 'translateX(-100%)'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(151,151,151,0.46)', number: this.state.index + 1 })
          ),
          React__default.createElement(GalleryScroll, {
            displayMode: this.state.displayMode,
            onLanguageChange: this.props.onContentLanguageChange,
            canTranslateAsset: this.props.canTranslateAsset,
            onContentUpdate: this.props.onContentUpdate,

            width: remToPixels(42.75),
            height: this.state.screenHeight,
            shadow: true,
            direction: DIRECTION_UP,
            shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT || this.props.canTranslateAsset && this.state.displayMode === DISPLAY_MODE_TRANSLATE,
            assets: this.state.gallery,
            onChange: this.onGalleryChange,
            onAnimationReady: function onAnimationReady(animation) {
              _this3.animation = animation;
              _this3.animation.seek(clamp(_this3.progress, 0, 1));
            }
          })
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return AdvertisingCampaign;
}(React.Component);

var blueprint$2 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  };
};

var AdvertisingCampaign$1 = styled.withTheme(asTemplate('AdvertisingCampaign', AdvertisingCampaign, blueprint$2, '#000'));

var _extends$33 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$24 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$10 = _taggedTemplateLiteral$10(['\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  width: 43rem;\n  padding: 7rem 5rem;\n  background-color: rgba(0,0,0,.9);\n  color: #fff;\n  font-size: 1.75rem;\n  line-height: 1;\n\n  > * {\n    // Stretch the child TextTranslatable component\n    flex: 1;\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  width: 43rem;\n  padding: 7rem 5rem;\n  background-color: rgba(0,0,0,.9);\n  color: #fff;\n  font-size: 1.75rem;\n  line-height: 1;\n\n  > * {\n    // Stretch the child TextTranslatable component\n    flex: 1;\n  }\n']);

function _taggedTemplateLiteral$10(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator$3(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$50(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$36(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$39(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hashtag = function (_Component) {
  _inherits$39(Hashtag, _Component);

  function Hashtag() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$50(this, Hashtag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$36(this, (_ref = Hashtag.__proto__ || Object.getPrototypeOf(Hashtag)).call.apply(_ref, [this].concat(args))), _this), _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$33({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      screenWidth: _this.props.screenWidth,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$3( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$33({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                media: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$36(_this, _ret);
  }

  _createClass$24(Hashtag, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        media: chapter.media
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 1.5,
          onEnter: this.props.onEnter(),
          onLeave: this.props.onLeave },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight },
            onProgressChange: function onProgressChange(progress) {
              if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                _this3.textScrollableCallback(progress);
              }
            }
          },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, right: '.25rem', top: '.25rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                flexDirection: 'column',
                height: this.state.screenHeight
              } },
            React__default.createElement(
              'div',
              { style: {
                  display: 'flex',
                  marginTop: 'max(1rem, env(safe-area-inset-top))',
                  marginRight: '1rem',
                  marginLeft: '1rem'
                } },
              React__default.createElement(
                'div',
                { style: { marginRight: '1rem' } },
                React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
              ),
              React__default.createElement(
                Title,
                { style: { flex: 1 } },
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  flex: 1
                } },
              React__default.createElement(Media, {
                width: this.state.screenWidth,
                height: '20rem',
                src: this.state.media.value,
                options: this.state.media.options,
                shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                onChange: this.onMediaChange })
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                position: 'absolute',
                right: '0',
                bottom: '0',
                left: '0',
                padding: '0 1rem',
                color: '#fff',
                background: 'rgb(0 0 0 / .7)'
              } },
            React__default.createElement(
              Scrollable,
              {
                innerPaddingTop: '1rem',
                innerPaddingBottom: '4rem',
                onProgressCallback: function onProgressCallback(callback) {
                  return _this3.textScrollableCallback = callback;
                },
                style: {
                  pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                  height: this.state.screenHeight * .35
                }
              },
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: {
                  // minWidth: '1.375rem',
                  // marginLeft: '.5rem',
                  paddingBottom: '1rem',
                  paddingTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                } },
              React__default.createElement('div', null),
              React__default.createElement(
                'div',
                { style: {
                    fontSize: 0,
                    textAlign: 'end'
                  } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.text
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 1.5,
          onEnter: this.props.onEnter(),
          onLeave: this.props.onLeave },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, right: '1rem', top: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 2,
                pointerEvents: 'none',
                position: 'absolute',
                top: '0',
                left: '16.5rem'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(255,255,255,.1)', number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                height: this.state.screenHeight
              } },
            React__default.createElement(
              Title,
              { style: { height: '12.25rem', padding: '8.5rem 5rem 0', color: '#fff', backgroundColor: '#353637' } },
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  zIndex: 1,
                  position: 'relative',
                  height: 'calc(' + this.state.screenHeight + 'px - 12.25rem)'
                } },
              React__default.createElement(
                'div',
                { style: { overflowY: 'hidden', height: '100%' } },
                React__default.createElement(Media, {
                  width: this.state.screenWidth,
                  height: this.state.screenHeight - remToPixels(12.25),
                  src: this.state.media.value,
                  options: this.state.media.options,
                  shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                  onChange: this.onMediaChange })
              ),
              React__default.createElement(
                HashTagTextContainer,
                null,
                React__default.createElement(
                  'div',
                  { style: { zIndex: 1, position: 'absolute', top: '-2rem', right: '6.5rem', minWidth: '1rem', height: '2rem' } },
                  React__default.createElement(ButtonList, {
                    displayMode: this.state.displayMode,
                    buttons: this.props.buttons,
                    content: this.state.text })
                ),
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.text,
                  onBlur: this.onTextBlur })
              )
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        screenWidth: nextProps.screenWidth,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Hashtag;
}(React.Component);

var blueprint$3 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/700x500')
  };
};

var Hashtag$1 = styled.withTheme(asTemplate('Hashtag', Hashtag, blueprint$3, 'rgb(53,54,55)'));

var HashTagTextContainer = styled__default.div(_templateObject$10);

var _extends$34 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$11 = _taggedTemplateLiteral$11(['\n  pointer-events: none;\n\n  ', ';\n'], ['\n  pointer-events: none;\n\n  ', ';\n']),
    _templateObject2$6 = _taggedTemplateLiteral$11(['\n    background-image: ', ';\n  '], ['\n    background-image: ', ';\n  ']),
    _templateObject3$4 = _taggedTemplateLiteral$11(['\n      linear-gradient(rgb(255 255 255 / 0) 25%, 75%, rgb(255 255 255 / .94))\n    '], ['\n      linear-gradient(rgb(255 255 255 / 0) 25%, 75%, rgb(255 255 255 / .94))\n    ']),
    _templateObject4$2 = _taggedTemplateLiteral$11(['\n      linear-gradient(rgb(0 0 0 / 0) 25%, 75%, rgb(0 0 0 / .44))\n    '], ['\n      linear-gradient(rgb(0 0 0 / 0) 25%, 75%, rgb(0 0 0 / .44))\n    ']),
    _templateObject5 = _taggedTemplateLiteral$11(['\n\tmargin-bottom: .5rem;\n\tfont-size: ', ';\n\tfont-weight: ', ';\n\tcolor: ', ';\n'], ['\n\tmargin-bottom: .5rem;\n\tfont-size: ', ';\n\tfont-weight: ', ';\n\tcolor: ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral$11(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject7 = _taggedTemplateLiteral$11(['\n  height: ', ';\n  display: block;\n  margin-right: ', ';\n  flex: 1;\n  background-color: ', ';\n'], ['\n  height: ', ';\n  display: block;\n  margin-right: ', ';\n  flex: 1;\n  background-color: ', ';\n']);

function _taggedTemplateLiteral$11(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$10(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StepIndicator = (function (_ref) {
  var total = _ref.total,
      active = _ref.active,
      showNumbers = _ref.showNumbers,
      showPercentage = _ref.showPercentage,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? true : _ref$step,
      dark = _ref.dark,
      _ref$gradient = _ref.gradient,
      gradient = _ref$gradient === undefined ? false : _ref$gradient,
      props = _objectWithoutProperties$10(_ref, ['total', 'active', 'showNumbers', 'showPercentage', 'step', 'dark', 'gradient']);

  return React__default.createElement(
    Container$2,
    _extends$34({ gradient: gradient, dark: dark }, props),
    showNumbers && React__default.createElement(
      TextContainer,
      { dark: dark },
      active + 1,
      ' / ',
      total
    ),
    showPercentage !== undefined && React__default.createElement(
      TextContainer,
      { dark: dark },
      showPercentage(Math.floor((active + 1) / total * 100))
    ),
    React__default.createElement(
      StepsContainer,
      null,
      new Array(total).fill(1).map(function (_, index) {
        return React__default.createElement(Step, { key: index, active: active >= index, dark: dark, step: String(step) });
      })
    )
  );
});

var Container$2 = styled__default.div(_templateObject$11, function (props) {
  return props.gradient && styled.css(_templateObject2$6, props.dark ? styled.css(_templateObject3$4) : styled.css(_templateObject4$2));
});

var TextContainer = styled__default.div(_templateObject5, themeResponsiveProperty(null, '1.25rem'), themeResponsiveProperty(400, null), function (props) {
  return themeResponsiveProperty(props.dark ? '#444' : '#fff', '#686868')(props);
});

var StepsContainer = styled__default.div(_templateObject6);

var Step = styled__default.span(_templateObject7, function (props) {
  return props.step === 'false' ? '.325rem' : '.125rem';
}, function (props) {
  return props.step === 'false' ? '0' : '.25rem';
}, function (props) {
  return props.dark ? props.active ? props.theme.accentColorBright : 'rgba(0,0,0,.1)' : props.active ? props.theme.accentColorBright : 'rgba(255,255,255,.3)';
});

var removeBlock = (function (blocks, indexToRemove, message) {
  if (!window.confirm(message)) return blocks;

  return blocks.filter(function (b, i) {
    return i !== indexToRemove;
  });
});

var _templateObject$12 = _taggedTemplateLiteral$12(['\n  flex: 1;\n  display: inline-flex;\n  flex-direction: column;\n'], ['\n  flex: 1;\n  display: inline-flex;\n  flex-direction: column;\n']),
    _templateObject2$7 = _taggedTemplateLiteral$12(['\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n'], ['\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject3$5 = _taggedTemplateLiteral$12(['\n  flex: 1;\n  display: block;\n  width: ', ';\n  max-height: 1.75rem;\n  margin-bottom: ', ';\n  margin-left: .5rem;\n  background-color: ', ';\n'], ['\n  flex: 1;\n  display: block;\n  width: ', ';\n  max-height: 1.75rem;\n  margin-bottom: ', ';\n  margin-left: .5rem;\n  background-color: ', ';\n']);

function _taggedTemplateLiteral$12(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$11(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StepIndicator2 = (function (_ref) {
  var total = _ref.total,
      active = _ref.active,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? true : _ref$step,
      dark = _ref.dark,
      props = _objectWithoutProperties$11(_ref, ['total', 'active', 'step', 'dark']);

  return React__default.createElement(
    Container$3,
    props,
    React__default.createElement(
      StepsContainer$1,
      null,
      new Array(total).fill(1).map(function (_, index) {
        return React__default.createElement(Step$1, { key: index, active: active >= index, dark: dark, step: String(step) });
      })
    )
  );
});

var Container$3 = styled__default.div(_templateObject$12);

var StepsContainer$1 = styled__default.div(_templateObject2$7);

var Step$1 = styled__default.span(_templateObject3$5, function (props) {
  return props.step === 'false' ? '.375rem' : '.25rem';
}, function (props) {
  return props.step === 'false' ? '0' : '.25rem';
}, function (props) {
  return props.active ? '#d0cece' : 'rgba(196, 196, 196, 0.48)';
});

var _createClass$25 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$35 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator$4(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck$51(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$37(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$40(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function appendNewBlock(blocks) {
  return blocks.concat([blockBlueprint()]);
}

function getChapterHeight$1(screenHeight, blocks, theme) {
  return blocks.reduce(function (total, block) {
    return total + blockHeight(screenHeight, block, theme);
  }, 0);
}

function blockHeight(screenHeight, block, theme) {
  return themeResponsiveProperty(Math.max(screenHeight * 1.25, block.gallery.length * screenHeight / 2.33), Math.max(screenHeight * 1.25, block.gallery.length * screenHeight / 1.33))({ theme: theme });
}

function blockBlueprint() {
  return _extends$35({}, {
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  });
}

var Items = function (_Component) {
  _inherits$40(Items, _Component);

  function Items() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$51(this, Items);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$37(this, (_ref = Items.__proto__ || Object.getPrototypeOf(Items)).call.apply(_ref, [this].concat(args))), _this), _this.animations = [], _this.progresses = new Array(10).fill(function () {
      return 0;
    }), _this.textScrollableCallbacks = new Array(10).fill(function () {
      return null;
    }), _this.state = _extends$35({
      index: _this.props.index,
      chapterHeight: getChapterHeight$1(_this.props.screenHeight, _this.props.content.blocks, _this.props.theme),
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode,
      currentIndex: 0
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.onBlockTextBlur = function (index, value) {
      var blocks = [].concat(_toConsumableArray(_this.state.blocks));
      blocks[index].text.value = value;
      _this.setState({ blocks: blocks });
    }, _this.onBlockGalleryChange = function (assets, index) {
      var blocks = [].concat(_toConsumableArray(_this.state.blocks));
      blocks[index].gallery = assets.map(function (asset) {
        return makeContent('thron-asset', asset.value, asset.options);
      });

      _this.setState({
        blocks: blocks,
        chapterHeight: getChapterHeight$1(_this.state.screenHeight, blocks, _this.props.theme)
      });
    }, _this.handleAddBlockClick = function () {
      _this.setState({ blocks: appendNewBlock(_this.state.blocks) });
    }, _this.removeBlock = function (index) {
      var blocks = removeBlock(_this.state.blocks, index, 'This will be removed:\nText:\n' + _this.state.blocks[index].text.value + '\n\nMedia:\n' + _this.state.blocks[index].gallery.map(function (m) {
        return m.value;
      }).join("\n"));

      _this.setState({ blocks: blocks });
    }, _this.handleSaveChapterClick = _asyncToGenerator$4( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$35({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 8:
              _context2.t2 = _context2.sent;
              _context2.next = 11;
              return Promise.all(_this.state.blocks.map(function () {
                var _ref3 = _asyncToGenerator$4( /*#__PURE__*/regenerator.mark(function _callee(block) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(block.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return Promise.all(block.gallery.map(function (media) {
                            return save(ContentManager.make(media, 'thron-asset'));
                          }));

                        case 5:
                          _context.t1 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            gallery: _context.t1
                          });

                        case 7:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 11:
              _context2.t3 = _context2.sent;
              state = {
                templateName: _context2.t0,
                title: _context2.t1,
                media: _context2.t2,
                blocks: _context2.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _temp), _possibleConstructorReturn$37(_this, _ret);
  }

  // @todo 2021-07-26 10 has to be changed and made dynamic


  _createClass$25(Items, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        media: chapter.media,
        blocks: chapter.blocks
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var chapterHeight = getChapterHeight$1(this.state.screenHeight, this.state.blocks, this.props.theme);

      if (this.state.chapterHeight !== chapterHeight) {
        this.setState({ chapterHeight: chapterHeight });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              null,
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            displayMode: this.state.displayMode,
            height: getChapterHeight$1(this.state.screenHeight, this.state.blocks, this.props.theme),
            columns: ['0%', '100%'],
            onEnter: this.props.onEnter,
            style: { display: 'flex' } },
          React__default.createElement(
            'div',
            null,
            this.state.blocks.map(function (block, index) {
              return React__default.createElement(
                StickyContainer$1,
                {
                  key: index,
                  leading: true,
                  style: { height: blockHeight(_this3.state.screenHeight, block, _this3.props.theme) }
                },
                React__default.createElement(StickyContent, {
                  identifier: index,
                  onProgressChange: function onProgressChange(progress) {
                    if (_this3.state.currentIndex !== index) return;

                    _this3.progresses[index] = progress;
                    _this3.animations[index] && _this3.animations[index].seek(clamp(progress, 0, 1));

                    if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                      _this3.textScrollableCallbacks[index](progress);
                    }
                  },
                  onEnter: function onEnter(identifier) {
                    return _this3.setState({ currentIndex: identifier });
                  }
                })
              );
            })
          ),
          React__default.createElement(
            StickyContent,
            { style: { height: this.state.screenHeight, zIndex: 3 } },
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleAddBlockClick },
                __('+Block')
              ),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              )
            ),
            React__default.createElement(
              'div',
              { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start' } },
              React__default.createElement(
                'div',
                null,
                React__default.createElement(Media, {
                  width: remToPixels(36),
                  src: this.state.media.value,
                  options: this.state.media.options,
                  shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                  onChange: this.onMediaChange })
              ),
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    position: 'absolute',
                    top: this.state.screenHeight * .25,
                    right: '1.5rem',
                    left: '1.5rem',
                    padding: '0 1rem',
                    color: '#fff',
                    background: '#000'
                  } },
                this.state.blocks.map(function (block, index) {
                  return React__default.createElement(
                    'div',
                    { key: index, style: {
                        flex: index === _this3.state.currentIndex ? 1 : 0,
                        visibility: index === _this3.state.currentIndex ? null : 'hidden',
                        overflow: index === _this3.state.currentIndex ? null : 'hidden',
                        display: 'flex',
                        width: index === _this3.state.currentIndex ? null : 0
                      } },
                    React__default.createElement(
                      TemplateControl,
                      {
                        style: { position: 'absolute', top: '-1rem', left: '1rem', transform: 'translateY(-100%)' },
                        displayMode: _this3.state.displayMode
                      },
                      React__default.createElement(
                        TemplateControlButton,
                        { onClick: function onClick() {
                            return _this3.removeBlock(index);
                          } },
                        __('Remove block')
                      )
                    ),
                    React__default.createElement(
                      Scrollable,
                      {
                        innerPaddingTop: '1rem',
                        innerPaddingBottom: '4rem',
                        fade: true,
                        onProgressCallback: function onProgressCallback(callback) {
                          return _this3.textScrollableCallbacks[index] = callback;
                        },
                        style: {
                          pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1 ? 'none' : null,
                          width: '100%',
                          height: _this3.state.screenHeight * .4375
                        }
                      },
                      React__default.createElement(TextTranslatable, {
                        highlight: _this3.props.highlightWord,
                        onLanguageChange: _this3.props.onContentLanguageChange,
                        onContentUpdate: _this3.props.onContentUpdate,
                        displayMode: _this3.state.displayMode,
                        content: block.text,
                        onBlur: function onBlur(value) {
                          return _this3.onBlockTextBlur(index, value);
                        } })
                    ),
                    React__default.createElement(
                      'div',
                      { style: {
                          // minWidth: '1.375rem',
                          // marginLeft: '.5rem',
                          paddingBottom: '1rem',
                          paddingTop: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          justifyContent: 'space-between'
                        } },
                      _this3.props.theme.isMobile ? React__default.createElement(StepIndicator2, { active: index, total: _this3.state.blocks.length }) : _this3.props.theme.isTablet ? React__default.createElement(StepIndicator, { active: index, total: _this3.state.blocks.length }) : null,
                      React__default.createElement(
                        'div',
                        { style: {
                            fontSize: 0,
                            textAlign: 'end'
                          } },
                        React__default.createElement(ButtonList, {
                          displayMode: _this3.state.displayMode,
                          buttons: _this3.props.buttons,
                          content: block.text
                        })
                      )
                    )
                  );
                })
              ),
              this.state.blocks.map(function (block, index) {
                return index === _this3.state.currentIndex && React__default.createElement(
                  'div',
                  { key: index, style: {
                      position: 'absolute',
                      right: 0,
                      bottom: 0,
                      left: 0,
                      height: _this3.state.screenHeight * .3125 - remToPixels(1)
                    } },
                  React__default.createElement(GalleryScroll, {
                    displayMode: _this3.state.displayMode,
                    onLanguageChange: _this3.props.onContentLanguageChange,
                    canTranslateAsset: _this3.props.canTranslateAsset,
                    onContentUpdate: _this3.props.onContentUpdate,

                    assets: block.gallery,
                    onChange: function onChange(assets) {
                      return _this3.onBlockGalleryChange(assets, index);
                    },
                    height: _this3.state.screenHeight * .3125 - remToPixels(1),
                    direction: DIRECTION_LEFT,
                    offsetEnd: '4rem',
                    shouldOpenThronBrowser: _this3.state.displayMode === DISPLAY_MODE_EDIT,
                    onAnimationReady: function onAnimationReady(animation) {
                      _this3.animations[index] = animation;
                      _this3.animations[index].seek(clamp(_this3.progresses[index], 0, 1));
                    }
                  })
                );
              })
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: getChapterHeight$1(this.state.screenHeight, this.state.blocks, this.props.theme),
          columns: ['0%', '39%', '61%'],
          onEnter: this.props.onEnter,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          { style: { zIndex: [DISPLAY_MODE_EDIT, DISPLAY_MODE_TRANSLATE].indexOf(this.state.displayMode) !== -1 ? 3 : 1, height: this.state.screenHeight } },
          React__default.createElement(
            'div',
            { style: {
                position: 'absolute',
                left: '3.125rem',
                top: '2.5rem',
                width: '21.75rem'
              } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            )
          )
        ),
        React__default.createElement(
          'div',
          { style: { width: '100%', paddingLeft: '3rem', zIndex: 2 } },
          this.state.blocks.map(function (block, index) {
            return React__default.createElement(
              StickyContainer$1,
              {
                key: index,
                leading: true,
                style: { display: 'flex', height: blockHeight(_this3.state.screenHeight, block, _this3.props.theme) /* paddingTop: '9.75rem',*/ }
              },
              React__default.createElement(
                StickyContent,
                {
                  style: { height: _this3.state.screenHeight, display: 'flex' },
                  identifier: index,
                  onProgressChange: function onProgressChange(progress) {
                    _this3.progresses[index] = progress;
                    _this3.animations[index] && _this3.animations[index].seek(clamp(progress, 0, 1));
                  },
                  onEnter: function onEnter(identifier) {
                    return _this3.setState({ currentIndex: identifier });
                  } },
                React__default.createElement(GalleryScroll, {
                  displayMode: _this3.state.displayMode,
                  onLanguageChange: _this3.props.onContentLanguageChange,
                  canTranslateAsset: _this3.props.canTranslateAsset,
                  onContentUpdate: _this3.props.onContentUpdate,

                  assets: block.gallery,
                  onChange: function onChange(assets) {
                    return _this3.onBlockGalleryChange(assets, index);
                  },
                  width: remToPixels(21.75),
                  height: _this3.state.screenHeight,
                  offsetStart: remToPixels(index === 0 ? 14 : 11),
                  direction: DIRECTION_UP,
                  shouldOpenThronBrowser: _this3.state.displayMode === DISPLAY_MODE_EDIT,
                  onAnimationReady: function onAnimationReady(animation) {
                    _this3.animations[index] = animation;
                    _this3.animations[index].seek(clamp(_this3.progresses[index], 0, 1));
                  } })
              )
            );
          })
        ),
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight, zIndex: 3 } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleAddBlockClick },
              __('+Block')
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '4.75rem',
                left: '-1rem',
                transform: 'translateX(-100%)'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(151,151,151,0.46)', number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start', paddingTop: '5rem' } },
            React__default.createElement(
              'div',
              { style: { paddingRight: '3rem' } },
              React__default.createElement(Media, {
                width: remToPixels(36),
                src: this.state.media.value,
                options: this.state.media.options,
                shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                onChange: this.onMediaChange })
            ),
            React__default.createElement(
              'div',
              { style: {
                  position: 'absolute',
                  right: '4.75rem',
                  bottom: '4.75rem',
                  width: '100%',
                  padding: '2.5rem 4.625rem',
                  backgroundColor: '#000',
                  color: '#fff'
                } },
              this.state.blocks.map(function (block, index) {
                return React__default.createElement(
                  'div',
                  { key: index, style: { position: null, display: index === _this3.state.currentIndex ? null : 'none' } },
                  React__default.createElement(
                    TemplateControl,
                    {
                      style: { position: 'absolute', top: '.5rem', left: '.5rem' },
                      displayMode: _this3.state.displayMode },
                    React__default.createElement(
                      TemplateControlButton,
                      { onClick: function onClick() {
                          return _this3.removeBlock(index);
                        } },
                      __('Remove block')
                    )
                  ),
                  React__default.createElement(
                    'div',
                    { style: { height: '100%' } },
                    React__default.createElement(TextTranslatable, {
                      highlight: _this3.props.highlightWord,
                      onLanguageChange: _this3.props.onContentLanguageChange,
                      onContentUpdate: _this3.props.onContentUpdate,
                      displayMode: _this3.state.displayMode,
                      content: block.text,
                      onBlur: function onBlur(value) {
                        return _this3.onBlockTextBlur(index, value);
                      } })
                  ),
                  React__default.createElement(
                    'div',
                    { style: { width: '15rem', marginTop: '2rem' } },
                    React__default.createElement(StepIndicator, { active: index, total: _this3.state.blocks.length })
                  ),
                  React__default.createElement(
                    'div',
                    { style: { zIndex: 1, position: 'absolute', bottom: 0, minWidth: '1rem', height: '2rem' } },
                    React__default.createElement(ButtonList, { displayMode: _this3.state.displayMode, buttons: _this3.props.buttons, content: block.text })
                  )
                );
              })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Items;
}(React.Component);

var blueprint$4 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/700x500'),
    blocks: [blockBlueprint()]
  };
};

var Items$1 = styled.withTheme(asTemplate('Items', Items, blueprint$4));

var _extends$36 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$26 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$12(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$52(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$38(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$41(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animatable = function (_Component) {
  _inherits$41(Animatable, _Component);

  function Animatable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$52(this, Animatable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$38(this, (_ref = Animatable.__proto__ || Object.getPrototypeOf(Animatable)).call.apply(_ref, [this].concat(args))), _this), _this.references = [], _this.pushReference = function (ref) {
      // @todo 2018-05-15
      // This "references" array somehow always has the current references. I have
      // no idea why it gets reset on every render.
      // @todo 2018-07-30
      // Maybe Animatable gets re-instantiated whenever a new render in the parent
      // component is invoked.
      _this.references.push(ref);
    }, _this.mapChildren = function (child, index) {
      var style = _extends$36({
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }, child.props.style);

      return React.cloneElement(child, { ref: _this.pushReference, style: style });
    }, _temp), _possibleConstructorReturn$38(_this, _ret);
  }

  _createClass$26(Animatable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateAnimation();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateAnimation();
    }
  }, {
    key: 'updateAnimation',
    value: function updateAnimation() {
      var _this2 = this;

      this.props.hook({
        seek: function seek(index) {
          requestAnimationFrame(function () {
            _this2.references.filter(function (reference) {
              return reference !== null;
            })
            // hot-fix: we make sure to only work with existing dom nodes
            // otherwise the index comparison won't work as expected. This bug
            // is caused by a de-sync between what react renders and the
            // in-memory references.
            .filter(function (reference) {
              return window.document.body.contains(reference);
            }).forEach(function (reference, referenceIndex) {
              reference.style.display = index === referenceIndex ? '' : 'none';
            });
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hook = _props.hook,
          children = _props.children,
          style = _props.style,
          props = _objectWithoutProperties$12(_props, ['hook', 'children', 'style']);

      return React__default.createElement(
        'div',
        _extends$36({}, props, { style: _extends$36({ position: 'relative' }, style) }),
        React__default.Children.map(children, this.mapChildren)
      );
    }
  }]);

  return Animatable;
}(React.Component);

Animatable.defaultProps = {
  hook: function hook(animatable) {
    return null;
  }
};

var _createClass$27 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$37 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator$5(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$53(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$39(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$42(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function blockBlueprint$1() {
  return _extends$37({}, {
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  });
}

function getChapterHeight$2(screenHeight, blocks) {
  return blocks.reduce(function (total, block) {
    return total + blockHeight$1(screenHeight, block);
  }, 0);
}

function blockHeight$1(screenHeight, block) {
  return Math.max(block.gallery.length * screenHeight / 1.75, screenHeight * 1.5);
}

function appendNewBlock$1(blocks) {
  return blocks.concat([blockBlueprint$1()]);
}

var GALLERY_HEIGHT_REM = 24;

var PopUpProject = function (_Component) {
  _inherits$42(PopUpProject, _Component);

  function PopUpProject() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$53(this, PopUpProject);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$39(this, (_ref = PopUpProject.__proto__ || Object.getPrototypeOf(PopUpProject)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$37({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode,
      chapterHeight: getChapterHeight$2(_this.props.screenHeight, _this.props.content.blocks),
      currentIndex: 0
    }, _this.getStateFromChapter(_this.props.content)), _this.animations = [], _this.progresses = new Array(10).fill(function () {
      return 0;
    }), _this.animatable = null, _this.activeIndex = 0, _this.textScrollableCallbacks = new Array(10).fill(function () {
      return null;
    }), _this.onBlockProgress = function (progress, index) {
      _this.progresses[index] = progress;
      _this.animations[index] && _this.animations[index].seek(clamp(progress, 0, 1));
    }, _this.onBlockEnter = function (index) {
      _this.activeIndex = index;
      _this.animatable.seek(index);
    }, _this.handleSaveChapterClick = _asyncToGenerator$5( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$37({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return Promise.all(_this.state.blocks.map(function () {
                var _ref3 = _asyncToGenerator$5( /*#__PURE__*/regenerator.mark(function _callee(block) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(block.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return Promise.all(block.gallery.map(function (media) {
                            return (
                              // @todo 2024-09-17 it happened that one of gallery item was "null",
                              //  breaking the theme builder. This has to be handled.
                              save(ContentManager.make(media, 'thron-asset'))
                            );
                          }));

                        case 5:
                          _context.t1 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            gallery: _context.t1
                          });

                        case 7:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 8:
              _context2.t2 = _context2.sent;
              state = {
                templateName: _context2.t0,
                title: _context2.t1,
                blocks: _context2.t2
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.onTextBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.handleAddBlockClick = function () {
      _this.setState({ blocks: appendNewBlock$1(_this.state.blocks) });
    }, _this.onBlockTextBlur = function (index, value) {
      var blocks = [].concat(_toConsumableArray$1(_this.state.blocks));
      blocks[index].text.value = value;
      _this.setState({ blocks: blocks });
    }, _this.onBlockGalleryChange = function (assets, index) {
      // @todo 2018-04-22
      // Do not override existing ids, remove old ones and save new ones.
      // The onChange event could give us (new, removed, all) as parameters.
      var blocks = [].concat(_toConsumableArray$1(_this.state.blocks));
      blocks[index].gallery = assets.map(function (asset) {
        return makeContent('thron-asset', asset.value, asset.options);
      });

      _this.setState({
        blocks: blocks,
        chapterHeight: getChapterHeight$2(_this.state.screenHeight, _this.state.blocks)
      });
    }, _this.removeBlock = function (index) {
      var blocks = removeBlock(_this.state.blocks, index, 'This will be removed:\nText:\n' + _this.state.blocks[index].text.value);

      _this.setState({ blocks: blocks });
    }, _temp), _possibleConstructorReturn$39(_this, _ret);
  }

  _createClass$27(PopUpProject, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        blocks: chapter.blocks
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var chapterHeight = getChapterHeight$2(this.state.screenHeight, this.state.blocks);

      if (this.state.chapterHeight !== chapterHeight) {
        this.setState({ chapterHeight: chapterHeight });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              null,
              React__default.createElement(TextTranslatable, {
                plain: true,
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTextBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            displayMode: this.state.displayMode,
            height: getChapterHeight$2(this.state.screenHeight, this.state.blocks),
            columns: ['0%', '100%'],
            onEnter: this.props.onEnter,
            style: { display: 'flex' } },
          React__default.createElement(
            'div',
            null,
            this.state.blocks.map(function (block, index) {
              return React__default.createElement(
                StickyContainer$1,
                {
                  key: index,
                  leading: index > 0,
                  style: {
                    height: blockHeight$1(_this3.state.screenHeight, block)
                    // backgroundColor: '#'+(Math.random()*0xFFFFFF<<0).toString(16),
                  }
                },
                React__default.createElement(StickyContent, {
                  identifier: index,
                  onProgressChange: function onProgressChange(progress) {
                    if (_this3.state.currentIndex !== index) return;

                    _this3.progresses[index] = progress;
                    _this3.animations[index] && _this3.animations[index].seek(clamp(progress, 0, 1));

                    if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                      _this3.textScrollableCallbacks[index](progress);
                    }
                  },
                  onEnter: function onEnter(identifier) {
                    return _this3.setState({ currentIndex: identifier });
                  }
                })
              );
            })
          ),
          React__default.createElement(
            StickyContent,
            { style: { height: this.state.screenHeight, zIndex: 3 } },
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleAddBlockClick },
                __('+Block')
              ),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              )
            ),
            React__default.createElement(
              'div',
              { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start' } },
              this.state.blocks.map(function (block, index) {
                return index === _this3.state.currentIndex && React__default.createElement(
                  'div',
                  { key: index, style: {
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      left: 0,
                      height: _this3.state.screenHeight * .65
                    } },
                  React__default.createElement(GalleryScroll, {
                    displayMode: _this3.state.displayMode,
                    onLanguageChange: _this3.props.onContentLanguageChange,
                    canTranslateAsset: _this3.props.canTranslateAsset,
                    onContentUpdate: _this3.props.onContentUpdate,

                    assets: block.gallery,
                    onChange: function onChange(assets) {
                      return _this3.onBlockGalleryChange(assets, index);
                    },
                    height: _this3.state.screenHeight * .65,
                    direction: DIRECTION_UP,
                    shouldOpenThronBrowser: _this3.state.displayMode === DISPLAY_MODE_EDIT,
                    onAnimationReady: function onAnimationReady(animation) {
                      _this3.animations[index] = animation;
                      _this3.animations[index].seek(clamp(_this3.progresses[index], 0, 1));
                    }
                  })
                );
              }),
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    position: 'absolute',
                    top: this.state.screenHeight * .65,
                    right: '1.5rem',
                    left: '1.5rem'
                  } },
                this.state.blocks.map(function (block, index) {
                  return React__default.createElement(
                    'div',
                    { key: index, style: {
                        flex: index === _this3.state.currentIndex ? 1 : 0,
                        visibility: index === _this3.state.currentIndex ? null : 'hidden',
                        overflow: index === _this3.state.currentIndex ? null : 'hidden',
                        display: 'flex',
                        width: index === _this3.state.currentIndex ? null : 0
                      } },
                    React__default.createElement(
                      TemplateControl,
                      {
                        style: { position: 'absolute', top: '-1rem', left: '1rem', transform: 'translateY(-100%)' },
                        displayMode: _this3.state.displayMode
                      },
                      React__default.createElement(
                        TemplateControlButton,
                        { onClick: function onClick() {
                            return _this3.removeBlock(index);
                          } },
                        __('Remove block')
                      )
                    ),
                    React__default.createElement(
                      Scrollable,
                      {
                        innerPaddingTop: '1rem',
                        innerPaddingBottom: '4rem',
                        fade: true,
                        fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                        onProgressCallback: function onProgressCallback(callback) {
                          return _this3.textScrollableCallbacks[index] = callback;
                        },
                        style: {
                          pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1 ? 'none' : null,
                          height: _this3.state.screenHeight * .35
                        }
                      },
                      React__default.createElement(TextTranslatable, {
                        highlight: _this3.props.highlightWord,
                        onLanguageChange: _this3.props.onContentLanguageChange,
                        onContentUpdate: _this3.props.onContentUpdate,
                        displayMode: _this3.state.displayMode,
                        content: block.text,
                        onBlur: function onBlur(value) {
                          return _this3.onBlockTextBlur(index, value);
                        } })
                    ),
                    React__default.createElement(
                      'div',
                      { style: {
                          // minWidth: '1.375rem',
                          // marginLeft: '.5rem',
                          paddingBottom: '1rem',
                          paddingTop: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          justifyContent: 'space-between'
                        } },
                      _this3.props.theme.isMobile ? React__default.createElement(StepIndicator2, { active: index, total: _this3.state.blocks.length }) : _this3.props.theme.isTablet ? React__default.createElement(StepIndicator, { active: index, total: _this3.state.blocks.length }) : null,
                      React__default.createElement(
                        'div',
                        { style: {
                            fontSize: 0,
                            textAlign: 'end'
                          } },
                        React__default.createElement(ButtonList, {
                          displayMode: _this3.state.displayMode,
                          buttons: _this3.props.buttons,
                          content: block.text
                        })
                      )
                    )
                  );
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          columns: ['0%', '64%', '36%'],
          height: this.state.chapterHeight,
          onEnter: this.props.onEnter,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          { style: {
              zIndex: 2,
              display: 'flex',
              alignItems: 'center',
              height: this.state.screenHeight
            } },
          React__default.createElement(
            'div',
            { style: {
                position: 'relative',
                height: GALLERY_HEIGHT_REM + 11 + 'rem'
              } },
            React__default.createElement(
              'div',
              { style: {
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: '-6.5rem',
                  left: '5rem',
                  width: '10rem'
                } },
              React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.31)', number: this.state.index + 1 })
            )
          )
        ),
        React__default.createElement(
          'div',
          { style: { zIndex: 1 } },
          this.state.blocks.map(function (block, index) {
            return React__default.createElement(
              StickyContainer$1,
              {
                height: blockHeight$1(_this3.state.screenHeight, block),
                style: { display: 'flex' },
                key: block.text.id === null ? 'temp-' + index : block.text.id },
              React__default.createElement(
                StickyContent,
                {
                  style: { height: _this3.state.screenHeight, display: 'flex', alignItems: 'center' },
                  identifier: index,
                  onProgressChange: _this3.onBlockProgress,
                  onEnter: _this3.onBlockEnter },
                React__default.createElement(
                  'div',
                  { style: { position: 'relative' } },
                  React__default.createElement('div', { style: {
                      position: 'absolute',
                      top: '-5rem',
                      right: 0,
                      bottom: '-5rem',
                      left: 0,
                      backgroundColor: '#000'
                    } }),
                  React__default.createElement(GalleryScroll, {
                    displayMode: _this3.state.displayMode,
                    onLanguageChange: _this3.props.onContentLanguageChange,
                    canTranslateAsset: _this3.props.canTranslateAsset,
                    onContentUpdate: _this3.props.onContentUpdate,

                    assets: block.gallery,
                    onChange: function onChange(assets) {
                      return _this3.onBlockGalleryChange(assets, index);
                    },
                    height: remToPixels(GALLERY_HEIGHT_REM),
                    shadow: false,
                    direction: DIRECTION_LEFT,
                    shouldOpenThronBrowser: _this3.state.displayMode === DISPLAY_MODE_EDIT,
                    onAnimationReady: function onAnimationReady(animation) {
                      _this3.animations[index] = animation;
                      _this3.onBlockProgress(_this3.progresses[index], index);
                    } })
                ),
                React__default.createElement(
                  TemplateControl,
                  {
                    style: { position: 'absolute', top: '1rem', right: 0, left: '1rem' },
                    displayMode: _this3.state.displayMode },
                  React__default.createElement(
                    TemplateControlButton,
                    { onClick: function onClick() {
                        return _this3.removeBlock(index);
                      } },
                    __('Remove block')
                  )
                )
              )
            );
          })
        ),
        React__default.createElement(
          StickyContent,
          {
            style: {
              zIndex: 2,
              height: this.state.screenHeight,
              display: 'flex',
              alignItems: 'center',
              padding: '0 2.75rem 0 1.75rem',
              backgroundColor: '#fff'
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', right: 0, left: 0 },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleAddBlockClick },
              __('+Block')
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'column', height: GALLERY_HEIGHT_REM + 8 + 'rem' } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTextBlur })
              )
            ),
            React__default.createElement(
              Animatable,
              {
                style: { flex: 1 },
                hook: function hook(animatable) {
                  _this3.animatable = animatable;
                  _this3.onBlockEnter(_this3.activeIndex);
                } },
              this.state.blocks.map(function (block, index) {
                return React__default.createElement(
                  'div',
                  { key: block.text.id === null ? 'temp-' + index : block.text.id, style: { bottom: 0 } },
                  React__default.createElement(
                    'div',
                    { style: {
                        width: '100%',
                        wordBreak: 'break-word',
                        paddingBottom: '1rem'
                      } },
                    React__default.createElement(TextTranslatable, {
                      highlight: _this3.props.highlightWord,
                      onLanguageChange: _this3.props.onContentLanguageChange,
                      onContentUpdate: _this3.props.onContentUpdate,
                      displayMode: _this3.state.displayMode,
                      content: block.text,
                      onBlur: function onBlur(value) {
                        return _this3.onBlockTextBlur(index, value);
                      } })
                  ),
                  React__default.createElement(
                    'div',
                    { style: { position: 'absolute', right: 0, bottom: 0, left: 0, width: '15rem' } },
                    React__default.createElement(StepIndicator, { dark: true, active: index, total: _this3.state.blocks.length })
                  ),
                  React__default.createElement(
                    'div',
                    { style: { zIndex: 1, position: 'absolute', bottom: 0, minWidth: '1rem', height: '2rem' } },
                    React__default.createElement(ButtonList, {
                      displayMode: _this3.state.displayMode,
                      buttons: _this3.props.buttons,
                      content: block.text })
                  )
                );
              })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }

    // @todo 2021-07-26 10 has to be changed and made dynamic

  }]);

  return PopUpProject;
}(React.Component);

var blueprint$5 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    blocks: [blockBlueprint$1()]
  };
};

var PopUpProject$1 = styled.withTheme(asTemplate('PopUpProject', PopUpProject, blueprint$5));

var _createClass$28 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$38 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator$6(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray$2(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck$54(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$40(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$43(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function appendNewBlock$2(blocks) {
  return blocks.concat([blockBlueprint$2()]);
}

function blockBlueprint$2() {
  return _extends$38({}, {
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  });
}

function getChapterHeight$3(screenHeight, blocks) {
  return blocks.reduce(function (total, block) {
    return total + blockHeight$2(screenHeight, block);
  }, 0);
}

function blockHeight$2(screenHeight, block) {
  return Math.max(block.gallery.length * screenHeight / 1.5, screenHeight * 1.5);
}

var HowToSell = function (_Component) {
  _inherits$43(HowToSell, _Component);

  function HowToSell() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$54(this, HowToSell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$40(this, (_ref = HowToSell.__proto__ || Object.getPrototypeOf(HowToSell)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$38({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode,
      chapterHeight: getChapterHeight$3(_this.props.screenHeight, _this.props.content.blocks),
      currentIndex: 0
    }, _this.getStateFromChapter(_this.props.content)), _this.animations = [], _this.progresses = new Array(10).fill(function () {
      return 0;
    }), _this.activeIndex = 0, _this.textAnimation = null, _this.textScrollableCallbacks = new Array(10).fill(function () {
      return null;
    }), _this.onBlockEnter = function (index) {
      _this.activeIndex = index;
      _this.textAnimation.seek(index);
    }, _this.onTitleBlur = function (value) {
      var title = _extends$38({}, _this.state.title);
      title.value = value;
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onBlockTextBlur = function (index, value) {
      var blocks = [].concat(_toConsumableArray$2(_this.state.blocks));
      blocks[index].text.value = value;
      _this.setState({ blocks: blocks });
    }, _this.onBlockGalleryChange = function (assets, index) {
      var blocks = [].concat(_toConsumableArray$2(_this.state.blocks));
      blocks[index].gallery = assets.map(function (asset) {
        return makeContent('thron-asset', asset.value, asset.options);
      });
      _this.setState({ blocks: blocks });
    }, _this.handleAddBlockClick = function () {
      _this.setState({ blocks: appendNewBlock$2(_this.state.blocks) });
    }, _this.removeBlock = function (index) {
      var blocks = removeBlock(_this.state.blocks, index, 'This will be removed:\nText:\n' + _this.state.blocks[index].text.value + '\n\nMedia:\n' + _this.state.blocks[index].gallery.map(function (m) {
        return m.value;
      }).join("\n"));

      _this.setState({ blocks: blocks });
    }, _this.handleSaveChapterClick = _asyncToGenerator$6( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$38({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return Promise.all(_this.state.blocks.map(function () {
                var _ref3 = _asyncToGenerator$6( /*#__PURE__*/regenerator.mark(function _callee(block) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(block.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return Promise.all(block.gallery.map(function (media) {
                            return save(ContentManager.make(media, 'thron-asset'));
                          }));

                        case 5:
                          _context.t1 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            gallery: _context.t1
                          });

                        case 7:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 8:
              _context2.t2 = _context2.sent;
              state = {
                templateName: _context2.t0,
                title: _context2.t1,
                blocks: _context2.t2
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _temp), _possibleConstructorReturn$40(_this, _ret);
  }

  _createClass$28(HowToSell, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        blocks: chapter.blocks
      };
    }

    // @todo 2021-07-26 10 has to be changed and made dynamic

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var chapterHeight = getChapterHeight$3(this.state.screenHeight, this.state.blocks);

      if (this.state.chapterHeight !== chapterHeight) {
        this.setState({ chapterHeight: chapterHeight });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              null,
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            displayMode: this.state.displayMode,
            height: getChapterHeight$3(this.state.screenHeight, this.state.blocks),
            columns: ['0%', '100%'],
            onEnter: this.props.onEnter,
            style: { display: 'flex' } },
          React__default.createElement(
            'div',
            null,
            this.state.blocks.map(function (block, index) {
              return React__default.createElement(
                StickyContainer$1,
                {
                  key: index,
                  leading: index > 0,
                  style: {
                    height: blockHeight$2(_this3.state.screenHeight, block)
                    // backgroundColor: '#'+(Math.random()*0xFFFFFF<<0).toString(16),
                  }
                },
                React__default.createElement(StickyContent, {
                  identifier: index,
                  onProgressChange: function onProgressChange(progress) {
                    if (_this3.state.currentIndex !== index) return;

                    _this3.progresses[index] = progress;
                    _this3.animations[index] && _this3.animations[index].seek(clamp(progress, 0, 1));

                    if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                      _this3.textScrollableCallbacks[index](progress);
                    }
                  },
                  onEnter: function onEnter(identifier) {
                    return _this3.setState({ currentIndex: identifier });
                  }
                })
              );
            })
          ),
          React__default.createElement(
            StickyContent,
            { style: { height: this.state.screenHeight, zIndex: 3 } },
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleAddBlockClick },
                __('+Block')
              ),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              )
            ),
            React__default.createElement(
              'div',
              { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start' } },
              this.state.blocks.map(function (block, index) {
                return index === _this3.state.currentIndex && React__default.createElement(
                  'div',
                  { key: index, style: {
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      left: 0,
                      height: _this3.state.screenHeight * .65
                    } },
                  React__default.createElement(GalleryScroll, {
                    displayMode: _this3.state.displayMode,
                    onLanguageChange: _this3.props.onContentLanguageChange,
                    canTranslateAsset: _this3.props.canTranslateAsset,
                    onContentUpdate: _this3.props.onContentUpdate,

                    assets: block.gallery.slice().reverse(),
                    onChange: function onChange(assets) {
                      return _this3.onBlockGalleryChange(assets, index);
                    },
                    height: _this3.state.screenHeight * .65,
                    direction: DIRECTION_UP,
                    shouldOpenThronBrowser: _this3.state.displayMode === DISPLAY_MODE_EDIT,
                    onAnimationReady: function onAnimationReady(animation) {
                      _this3.animations[index] = animation;
                      _this3.animations[index].seek(clamp(_this3.progresses[index], 0, 1));
                    }
                  })
                );
              }),
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    position: 'absolute',
                    top: this.state.screenHeight * .65,
                    right: '1.5rem',
                    left: '1.5rem'
                  } },
                this.state.blocks.map(function (block, index) {
                  return React__default.createElement(
                    'div',
                    { key: index, style: {
                        flex: index === _this3.state.currentIndex ? 1 : 0,
                        visibility: index === _this3.state.currentIndex ? null : 'hidden',
                        overflow: index === _this3.state.currentIndex ? null : 'hidden',
                        display: 'flex',
                        width: index === _this3.state.currentIndex ? null : 0
                      } },
                    React__default.createElement(
                      TemplateControl,
                      {
                        style: { position: 'absolute', top: '-1rem', left: '1rem', transform: 'translateY(-100%)' },
                        displayMode: _this3.state.displayMode
                      },
                      React__default.createElement(
                        TemplateControlButton,
                        { onClick: function onClick() {
                            return _this3.removeBlock(index);
                          } },
                        __('Remove block')
                      )
                    ),
                    React__default.createElement(
                      Scrollable,
                      {
                        innerPaddingTop: '1rem',
                        innerPaddingBottom: '4rem',
                        fade: true,
                        fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                        onProgressCallback: function onProgressCallback(callback) {
                          return _this3.textScrollableCallbacks[index] = callback;
                        },
                        style: {
                          pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1 ? 'none' : null,
                          height: _this3.state.screenHeight * .35
                        }
                      },
                      React__default.createElement(TextTranslatable, {
                        highlight: _this3.props.highlightWord,
                        onLanguageChange: _this3.props.onContentLanguageChange,
                        onContentUpdate: _this3.props.onContentUpdate,
                        displayMode: _this3.state.displayMode,
                        content: block.text,
                        onBlur: function onBlur(value) {
                          return _this3.onBlockTextBlur(index, value);
                        } })
                    ),
                    React__default.createElement(
                      'div',
                      { style: {
                          // minWidth: '1.375rem',
                          // marginLeft: '.5rem',
                          paddingBottom: '1rem',
                          paddingTop: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          justifyContent: 'space-between'
                        } },
                      _this3.props.theme.isMobile ? React__default.createElement(StepIndicator2, { active: index, total: _this3.state.blocks.length }) : _this3.props.theme.isTablet ? React__default.createElement(StepIndicator, { active: index, total: _this3.state.blocks.length }) : null,
                      React__default.createElement(
                        'div',
                        { style: {
                            fontSize: 0,
                            textAlign: 'end'
                          } },
                        React__default.createElement(ButtonList, {
                          displayMode: _this3.state.displayMode,
                          buttons: _this3.props.buttons,
                          content: block.text
                        })
                      )
                    )
                  );
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.chapterHeight,
          columns: ['48%', '0', '52%'],
          onEnter: this.props.onEnter,
          onLeave: this.props.onLeave,
          style: {
            display: 'flex',
            backgroundColor: '#363636'
          } },
        React__default.createElement(
          StickyContent,
          {
            style: {
              height: this.state.screenHeight,
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '3rem',
              color: '#fff',
              zIndex: 3
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', left: '1rem' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleAddBlockClick },
              __('+Block')
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                height: '41rem',
                backgroundColor: '#000',
                padding: '2.25rem 1rem 3.5rem 2.5rem'
              } },
            React__default.createElement(
              'div',
              { style: {
                  zIndex: 2,
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: '-3.3rem',
                  right: '-15.5rem'
                } },
              React__default.createElement(BigChapterNumber, { color: 'rgba(255,255,255,0.41)', number: this.state.index + 1 })
            ),
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  plain: true,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(
              Animatable,
              {
                style: {
                  flex: 1,
                  height: '21.5rem',
                  marginRight: '2rem'
                },
                hook: function hook(animation) {
                  _this3.textAnimation = animation;
                  _this3.onBlockEnter(_this3.activeIndex);
                } },
              this.state.blocks.map(function (block, index) {
                return React__default.createElement(
                  'div',
                  { key: index, style: { bottom: 0 } },
                  React__default.createElement(
                    TemplateControl,
                    {
                      style: { position: 'absolute', top: '-5.75rem', left: '-2rem' },
                      displayMode: _this3.state.displayMode },
                    React__default.createElement(
                      TemplateControlButton,
                      { onClick: function onClick() {
                          return _this3.removeBlock(index);
                        } },
                      __('Remove block')
                    )
                  ),
                  React__default.createElement(
                    'div',
                    { style: { height: '100%' } },
                    React__default.createElement(TextTranslatable, {
                      highlight: _this3.props.highlightWord,
                      onLanguageChange: _this3.props.onContentLanguageChange,
                      onContentUpdate: _this3.props.onContentUpdate,
                      displayMode: _this3.state.displayMode,
                      content: block.text,
                      onBlur: function onBlur(value) {
                        return _this3.onBlockTextBlur(index, value);
                      } })
                  ),
                  React__default.createElement(
                    'div',
                    { style: { width: '15rem', marginRight: '3rem' } },
                    React__default.createElement(StepIndicator, { active: index, total: _this3.state.blocks.length })
                  ),
                  React__default.createElement(
                    'div',
                    { style: { zIndex: 1, position: 'absolute', bottom: 0, minWidth: '1rem', height: '2rem' } },
                    React__default.createElement(ButtonList, {
                      displayMode: _this3.state.displayMode,
                      buttons: _this3.props.buttons,
                      content: block.text })
                  )
                );
              })
            )
          )
        ),
        React__default.createElement(
          StickyContent,
          null,
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                alignItems: 'center',
                height: this.state.screenHeight
              } },
            React__default.createElement(
              'div',
              { style: { position: 'relative', height: '41rem' } },
              React__default.createElement('div', { style: {
                  position: 'absolute',
                  top: 0,
                  right: '-6rem',
                  bottom: 0,
                  width: '6rem',
                  backgroundColor: '#000'
                } })
            )
          )
        ),
        React__default.createElement(
          'div',
          { style: { zIndex: 2 } },
          this.state.blocks.map(function (block, index) {
            return React__default.createElement(
              StickyContainer$1,
              { style: { display: 'flex', height: blockHeight$2(_this3.state.screenHeight, block) }, key: index },
              React__default.createElement(
                StickyContent,
                {
                  identifier: index,
                  style: { height: _this3.state.screenHeight, display: 'flex', alignItems: 'center', zIndex: 2 },
                  onProgressChange: function onProgressChange(progress) {
                    _this3.progresses[index] = progress;
                    _this3.animations[index] && _this3.animations[index].seek(clamp(progress, 0, 1));
                  },
                  onEnter: _this3.onBlockEnter },
                React__default.createElement(
                  'div',
                  { style: { height: '41rem', display: 'flex', alignItems: 'flex-end' } },
                  React__default.createElement(GalleryScroll, {
                    displayMode: _this3.state.displayMode,
                    onLanguageChange: _this3.props.onContentLanguageChange,
                    canTranslateAsset: _this3.props.canTranslateAsset,
                    onContentUpdate: _this3.props.onContentUpdate,

                    assets: block.gallery,
                    onChange: function onChange(assets) {
                      return _this3.onBlockGalleryChange(assets, index);
                    },
                    height: remToPixels(37),
                    direction: DIRECTION_RIGHT,
                    shouldOpenThronBrowser: _this3.state.displayMode === DISPLAY_MODE_EDIT,
                    onAnimationReady: function onAnimationReady(animation) {
                      _this3.animations[index] = animation;
                      _this3.animations[index].seek(clamp(_this3.progresses[index], 0, 1));
                    } })
                )
              )
            );
          })
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return HowToSell;
}(React.Component);

var blueprint$6 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    blocks: [blockBlueprint$2()]
  };
};

var HowToSell$1 = styled.withTheme(asTemplate('HowToSell', HowToSell, blueprint$6, 'rgb(53,54,55)'));

var anime_min = createCommonjsModule(function (module) {
/*
 2017 Julian Garnier
 Released under the MIT license
*/
var $jscomp={scope:{}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(e,r,p){if(p.get||p.set)throw new TypeError("ES3 does not support getters and setters.");e!=Array.prototype&&e!=Object.prototype&&(e[r]=p.value);};$jscomp.getGlobal=function(e){return"undefined"!=typeof window&&window===e?e:"undefined"!=typeof commonjsGlobal&&null!=commonjsGlobal?commonjsGlobal:e};$jscomp.global=$jscomp.getGlobal(commonjsGlobal);$jscomp.SYMBOL_PREFIX="jscomp_symbol_";
$jscomp.initSymbol=function(){$jscomp.initSymbol=function(){};$jscomp.global.Symbol||($jscomp.global.Symbol=$jscomp.Symbol);};$jscomp.symbolCounter_=0;$jscomp.Symbol=function(e){return $jscomp.SYMBOL_PREFIX+(e||"")+$jscomp.symbolCounter_++};
$jscomp.initSymbolIterator=function(){$jscomp.initSymbol();var e=$jscomp.global.Symbol.iterator;e||(e=$jscomp.global.Symbol.iterator=$jscomp.global.Symbol("iterator"));"function"!=typeof Array.prototype[e]&&$jscomp.defineProperty(Array.prototype,e,{configurable:!0,writable:!0,value:function(){return $jscomp.arrayIterator(this)}});$jscomp.initSymbolIterator=function(){};};$jscomp.arrayIterator=function(e){var r=0;return $jscomp.iteratorPrototype(function(){return r<e.length?{done:!1,value:e[r++]}:{done:!0}})};
$jscomp.iteratorPrototype=function(e){$jscomp.initSymbolIterator();e={next:e};e[$jscomp.global.Symbol.iterator]=function(){return this};return e};$jscomp.array=$jscomp.array||{};$jscomp.iteratorFromArray=function(e,r){$jscomp.initSymbolIterator();e instanceof String&&(e+="");var p=0,m={next:function(){if(p<e.length){var u=p++;return{value:r(u,e[u]),done:!1}}m.next=function(){return{done:!0,value:void 0}};return m.next()}};m[Symbol.iterator]=function(){return m};return m};
$jscomp.polyfill=function(e,r,p,m){if(r){p=$jscomp.global;e=e.split(".");for(m=0;m<e.length-1;m++){var u=e[m];u in p||(p[u]={});p=p[u];}e=e[e.length-1];m=p[e];r=r(m);r!=m&&null!=r&&$jscomp.defineProperty(p,e,{configurable:!0,writable:!0,value:r});}};$jscomp.polyfill("Array.prototype.keys",function(e){return e?e:function(){return $jscomp.iteratorFromArray(this,function(e){return e})}},"es6-impl","es3");var $jscomp$this=commonjsGlobal;
(function(e,r){"function"===typeof undefined&&undefined.amd?undefined([],r):"object"==='object'&&module.exports?module.exports=r():e.anime=r();})(commonjsGlobal,function(){function e(a){if(!h.col(a))try{return document.querySelectorAll(a)}catch(c){}}function r(a,c){for(var d=a.length,b=2<=arguments.length?arguments[1]:void 0,f=[],n=0;n<d;n++)if(n in a){var k=a[n];c.call(b,k,n,a)&&f.push(k);}return f}function p(a){return a.reduce(function(a,d){return a.concat(h.arr(d)?p(d):d)},[])}function m(a){if(h.arr(a))return a;
h.str(a)&&(a=e(a)||a);return a instanceof NodeList||a instanceof HTMLCollection?[].slice.call(a):[a]}function u(a,c){return a.some(function(a){return a===c})}function C(a){var c={},d;for(d in a)c[d]=a[d];return c}function D(a,c){var d=C(a),b;for(b in a)d[b]=c.hasOwnProperty(b)?c[b]:a[b];return d}function z(a,c){var d=C(a),b;for(b in c)d[b]=h.und(a[b])?c[b]:a[b];return d}function T(a){a=a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(a,c,d,k){return c+c+d+d+k+k});var c=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
a=parseInt(c[1],16);var d=parseInt(c[2],16),c=parseInt(c[3],16);return"rgba("+a+","+d+","+c+",1)"}function U(a){function c(a,c,b){0>b&&(b+=1);1<b&&--b;return b<1/6?a+6*(c-a)*b:.5>b?c:b<2/3?a+(c-a)*(2/3-b)*6:a}var d=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a=parseInt(d[1])/360;var b=parseInt(d[2])/100,f=parseInt(d[3])/100,d=d[4]||1;if(0==b)f=b=a=f;else{var n=.5>f?f*(1+b):f+b-f*b,k=2*f-n,f=c(k,n,a+1/3),b=c(k,n,a);a=c(k,n,a-1/3);}return"rgba("+
255*f+","+255*b+","+255*a+","+d+")"}function y(a){if(a=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a))return a[2]}function V(a){if(-1<a.indexOf("translate")||"perspective"===a)return"px";if(-1<a.indexOf("rotate")||-1<a.indexOf("skew"))return"deg"}function I(a,c){return h.fnc(a)?a(c.target,c.id,c.total):a}function E(a,c){if(c in a.style)return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function J(a,c){if(h.dom(a)&&
u(W,c))return"transform";if(h.dom(a)&&(a.getAttribute(c)||h.svg(a)&&a[c]))return"attribute";if(h.dom(a)&&"transform"!==c&&E(a,c))return"css";if(null!=a[c])return"object"}function X(a,c){var d=V(c),d=-1<c.indexOf("scale")?1:0+d;a=a.style.transform;if(!a)return d;for(var b=[],f=[],n=[],k=/(\w+)\((.+?)\)/g;b=k.exec(a);)f.push(b[1]), n.push(b[2]);a=r(n,function(a,b){return f[b]===c});return a.length?a[0]:d}function K(a,c){switch(J(a,c)){case "transform":return X(a,c);case "css":return E(a,c);case "attribute":return a.getAttribute(c)}return a[c]||
0}function L(a,c){var d=/^(\*=|\+=|-=)/.exec(a);if(!d)return a;var b=y(a)||0;c=parseFloat(c);a=parseFloat(a.replace(d[0],""));switch(d[0][0]){case "+":return c+a+b;case "-":return c-a+b;case "*":return c*a+b}}function F(a,c){return Math.sqrt(Math.pow(c.x-a.x,2)+Math.pow(c.y-a.y,2))}function M(a){a=a.points;for(var c=0,d,b=0;b<a.numberOfItems;b++){var f=a.getItem(b);0<b&&(c+=F(d,f));d=f;}return c}function N(a){if(a.getTotalLength)return a.getTotalLength();switch(a.tagName.toLowerCase()){case "circle":return 2*
Math.PI*a.getAttribute("r");case "rect":return 2*a.getAttribute("width")+2*a.getAttribute("height");case "line":return F({x:a.getAttribute("x1"),y:a.getAttribute("y1")},{x:a.getAttribute("x2"),y:a.getAttribute("y2")});case "polyline":return M(a);case "polygon":var c=a.points;return M(a)+F(c.getItem(c.numberOfItems-1),c.getItem(0))}}function Y(a,c){function d(b){b=void 0===b?0:b;return a.el.getPointAtLength(1<=c+b?c+b:0)}var b=d(),f=d(-1),n=d(1);switch(a.property){case "x":return b.x;case "y":return b.y;
case "angle":return 180*Math.atan2(n.y-f.y,n.x-f.x)/Math.PI}}function O(a,c){var d=/-?\d*\.?\d+/g,b;b=h.pth(a)?a.totalLength:a;if(h.col(b))if(h.rgb(b)){var f=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b=f?"rgba("+f[1]+",1)":b;}else b=h.hex(b)?T(b):h.hsl(b)?U(b):void 0;else f=(f=y(b))?b.substr(0,b.length-f.length):b, b=c&&!/\s/g.test(b)?f+c:f;b+="";return{original:b,numbers:b.match(d)?b.match(d).map(Number):[0],strings:h.str(a)||c?b.split(d):[]}}function P(a){a=a?p(h.arr(a)?a.map(m):m(a)):[];return r(a,
function(a,d,b){return b.indexOf(a)===d})}function Z(a){var c=P(a);return c.map(function(a,b){return{target:a,id:b,total:c.length}})}function aa(a,c){var d=C(c);if(h.arr(a)){var b=a.length;2!==b||h.obj(a[0])?h.fnc(c.duration)||(d.duration=c.duration/b):a={value:a};}return m(a).map(function(a,b){b=b?0:c.delay;a=h.obj(a)&&!h.pth(a)?a:{value:a};h.und(a.delay)&&(a.delay=b);return a}).map(function(a){return z(a,d)})}function ba(a,c){var d={},b;for(b in a){var f=I(a[b],c);h.arr(f)&&(f=f.map(function(a){return I(a,
c)}), 1===f.length&&(f=f[0]));d[b]=f;}d.duration=parseFloat(d.duration);d.delay=parseFloat(d.delay);return d}function ca(a){return h.arr(a)?A.apply(this,a):Q[a]}function da(a,c){var d;return a.tweens.map(function(b){b=ba(b,c);var f=b.value,e=K(c.target,a.name),k=d?d.to.original:e,k=h.arr(f)?f[0]:k,w=L(h.arr(f)?f[1]:f,k),e=y(w)||y(k)||y(e);b.from=O(k,e);b.to=O(w,e);b.start=d?d.end:a.offset;b.end=b.start+b.delay+b.duration;b.easing=ca(b.easing);b.elasticity=(1E3-Math.min(Math.max(b.elasticity,1),999))/
1E3;b.isPath=h.pth(f);b.isColor=h.col(b.from.original);b.isColor&&(b.round=1);return d=b})}function ea(a,c){return r(p(a.map(function(a){return c.map(function(b){var c=J(a.target,b.name);if(c){var d=da(b,a);b={type:c,property:b.name,animatable:a,tweens:d,duration:d[d.length-1].end,delay:d[0].delay};}else b=void 0;return b})})),function(a){return!h.und(a)})}function R(a,c,d,b){var f="delay"===a;return c.length?(f?Math.min:Math.max).apply(Math,c.map(function(b){return b[a]})):f?b.delay:d.offset+b.delay+
b.duration}function fa(a){var c=D(ga,a),d=D(S,a),b=Z(a.targets),f=[],e=z(c,d),k;for(k in a)e.hasOwnProperty(k)||"targets"===k||f.push({name:k,offset:e.offset,tweens:aa(a[k],d)});a=ea(b,f);return z(c,{children:[],animatables:b,animations:a,duration:R("duration",a,c,d),delay:R("delay",a,c,d)})}function q(a){function c(){return window.Promise&&new Promise(function(a){return p=a})}function d(a){return g.reversed?g.duration-a:a}function b(a){for(var b=0,c={},d=g.animations,f=d.length;b<f;){var e=d[b],
k=e.animatable,h=e.tweens,n=h.length-1,l=h[n];n&&(l=r(h,function(b){return a<b.end})[0]||l);for(var h=Math.min(Math.max(a-l.start-l.delay,0),l.duration)/l.duration,w=isNaN(h)?1:l.easing(h,l.elasticity),h=l.to.strings,p=l.round,n=[],m=void 0,m=l.to.numbers.length,t=0;t<m;t++){var x=void 0,x=l.to.numbers[t],q=l.from.numbers[t],x=l.isPath?Y(l.value,w*x):q+w*(x-q);p&&(l.isColor&&2<t||(x=Math.round(x*p)/p));n.push(x);}if(l=h.length)for(m=h[0], w=0;w<l;w++)p=h[w+1], t=n[w], isNaN(t)||(m=p?m+(t+p):m+(t+" "));
else m=n[0];ha[e.type](k.target,e.property,m,c,k.id);e.currentValue=m;b++;}if(b=Object.keys(c).length)for(d=0;d<b;d++)H||(H=E(document.body,"transform")?"transform":"-webkit-transform"), g.animatables[d].target.style[H]=c[d].join(" ");g.currentTime=a;g.progress=a/g.duration*100;}function f(a){if(g[a])g[a](g);}function e(){g.remaining&&!0!==g.remaining&&g.remaining--;}function k(a){var k=g.duration,n=g.offset,w=n+g.delay,r=g.currentTime,x=g.reversed,q=d(a);if(g.children.length){var u=g.children,v=u.length;
if(q>=g.currentTime)for(var G=0;G<v;G++)u[G].seek(q);else for(;v--;)u[v].seek(q);}if(q>=w||!k)g.began||(g.began=!0, f("begin")), f("run");if(q>n&&q<k)b(q);else if(q<=n&&0!==r&&(b(0), x&&e()), q>=k&&r!==k||!k)b(k), x||e();f("update");a>=k&&(g.remaining?(t=h, "alternate"===g.direction&&(g.reversed=!g.reversed)):(g.pause(), g.completed||(g.completed=!0, f("complete"), "Promise"in window&&(p(), m=c()))), l=0);}a=void 0===a?{}:a;var h,t,l=0,p=null,m=c(),g=fa(a);g.reset=function(){var a=g.direction,c=g.loop;g.currentTime=
0;g.progress=0;g.paused=!0;g.began=!1;g.completed=!1;g.reversed="reverse"===a;g.remaining="alternate"===a&&1===c?2:c;b(0);for(a=g.children.length;a--;)g.children[a].reset();};g.tick=function(a){h=a;t||(t=h);k((l+h-t)*q.speed);};g.seek=function(a){k(d(a));};g.pause=function(){var a=v.indexOf(g);-1<a&&v.splice(a,1);g.paused=!0;};g.play=function(){g.paused&&(g.paused=!1, t=0, l=d(g.currentTime), v.push(g), B||ia());};g.reverse=function(){g.reversed=!g.reversed;t=0;l=d(g.currentTime);};g.restart=function(){g.pause();
g.reset();g.play();};g.finished=m;g.reset();g.autoplay&&g.play();return g}var ga={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},S={duration:1E3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},W="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),H,h={arr:function(a){return Array.isArray(a)},obj:function(a){return-1<Object.prototype.toString.call(a).indexOf("Object")},
pth:function(a){return h.obj(a)&&a.hasOwnProperty("totalLength")},svg:function(a){return a instanceof SVGElement},dom:function(a){return a.nodeType||h.svg(a)},str:function(a){return"string"===typeof a},fnc:function(a){return"function"===typeof a},und:function(a){return"undefined"===typeof a},hex:function(a){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)},rgb:function(a){return/^rgb/.test(a)},hsl:function(a){return/^hsl/.test(a)},col:function(a){return h.hex(a)||h.rgb(a)||h.hsl(a)}},A=function(){function a(a,
d,b){return(((1-3*b+3*d)*a+(3*b-6*d))*a+3*d)*a}return function(c,d,b,f){if(0<=c&&1>=c&&0<=b&&1>=b){var e=new Float32Array(11);if(c!==d||b!==f)for(var k=0;11>k;++k)e[k]=a(.1*k,c,b);return function(k){if(c===d&&b===f)return k;if(0===k)return 0;if(1===k)return 1;for(var h=0,l=1;10!==l&&e[l]<=k;++l)h+=.1;--l;var l=h+(k-e[l])/(e[l+1]-e[l])*.1,n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(.001<=n){for(h=0;4>h;++h){n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(0===n)break;var m=a(l,c,b)-k,l=l-m/n;}k=l;}else if(0===
n)k=l;else{var l=h,h=h+.1,g=0;do m=l+(h-l)/2, n=a(m,c,b)-k, 0<n?h=m:l=m;while(1e-7<Math.abs(n)&&10>++g);k=m;}return a(k,d,f)}}}}(),Q=function(){function a(a,b){return 0===a||1===a?a:-Math.pow(2,10*(a-1))*Math.sin(2*(a-1-b/(2*Math.PI)*Math.asin(1))*Math.PI/b)}var c="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),d={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],a],Out:[[.25,
.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(b,c){return 1-a(1-b,c)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(b,c){return.5>b?a(2*b,c)/2:1-a(-2*b+2,c)/2}]},b={linear:A(.25,.25,.75,.75)},f={},e;for(e in d)f.type=e, d[f.type].forEach(function(a){return function(d,f){b["ease"+a.type+c[f]]=h.fnc(d)?
d:A.apply($jscomp$this,d);}}(f)), f={type:f.type};return b}(),ha={css:function(a,c,d){return a.style[c]=d},attribute:function(a,c,d){return a.setAttribute(c,d)},object:function(a,c,d){return a[c]=d},transform:function(a,c,d,b,f){b[f]||(b[f]=[]);b[f].push(c+"("+d+")");}},v=[],B=0,ia=function(){function a(){B=requestAnimationFrame(c);}function c(c){var b=v.length;if(b){for(var d=0;d<b;)v[d]&&v[d].tick(c), d++;a();}else cancelAnimationFrame(B), B=0;}return a}();q.version="2.2.0";q.speed=1;q.running=v;q.remove=
function(a){a=P(a);for(var c=v.length;c--;)for(var d=v[c],b=d.animations,f=b.length;f--;)u(a,b[f].animatable.target)&&(b.splice(f,1), b.length||d.pause());};q.getValue=K;q.path=function(a,c){var d=h.str(a)?e(a)[0]:a,b=c||100;return function(a){return{el:d,property:a,totalLength:N(d)*(b/100)}}};q.setDashoffset=function(a){var c=N(a);a.setAttribute("stroke-dasharray",c);return c};q.bezier=A;q.easings=Q;q.timeline=function(a){var c=q(a);c.pause();c.duration=0;c.add=function(d){c.children.forEach(function(a){a.began=
!0;a.completed=!0;});m(d).forEach(function(b){var d=z(b,D(S,a||{}));d.targets=d.targets||a.targets;b=c.duration;var e=d.offset;d.autoplay=!1;d.direction=c.direction;d.offset=h.und(e)?b:L(e,b);c.began=!0;c.completed=!0;c.seek(d.offset);d=q(d);d.began=!0;d.completed=!0;d.duration>b&&(c.duration=d.duration);c.children.push(d);});c.seek(0);c.reset();c.autoplay&&c.restart();return c};return c};q.random=function(a,c){return Math.floor(Math.random()*(c-a+1))+a};return q});
});

var _createClass$29 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$39 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$55(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$41(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$44(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function renderThronAsset$1(state, props, asset, index) {
  var common = {
    key: index,
    width: props.width,
    height: props.height,
    zIndex: state.assets.length - index,
    wrapperStyle: imageStyle$2({ zIndex: state.assets.length - index }),
    style: { objectFit: 'cover' }
  };

  return React__default.createElement(ThronAssetTranslatable, _extends$39({}, common, {
    asset: asset,
    displayMode: state.displayMode,
    onLanguageChange: props.onLanguageChange,
    canTranslateAsset: props.canTranslateAsset,
    onContentUpdate: props.onContentUpdate }));
}

var GalleryStack = function (_Component) {
  _inherits$44(GalleryStack, _Component);

  function GalleryStack() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$55(this, GalleryStack);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$41(this, (_ref = GalleryStack.__proto__ || Object.getPrototypeOf(GalleryStack)).call.apply(_ref, [this].concat(args))), _this), _this.containerReference = null, _this.state = {
      displayMode: _this.props.displayMode,
      assets: _this.props.assets,
      shouldOpenThronBrowser: _this.props.shouldOpenThronBrowser,
      width: _this.props.width,
      height: _this.props.height
    }, _this.attemptAnimationReadyCallback = function () {
      var animation = anime_min.timeline({
        autoplay: false,
        duration: 1 / (_this.containerReference.childNodes.length - 1),
        easing: 'linear'
      });

      Array.from(_this.containerReference.childNodes).forEach(function (reference, index) {
        // We do not animate the last element to let it stay in the view.
        // Probably not a good solution since it stays for far more than the other
        // elements (scroll wise).
        if (_this.containerReference.childNodes.length - 1 === index) {
          return;
        }

        var transition = {};

        switch (_this.props.direction) {
          case DIRECTION_UP:
            transition['translateY'] = [0, -1 * _this.props.height];
            break;

          case DIRECTION_RIGHT:
            transition['translateX'] = [0, _this.containerReference.scrollWidth];
            break;

          case DIRECTION_DOWN:
            transition['translateY'] = [-1 * _this.props.height, 0];
            break;

          case DIRECTION_LEFT:
            transition['translateX'] = [0, -1 * _this.containerReference.scrollWidth];
            break;

          default:
          //
        }

        animation.add(_extends$39({ targets: reference }, transition));
      });

      _this.props.onAnimationReady(animation);
    }, _this.handleThronBrowserSelectionChange = function (assets) {
      var mapAssets = function mapAssets(assets) {
        return assets.map(function (asset) {
          return {
            value: asset.src,
            options: asset.options
          };
        });
      };

      _this.props.onChange(mapAssets(assets));
    }, _temp), _possibleConstructorReturn$41(_this, _ret);
  }

  _createClass$29(GalleryStack, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.attemptAnimationReadyCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.attemptAnimationReadyCallback();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        ThronBrowserTriggerer,
        {
          innerRef: function innerRef(ref) {
            return _this2.containerReference = ref;
          },
          style: { height: this.props.height },
          selectedAssets: this.state.assets.map(function (asset) {
            return asset.options;
          }),
          shouldOpenThronBrowser: this.state.shouldOpenThronBrowser && this.state.displayMode !== DISPLAY_MODE_TRANSLATE,
          onThronBrowserSelectionChange: this.handleThronBrowserSelectionChange },
        this.state.assets.map(function (asset, index) {
          return renderThronAsset$1(_this2.state, _this2.props, asset, index);
        })
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextState = {};

      if (nextProps.displayMode !== prevState.displayMode) {
        nextState.displayMode = nextProps.displayMode;
      }

      return _extends$39({}, nextState, {
        assets: nextProps.assets,
        shouldOpenThronBrowser: nextProps.shouldOpenThronBrowser,
        width: nextProps.width,
        height: nextProps.height
      });
    }
  }]);

  return GalleryStack;
}(React.Component);

GalleryStack.defaultProps = {
  onAnimationReady: function onAnimationReady(animation) {
    return null;
  },
  shouldOpenThronBrowser: false,
  assets: [],
  direction: DIRECTION_LEFT,
  height: undefined,
  width: undefined
};

var imageStyle$2 = function imageStyle(props) {
  return {
    zIndex: props.zIndex,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    willChange: 'transform'
  };
};

var _extends$40 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$30 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$7(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$56(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$42(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$45(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function chapterHeight(screenHeight, gallery) {
  return Math.max(gallery.length * screenHeight, screenHeight * 1.5);
}

var Highlights = function (_Component) {
  _inherits$45(Highlights, _Component);

  function Highlights() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$56(this, Highlights);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$42(this, (_ref = Highlights.__proto__ || Object.getPrototypeOf(Highlights)).call.apply(_ref, [this].concat(args))), _this), _this.animation = null, _this.progress = 0, _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$40({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      screenWidth: _this.props.screenWidth,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onProgress = function (progress) {
      _this.progress = progress;
      _this.animation && _this.animation.seek(clamp(progress, 0, 1));

      if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this.state.displayMode) !== -1) {
        _this.textScrollableCallback(progress);
      }
    }, _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onGalleryChange = function (assets) {
      _this.setState({ gallery: assets.map(function (asset) {
          return makeContent('thron-asset', asset.value, asset.options);
        }) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$7( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$40({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return Promise.all(_this.state.gallery.map(function (media) {
                return save(ContentManager.make(media, 'thron-asset'));
              }));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                gallery: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$42(_this, _ret);
  }

  _createClass$30(Highlights, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        gallery: chapter.gallery
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: chapterHeight(this.state.screenHeight, this.state.gallery),
          onEnter: this.props.onEnter,
          onLeave: this.props.onLeave },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight },
            onProgressChange: this.onProgress },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 2,
                display: 'flex',
                position: 'absolute',
                right: '0',
                bottom: '0',
                left: '0',
                padding: '0 1rem',
                color: '#fff',
                background: 'linear-gradient(0deg, rgb(0, 0, 0) 4rem, rgba(0, 0, 0, .4) 70%, rgba(0, 0, 0, 0) 100%)'
              } },
            React__default.createElement(
              Scrollable,
              {
                innerPaddingTop: '1rem',
                innerPaddingBottom: '4rem',
                fade: true,
                onProgressCallback: function onProgressCallback(callback) {
                  return _this3.textScrollableCallback = callback;
                },
                style: {
                  pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                  height: this.state.screenHeight * .5
                }
              },
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex'
                  } },
                React__default.createElement(
                  'div',
                  { style: { marginRight: '1rem' } },
                  React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
                ),
                React__default.createElement(
                  Title,
                  { style: { flex: 1 } },
                  React__default.createElement(
                    TitleText,
                    null,
                    React__default.createElement(TextTranslatable, {
                      highlight: this.props.highlightWord,
                      onLanguageChange: this.props.onContentLanguageChange,
                      onContentUpdate: this.props.onContentUpdate,
                      displayMode: this.state.displayMode,
                      content: this.state.title,
                      onBlur: this.onTitleBlur })
                  )
                )
              ),
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: {
                  // minWidth: '1.375rem',
                  // marginLeft: '.5rem',
                  paddingBottom: '1rem',
                  paddingTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                } },
              React__default.createElement('div', null),
              React__default.createElement(
                'div',
                { style: {
                    fontSize: 0,
                    textAlign: 'end'
                  } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.text
                })
              )
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 1,
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              } },
            React__default.createElement(GalleryStack, {
              displayMode: this.state.displayMode,
              onLanguageChange: this.props.onContentLanguageChange,
              canTranslateAsset: this.props.canTranslateAsset,
              onContentUpdate: this.props.onContentUpdate,

              assets: this.state.gallery,
              onChange: this.onGalleryChange,
              width: this.state.screenWidth,
              height: this.state.screenHeight,
              direction: DIRECTION_UP,
              onAnimationReady: function onAnimationReady(animation) {
                _this3.animation = animation;
                _this3.animation.seek(clamp(_this3.progress, 0, 1));
              },
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT })
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: chapterHeight(this.state.screenHeight, this.state.gallery),
          onEnter: this.props.onEnter,
          onLeave: this.props.onLeave },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight },
            onProgressChange: this.onProgress },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement('div', { style: {
              pointerEvents: 'none',
              zIndex: 2,
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: this.state.displayMode === DISPLAY_MODE_EDIT ? 'none' : 'block',
              background: 'linear-gradient(3deg, rgba(0,0,0,.9) 20%, rgba(255,255,255,0) 100%)'
            } }),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 3,
                pointerEvents: 'none',
                position: 'absolute',
                right: '5.5rem',
                bottom: '3rem'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(255,255,255,.1)', number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 4,
                position: 'absolute',
                right: '5.5rem',
                bottom: '5rem',
                left: '5.5rem',
                color: '#fff'
              } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '1rem'
                  } },
                React__default.createElement(
                  TitleText,
                  { style: {
                      marginBottom: 0,
                      minWidth: '13rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                ),
                React__default.createElement(
                  'div',
                  { style: { minWidth: '1rem', height: '2rem', marginLeft: '2rem' } },
                  React__default.createElement(ButtonList, {
                    displayMode: this.state.displayMode,
                    buttons: this.props.buttons,
                    content: this.state.text })
                )
              )
            ),
            React__default.createElement('div', { style: {
                width: '6.25rem',
                marginBottom: '1.75rem',
                height: 3,
                backgroundColor: '#fff'
              } }),
            React__default.createElement(TextTranslatable, {
              highlight: this.props.highlightWord,
              onLanguageChange: this.props.onContentLanguageChange,
              onContentUpdate: this.props.onContentUpdate,
              displayMode: this.state.displayMode,
              content: this.state.text,
              onBlur: this.onTextBlur })
          ),
          React__default.createElement(
            'div',
            { style: { zIndex: 1, position: 'relative' } },
            React__default.createElement(GalleryStack, {
              displayMode: this.state.displayMode,
              onLanguageChange: this.props.onContentLanguageChange,
              canTranslateAsset: this.props.canTranslateAsset,
              onContentUpdate: this.props.onContentUpdate,

              assets: this.state.gallery,
              onChange: this.onGalleryChange,
              width: this.state.screenWidth,
              height: this.state.screenHeight,
              direction: DIRECTION_UP,
              onAnimationReady: function onAnimationReady(animation) {
                _this3.animation = animation;
                _this3.animation.seek(clamp(_this3.progress, 0, 1));
              },
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT })
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        screenWidth: nextProps.screenWidth,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Highlights;
}(React.Component);

var blueprint$7 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  };
};

var Highlights$1 = styled.withTheme(asTemplate('Highlights', Highlights, blueprint$7, '#000'));

var _extends$41 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$31 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$8(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$57(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$43(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$46(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoodboardIntro = function (_Component) {
  _inherits$46(MoodboardIntro, _Component);

  function MoodboardIntro() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$57(this, MoodboardIntro);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$43(this, (_ref = MoodboardIntro.__proto__ || Object.getPrototypeOf(MoodboardIntro)).call.apply(_ref, [this].concat(args))), _this), _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$41({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$8( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$41({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                media: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$43(_this, _ret);
  }

  _createClass$31(MoodboardIntro, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        media: chapter.media
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          onEnter: this.props.onEnter,
          height: this.state.screenHeight * 2
        },
        React__default.createElement(
          StickyContent,
          {
            onProgressChange: function onProgressChange(progress) {
              if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                _this3.textScrollableCallback(progress);
              }
            },
            style: {
              height: this.state.screenHeight
            }
          },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '.5rem', right: '.5rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                paddingTop: '3rem'
              } },
            React__default.createElement(Media, {
              src: this.state.media.value,
              options: this.state.media.options,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              onChange: this.onMediaChange })
          ),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '1.5rem',
                left: '1rem'
              } },
            React__default.createElement(BigChapterNumber, { small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                position: 'absolute',
                right: '1.5rem',
                bottom: '1.5rem',
                left: '1.5rem',
                padding: '0 1.25rem',
                color: '#fff',
                background: '#000'
              } },
            React__default.createElement(
              Scrollable,
              {
                innerPaddingTop: '1.25rem',
                innerPaddingBottom: '4rem',
                fade: true,
                onProgressCallback: function onProgressCallback(callback) {
                  return _this3.textScrollableCallback = callback;
                },
                style: {
                  pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                  height: this.state.screenHeight * .625 - remToPixels(1.5)
                }
              },
              React__default.createElement(
                Title,
                null,
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: {
                  // minWidth: '1.375rem',
                  // marginLeft: '.5rem',
                  paddingBottom: '1rem',
                  paddingTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                } },
              React__default.createElement('div', null),
              React__default.createElement(
                'div',
                { style: {
                    fontSize: 0,
                    textAlign: 'end'
                  } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.text
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 1.5,
          columns: ['40%', '0', '60%'],
          onEnter: this.props.onEnter,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          { style: { zIndex: 1, height: this.state.screenHeight, paddingLeft: '5rem' } },
          React__default.createElement(
            TemplateControl,
            {
              style: { color: 'red', position: 'absolute', zIndex: 999, top: '.5rem', left: '2.5rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { position: 'relative', padding: '2.5rem 2.5rem 2.5rem 2.5rem', color: '#fff', background: '#000' } },
            React__default.createElement('div', { style: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '-5rem',
                width: '5rem',
                backgroundColor: '#000'
              } }),
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(TextTranslatable, {
              highlight: this.props.highlightWord,
              onLanguageChange: this.props.onContentLanguageChange,
              onContentUpdate: this.props.onContentUpdate,
              displayMode: this.state.displayMode,
              content: this.state.text,
              onBlur: this.onTextBlur }),
            React__default.createElement(
              'div',
              { style: { zIndex: 1, position: 'absolute', top: '1rem', right: '1rem', minWidth: '1rem', height: '2rem' } },
              React__default.createElement(ButtonList, {
                displayMode: this.state.displayMode,
                buttons: this.props.buttons,
                content: this.state.text })
            )
          )
        ),
        React__default.createElement(
          StickyContent,
          { style: { zIndex: 3, height: this.state.screenHeight } },
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                left: '5rem',
                width: '10rem'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(0,0,0,0.3)', number: this.state.index + 1 })
          )
        ),
        React__default.createElement(
          StickyContent,
          { style: {
              zIndex: 2,
              height: this.state.screenHeight,
              display: 'flex',
              alignItems: 'center',
              paddingRight: '5rem'
            } },
          React__default.createElement(Media, {
            width: remToPixels(33.5),
            src: this.state.media.value,
            options: this.state.media.options,
            shadow: true,
            shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
            onChange: this.onMediaChange })
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return MoodboardIntro;
}(React.Component);

var blueprint$8 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/1000x900')
  };
};

var MoodboardIntro$1 = styled.withTheme(asTemplate('MoodboardIntro', MoodboardIntro, blueprint$8));

var _extends$42 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$32 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$13 = _taggedTemplateLiteral$13(['\n z-index: 2;\n display: inline-block;\n position: relative;\n width: 19rem;\n padding: 2rem 3.25rem 3.25rem;\n background-color: #fff;\n box-shadow: -3px -2px 12px rgba(0,0,0,0.16);\n'], ['\n z-index: 2;\n display: inline-block;\n position: relative;\n width: 19rem;\n padding: 2rem 3.25rem 3.25rem;\n background-color: #fff;\n box-shadow: -3px -2px 12px rgba(0,0,0,0.16);\n']);

function _taggedTemplateLiteral$13(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator$9(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$58(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$44(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$47(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoodboardDetails = function (_Component) {
  _inherits$47(MoodboardDetails, _Component);

  function MoodboardDetails() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$58(this, MoodboardDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$44(this, (_ref = MoodboardDetails.__proto__ || Object.getPrototypeOf(MoodboardDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$42({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.onTitleSecondaryBlur = function (value) {
      _this.setState({ titleSecondary: setContentValue(_this.state.titleSecondary, value) });
    }, _this.onTextSecondaryBlur = function (value) {
      _this.setState({ textSecondary: setContentValue(_this.state.textSecondary, value) });
    }, _this.onMediaSecondaryChange = function (asset) {
      _this.setState({ mediaSecondary: setContentValue(_this.state.mediaSecondary, asset.value, asset.options) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$9( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$42({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 11:
              _context.t3 = _context.sent;
              _context.next = 14;
              return save(ContentManager.make(_this.state.titleSecondary, 'text'));

            case 14:
              _context.t4 = _context.sent;
              _context.next = 17;
              return save(ContentManager.make(_this.state.textSecondary, 'text'));

            case 17:
              _context.t5 = _context.sent;
              _context.next = 20;
              return save(ContentManager.make(_this.state.mediaSecondary, 'thron-asset'));

            case 20:
              _context.t6 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                media: _context.t3,
                titleSecondary: _context.t4,
                textSecondary: _context.t5,
                mediaSecondary: _context.t6
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$44(_this, _ret);
  }

  _createClass$32(MoodboardDetails, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        media: chapter.media,
        titleSecondary: chapter.titleSecondary,
        textSecondary: chapter.textSecondary,
        mediaSecondary: chapter.mediaSecondary
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          onEnter: this.props.onEnter
        },
        React__default.createElement(
          'div',
          { style: { position: 'relative' } },
          React__default.createElement(
            TemplateControl,
            {
              style: { color: 'red', position: 'absolute', zIndex: 999, top: '1rem', left: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                zIndex: 1,
                pointerEvents: 'none',
                position: 'absolute',
                top: '1.5rem',
                left: '1rem'
              } },
            React__default.createElement(BigChapterNumber, { small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            'div',
            { style: {
                paddingTop: '3rem'
              } },
            React__default.createElement(Media, {
              src: this.state.media.value,
              options: this.state.media.options,
              shadow: true,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              onChange: this.onMediaChange
            }),
            React__default.createElement(
              'div',
              { style: {
                  padding: '1.5rem'
                } },
              React__default.createElement(
                Title,
                null,
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(Media, {
              src: this.state.mediaSecondary.value,
              options: this.state.mediaSecondary.options,
              shadow: true,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              onChange: this.onMediaSecondaryChange
            }),
            React__default.createElement(
              'div',
              { style: {
                  display: 'flex',
                  padding: '1.5rem 1rem'
                } },
              React__default.createElement(
                'div',
                { style: { flex: 1, paddingBottom: '1rem' } },
                React__default.createElement(
                  Title,
                  null,
                  React__default.createElement(
                    TitleText,
                    null,
                    React__default.createElement(TextTranslatable, {
                      plain: true,
                      highlight: this.props.highlightWord,
                      onLanguageChange: this.props.onContentLanguageChange,
                      onContentUpdate: this.props.onContentUpdate,
                      displayMode: this.state.displayMode,
                      content: this.state.titleSecondary,
                      onBlur: this.onTitleSecondaryBlur })
                  )
                ),
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.textSecondary,
                  onBlur: this.onTextSecondaryBlur })
              ),
              React__default.createElement(
                'div',
                { style: {
                    // minWidth: '1.375rem',
                    // marginLeft: '.5rem',
                    paddingBottom: '1rem',
                    paddingTop: '1rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between'
                  } },
                React__default.createElement('div', null),
                React__default.createElement(
                  'div',
                  { style: {
                      fontSize: 0,
                      textAlign: 'end'
                    } },
                  React__default.createElement(ButtonList, {
                    displayMode: this.state.displayMode,
                    buttons: this.props.buttons,
                    content: this.state.textSecondary
                  })
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 1.5,
          onEnter: this.props.onEnter,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight, paddingLeft: '1.5rem' } },
          React__default.createElement(
            TemplateControl,
            {
              style: { color: 'red', position: 'absolute', zIndex: 999, top: '1rem', left: '0', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { padding: '1.5rem 0 1.5rem', height: this.state.screenHeight } },
            React__default.createElement(
              'div',
              { style: {
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: '3rem',
                  right: '3.5rem'
                } },
              React__default.createElement(BigChapterNumber, { color: 'rgba(0,0,0,0.3)', number: this.state.index + 1 })
            ),
            React__default.createElement(
              WhiteBox,
              null,
              React__default.createElement(
                Title,
                null,
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(
                'div',
                null,
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.text,
                  onBlur: this.onTextBlur })
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  zIndex: 1,
                  position: 'absolute',
                  top: '11.5rem',
                  right: '0.5rem',
                  width: '18rem'
                } },
              React__default.createElement(Media, {
                width: remToPixels(18),
                src: this.state.media.value,
                options: this.state.media.options,
                shadow: true,
                shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                onChange: this.onMediaChange })
            )
          )
        ),
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight, paddingRight: '1.5rem' } },
          React__default.createElement(
            'div',
            { style: {
                padding: '1.5rem 0 1.5rem',
                height: this.state.screenHeight,
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end'
              } },
            React__default.createElement(
              WhiteBox,
              { style: {
                  marginRight: '1rem',
                  marginBottom: '1rem'
                } },
              React__default.createElement(
                Title,
                null,
                React__default.createElement(
                  TitleText,
                  null,
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.titleSecondary,
                    onBlur: this.onTitleSecondaryBlur })
                )
              ),
              React__default.createElement(
                'div',
                null,
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.textSecondary,
                  onBlur: this.onTextSecondaryBlur })
              ),
              React__default.createElement(
                'div',
                { style: { zIndex: 1, position: 'absolute', bottom: 0, minWidth: '1rem', height: '2rem' } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.textSecondary })
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  zIndex: 1,
                  position: 'absolute',
                  top: '1.5rem',
                  left: '0.5rem',
                  width: '18rem'
                } },
              React__default.createElement(Media, {
                width: remToPixels(18),
                src: this.state.mediaSecondary.value,
                options: this.state.mediaSecondary.options,
                shadow: true,
                shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                onChange: this.onMediaSecondaryChange })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return MoodboardDetails;
}(React.Component);

var blueprint$9 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/500x900'),
    titleSecondary: makeContent('text'),
    textSecondary: makeContent('text'),
    mediaSecondary: makeContent('thron-asset', 'http://via.placeholder.com/500x900')
  };
};

var MoodboardDetails$1 = styled.withTheme(asTemplate('MoodboardDetails', MoodboardDetails, blueprint$9));

var WhiteBox = styled__default.div(_templateObject$13);

var _extends$43 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$33 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$10(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$59(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$45(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$48(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getChapterHeight$4(screenHeight, gallery) {
  return Math.max(gallery.length * screenHeight / 1.75, screenHeight * 1.5);
}

var MoodboardRunway = function (_Component) {
  _inherits$48(MoodboardRunway, _Component);

  function MoodboardRunway() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$59(this, MoodboardRunway);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$45(this, (_ref = MoodboardRunway.__proto__ || Object.getPrototypeOf(MoodboardRunway)).call.apply(_ref, [this].concat(args))), _this), _this.progress = 0, _this.animation = null, _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$43({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onGalleryChange = function (assets) {
      _this.setState({ gallery: assets.map(function (asset) {
          return makeContent('thron-asset', asset.value, asset.options);
        }) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$10( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$43({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return Promise.all(_this.state.gallery.map(function (media) {
                return save(ContentManager.make(media, 'thron-asset'));
              }));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                gallery: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$45(_this, _ret);
  }

  _createClass$33(MoodboardRunway, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        gallery: chapter.gallery
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              null,
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            displayMode: this.state.displayMode,
            height: getChapterHeight$4(this.state.screenHeight, this.state.gallery),
            onEnter: this.props.onEnter,
            style: { display: 'flex' } },
          React__default.createElement(
            StickyContent,
            {
              style: { height: this.state.screenHeight, zIndex: 3 },
              onProgressChange: function onProgressChange(progress) {
                _this3.progress = progress;
                _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));

                if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                  _this3.textScrollableCallback(progress);
                }
              }
            },
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              )
            ),
            React__default.createElement(
              'div',
              { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start' } },
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    left: 0,
                    height: this.state.screenHeight * .65
                  } },
                React__default.createElement(GalleryScroll, {
                  displayMode: this.state.displayMode,
                  onLanguageChange: this.props.onContentLanguageChange,
                  canTranslateAsset: this.props.canTranslateAsset,
                  onContentUpdate: this.props.onContentUpdate,

                  assets: this.state.gallery,
                  onChange: this.onGalleryChange,
                  height: this.state.screenHeight * .65,
                  direction: DIRECTION_UP,
                  shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                  onAnimationReady: function onAnimationReady(animation) {
                    _this3.animation = animation;
                    _this3.animation.seek(clamp(_this3.progress, 0, 1));
                  }
                })
              ),
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    position: 'absolute',
                    top: this.state.screenHeight * .65,
                    right: '1.5rem',
                    left: '1.5rem'
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      flex: 1,
                      display: 'flex'
                    } },
                  React__default.createElement(
                    Scrollable,
                    {
                      innerPaddingTop: '1rem',
                      innerPaddingBottom: '4rem',
                      fade: true,
                      fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                      onProgressCallback: function onProgressCallback(callback) {
                        return _this3.textScrollableCallback = callback;
                      },
                      style: {
                        pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                        height: this.state.screenHeight * .35
                      }
                    },
                    React__default.createElement(TextTranslatable, {
                      highlight: this.props.highlightWord,
                      onLanguageChange: this.props.onContentLanguageChange,
                      onContentUpdate: this.props.onContentUpdate,
                      displayMode: this.state.displayMode,
                      content: this.state.text,
                      onBlur: this.onTextBlur })
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        // minWidth: '1.375rem',
                        // marginLeft: '.5rem',
                        paddingBottom: '1rem',
                        paddingTop: '1rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        justifyContent: 'space-between'
                      } },
                    React__default.createElement('div', null),
                    React__default.createElement(
                      'div',
                      { style: {
                          fontSize: 0,
                          textAlign: 'end'
                        } },
                      React__default.createElement(ButtonList, {
                        displayMode: this.state.displayMode,
                        buttons: this.props.buttons,
                        content: this.state.text
                      })
                    )
                  )
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          columns: ['63%', '37%'],
          height: getChapterHeight$4(this.state.screenHeight, this.state.gallery),
          onEnter: this.props.onEnter,
          style: { display: 'flex' } },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight, display: 'flex', alignItems: 'center' },
            onProgressChange: function onProgressChange(progress) {
              _this3.progress = progress;
              _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, left: '1rem', top: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { position: 'relative' } },
            React__default.createElement('div', { style: {
                position: 'absolute',
                top: '-2.5rem',
                right: '9.375rem',
                bottom: '-2.5rem',
                left: 0,
                backgroundColor: '#000',
                zIndex: 2
              } }),
            React__default.createElement(
              'div',
              { style: {
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: '-6rem',
                  right: '1.3rem',
                  zIndex: 1
                } },
              React__default.createElement(BigChapterNumber, { color: 'rgba(0,0,0,.45)', number: this.state.index + 1 })
            ),
            React__default.createElement(GalleryScroll, {
              displayMode: this.state.displayMode,
              onLanguageChange: this.props.onContentLanguageChange,
              canTranslateAsset: this.props.canTranslateAsset,
              onContentUpdate: this.props.onContentUpdate,

              style: { zIndex: 3 },
              assets: this.state.gallery,
              onChange: this.onGalleryChange,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              height: remToPixels(31.25),
              shadow: true,
              direction: DIRECTION_LEFT,
              onAnimationReady: function onAnimationReady(animation) {
                _this3.animation = animation;
                _this3.animation && _this3.animation.seek(clamp(_this3.progress, 0, 1));
              }
            })
          )
        ),
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight, backgroundColor: '#fff' } },
          React__default.createElement(
            'div',
            { style: { padding: '5rem 3.5rem 7rem 2.5rem' } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                null,
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(
              'div',
              { style: { paddingBottom: '2rem' } },
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: { zIndex: 1, position: 'absolute', bottom: '4rem', minWidth: '1rem' } },
              React__default.createElement(ButtonList, {
                displayMode: this.state.displayMode,
                buttons: this.props.buttons,
                content: this.state.text })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return MoodboardRunway;
}(React.Component);

var blueprint$10 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/700x500')]
  };
};

var MoodboardRunway$1 = styled.withTheme(asTemplate('MoodboardRunway', MoodboardRunway, blueprint$10));

var _extends$44 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$34 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$11(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$60(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$46(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$49(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function computeGalleryHeight(screenHeight) {
  return screenHeight - remToPixels(24 /* 21rem (text below) + 3rem (padding below) */);
}

var columnStyle = {
  zIndex: 2,
  flex: '0 0 38%',
  color: '#fff',
  marginBottom: '1rem',
  paddingTop: '1.5rem',
  paddingRight: '3rem',
  paddingBottom: '1.5rem',
  paddingLeft: '1rem',
  height: '19rem'
};

function getChapterHeight$5(screenHeight, gallery) {
  return Math.max(gallery.length * screenHeight / 2.5, screenHeight * 1.5);
}

var MoodboardLookbook = function (_Component) {
  _inherits$49(MoodboardLookbook, _Component);

  function MoodboardLookbook() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$60(this, MoodboardLookbook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$46(this, (_ref = MoodboardLookbook.__proto__ || Object.getPrototypeOf(MoodboardLookbook)).call.apply(_ref, [this].concat(args))), _this), _this.progress = 0, _this.animation = null, _this.textScrollableCallback = function () {
      return null;
    }, _this.leftColumnScrollableCallback = function () {
      return null;
    }, _this.rightColumnScrollableCallback = function () {
      return null;
    }, _this.state = _extends$44({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode,
      galleryHeight: computeGalleryHeight(_this.props.screenHeight)
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onLeftColumnTitleBlur = function (value) {
      _this.setState({ leftColumnTitle: setContentValue(_this.state.leftColumnTitle, value) });
    }, _this.onLeftColumnTextBlur = function (value) {
      _this.setState({ leftColumnText: setContentValue(_this.state.leftColumnText, value) });
    }, _this.onRightColumnTitleBlur = function (value) {
      _this.setState({ rightColumnTitle: setContentValue(_this.state.rightColumnTitle, value) });
    }, _this.onRightColumnTextBlur = function (value) {
      _this.setState({ rightColumnText: setContentValue(_this.state.rightColumnText, value) });
    }, _this.onGalleryChange = function (assets) {
      _this.setState({ gallery: assets.map(function (asset) {
          return makeContent('thron-asset', asset.value, asset.options);
        }) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$11( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$44({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return Promise.all(_this.state.gallery.map(function (media) {
                return save(ContentManager.make(media, 'thron-asset'));
              }));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return save(ContentManager.make(_this.state.leftColumnTitle, 'text'));

            case 11:
              _context.t3 = _context.sent;
              _context.next = 14;
              return save(ContentManager.make(_this.state.leftColumnText, 'text'));

            case 14:
              _context.t4 = _context.sent;
              _context.next = 17;
              return save(ContentManager.make(_this.state.rightColumnTitle, 'text'));

            case 17:
              _context.t5 = _context.sent;
              _context.next = 20;
              return save(ContentManager.make(_this.state.rightColumnText, 'text'));

            case 20:
              _context.t6 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                gallery: _context.t2,
                leftColumnTitle: _context.t3,
                leftColumnText: _context.t4,
                rightColumnTitle: _context.t5,
                rightColumnText: _context.t6
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$46(_this, _ret);
  }

  _createClass$34(MoodboardLookbook, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        gallery: chapter.gallery,
        leftColumnTitle: chapter.leftColumnTitle,
        leftColumnText: chapter.leftColumnText,
        rightColumnTitle: chapter.rightColumnTitle,
        rightColumnText: chapter.rightColumnText
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              null,
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            displayMode: this.state.displayMode,
            height: getChapterHeight$5(this.state.screenHeight, this.state.gallery),
            onEnter: this.props.onEnter,
            style: { display: 'flex' } },
          React__default.createElement(
            StickyContent,
            {
              style: { height: this.state.screenHeight, zIndex: 3 },
              onProgressChange: function onProgressChange(progress) {
                _this3.progress = progress;
                _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));

                if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                  _this3.textScrollableCallback(progress);
                }
              }
            },
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', right: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              )
            ),
            React__default.createElement(
              'div',
              { style: { height: this.state.screenHeight, display: 'flex', flexDirection: 'column', justifyContent: 'start' } },
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    left: 0,
                    height: this.state.screenHeight * .5
                  } },
                React__default.createElement(GalleryScroll, {
                  displayMode: this.state.displayMode,
                  onLanguageChange: this.props.onContentLanguageChange,
                  canTranslateAsset: this.props.canTranslateAsset,
                  onContentUpdate: this.props.onContentUpdate,

                  assets: this.state.gallery,
                  onChange: this.onGalleryChange,
                  height: this.state.screenHeight * .5,
                  direction: DIRECTION_LEFT,
                  shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                  onAnimationReady: function onAnimationReady(animation) {
                    _this3.animation = animation;
                    _this3.animation.seek(clamp(_this3.progress, 0, 1));
                  }
                })
              ),
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex',
                    position: 'absolute',
                    top: this.state.screenHeight * .5,
                    right: '1.5rem',
                    left: '1.5rem',
                    padding: '0 1rem',
                    color: '#fff',
                    background: '#000'
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      flex: 1,
                      display: 'flex'
                    } },
                  React__default.createElement(
                    Scrollable,
                    {
                      innerPaddingTop: '1rem',
                      innerPaddingBottom: '4rem',
                      fade: true,
                      onProgressCallback: function onProgressCallback(callback) {
                        return _this3.textScrollableCallback = callback;
                      },
                      style: {
                        pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                        height: this.state.screenHeight * .5
                      }
                    },
                    React__default.createElement(
                      'div',
                      { style: { fontSize: '1.125em', color: '#888', fontStyle: 'italic', marginBottom: '1rem' } },
                      React__default.createElement(TextTranslatable, {
                        plain: true,
                        highlight: this.props.highlightWord,
                        onLanguageChange: this.props.onContentLanguageChange,
                        onContentUpdate: this.props.onContentUpdate,
                        displayMode: this.state.displayMode,
                        content: this.state.leftColumnTitle,
                        onBlur: this.onLeftColumnTitleBlur })
                    ),
                    React__default.createElement(
                      'div',
                      { style: { marginBottom: '2rem' } },
                      React__default.createElement(TextTranslatable, {
                        highlight: this.props.highlightWord,
                        onLanguageChange: this.props.onContentLanguageChange,
                        onContentUpdate: this.props.onContentUpdate,
                        displayMode: this.state.displayMode,
                        content: this.state.leftColumnText,
                        onBlur: this.onLeftColumnTextBlur })
                    ),
                    React__default.createElement(
                      'div',
                      { style: { fontSize: '1.125em', color: '#888', fontStyle: 'italic', marginBottom: '1rem' } },
                      React__default.createElement(TextTranslatable, {
                        highlight: this.props.highlightWord,
                        onLanguageChange: this.props.onContentLanguageChange,
                        onContentUpdate: this.props.onContentUpdate,
                        displayMode: this.state.displayMode,
                        content: this.state.rightColumnTitle,
                        onBlur: this.onRightColumnTitleBlur })
                    ),
                    React__default.createElement(
                      'div',
                      null,
                      React__default.createElement(TextTranslatable, {
                        highlight: this.props.highlightWord,
                        onLanguageChange: this.props.onContentLanguageChange,
                        onContentUpdate: this.props.onContentUpdate,
                        displayMode: this.state.displayMode,
                        content: this.state.rightColumnText,
                        onBlur: this.onRightColumnTextBlur })
                    )
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        // minWidth: '1.375rem',
                        // marginLeft: '.5rem',
                        paddingBottom: '1rem',
                        paddingTop: '1rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        justifyContent: 'space-between'
                      } },
                    React__default.createElement('div', null),
                    React__default.createElement(
                      'div',
                      { style: {
                          fontSize: 0,
                          textAlign: 'end'
                        } },
                      React__default.createElement(ButtonList, {
                        displayMode: this.state.displayMode,
                        buttons: this.props.buttons,
                        content: this.state.rightColumnText
                      })
                    )
                  )
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: getChapterHeight$5(this.state.screenHeight, this.state.gallery),
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          {
            style: { height: this.state.screenHeight },
            onProgressChange: function onProgressChange(progress) {
              _this3.progress = progress;
              _this3.animation && _this3.animation.seek(clamp(progress, 0, 1));

              _this3.leftColumnScrollableCallback(progress);
              _this3.rightColumnScrollableCallback(progress);
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, left: '1rem', top: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                height: this.state.screenHeight,
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '1rem',
                paddingBottom: '3rem'
              } },
            React__default.createElement(GalleryScroll, {
              displayMode: this.state.displayMode,
              onLanguageChange: this.props.onContentLanguageChange,
              canTranslateAsset: this.props.canTranslateAsset,
              onContentUpdate: this.props.onContentUpdate,

              height: this.state.galleryHeight,
              style: { zIndex: 3, flex: '0 0 ' + this.state.galleryHeight + 'px' },
              assets: this.state.gallery,
              onChange: this.onGalleryChange,
              shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
              shadow: true,
              direction: DIRECTION_LEFT,
              onAnimationReady: function onAnimationReady(animation) {
                _this3.animation = animation;
                _this3.animation && _this3.animation.seek(clamp(_this3.progress, 0, 1));
              }
            }),
            React__default.createElement(
              'div',
              { style: { position: 'relative', flex: '1 1 21rem', display: 'flex' } },
              React__default.createElement('div', { style: {
                  zIndex: 1,
                  position: 'absolute',
                  top: '-8rem',
                  right: '1.5rem',
                  bottom: 0,
                  left: '9.5rem',
                  backgroundColor: '#000'
                } }),
              React__default.createElement(
                'div',
                { style: {
                    zIndex: 2,
                    pointerEvents: 'none',
                    position: 'absolute',
                    bottom: 0,
                    left: '9.5rem'
                  } },
                React__default.createElement(BigChapterNumber, { color: 'rgba(255,255,255,.3)', number: this.state.index + 1 })
              ),
              React__default.createElement(
                'div',
                { style: { zIndex: 2, flex: '0 0 24%', paddingTop: '5rem', paddingLeft: '3rem', color: '#484848', wordBreak: 'break-word' } },
                React__default.createElement(
                  Title,
                  null,
                  React__default.createElement(
                    TitleText,
                    null,
                    React__default.createElement(TextTranslatable, {
                      plain: true,
                      highlight: this.props.highlightWord,
                      onLanguageChange: this.props.onContentLanguageChange,
                      onContentUpdate: this.props.onContentUpdate,
                      displayMode: this.state.displayMode,
                      content: this.state.title,
                      onBlur: this.onTitleBlur })
                  )
                )
              ),
              React__default.createElement(
                Scrollable,
                {
                  innerPaddingBottom: '1rem',
                  onProgressCallback: function onProgressCallback(callback) {
                    return _this3.leftColumnScrollableCallback = callback;
                  },
                  style: _extends$44({}, columnStyle, {
                    pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null
                  }) },
                React__default.createElement(
                  'div',
                  { style: { fontSize: '1.125em', color: '#888', fontStyle: 'italic', marginBottom: '1rem' } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.leftColumnTitle,
                    onBlur: this.onLeftColumnTitleBlur })
                ),
                React__default.createElement(
                  'div',
                  null,
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.leftColumnText,
                    onBlur: this.onLeftColumnTextBlur })
                )
              ),
              React__default.createElement(
                Scrollable,
                {
                  innerPaddingBottom: '1rem',
                  onProgressCallback: function onProgressCallback(callback) {
                    return _this3.rightColumnScrollableCallback = callback;
                  },
                  style: _extends$44({}, columnStyle, {
                    pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null
                  }) },
                React__default.createElement(
                  'div',
                  { style: { fontSize: '1.125em', color: '#888', fontStyle: 'italic', marginBottom: '1rem' } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.rightColumnTitle,
                    onBlur: this.onRightColumnTitleBlur })
                ),
                React__default.createElement(
                  'div',
                  null,
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.rightColumnText,
                    onBlur: this.onRightColumnTextBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: { zIndex: 2, position: 'absolute', right: '2.5rem', bottom: 0, minWidth: '1rem', height: '2rem' } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.rightColumnText })
              )
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode,
        galleryHeight: computeGalleryHeight(nextProps.screenHeight)
      };
    }
  }]);

  return MoodboardLookbook;
}(React.Component);

var blueprint$11 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    gallery: [makeContent('thron-asset', 'http://via.placeholder.com/300x700')],
    leftColumnTitle: makeContent('text'),
    leftColumnText: makeContent('text'),
    rightColumnTitle: makeContent('text'),
    rightColumnText: makeContent('text')
  };
};

var MoodboardLookbook$1 = styled.withTheme(asTemplate('MoodboardLookbook', MoodboardLookbook, blueprint$11));

var _extends$45 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$13(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TooltipBoxDecoration = (function (_ref) {
  var small = _ref.small,
      props = _objectWithoutProperties$13(_ref, ['small']);

  return React__default.createElement(
    'div',
    props,
    React__default.createElement(ArrowRight, { style: {
        position: 'absolute',
        top: '2rem',
        bottom: 0,
        left: '-2.25rem'
      } }),
    React__default.createElement('div', { style: {
        position: 'absolute',
        top: '2rem',
        width: '.1875rem',
        height: small ? '4.25rem' : '8.75rem',
        backgroundColor: '#000'
      } })
  );
});

var ArrowRight = function ArrowRight(_ref2) {
  var style = _ref2.style,
      props = _objectWithoutProperties$13(_ref2, ['style']);

  return React__default.createElement(
    'svg',
    _extends$45({}, props, { style: _extends$45({ width: '1.625rem', height: '2.625rem' }, style), viewBox: '0 0 14 26', version: '1.1' }),
    React__default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
      React__default.createElement(
        'g',
        { stroke: '#1A1919', strokeWidth: '1.98305085' },
        React__default.createElement('polyline', { points: '0.991492373 0.991558475 12.9544669 12.9544229 0.991492373 24.9173975' })
      )
    )
  );
};

var _templateObject$14 = _taggedTemplateLiteral$14(['\n  pointer-events: none;\n\n  ', ';\n\n  background-color: ', ';\n  transition: all .3s ease;\n  transform: ', ';\n  opacity: 0;\n\n  ', ';\n\n  ', ';\n'], ['\n  pointer-events: none;\n\n  ', ';\n\n  background-color: ', ';\n  transition: all .3s ease;\n  transform: ', ';\n  opacity: 0;\n\n  ', ';\n\n  ', ';\n']),
    _templateObject2$8 = _taggedTemplateLiteral$14(['\n    width: 100%;\n    padding: max(1.5rem, env(safe-area-inset-top)) 3rem 1.5rem 1.5rem;\n  '], ['\n    width: 100%;\n    padding: max(1.5rem, env(safe-area-inset-top)) 3rem 1.5rem 1.5rem;\n  ']),
    _templateObject3$6 = _taggedTemplateLiteral$14(['\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    padding: 1.5rem;\n  '], ['\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    padding: 1.5rem;\n  ']),
    _templateObject4$3 = _taggedTemplateLiteral$14(['\n    bottom: 0;\n    width: 22.125rem;\n    height: 100%;\n  '], ['\n    bottom: 0;\n    width: 22.125rem;\n    height: 100%;\n  ']),
    _templateObject5$1 = _taggedTemplateLiteral$14(['\n    pointer-events: initial;\n    display: flex;\n    transform: ', ';\n    opacity: 1;\n  '], ['\n    pointer-events: initial;\n    display: flex;\n    transform: ', ';\n    opacity: 1;\n  ']);

function _taggedTemplateLiteral$14(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipBoxInner = styled__default.div(_templateObject$14, themeResponsiveProperty(styled.css(_templateObject2$8), styled.css(_templateObject3$6)), function (_ref) {
  var solidColor = _ref.solidColor;
  return solidColor ? '#363636' : 'rgba(0, 0, 0, 0.9)';
}, themeResponsiveProperty('translateY(-1.5rem)', 'translateX(-1.5rem)'), themeResponsiveProperty(null, styled.css(_templateObject4$3)), function (_ref2) {
  var visible = _ref2.visible;
  return visible && styled.css(_templateObject5$1, themeResponsiveProperty('translateY(var(--app-safe-area-inset-top, 0rem))', 'translateX(0)'));
});

function arrayRepeat(array) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var result = array;

  while (amount--) {
    result = result.concat(array);
  }

  return result;
}

function arrayPad(array, length) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (array.length >= length) {
    return array;
  }

  return array.concat(new Array(length - array.length).fill(value));
}

function arrayShuffle(array) {
  return array.slice().sort(function () {
    return Math.random() < 0.5 ? -1 : 1;
  });
}

var _templateObject$15 = _taggedTemplateLiteral$15(['\n  ', ';\n  \n  ', ';\n'], ['\n  ', ';\n  \n  ', ';\n']),
    _templateObject2$9 = _taggedTemplateLiteral$15(['\n    color: rgba(255,255,255,.4);\n  '], ['\n    color: rgba(255,255,255,.4);\n  ']),
    _templateObject3$7 = _taggedTemplateLiteral$15(['\n    color: rgba(0,0,0,.6);\n  '], ['\n    color: rgba(0,0,0,.6);\n  ']);

function _taggedTemplateLiteral$15(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PreTitle = styled__default.div(_templateObject$15, function (_ref) {
  var light = _ref.light;
  return light && styled.css(_templateObject2$9);
}, function (_ref2) {
  var dark = _ref2.dark;
  return dark && styled.css(_templateObject3$7);
});

var _templateObject$16 = _taggedTemplateLiteral$16(['\n  z-index: 100; // OverallProgress is 99 and the card\'s box is 10\n\n  display: ', ';\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 0 2rem 0 .5rem;\n  background-color: rgba(0,0,0,.8);\n'], ['\n  z-index: 100; // OverallProgress is 99 and the card\'s box is 10\n\n  display: ', ';\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 0 2rem 0 .5rem;\n  background-color: rgba(0,0,0,.8);\n']),
    _templateObject2$10 = _taggedTemplateLiteral$16(['\n  width: 100%;\n  max-width: 32rem;\n  padding: ', ';\n  background-color: #fff;\n  box-shadow: 0 .25rem 2rem rgba(0,0,0,.4);\n  border-radius: .5rem;\n  text-align: center;\n\n  h3 {\n    color: #bbb;\n    font-weight: normal;\n    text-transform: uppercase;\n  }\n\n  h3,\n  p {\n    margin-top: 0;\n  }\n'], ['\n  width: 100%;\n  max-width: 32rem;\n  padding: ', ';\n  background-color: #fff;\n  box-shadow: 0 .25rem 2rem rgba(0,0,0,.4);\n  border-radius: .5rem;\n  text-align: center;\n\n  h3 {\n    color: #bbb;\n    font-weight: normal;\n    text-transform: uppercase;\n  }\n\n  h3,\n  p {\n    margin-top: 0;\n  }\n']);

function _taggedTemplateLiteral$16(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$14(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ExerciseTutorialModal = (function (_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible,
      props = _objectWithoutProperties$14(_ref, ['children', 'isVisible']);

  return React__default.createElement(
    HelpModalOverlay,
    { isVisible: isVisible },
    React__default.createElement(
      HelpModalInner,
      props,
      children
    )
  );
});

// @todo 2019-01-10 Copied from HelpOverlay, extract somehow
var HelpModalOverlay = styled__default.div(_templateObject$16, function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? 'flex' : 'none';
});

var HelpModalInner = styled__default.div(_templateObject2$10, themeResponsiveProperty('2rem', '2rem 4rem'));

var _templateObject$17 = _taggedTemplateLiteral$17(['\n  margin-top: 1rem;\n  padding: 1rem 1.5rem;\n  background-color: ', ';\n  color: ', ';\n  font-size: 1rem;\n  border: none;\n'], ['\n  margin-top: 1rem;\n  padding: 1rem 1.5rem;\n  background-color: ', ';\n  color: ', ';\n  font-size: 1rem;\n  border: none;\n']);

function _taggedTemplateLiteral$17(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ExerciseTutorialButton = styled__default.button(_templateObject$17, function (props) {
  return props.theme.primaryBackgroundColor;
}, function (props) {
  return props.theme.primaryColor;
});

var _templateObject$18 = _taggedTemplateLiteral$18(['\n  position: absolute;\n  top: 4rem;\n  right: 1rem;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n'], ['\n  position: absolute;\n  top: 4rem;\n  right: 1rem;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n']);

function _taggedTemplateLiteral$18(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ExerciseTutorialHelpIcon = (function (props) {
  return React__default.createElement(
    Button$1,
    props,
    React__default.createElement(
      'svg',
      { viewBox: '0 0 512 512', style: { width: '2rem', height: '2rem' } },
      React__default.createElement(
        'g',
        { fill: 'currentColor' },
        React__default.createElement('path', { d: 'M257.338 166.245c16.297 0 29.52-13.223 29.52-29.52 0-16.317-13.223-29.501-29.52-29.501-16.298 0-29.52 13.185-29.52 29.501 0 16.297 13.222 29.52 29.52 29.52zM277.383 205.605v-19.68h-59.04v19.68h19.68v167.28h-19.68v19.68h78.72v-19.68h-19.68z' }),
        React__default.createElement('path', { d: 'M256.108 9.65c-135.857 0-246 110.143-246 246 0 135.877 110.143 246 246 246s246-110.123 246-246c0-135.857-110.142-246-246-246zm0 472.32c-124.797 0-226.32-101.533-226.32-226.32S131.312 29.33 256.108 29.33c124.797 0 226.32 101.533 226.32 226.32s-101.523 226.32-226.32 226.32z' })
      )
    )
  );
});

var Button$1 = styled__default.button(_templateObject$18);

var _extends$46 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$19 = _taggedTemplateLiteral$19(['\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: translateY(calc(var(--app-safe-area-inset-bottom, 0rem) * -1));\n  transition: transform 200ms ease-in-out;\n  padding: 1rem 2rem max(1rem, env(safe-area-inset-bottom));\n  color: #fff;\n  cursor: pointer;\n  // disabled because not very good looking with the radial background animation\n  // box-shadow: .25rem 0 .25rem rgba(0, 0, 0, .25);\n'], ['\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: translateY(calc(var(--app-safe-area-inset-bottom, 0rem) * -1));\n  transition: transform 200ms ease-in-out;\n  padding: 1rem 2rem max(1rem, env(safe-area-inset-bottom));\n  color: #fff;\n  cursor: pointer;\n  // disabled because not very good looking with the radial background animation\n  // box-shadow: .25rem 0 .25rem rgba(0, 0, 0, .25);\n']),
    _templateObject2$11 = _taggedTemplateLiteral$19(['\n  to {\n    transform: translateY(-50%) scale(40);\n  }\n'], ['\n  to {\n    transform: translateY(-50%) scale(40);\n  }\n']),
    _templateObject3$8 = _taggedTemplateLiteral$19(['\n  pointer-events: none;\n  z-index: 1;\n  position: absolute;\n  top: 50%;\n  width: 2rem;\n  height: 2rem;\n  transform: translateY(-50%) scale(0);\n  background-color: ', ';\n  border-radius: 50%;\n\n  ', ';\n\n  ', ';\n'], ['\n  pointer-events: none;\n  z-index: 1;\n  position: absolute;\n  top: 50%;\n  width: 2rem;\n  height: 2rem;\n  transform: translateY(-50%) scale(0);\n  background-color: ', ';\n  border-radius: 50%;\n\n  ', ';\n\n  ', ';\n']),
    _templateObject4$4 = _taggedTemplateLiteral$19(['\n    animation: ', ' 800ms ease forwards;\n  '], ['\n    animation: ', ' 800ms ease forwards;\n  ']),
    _templateObject5$2 = _taggedTemplateLiteral$19(['\n    transform: translateY(-50%) scale(40);\n  '], ['\n    transform: translateY(-50%) scale(40);\n  ']),
    _templateObject6$1 = _taggedTemplateLiteral$19(['\n  z-index: 2;\n  margin-bottom: .5rem;\n  font-weight: 500;\n  letter-spacing: .0625rem;\n  text-transform: uppercase;\n  color: #fff;\n'], ['\n  z-index: 2;\n  margin-bottom: .5rem;\n  font-weight: 500;\n  letter-spacing: .0625rem;\n  text-transform: uppercase;\n  color: #fff;\n']),
    _templateObject7$1 = _taggedTemplateLiteral$19(['\n  from {\n    transform: translateY(8%);\n  }\n\n  to {\n    transform: translateY(-8%);\n  }\n'], ['\n  from {\n    transform: translateY(8%);\n  }\n\n  to {\n    transform: translateY(-8%);\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral$19(['\n  from {\n    transform: scale(.7);\n  }\n\n  to {\n    transform: scale(1);\n  }\n'], ['\n  from {\n    transform: scale(.7);\n  }\n\n  to {\n    transform: scale(1);\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral$19(['\n  z-index: 2;\n  font-size: 0;\n\n  transition: transform ease 300ms;\n\n  ', ';\n\n  > svg {\n    ', ';\n\n    ', ';\n  }\n'], ['\n  z-index: 2;\n  font-size: 0;\n\n  transition: transform ease 300ms;\n\n  ', ';\n\n  > svg {\n    ', ';\n\n    ', ';\n  }\n']),
    _templateObject10 = _taggedTemplateLiteral$19(['\n    animation: ', ' 400ms ease-in-out alternate infinite;\n  '], ['\n    animation: ', ' 400ms ease-in-out alternate infinite;\n  ']),
    _templateObject11 = _taggedTemplateLiteral$19(['\n      animation: ', ' 400ms cubic-bezier(0.23, -0.29, 0.54, 1.62) forwards;\n    '], ['\n      animation: ', ' 400ms cubic-bezier(0.23, -0.29, 0.54, 1.62) forwards;\n    ']),
    _templateObject12 = _taggedTemplateLiteral$19(['\n      transform: scale(1);\n    '], ['\n      transform: scale(1);\n    ']);

function _objectWithoutProperties$15(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral$19(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ENTERED = 'ENTERED';
var ENTERING = 'ENTERING';
var EXERCISE_COMPLETED_ANIMATION_TIMEOUT = 600;

function exerciseCompletedAnimationFactory(stickyContainerReference, chapterHeight) {
  if (stickyContainerReference === null) {
    return;
  }

  var scrollAmountPixel = 300;
  var pageYOffset = window.pageYOffset;
  var screenHeight = window.innerHeight;
  var bottomOfExercise = stickyContainerReference.offsetTop + chapterHeight - screenHeight;

  var properties = {
    scrollTop: pageYOffset <= bottomOfExercise ? bottomOfExercise : pageYOffset
  };

  anime_min({
    targets: properties,
    scrollTop: bottomOfExercise + scrollAmountPixel,
    easing: 'easeOutQuad',
    round: 1,
    duration: 600,
    update: function update() {
      window.scroll(0, properties.scrollTop);
    }
  });
}

function exerciseCompletedAnimationChange(callback) {
  callback(ENTERING);

  setTimeout(function () {
    callback(ENTERED);
  }, EXERCISE_COMPLETED_ANIMATION_TIMEOUT);
}

var ExerciseCompletedContainer = styled__default.div(_templateObject$19);

var radial = styled.keyframes(_templateObject2$11);

var RadialEffect = styled__default.div(_templateObject3$8, themeResponsiveProperty('rgb(221 0 156 / 0.8)', 'rgba(0,0,0,.9)'), function (_ref) {
  var state = _ref.state;
  return state === ENTERING && styled.css(_templateObject4$4, radial);
}, function (_ref2) {
  var state = _ref2.state;
  return state === ENTERED && styled.css(_templateObject5$2);
});

var ExerciseCompleted = styled.withTheme(function ExerciseCompleted(_ref3) {
  var isVisible = _ref3.isVisible,
      state = _ref3.state,
      props = _objectWithoutProperties$15(_ref3, ['isVisible', 'state']);

  if (state === null) {
    // noinspection JSConstructorReturnsPrimitive
    return null;
  }

  return React__default.createElement(
    ExerciseCompletedContainer,
    _extends$46({ state: state }, props),
    themeResponsiveProperty(React__default.createElement(
      ExerciseCompletedText,
      null,
      __('Theme completed')
    ), null)(props),
    React__default.createElement(FloatingIcon, { state: state }),
    React__default.createElement(RadialEffect, { state: state })
  );
});

var ExerciseCompletedText = styled__default.span(_templateObject6$1);

var Icon = function Icon(props) {
  return React__default.createElement(
    'svg',
    _extends$46({
      width: 21,
      height: 14,
      viewBox: '0 0 21 14',
      style: { zIndex: 2, width: '2rem' }
    }, props),
    React__default.createElement('path', {
      d: 'M9.703 12.906a1.103 1.103 0 0 0 1.547 0l9.14-9.094c.422-.468.422-1.171 0-1.593L19.313 1.14c-.421-.422-1.125-.422-1.593 0L10.5 8.359 3.234 1.141c-.468-.422-1.171-.422-1.593 0L.562 2.219c-.421.422-.421 1.125 0 1.594l9.141 9.093Z',
      fill: 'currentColor'
    })
  );
};

var float = styled.keyframes(_templateObject7$1);

var pop = styled.keyframes(_templateObject8);

var FloatingIconContainer = styled__default.div(_templateObject9, function (_ref4) {
  var state = _ref4.state;
  return state === ENTERED && styled.css(_templateObject10, float);
}, function (_ref5) {
  var state = _ref5.state;
  return state === ENTERING && styled.css(_templateObject11, pop);
}, function (_ref6) {
  var state = _ref6.state;
  return state === ENTERED && styled.css(_templateObject12);
});

var FloatingIcon = function FloatingIcon(props) {
  return React__default.createElement(
    FloatingIconContainer,
    props,
    React__default.createElement(Icon, null)
  );
};

var fallbackLanguage = 'en_UK';

var languages = {
  en_UK: {},
  zh_CN: {
    'Completed: :percentage%': '完成: :percentage%',
    'How it works?': '如何運作？',
    'Ok got it': '好的，我知道了',
    'Spin': '高速运转',
    'Click on': '點擊',
    'to discover the combinations and tips.': '以發掘組合和提示',
    'Click on the dark cards and find all the matching pairs to reveal tips.': '點擊黑卡及搜尋所有配對以顯示提示。',
    'Click on the images on the right side to discover the combinations and tips.': '单击右侧的图像以发现组合和提示。',
    'Click on the images at the bottom to discover the combinations and tips.': '點擊底部的圖像以發掘組合和提示。',
    'When you are done studying, mark this theme as completed by tapping the button below.': '完成學習後，點擊下面的按鈕將此主題標記為已完成。'
  },
  ja_JP: {
    'Completed: :percentage%': '完了： :percentage％',
    'How it works?': 'どのように操作する？',
    'Ok got it': '理解しました',
    'Spin': '回転',
    'Click on to discover the combinations and tips.': 'をクリックしてヒントと組み合わせを発見してください。',
    'Click on': 'Click on',
    'to discover the combinations and tips.': 'to discover the combinations and tips.',
    'Click on the dark cards and find all the matching pairs to reveal tips.': 'ダークカラーのカードをクリックしてマッチングしたすべてのペアとヒントを見る。',
    'Click on the images on the right side to discover the combinations and tips.': '右側の画像をクリックすると組み合わせとヒントが表示できます。',
    'Click on the images at the bottom to discover the combinations and tips.': '下のイメージをクリックして組み合わせとヒントを見る',
    'When you are done studying, mark this theme as completed by tapping the button below.': '学習を終えたら、下のボタンをクリックしてこのテーマを完了してください'
  },
  ko_KP: {
    'Completed: :percentage%': '완성됨: :percentage%',
    'How it works?': '어떻게 실행되나요?',
    'Ok got it': '네 찾았습니다.',
    'Spin': '보기 회전',
    'Click on to discover the combinations and tips.': '를 클릭하여 조합되는 결과물 및 팁을 확인하세요.',
    'Click on': 'Click on',
    'to discover the combinations and tips.': 'to discover the combinations and tips.',
    'Click on the dark cards and find all the matching pairs to reveal tips.': '다크 카드를 클릭하여 모든 매칭되는 짝을 찾아서 팁을 발견해 보세요.',
    'Click on the images on the right side to discover the combinations and tips.': '오른쪽 이미지를 눌러 조합과 팁을 찾아보세요.',
    'Click on the images at the bottom to discover the combinations and tips.': '아래의 이미지를 클릭하여 조합되는 결과물 및 팁을 확인하세요.',
    'When you are done studying, mark this theme as completed by tapping the button below.': '학습이 모두 완료되었다면 아래의 버튼을 탭하여 이 테마를 완성했다고 체크하세요.'
  },
  pt_PT: {
    'Completed: :percentage%': 'Completado: :percentage%',
    'How it works?': 'Como funciona?',
    'Ok got it': 'Ok entendi',
    'Spin': 'Rodar',
    'Click on': 'Clique no',
    'to discover the combinations and tips.': 'para descobrir as combinações e dicas',
    'Click on the dark cards and find all the matching pairs to reveal tips.': 'Clique nos cartões escuros e encontre todos os pares para revelar dicas.',
    'Click on the images on the right side to discover the combinations and tips.': 'Clique nas imagens do lado direito para descobrir combinações e dicas.',
    'Click on the images at the bottom to discover the combinations and tips.': 'Clique nas imagens na parte inferior para descobrir as combinações e dicas.',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'Quando terminar de estudar, marque esse tema como completado apertando o botão abaixo'
  },
  ru_RU: {
    'Completed: :percentage%': 'Завершено: :percentage%',
    'How it works?': 'КАК ЭТО РАБОТАЕТ?',
    'Ok got it': 'ОК, ПОНЯТНО',
    'Spin': 'Вращать',
    'Click on': 'Кликните',
    'to discover the combinations and tips.': 'чтобы просмотреть комбинации и рекомендации',
    'Click on the dark cards and find all the matching pairs to reveal tips.': 'Кликните на тёмные карты и найдите все подходящие пары, чтобы просмотреть рекомендации.',
    'Click on the images on the right side to discover the combinations and tips.': 'Нажимая на изображения справа, вы увидите возможные комбинации и подсказки.',
    'Click on the images at the bottom to discover the combinations and tips.': 'Кликните на изображения внизу, чтобы просмотреть комбинации и рекомендации.',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'После завершения обучения отметьте данную группу как завершённую, нажав на кнопку ниже'
  },
  ar_AE: {
    'Completed: :percentage%': 'اكتمل: percentage:%', // @todo 2019-10-16 updated,
    'How it works?': 'طريقة العمل؟',
    'Ok got it': 'حسناً، لقد فهمت',
    'Spin': 'دوران',
    'Click on': '.انقر على', // @todo 2019-10-18 check on UI
    'to discover the combinations and tips.': 'وتعرف على المجاميع والنصائح', // @todo 2019-10-18 check on UI
    'Click on the dark cards and find all the matching pairs to reveal tips.': 'انقر على البطاقات الغامقة لإيجاد الثنائيات المتشابهة والتعرف على النصائح.',
    'Click on the images on the right side to discover the combinations and tips.': 'انقر على الصور على الجانب الأيمن لاكتشاف التركيبات والنصائح.',
    'Click on the images at the bottom to discover the combinations and tips.': 'انقر على الصور أسفلاً للتعرف على المجاميع والنصائح',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'عند الانتهاء من الدراسة، حدد هذا الموضوع بإشارة للدلالة على أنه مكتمل وذلك بالنقر على الزر أدناه'
  },
  th_TH: {
    'Completed: :percentage%': 'ครบถ้วน: :percentage%',
    'When you are done studying, mark this theme as completed by tapping the button below.': 'เมื่อคุณเรียนรู้จบแล้ว กดปุ่มข้างล่างเพื่อแสดงเครื่องหมายจบบท',
    'Spin': 'สุ่ม',
    'How it works?': 'ทำงานอย่างไร?',
    'Click on': 'คลิกบน',
    'to discover the combinations and tips.': 'เพื่อพบกับลูกเล่นการจับคู่ และเกร็ดแนะนำต่างๆ',
    'Click on the dark cards and find all the matching pairs to reveal tips.': 'คลิกบนบัตรสีเข้มเพื่อพบกับภาพแสดงผลลัพธ์การจับคู่ชุดพร้อมเกร็ดแนะนำ',
    'Click on the images on the right side to discover the combinations and tips.': 'คลิกบนภาพต่างๆ ทางขวามือเพื่อพบกับลูกเล่นการจับคู่ และเกร็ดแนะนำต่างๆ',
    'Click on the images at the bottom to discover the combinations and tips.': 'คลิกบนภาพต่างๆ ด้านล่างเพื่อพบกับลูกเล่นการจับคู่ และเกร็ดแนะนำต่างๆ',
    'Ok got it': 'โอเค ฉันเข้าใจแล้ว'
  }
};

function translate$1(key, language) {
  return languages[language] && languages[language][key] ? languages[language][key] : key;
}

function trans() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fallbackLanguage;
  var text = arguments[1];
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return translate$1(text, language).replace(/:(\w+)/g, function (match, attribute) {
    return attributes[attribute];
  });
}

var _extends$47 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$20 = _taggedTemplateLiteral$20(['\n  position: absolute;\n  top: max(.5rem, env(safe-area-inset-top));\n  right: .5rem;\n  width: 2rem;\n  height: 2rem;\n'], ['\n  position: absolute;\n  top: max(.5rem, env(safe-area-inset-top));\n  right: .5rem;\n  width: 2rem;\n  height: 2rem;\n']);

function _taggedTemplateLiteral$20(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function CloseTooltipBoxButton (props) {

  return React__default.createElement(
    Icon$1,
    _extends$47({
      viewBox: '0 0 32 32',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    React__default.createElement('path', {
      d: 'M16 .5C7.437.5.5 7.438.5 16c0 8.563 6.938 15.5 15.5 15.5 8.563 0 15.5-6.938 15.5-15.5C31.5 7.437 24.562.5 16 .5zm7.563 19.625c.312.25.312.75 0 1.063l-2.438 2.437c-.313.313-.813.313-1.063 0L16 19.5l-4.125 4.125c-.25.313-.75.313-1.063 0l-2.437-2.5c-.313-.25-.313-.75 0-1.063L12.5 16l-4.125-4.063c-.313-.25-.313-.75 0-1.062l2.5-2.438c.25-.312.75-.312 1.063 0L16 12.5l4.063-4.063c.25-.312.75-.312 1.062 0l2.438 2.438c.312.313.312.813 0 1.063L19.5 16l4.063 4.125z',
      fill: 'currentColor'
    })
  );
}

var Icon$1 = styled__default.svg(_templateObject$20);

var _templateObject$21 = _taggedTemplateLiteral$21(['\n  pointer-events: ', ';\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  color: #fff;\n  background-color: rgb(0 0 0 / ', ');\n  transition: background-color .3s ease;\n\n  ', ' {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    padding: max(1rem, env(safe-area-inset-top)) 3.125rem max(1rem, env(safe-area-inset-bottom)) 3.125rem;\n    background-color: transparent;\n  }\n'], ['\n  pointer-events: ', ';\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  color: #fff;\n  background-color: rgb(0 0 0 / ', ');\n  transition: background-color .3s ease;\n\n  ', ' {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    padding: max(1rem, env(safe-area-inset-top)) 3.125rem max(1rem, env(safe-area-inset-bottom)) 3.125rem;\n    background-color: transparent;\n  }\n']);

function _taggedTemplateLiteral$21(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FullscreenTooltipBoxContainer = styled__default.div(_templateObject$21, function (props) {
  return props.visible ? null : 'none';
}, function (props) {
  return props.visible ? .75 : 0;
}, TooltipBoxInner);

var _extends$48 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$22 = _taggedTemplateLiteral$22(['\n    position: absolute;\n    top: -.5rem;\n    right: -.75rem;\n    width: 2rem;\n    background: #fff;\n    border-radius: 100%;\n'], ['\n    position: absolute;\n    top: -.5rem;\n    right: -.75rem;\n    width: 2rem;\n    background: #fff;\n    border-radius: 100%;\n']);

function _taggedTemplateLiteral$22(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CheckCircleIcon = styled__default(function (props) {
  return React__default.createElement(
    'svg',
    _extends$48({
      viewBox: '0 0 33 33',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    React__default.createElement('path', {
      d: 'M8.36 15.618l.01-.008.007-.01a.635.635 0 01.996 0l.007.008.007.008 4.438 4.375.176.174.176-.176 9.375-9.375.007-.007.006-.007a.635.635 0 01.995 0l.008.01.01.008 1.434 1.373c.276.278.276.806-.001 1.082l-11.5 11.5c-.278.278-.807.278-1.084 0l-6.5-6.5c-.277-.276-.278-.804-.002-1.082l1.435-1.373zm23.89.882C32.25 7.862 25.138.75 16.5.75 7.799.75.75 7.863.75 16.5c0 8.7 7.05 15.75 15.75 15.75 8.637 0 15.75-7.049 15.75-15.75z',
      fill: 'currentColor'
    })
  );
})(_templateObject$22);

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle$1 (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index$5 = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
})();


var ResizeObserver_es = Object.freeze({
	default: index$5
});

var require$$0 = ( ResizeObserver_es && index$5 ) || ResizeObserver_es;

var e,t=(e=require$$0)&&"object"==typeof e&&"default"in e?e.default:e,r$1={debug:10,info:20,warn:30,error:40,none:100},i="undefined"!=typeof window&&window.document&&window.document.createElement?React__default.useLayoutEffect:React__default.useEffect;var dist=function(e){void 0===e&&(e={});var o=e.logLevel;void 0===o&&(o="info");var c=e.maxFontSize;void 0===c&&(c=100);var f=e.minFontSize;void 0===f&&(f=20);var u=e.onFinish,a=e.onStart,s=e.resolution;void 0===s&&(s=5);var l=r$1[o],S=React__default.useCallback(function(){return{calcKey:0,fontSize:c,fontSizePrev:f,fontSizeMax:c,fontSizeMin:f}},[c,f]),d=React__default.useRef(null),v=React__default.useRef(),z=React__default.useRef(!1),m=React__default.useState(S),w=m[0],M=m[1],h=w.calcKey,y=w.fontSize,x=w.fontSizeMax,b=w.fontSizeMin,g=w.fontSizePrev,F=null,K=React__default.useState(function(){return new t(function(){F=window.requestAnimationFrame(function(){z.current||(a&&a(), z.current=!0, M(Object.assign({},S(),{calcKey:h+1})));});})})[0];React__default.useEffect(function(){return d.current&&K.observe(d.current), function(){F&&window.cancelAnimationFrame(F), K.disconnect();}},[F,K]);var E=d.current&&d.current.innerHTML;return React__default.useEffect(function(){0===h||z.current||(E!==v.current&&(a&&a(), M(Object.assign({},S(),{calcKey:h+1}))), v.current=E);},[h,S,E,a]), i(function(){if(0!==h){var e=Math.abs(y-g)<=s,n=!!d.current&&(d.current.scrollHeight>d.current.offsetHeight||d.current.scrollWidth>d.current.offsetWidth),t=y>g;if(e)n&&y===g?(z.current=!1, l<=r$1.info&&console.info("[use-fit-text] reached `minFontSize = "+f+"` without fitting text")):n?M({fontSize:t?g:b,fontSizeMax:x,fontSizeMin:b,fontSizePrev:g,calcKey:h}):(z.current=!1, u&&u(y));else{var i,o=x,c=b;n?(i=t?g-y:b-y, o=Math.min(x,y)):(i=t?x-y:g-y, c=Math.max(b,y)), M({calcKey:h,fontSize:y+i/2,fontSizeMax:o,fontSizeMin:c,fontSizePrev:y});}}},[h,y,x,b,g,u,d,s]), {fontSize:y+"%",ref:d}};

var _extends$49 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$16(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function AutoResizeFontSizeText(_ref) {
  var disabled = _ref.disabled,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === undefined ? 'div' : _ref$tagName,
      style = _ref.style,
      props = _objectWithoutProperties$16(_ref, ["disabled", "tagName", "style"]);

  var _useFitText = dist(),
      fontSize = _useFitText.fontSize,
      ref = _useFitText.ref;

  var TagName = "" + tagName;

  if (disabled) {
    return React__default.createElement(TagName, _extends$49({ style: style }, props));
  }

  return React__default.createElement(TagName, _extends$49({
    ref: ref,
    style: _extends$49({
      height: '100%',
      width: '100%'
    }, style, {
      fontSize: fontSize
    })
  }, props));
}

var _slicedToArray$1 = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends$50 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$35 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$23 = _taggedTemplateLiteral$23(['\n  display: flex;\n  flex-direction: column;\n  position: relative;\n'], ['\n  display: flex;\n  flex-direction: column;\n  position: relative;\n']),
    _templateObject2$12 = _taggedTemplateLiteral$23(['\n  display: flex;\n  align-items: center;\n  height: ', 'rem;\n  padding: 2rem 3.75rem 1rem;\n  background-color: #000;\n'], ['\n  display: flex;\n  align-items: center;\n  height: ', 'rem;\n  padding: 2rem 3.75rem 1rem;\n  background-color: #000;\n']),
    _templateObject3$9 = _taggedTemplateLiteral$23(['\n  display: flex;\n  flex: 1;\n  height: ', 'px;\n  ', '\n'], ['\n  display: flex;\n  flex: 1;\n  height: ', 'px;\n  ', '\n']),
    _templateObject4$5 = _taggedTemplateLiteral$23(['\n  position: absolute;\n\n  ', ';\n'], ['\n  position: absolute;\n\n  ', ';\n']),
    _templateObject5$3 = _taggedTemplateLiteral$23(['\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1rem calc(100% - 14.25rem) 1rem 1rem;\n  '], ['\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1rem calc(100% - 14.25rem) 1rem 1rem;\n  ']),
    _templateObject6$2 = _taggedTemplateLiteral$23(['\n    bottom: -2.75rem;\n    left: 0;\n    width: 14.25rem;\n  '], ['\n    bottom: -2.75rem;\n    left: 0;\n    width: 14.25rem;\n  ']),
    _templateObject7$2 = _taggedTemplateLiteral$23(['\n  z-index: ', ';\n  perspective: 1000px;\n  position: ', ';\n  top: ', ';\n  left: ', ';\n'], ['\n  z-index: ', ';\n  perspective: 1000px;\n  position: ', ';\n  top: ', ';\n  left: ', ';\n']),
    _templateObject8$1 = _taggedTemplateLiteral$23(['\n  position: relative;\n  height: ', ';\n  width: ', ';\n\n  .inner {\n    position: absolute;\n    inset: 0;\n    border-radius: .25rem;\n    transition: transform .3s ease;\n    transform-style: preserve-3d;\n    transform-origin: center;\n\n    ', ';\n\n    ', ';\n\n    ', ';\n  }\n\n  .front, .back {\n    position: absolute;\n    inset: 0;\n    border: 1px solid #323334;\n    border-radius: .25rem;\n    box-shadow: 2px -1px 5px 1px rgba(0,0,0,.2);\n  }\n\n  .front {\n    position: absolute;\n    inset: 0;\n\n    ', ';\n\n    backface-visibility: hidden;\n  }\n\n  .back {\n    background: #252525 url(data:image/svg+xml;base64,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) no-repeat right center;\n    background-size: contain;\n    transform: rotateY(180deg);\n    transform-style: preserve-3d;\n    visibility:visible;\n    backface-visibility: hidden;\n    z-index: 2;\n\n    ', ';\n  }\n'], ['\n  position: relative;\n  height: ', ';\n  width: ', ';\n\n  .inner {\n    position: absolute;\n    inset: 0;\n    border-radius: .25rem;\n    transition: transform .3s ease;\n    transform-style: preserve-3d;\n    transform-origin: center;\n\n    ', ';\n\n    ', ';\n\n    ', ';\n  }\n\n  .front, .back {\n    position: absolute;\n    inset: 0;\n    border: 1px solid #323334;\n    border-radius: .25rem;\n    box-shadow: 2px -1px 5px 1px rgba(0,0,0,.2);\n  }\n\n  .front {\n    position: absolute;\n    inset: 0;\n\n    ', ';\n\n    backface-visibility: hidden;\n  }\n\n  .back {\n    background: #252525 url(data:image/svg+xml;base64,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) no-repeat right center;\n    background-size: contain;\n    transform: rotateY(180deg);\n    transform-style: preserve-3d;\n    visibility:visible;\n    backface-visibility: hidden;\n    z-index: 2;\n\n    ', ';\n  }\n']),
    _templateObject9$1 = _taggedTemplateLiteral$23(['\n      border: 1px solid #111;\n      box-shadow: none;\n      opacity: .1;\n    '], ['\n      border: 1px solid #111;\n      box-shadow: none;\n      opacity: .1;\n    ']),
    _templateObject10$1 = _taggedTemplateLiteral$23(['\n      z-index: 9;\n      border: 1px solid #111;\n      box-shadow: 4px -3px 8px 1px rgba(0,0,0,.2);\n    '], ['\n      z-index: 9;\n      border: 1px solid #111;\n      box-shadow: 4px -3px 8px 1px rgba(0,0,0,.2);\n    ']),
    _templateObject11$1 = _taggedTemplateLiteral$23(['\n      transform: rotateY(180deg);\n    '], ['\n      transform: rotateY(180deg);\n    ']),
    _templateObject12$1 = _taggedTemplateLiteral$23(['\n      background: #555 url("', '") center no-repeat;\n      background-size: cover;\n    '], ['\n      background: #555 url("', '") center no-repeat;\n      background-size: cover;\n    ']),
    _templateObject13 = _taggedTemplateLiteral$23(['\n      background: #eee;\n      box-shadow: none;\n      border: 0;\n    '], ['\n      background: #eee;\n      box-shadow: none;\n      border: 0;\n    ']);

function _taggedTemplateLiteral$23(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator$12(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$61(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$47(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$50(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HEADER_HEIGHT_REM = 9.5;
var MAX_CARD_PAIR_NUMBER = 6;
var MAX_CARD_NUMBER = MAX_CARD_PAIR_NUMBER * 2;

/**
 * From an array of cards, create their matching card, pad with empty cards to
 * fill the available space, and then shuffle all of them.
 * Also makes sure there is one card in the first position for the overlay help.
 *
 * @param cards
 * @returns {array}
 */
function prepareMemoryCards(cards) {
  var repeated = arrayRepeat(cards);

  var randomIndex = Math.floor(Math.random() * (repeated.length - 2));
  var randomCard = repeated.splice(randomIndex, 1);

  return randomCard.concat(arrayShuffle(arrayPad(repeated, MAX_CARD_NUMBER - 1)));
}

function getChapterHeight$6(screenHeight) {
  return screenHeight * 3;
}

function isTooltipBoxVisible(state) {
  return state.displayMode === DISPLAY_MODE_EDIT || state.displayMode === DISPLAY_MODE_TRANSLATE || !state.exerciseCompleted && state.discoveredCard !== null || state.exerciseCompleted && state.inFocus;
}

var Memory = function (_Component) {
  _inherits$50(Memory, _Component);

  function Memory() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$61(this, Memory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$47(this, (_ref = Memory.__proto__ || Object.getPrototypeOf(Memory)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$50({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content), {

      isHelpModalVisible: true,
      exerciseCompleted: false,
      exerciseCompletedAnimationState: null,

      inFocus: null,
      active: {},
      discovered: {},
      discoveredCard: null,
      memoryCards: prepareMemoryCards(_this.props.content.cards)
    }), _this.stickyContainerReference = null, _this.onPreTitleBlur = function (value) {
      _this.setState({ preTitle: setContentValue(_this.state.preTitle, value) });
    }, _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.onCardTextBlur = function (card, value) {
      // Update the blurred card (looping the cards array, and replacing the one
      // that has been blurred).
      var cards = _this.state.cards.map(function (loopingCard) {
        return loopingCard.media.value === card.media.value ? _extends$50({}, loopingCard, { text: setContentValue(loopingCard.text, value) }) : loopingCard;
      });

      _this.setState({ cards: cards });
    }, _this.onCardsMediaChange = function (assets) {
      var cards = assets.map(function (asset) {
        var existingCard = _this.state.cards.find(function (card) {
          return card.media.value === asset.src;
        });

        if (existingCard) {
          return existingCard;
        }

        var newCard = cardBlueprint();
        var media = _extends$50({}, newCard.media, { value: asset.src, options: asset.options });

        return _extends$50({}, newCard, { media: media });
      });

      _this.setState({
        cards: cards,
        memoryCards: prepareMemoryCards(cards)
        // @todo 2018-06-11
        // Maybe update the inFocus and related state properties if the card being
        // edited is removed
      });
    }, _this.onCardClick = function (card, index) {
      _this.setState({ inFocus: card });

      if (_this.state.timeoutTimerRunning || _this.state.active[card.media.value + '+' + index] || _this.state.discovered[card.media.value]) {
        return;
      }

      var active = _extends$50({}, _this.state.active, _defineProperty$2({}, card.media.value + '+' + index, card));
      var discovered = _extends$50({}, _this.state.discovered);
      var discoveredCard = null;
      var timeoutTimerRunning = false;

      if (Object.keys(active).length === 2) {
        var _Object$keys = Object.keys(active),
            _Object$keys2 = _slicedToArray$1(_Object$keys, 2),
            key1 = _Object$keys2[0],
            key2 = _Object$keys2[1];

        var areTheSame = active[key1].media.value === active[key2].media.value;

        timeoutTimerRunning = true;

        if (areTheSame) {
          discovered[card.media.value] = card;
          discoveredCard = card;
        }

        window.setTimeout(function () {
          _this.setState({
            active: {},
            timeoutTimerRunning: false
          });
        }, 1000);
      }

      if (Object.keys(discovered).length === _this.state.cards.length) {
        _this.props.onExerciseComplete(_this.props.content._id).then(function () {
          _this.setState({ exerciseCompleted: true, discoveredCard: null });
        }).catch(console.error);
      }

      _this.setState({
        active: active,
        discovered: discovered,
        discoveredCard: discoveredCard,
        timeoutTimerRunning: timeoutTimerRunning
      });
    }, _this.handleSaveChapterClick = _asyncToGenerator$12( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$50({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.preTitle, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 8:
              _context2.t2 = _context2.sent;
              _context2.next = 11;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 11:
              _context2.t3 = _context2.sent;
              _context2.next = 14;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 14:
              _context2.t4 = _context2.sent;
              _context2.next = 17;
              return Promise.all(_this.state.cards.map(function () {
                var _ref3 = _asyncToGenerator$12( /*#__PURE__*/regenerator.mark(function _callee(card) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(card.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return save(ContentManager.make(card.media, 'thron-asset'));

                        case 5:
                          _context.t1 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            media: _context.t1
                          });

                        case 7:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 17:
              _context2.t5 = _context2.sent;
              state = {
                templateName: _context2.t0,
                preTitle: _context2.t1,
                title: _context2.t2,
                text: _context2.t3,
                media: _context2.t4,
                cards: _context2.t5
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.handleDisplayModeSwitch = function () {
      _this.setState({
        active: {},
        discovered: {},
        discoveredCard: null,
        exerciseCompleted: false
      });

      _this.props.handleDisplayModeSwitch();
    }, _this.isCardInFocus = function (card) {
      return _this.state.inFocus && _this.state.inFocus.media.value === card.media.value && (_this.state.displayMode === DISPLAY_MODE_EDIT || _this.state.displayMode === DISPLAY_MODE_TRANSLATE || _this.state.exerciseCompleted);
    }, _temp), _possibleConstructorReturn$47(_this, _ret);
  }

  _createClass$35(Memory, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        // @todo 2019-01-10 Check for undefined added for backwards compatibility
        preTitle: chapter.preTitle === undefined ? makeContent('text') : chapter.preTitle,
        title: chapter.title,
        text: chapter.text,
        media: chapter.media,
        cards: chapter.cards
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;

      if (prevState.exerciseCompleted === false && this.state.exerciseCompleted === true) {
        exerciseCompletedAnimationChange(function (state) {
          return _this3.setState({ exerciseCompletedAnimationState: state });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              position: 'relative',
              display: 'flex',
              margin: '1rem'
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { zIndex: 2, position: 'absolute', top: '-1rem', right: 0, display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, _extends$50({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
            React__default.createElement(
              ThronBrowserTriggerer,
              {
                selectedAssets: this.state.cards.map(function (card) {
                  return card.media.options;
                }),
                shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                limit: MAX_CARD_PAIR_NUMBER,
                onThronBrowserSelectionChange: this.onCardsMediaChange },
              React__default.createElement(
                TemplateControlButton,
                { disabled: this.state.displayMode !== DISPLAY_MODE_EDIT },
                __('Select images')
              )
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              { style: { marginBottom: 0 } },
              React__default.createElement(TextTranslatable, {
                plain: true,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          'div',
          { style: {
              zIndex: 1,
              position: 'relative', // needed to cover the image below
              paddingBottom: '.5rem',
              background: 'linear-gradient(rgb(255 255 255 / .94) 25%, 75%, rgb(255 255 255 / 0))'
            } },
          React__default.createElement(
            PreTitle,
            { dark: true, style: {
                marginRight: '1rem',
                marginBottom: '1rem',
                marginLeft: '1rem'
              } },
            React__default.createElement(TextTranslatable, {
              plain: true,
              highlight: this.props.highlightWord,
              onLanguageChange: this.props.onContentLanguageChange,
              onContentUpdate: this.props.onContentUpdate,
              displayMode: this.state.displayMode,
              content: this.state.preTitle,
              onBlur: this.onPreTitleBlur })
          ),
          React__default.createElement(
            'div',
            { style: {
                marginRight: '1rem',
                marginBottom: '1rem',
                marginLeft: '1rem'
              } },
            React__default.createElement(TextTranslatable, {
              highlight: this.props.highlightWord,
              onLanguageChange: this.props.onContentLanguageChange,
              onContentUpdate: this.props.onContentUpdate,
              displayMode: this.state.displayMode,
              content: this.state.text,
              onBlur: this.onTextBlur
            })
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            ref: function ref(_ref4) {
              return _this4.stickyContainerReference = _ref4;
            },
            displayMode: this.state.displayMode,
            height: getChapterHeight$6(this.state.screenHeight),
            onEnter: this.props.onEnter },
          React__default.createElement(
            StickyContent,
            { style: { height: this.state.screenHeight } },
            React__default.createElement(
              MainContainer,
              { style: { height: this.state.screenHeight } },
              React__default.createElement(
                ExerciseTutorialModal,
                { isVisible: this.state.isHelpModalVisible },
                React__default.createElement(
                  'h3',
                  null,
                  trans(this.props.language, 'How it works?')
                ),
                React__default.createElement(
                  'p',
                  null,
                  trans(this.props.language, 'Click on the dark cards and find all the matching pairs to reveal tips.')
                ),
                React__default.createElement(
                  'p',
                  null,
                  React__default.createElement('img', { style: { width: '14rem' }, src: this.props.theme.exerciseTutorialSources.memory, alt: '' })
                ),
                React__default.createElement(
                  ExerciseTutorialButton,
                  { onClick: function onClick() {
                      return _this4.setState({ isHelpModalVisible: false });
                    } },
                  trans(this.props.language, 'Ok got it')
                )
              ),
              React__default.createElement(ExerciseCompleted, {
                style: { zIndex: 11 },
                state: this.state.exerciseCompletedAnimationState,
                isVisible: this.state.exerciseCompleted,
                onClick: function onClick() {
                  exerciseCompletedAnimationFactory(_this4.stickyContainerReference, getChapterHeight$6(_this4.state.screenHeight));
                }
              }),
              React__default.createElement(
                'div',
                { style: {
                    position: 'relative',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // screen height - cards height
                    // height: `calc(${this.state.screenHeight}px - 25.375rem)`,
                    // Fixes an issue on iOS where the cards were pushed down off of
                    // the screen
                    height: 0
                  } },
                React__default.createElement(
                  Media,
                  {
                    src: this.state.media.value,
                    options: this.state.media.options,
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: this.onMediaChange,
                    imageContainerStyle: {
                      width: '100%'
                    },
                    style: {
                      width: '100%',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      display: 'flex',
                      alignItems: 'flex-end'
                    }
                  },
                  React__default.createElement(StyledStepIndicator, {
                    showPercentage: function showPercentage(percentage) {
                      return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                    },
                    step: false,
                    gradient: true,
                    total: this.state.cards.length,
                    active: Object.keys(this.state.discovered).length - 1 })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    position: 'relative',
                    display: 'grid',
                    gridGap: '.5rem',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    margin: '.5rem .5rem max(.5rem, env(safe-area-inset-bottom)) .5rem'
                  } },
                this.state.memoryCards.map(function (card, index) {
                  return card === null ? React__default.createElement(
                    CardWrapper,
                    { key: index, position: positions[index] },
                    React__default.createElement(Card, { disabled: true, $faceDown: true })
                  ) : React__default.createElement(
                    CardWrapper,
                    {
                      key: index,
                      position: positions[index],
                      inFocus: _this4.isCardInFocus(card),
                      onClick: function onClick() {
                        return _this4.onCardClick(card, index);
                      } },
                    React__default.createElement(Card, {
                      seen: _this4.state.displayMode !== DISPLAY_MODE_EDIT && _this4.state.displayMode !== DISPLAY_MODE_TRANSLATE && _this4.state.exerciseCompleted === false && _this4.state.discovered[card.media.value] && !(_this4.state.discoveredCard && _this4.state.discoveredCard.media.value === card.media.value),
                      $faceDown: _this4.state.displayMode !== DISPLAY_MODE_EDIT && _this4.state.displayMode !== DISPLAY_MODE_TRANSLATE && _this4.state.exerciseCompleted === false && !_this4.state.active[card.media.value + '+' + index] && !_this4.state.discovered[card.media.value],
                      focus: _this4.isCardInFocus(card),
                      alt: '',
                      $thronImage: { src: card.media.value, options: card.media.options } })
                  );
                })
              ),
              React__default.createElement(
                FullscreenTooltipBoxContainer,
                { visible: isTooltipBoxVisible(this.state), style: {
                    zIndex: 10 // The cards have zIndex == 9, we add 1.
                  } },
                React__default.createElement(
                  TooltipBoxInner,
                  { visible: isTooltipBoxVisible(this.state) },
                  React__default.createElement(CloseTooltipBoxButton, { onClick: function onClick() {
                      _this4.setState({
                        inFocus: null,
                        active: {},
                        discoveredCard: null
                      });
                    } }),
                  this.state.inFocus === null && (this.state.displayMode === DISPLAY_MODE_EDIT || this.state.displayMode === DISPLAY_MODE_TRANSLATE) && React__default.createElement(
                    'i',
                    { style: { color: '#aaa' } },
                    __('Click on a card to edit its text.')
                  ),
                  this.state.cards.map(function (card) {
                    return React__default.createElement(
                      'div',
                      {
                        key: card.media.value,
                        style: {
                          display: _this4.isCardInFocus(card) || (_this4.state.displayMode !== DISPLAY_MODE_EDIT || _this4.state.displayMode !== DISPLAY_MODE_TRANSLATE) && _this4.state.discoveredCard && _this4.state.discoveredCard.media.value === card.media.value ? 'block' : 'none',
                          width: '100%'
                        }
                      },
                      React__default.createElement(TextTranslatable, {
                        highlight: _this4.props.highlightWord,
                        onLanguageChange: _this4.props.onContentLanguageChange,
                        onContentUpdate: _this4.props.onContentUpdate,
                        displayMode: _this4.state.displayMode,
                        content: card.text,
                        onBlur: function onBlur(value) {
                          return _this4.onCardTextBlur(card, value);
                        } })
                    );
                  })
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          ref: function ref(_ref5) {
            return _this4.stickyContainerReference = _ref5;
          },
          displayMode: this.state.displayMode,
          height: getChapterHeight$6(this.state.screenHeight),
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight } },
          React__default.createElement(
            MainContainer,
            { style: { height: this.state.screenHeight } },
            React__default.createElement(
              ExerciseTutorialModal,
              { isVisible: this.state.isHelpModalVisible },
              React__default.createElement(
                'h3',
                null,
                trans(this.props.language, 'How it works?')
              ),
              React__default.createElement(
                'p',
                null,
                trans(this.props.language, 'Click on the dark cards and find all the matching pairs to reveal tips.')
              ),
              React__default.createElement(
                'p',
                null,
                React__default.createElement('img', { style: { width: '14rem' }, src: this.props.theme.exerciseTutorialSources.memory, alt: '' })
              ),
              React__default.createElement(
                ExerciseTutorialButton,
                { onClick: function onClick() {
                    return _this4.setState({ isHelpModalVisible: false });
                  } },
                trans(this.props.language, 'Ok got it')
              )
            ),
            React__default.createElement(ExerciseCompleted, {
              style: { zIndex: 11 },
              state: this.state.exerciseCompletedAnimationState,
              isVisible: this.state.exerciseCompleted,
              onClick: function onClick() {
                exerciseCompletedAnimationFactory(_this4.stickyContainerReference, getChapterHeight$6(_this4.state.screenHeight));
              } }),
            React__default.createElement(
              Header,
              null,
              React__default.createElement(
                TemplateControl,
                {
                  style: { zIndex: 2, position: 'absolute', top: '1rem', right: '4rem', display: 'flex' },
                  displayMode: this.state.displayMode },
                React__default.createElement(TemplateControlDefaultButtons, _extends$50({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleSaveChapterClick },
                  __('Save')
                )
              ),
              React__default.createElement(ExerciseTutorialHelpIcon, {
                style: { color: '#fff' },
                onClick: function onClick() {
                  return _this4.setState({ isHelpModalVisible: true });
                } }),
              React__default.createElement(
                PreTitle,
                { light: true, style: {
                    position: 'absolute',
                    top: '.75rem',
                    right: '40%',
                    left: '3.75rem'
                  } },
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.preTitle,
                  onBlur: this.onPreTitleBlur })
              ),
              React__default.createElement(
                Title,
                { style: { color: '#fff', flex: '0 0 100%', display: 'flex', alignItems: 'center' } },
                React__default.createElement(
                  TitleText,
                  { style: { minWidth: '15rem', color: 'rgba(255,255,255,.6)', marginBottom: 0 } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: '1.75rem',
                    left: '43.25rem',
                    transform: 'translateX(-100%)'
                  } },
                React__default.createElement(BigChapterNumber, { color: 'rgba(255,255,255,0.41)', number: this.state.index + 1 })
              )
            ),
            React__default.createElement(
              Container$4,
              { columns: ['40%', '60%'], height: this.state.screenHeight - remToPixels(9.5) },
              React__default.createElement(
                'div',
                { style: { position: 'relative', paddingLeft: '4.75rem', fontSize: '1.125rem' } },
                React__default.createElement(
                  'div',
                  { style: { padding: '1rem 0' } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.text,
                    onBlur: this.onTextBlur })
                ),
                React__default.createElement(
                  'div',
                  { style: { width: '12rem' } },
                  React__default.createElement(Media, {
                    src: this.state.media.value,
                    options: this.state.media.options,
                    shadow: true,
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: this.onMediaChange })
                ),
                React__default.createElement(
                  'div',
                  { style: {
                      pointerEvents: isTooltipBoxVisible(this.state) ? null : 'none',
                      zIndex: 10, // The cards have zIndex == 9, we add 1.
                      position: 'absolute',
                      bottom: '6rem',
                      left: '4.75rem',
                      display: 'flex',
                      alignItems: 'center',
                      // width: 0, // this element functions as an anchor for the absolute positioned children, and to define the height
                      width: 'calc(100% - 4.75rem)',
                      height: '12.5rem',
                      color: '#fff',
                      fontSize: '1.25rem'
                    } },
                  React__default.createElement(TooltipBoxDecoration, { style: { position: 'absolute', top: 0, left: 0 } }),
                  React__default.createElement(
                    TooltipBoxInner,
                    { visible: isTooltipBoxVisible(this.state) },
                    this.state.inFocus === null && (this.state.displayMode === DISPLAY_MODE_EDIT || this.state.displayMode === DISPLAY_MODE_TRANSLATE) && React__default.createElement(
                      'i',
                      { style: { color: '#aaa' } },
                      __('Click on a card to edit its text.')
                    ),
                    this.state.cards.map(function (card) {
                      return React__default.createElement(
                        AutoResizeFontSizeText,
                        {
                          key: card.media.value,
                          disabled: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                          style: {
                            display: _this4.isCardInFocus(card) || (_this4.state.displayMode !== DISPLAY_MODE_EDIT || _this4.state.displayMode !== DISPLAY_MODE_TRANSLATE) && _this4.state.discoveredCard && _this4.state.discoveredCard.media.value === card.media.value && !_this4.state.exerciseCompleted ? 'block' : 'none',
                            width: '100%'
                          } },
                        React__default.createElement(TextTranslatable, {
                          highlight: _this4.props.highlightWord,
                          onLanguageChange: _this4.props.onContentLanguageChange,
                          onContentUpdate: _this4.props.onContentUpdate,
                          displayMode: _this4.state.displayMode,
                          content: card.text,
                          onBlur: function onBlur(value) {
                            return _this4.onCardTextBlur(card, value);
                          } })
                      );
                    })
                  ),
                  React__default.createElement(StyledStepIndicator, {
                    showPercentage: function showPercentage(percentage) {
                      return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                    },
                    dark: true,
                    step: false,
                    total: this.state.cards.length,
                    active: Object.keys(this.state.discovered).length - 1 })
                )
              ),
              React__default.createElement(
                'div',
                { style: { position: 'relative' } },
                React__default.createElement(
                  'div',
                  { style: {
                      position: 'absolute',
                      top: '-3.25rem',
                      right: '2rem',
                      bottom: '1.25rem',
                      left: '-7.5rem'
                    } },
                  React__default.createElement(
                    TemplateControl,
                    { displayMode: this.state.displayMode, style: {
                        position: 'absolute',
                        top: '-3.25rem',
                        right: '-1rem'
                      } },
                    React__default.createElement(
                      ThronBrowserTriggerer,
                      {
                        selectedAssets: this.state.cards.map(function (card) {
                          return card.media.options;
                        }),
                        shouldOpenThronBrowser: true,
                        limit: MAX_CARD_PAIR_NUMBER,
                        onThronBrowserSelectionChange: this.onCardsMediaChange },
                      this.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                        TemplateControlButton,
                        null,
                        __('Select images')
                      )
                    )
                  ),
                  React__default.createElement(
                    'div',
                    null,
                    this.state.memoryCards.map(function (card, index) {
                      return card === null ? React__default.createElement(
                        CardWrapper,
                        { key: index, position: positions[index] },
                        React__default.createElement(Card, { disabled: true, $faceDown: true })
                      ) : React__default.createElement(
                        CardWrapper,
                        {
                          key: index,
                          position: positions[index],
                          inFocus: _this4.isCardInFocus(card),
                          onClick: function onClick() {
                            return _this4.onCardClick(card, index);
                          } },
                        React__default.createElement(Card, {
                          seen: _this4.state.displayMode !== DISPLAY_MODE_EDIT && _this4.state.displayMode !== DISPLAY_MODE_TRANSLATE && _this4.state.exerciseCompleted === false && _this4.state.discovered[card.media.value] && !(_this4.state.discoveredCard && _this4.state.discoveredCard.media.value === card.media.value),
                          $faceDown: _this4.state.displayMode !== DISPLAY_MODE_EDIT && _this4.state.displayMode !== DISPLAY_MODE_TRANSLATE && _this4.state.exerciseCompleted === false && !_this4.state.active[card.media.value + '+' + index] && !_this4.state.discovered[card.media.value],
                          focus: _this4.isCardInFocus(card),
                          alt: '',
                          $thronImage: { src: card.media.value, options: card.media.options } })
                      );
                    })
                  )
                )
              )
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Memory;
}(React.Component);

function cardBlueprint() {
  return _extends$50({}, {
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/280x400')
  });
}

var blueprint$12 = function blueprint(templateName) {
  return {
    templateName: templateName,
    preTitle: makeContent('text'),
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/400x500'),
    cards: [cardBlueprint()]
  };
};

var Memory$1 = styled.withTheme(asTemplate('Memory', Memory, blueprint$12));

var MainContainer = styled__default.div(_templateObject$23);

var Header = styled__default.div(_templateObject2$12, HEADER_HEIGHT_REM);

var Container$4 = styled__default.div(_templateObject3$9, function (props) {
  return props.height;
}, function (_ref6) {
  var columns = _ref6.columns;
  return flexColumns(columns);
});

var StyledStepIndicator = styled__default(StepIndicator)(_templateObject4$5, themeResponsiveProperty(styled.css(_templateObject5$3), styled.css(_templateObject6$2)));

var CardWrapper = styled__default.div(_templateObject7$2, function (_ref7) {
  var inFocus = _ref7.inFocus;
  return inFocus ? 9 : 1;
}, themeResponsiveProperty(null, 'absolute'), function (_ref8) {
  var position = _ref8.position;
  return position.top;
}, function (_ref9) {
  var position = _ref9.position;
  return position.left;
});

var Card = styled__default(function (props) {
  return React__default.createElement(
    'div',
    props,
    React__default.createElement(
      'div',
      { className: 'inner' },
      React__default.createElement('div', { className: 'back' }),
      React__default.createElement('div', { className: 'front' }),
      props.focus && React__default.createElement(CheckCircleIcon, null)
    )
  );
})(_templateObject8$1, themeResponsiveProperty('calc(calc(100vw / 4) * 1.5 - 1rem)', '12.25rem'), themeResponsiveProperty(null, '8.375rem'), function (_ref10) {
  var seen = _ref10.seen;
  return seen && styled.css(_templateObject9$1);
}, function (_ref11) {
  var focus = _ref11.focus;
  return focus && styled.css(_templateObject10$1);
}, function (_ref12) {
  var $faceDown = _ref12.$faceDown;
  return $faceDown && styled.css(_templateObject11$1);
}, function (props) {
  return !props.disabled && styled.css(_templateObject12$1, thronImage(props.$thronImage, remToPixels(8.375), remToPixels(12.25)));
}, function (_ref13) {
  var disabled = _ref13.disabled;
  return disabled && styled.css(_templateObject13);
});

var positions = [{ top: '20rem', left: 0 }, { top: '1.75rem', left: '8.875rem' }, { top: '14.55rem', left: '8.875rem' }, { top: '27.25rem', left: '8.875rem' }, { top: '9.5rem', left: '17.75rem' }, { top: '22.25rem', left: '17.75rem' }, { top: '1.75rem', left: '26.625rem' }, { top: '14.5rem', left: '26.625rem' }, { top: '27.25rem', left: '26.625rem' }, { top: 0, left: '35.5rem' }, { top: '12.75rem', left: '35.5rem' }, { top: '25.5rem', left: '35.5rem' },

// @todo 2018-12-07
// Backwards compatibility: the number of cards has been reduced from 7 to 6
// with VTA-276. Safe to remove after all Memory exercises has been checked
// and adapted to this change.
{ top: '22rem', left: 0 }, { top: '-3.25rem', left: '17.75rem' }];

var _extends$51 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$24 = _taggedTemplateLiteral$24(['\n  from {\n    transform: translateY(.25rem);\n  }\n  \n  to {\n    transform: translateY(-.25rem);  \n  }\n'], ['\n  from {\n    transform: translateY(.25rem);\n  }\n  \n  to {\n    transform: translateY(-.25rem);  \n  }\n']),
    _templateObject2$13 = _taggedTemplateLiteral$24(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  animation: ', ' 1s ease infinite alternate-reverse;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  animation: ', ' 1s ease infinite alternate-reverse;\n']),
    _templateObject3$10 = _taggedTemplateLiteral$24(['\n  width: 3.125rem;\n  height: 3.125rem;\n  margin-bottom: .25rem;\n  text-align: center;\n  background-color: #252525;\n  background-size: contain;\n'], ['\n  width: 3.125rem;\n  height: 3.125rem;\n  margin-bottom: .25rem;\n  text-align: center;\n  background-color: #252525;\n  background-size: contain;\n']),
    _templateObject4$6 = _taggedTemplateLiteral$24(['\n  height: 100%;\n\tpadding: .5rem;\n\tcolor: #fff;\n'], ['\n  height: 100%;\n\tpadding: .5rem;\n\tcolor: #fff;\n']);

function _taggedTemplateLiteral$24(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var float$1 = styled.keyframes(_templateObject$24);

var Container$5 = styled__default.div(_templateObject2$13, float$1);

var ArrowContainer = styled__default.div(_templateObject3$10);

var Icon$2 = function Icon(props) {
  return React__default.createElement(
    'svg',
    _extends$51({ viewBox: '0 0 7 26' }, props),
    React__default.createElement(
      'g',
      { fill: 'currentColor', fillRule: 'nonzero' },
      React__default.createElement('path', { d: 'M4.445 8.83c0-.073-.035-.11-.035-.181 0-.073-.035-.109-.07-.145-.035-.036-.07-.108-.105-.144a.83.83 0 0 0-.63-.253H3.43c-.07 0-.105.036-.175.036-.07 0-.105.036-.14.072-.035.036-.105.072-.14.109a.497.497 0 0 0-.105.144.278.278 0 0 0-.07.145.334.334 0 0 0-.035.18v.361c0 .072.035.108.035.18 0 .073.035.11.07.145.035.036.07.109.105.145.04.044.087.08.14.108a.263.263 0 0 0 .14.072c.054.03.115.042.175.036a.578.578 0 0 0 .35 0c.07 0 .105-.036.175-.036.07 0 .105-.036.14-.072.035-.036.105-.072.14-.108a.497.497 0 0 0 .105-.145.278.278 0 0 0 .07-.144.278.278 0 0 0 .035-.18v-.326z' }),
      React__default.createElement('ellipse', { cx: 3.57, cy: 13.704, rx: 1, ry: 1 }),
      React__default.createElement('path', { d: 'M4.305 17.893c-.035-.036-.07-.108-.105-.144a.83.83 0 0 0-.63-.253h-.175c-.07 0-.105.036-.175.036-.07 0-.105.036-.14.072-.035.036-.105.072-.14.108a.497.497 0 0 0-.105.145.278.278 0 0 0-.07.144.334.334 0 0 0-.035.18v.362c0 .072.035.108.035.18 0 .073.035.109.07.145.035.036.07.108.105.145.04.044.087.08.14.108.07.036.105.072.14.072.054.03.115.042.175.036a.578.578 0 0 0 .35 0c.07 0 .105-.036.175-.036.07 0 .105-.036.14-.072.035-.036.105-.072.14-.108a.497.497 0 0 0 .105-.145.278.278 0 0 0 .07-.144.278.278 0 0 0 .035-.18v-.362c0-.072-.035-.108-.035-.18-.035 0-.035-.037-.07-.109zM2.94 25.549c.16.172.381.27.613.27a.835.835 0 0 0 .612-.27l2.45-2.528a.927.927 0 0 0-.018-1.282.86.86 0 0 0-1.242.018l-1.82 1.878-1.82-1.878a.86.86 0 0 0-1.242-.018.927.927 0 0 0-.018 1.282l2.485 2.528zM3.57 5.58c1.45 0 2.625-1.213 2.625-2.71C6.195 1.376 5.02.163 3.57.163S.945 1.376.945 2.872c.01 1.492 1.18 2.698 2.625 2.708zm0-3.612c.483 0 .875.404.875.903 0 .498-.392.903-.875.903s-.875-.405-.875-.903a.91.91 0 0 1 .254-.64.854.854 0 0 1 .621-.263z' })
    )
  );
};

var ArrowIcon = styled__default(Icon$2)(_templateObject4$6);

var _templateObject$25 = _taggedTemplateLiteral$25(['\n  position: absolute;\n  top: 1.75rem;\n  left: 0;\n  bottom: 0;\n  width: 15rem;\n  color: rgba(0,0,0,.1);\n  display: flex;\n  align-items: center;\n  padding: 0 1.5rem;\n  font-size: 6rem;\n  line-height: 4.5rem;\n  font-weight: 400;\n  letter-spacing: -.25rem;\n'], ['\n  position: absolute;\n  top: 1.75rem;\n  left: 0;\n  bottom: 0;\n  width: 15rem;\n  color: rgba(0,0,0,.1);\n  display: flex;\n  align-items: center;\n  padding: 0 1.5rem;\n  font-size: 6rem;\n  line-height: 4.5rem;\n  font-weight: 400;\n  letter-spacing: -.25rem;\n']);

function _taggedTemplateLiteral$25(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipBoxBackgroundText = styled__default.div(_templateObject$25);

var _extends$52 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$36 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$26 = _taggedTemplateLiteral$26(['\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n']),
    _templateObject2$14 = _taggedTemplateLiteral$26(['\n  display: flex;\n  align-items: center;\n  // @todo 2018-06-07\n  //   This is going to break when the font-size changes. Fix this.\n  height: ', 'rem;\n  padding: 5rem 0 .25rem 0;\n'], ['\n  display: flex;\n  align-items: center;\n  // @todo 2018-06-07\n  //   This is going to break when the font-size changes. Fix this.\n  height: ', 'rem;\n  padding: 5rem 0 .25rem 0;\n']),
    _templateObject3$11 = _taggedTemplateLiteral$26(['\n  display: flex;\n  flex: 1;\n  height: ', 'px;\n  ', '\n'], ['\n  display: flex;\n  flex: 1;\n  height: ', 'px;\n  ', '\n']),
    _templateObject4$7 = _taggedTemplateLiteral$26(['\n  position: absolute;\n\n  ', ';\n'], ['\n  position: absolute;\n\n  ', ';\n']),
    _templateObject5$4 = _taggedTemplateLiteral$26(['\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1rem calc(100% - 14.25rem) 1rem 1rem;\n  '], ['\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1rem calc(100% - 14.25rem) 1rem 1rem;\n  ']),
    _templateObject6$3 = _taggedTemplateLiteral$26(['\n    left: 4.75rem;\n    bottom: -2rem;\n    width: 14.25rem;\n  '], ['\n    left: 4.75rem;\n    bottom: -2rem;\n    width: 14.25rem;\n  ']),
    _templateObject7$3 = _taggedTemplateLiteral$26(['\n  width: ', ';\n  height: ', 'rem;\n  background: url("', '") no-repeat center;\n  background-size: cover;\n'], ['\n  width: ', ';\n  height: ', 'rem;\n  background: url("', '") no-repeat center;\n  background-size: cover;\n']),
    _templateObject8$2 = _taggedTemplateLiteral$26(['\n  from {\n    visibility: visible;\n    transform: translateY(', 'rem);\n  }\n\n  to {\n    visibility: visible;\n    transform: translateY(', 'rem);\n  }\n'], ['\n  from {\n    visibility: visible;\n    transform: translateY(', 'rem);\n  }\n\n  to {\n    visibility: visible;\n    transform: translateY(', 'rem);\n  }\n']),
    _templateObject9$2 = _taggedTemplateLiteral$26(['\n  from {\n    visibility: hidden;\n  }\n\n  to {\n    visibility: hidden;\n  }\n'], ['\n  from {\n    visibility: hidden;\n  }\n\n  to {\n    visibility: hidden;\n  }\n']),
    _templateObject10$2 = _taggedTemplateLiteral$26(['\n  from {\n    transform: translateY(-', 'rem);\n  }\n\n  to {\n    transform: translateY(-', 'rem);\n  }\n'], ['\n  from {\n    transform: translateY(-', 'rem);\n  }\n\n  to {\n    transform: translateY(-', 'rem);\n  }\n']),
    _templateObject11$2 = _taggedTemplateLiteral$26(['\n  ', ';\n\n  ', ';\n'], ['\n  ', ';\n\n  ', ';\n']),
    _templateObject12$2 = _taggedTemplateLiteral$26(['\n    opacity: .5;\n  '], ['\n    opacity: .5;\n  ']),
    _templateObject13$1 = _taggedTemplateLiteral$26(['\n    animation: ', ' ', 's linear infinite;\n    animation-delay: ', 'ms;\n  '], ['\n    animation: ', ' ', 's linear infinite;\n    animation-delay: ', 'ms;\n  ']),
    _templateObject14 = _taggedTemplateLiteral$26(['\n  position: absolute;\n  right: 0;\n  // bottom black area offset, we need this to align the symbols correctly\n  bottom: ', ';\n  left: 0;\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  position: absolute;\n  right: 0;\n  // bottom black area offset, we need this to align the symbols correctly\n  bottom: ', ';\n  left: 0;\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject15 = _taggedTemplateLiteral$26(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject16 = _taggedTemplateLiteral$26(['\n    visibility: hidden;\n    animation: ', ' ', 's;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0.23, 0.88, 0.61, 1.18);\n    animation-delay: ', 'ms;\n  '], ['\n    visibility: hidden;\n    animation: ', ' ', 's;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0.23, 0.88, 0.61, 1.18);\n    animation-delay: ', 'ms;\n  ']),
    _templateObject17 = _taggedTemplateLiteral$26(['\n    transform: translateY(', 'rem);\n    animation: ', ' .4s;\n    animation-fill-mode: forwards;\n    animation-delay: ', 'ms;\n  '], ['\n    transform: translateY(', 'rem);\n    animation: ', ' .4s;\n    animation-fill-mode: forwards;\n    animation-delay: ', 'ms;\n  ']),
    _templateObject18 = _taggedTemplateLiteral$26(['\n  z-index: 8;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n'], ['\n  z-index: 8;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n']),
    _templateObject19 = _taggedTemplateLiteral$26(['\n  z-index: 9;\n  position: absolute;\n  right: 0;\n  left: 0;\n  width: ', ';\n  height: ', ';\n  background-color: ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  z-index: 9;\n  position: absolute;\n  right: 0;\n  left: 0;\n  width: ', ';\n  height: ', ';\n  background-color: ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject20 = _taggedTemplateLiteral$26(['\n    top: 0;\n    //border-radius: .5rem .5rem 0 0;\n  '], ['\n    top: 0;\n    //border-radius: .5rem .5rem 0 0;\n  ']),
    _templateObject21 = _taggedTemplateLiteral$26(['\n    bottom: 0;\n    //border-radius: 0 0 .5rem .5rem;\n  '], ['\n    bottom: 0;\n    //border-radius: 0 0 .5rem .5rem;\n  ']),
    _templateObject22 = _taggedTemplateLiteral$26(['\n  z-index: 2;\n  padding: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  cursor: ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  z-index: 2;\n  padding: 0;\n  background: transparent;\n  border: none;\n  outline: none;\n  cursor: ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject23 = _taggedTemplateLiteral$26(['\n    width: 100%;\n    height: 100%;\n    padding: 1rem;\n    text-transform: uppercase;\n    font-weight: 500;\n    letter-spacing: .0625rem;\n    color: #fff;\n    background-color: ', ';\n\n    &[disabled] {\n      opacity: .6;\n    }\n  '], ['\n    width: 100%;\n    height: 100%;\n    padding: 1rem;\n    text-transform: uppercase;\n    font-weight: 500;\n    letter-spacing: .0625rem;\n    color: #fff;\n    background-color: ', ';\n\n    &[disabled] {\n      opacity: .6;\n    }\n  ']),
    _templateObject24 = _taggedTemplateLiteral$26(['\n    position: absolute;\n    top: 50%;\n    right: -.625rem;\n    transform: translateY(-50%);\n  '], ['\n    position: absolute;\n    top: 50%;\n    right: -.625rem;\n    transform: translateY(-50%);\n  ']),
    _templateObject25 = _taggedTemplateLiteral$26(['\n    &:hover ellipse {\n      fill: #575757;\n    }\n  '], ['\n    &:hover ellipse {\n      fill: #575757;\n    }\n  ']),
    _templateObject26 = _taggedTemplateLiteral$26(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n\n  ', ';\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n\n  ', ';\n']),
    _templateObject27 = _taggedTemplateLiteral$26(['\n    justify-content: space-between;\n    margin-left: 2rem;\n    margin-right: 4.5rem;\n  '], ['\n    justify-content: space-between;\n    margin-left: 2rem;\n    margin-right: 4.5rem;\n  ']),
    _templateObject28 = _taggedTemplateLiteral$26(['\n  position: relative;\n  width: ', ';\n'], ['\n  position: relative;\n  width: ', ';\n']),
    _templateObject29 = _taggedTemplateLiteral$26(['\n  position: absolute;\n  display: flex;\n  align-items: center;\n  color: #fff;\n\n  ', ';\n'], ['\n  position: absolute;\n  display: flex;\n  align-items: center;\n  color: #fff;\n\n  ', ';\n']),
    _templateObject30 = _taggedTemplateLiteral$26(['\n    z-index: 1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgb(0 0 0 / ', ');\n    transition: background-color .3s ease;\n\n    ', ' {\n      display: flex;\n      align-items: center;\n      height: 100%;\n      padding: max(1rem, env(safe-area-inset-top)) 3.125rem max(1rem, env(safe-area-inset-bottom)) 3.125rem;\n      background-color: transparent;\n    }\n  '], ['\n    z-index: 1;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgb(0 0 0 / ', ');\n    transition: background-color .3s ease;\n\n    ', ' {\n      display: flex;\n      align-items: center;\n      height: 100%;\n      padding: max(1rem, env(safe-area-inset-top)) 3.125rem max(1rem, env(safe-area-inset-bottom)) 3.125rem;\n      background-color: transparent;\n    }\n  ']),
    _templateObject31 = _taggedTemplateLiteral$26(['\n    z-index: 9;\n    right: 4.5rem;\n    bottom: -7rem;\n    left: 2rem;\n    height: 13.75rem;\n  '], ['\n    z-index: 9;\n    right: 4.5rem;\n    bottom: -7rem;\n    left: 2rem;\n    height: 13.75rem;\n  ']);

function _objectWithoutProperties$17(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral$26(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _asyncToGenerator$13(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$62(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$48(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$51(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HEADER_HEIGHT_PX = 152;
var SYMBOL_HEIGHT_REM = 10;
var SYMBOL_WIDTH_REM = 9.5;
var SYMBOL_W_H_PIXELS = remToPixels(SYMBOL_WIDTH_REM) * 2 + 'x' + remToPixels(SYMBOL_HEIGHT_REM) * 2;

function formatSymbolsForReel(index, combinations) {
  return combinations.map(function (combination) {
    var symbol = combination.symbols[index];

    return symbol ? thronImage({ src: symbol.value, options: symbol.options }, remToPixels(SYMBOL_WIDTH_REM), remToPixels(SYMBOL_HEIGHT_REM)) : 'http://via.placeholder.com/' + SYMBOL_W_H_PIXELS;
  });
}

function generateReels(combinations) {
  return [{ speed: .22, symbols: formatSymbolsForReel(0, combinations) }, { speed: .18, symbols: formatSymbolsForReel(1, combinations) }, { speed: .16, symbols: formatSymbolsForReel(2, combinations) }];
}

/**
 * Restart the slot machine
 *
 * @returns {{slotMachineCombinationIndex: null}}
 */
function getInitialSlotMachineState() {
  return {
    slotMachineCombinationIndex: null
  };
}

function getRepeatAmount(length) {
  if (length >= 5) {
    return 1;
  }

  return Math.ceil(5 / length);
}

function isTooltipBoxVisible$1(state) {
  return state.displayMode === DISPLAY_MODE_EDIT || state.isTooltipBoxVisible
  // (
  //   state.slotMachineCombinationIndex !== null &&
  //   state.shouldSlotMachineRun === false
  // )
  ;
}

function getChapterHeight$7(screenHeight) {
  return screenHeight * 3;
}

var SlotMachine = function (_Component) {
  _inherits$51(SlotMachine, _Component);

  function SlotMachine() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$62(this, SlotMachine);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$48(this, (_ref = SlotMachine.__proto__ || Object.getPrototypeOf(SlotMachine)).call.apply(_ref, [this].concat(args))), _this), _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$52({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content), {

      isTooltipBoxVisible: false,
      isHelpModalVisible: true,
      exerciseCompleted: false,
      exerciseCompletedAnimationState: null,

      shouldSlotMachineRun: false,
      slotMachineCombinationIndex: null,
      editingCombinationIndex: null,
      timeoutTimerRunning: false,

      reels: generateReels(_this.props.content.combinations)
    }), _this.stickyContainerReference = null, _this.slotMachineContainerReference = null, _this.slotMachineReelReferences = [], _this.resetReelPosition = function (reel) {
      reel.scrollTop = 0;
      // reel.scrollTop = (
      //   remToPixels(SYMBOL_HEIGHT_REM) * this.state.combinations.length * 2 - reel.clientHeight
      // );
    }, _this.synchronizeReelScroll = function (masterReel, slaves) {
      slaves.forEach(function (reel) {
        reel.scrollTop = masterReel.scrollTop;
      });
    }, _this.onPreTitleBlur = function (value) {
      _this.setState({ preTitle: setContentValue(_this.state.preTitle, value) });
    }, _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.onCombinationTextBlur = function (index, value) {
      // Update the blurred combination (looping the combinations array, and
      // replacing the text that has been blurred).
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$52({}, loopingCombination, { text: setContentValue(loopingCombination.text, value) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.onCombinationSymbolChange = function (assets, index) {
      var symbols = assets.map(function (asset) {
        return makeContent('thron-asset', asset.src, asset.options);
      });

      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$52({}, loopingCombination, { symbols: symbols }) : loopingCombination;
      });

      _this.setState({
        combinations: combinations,
        reels: generateReels(combinations)
      });
    }, _this.handleAddCombinationClick = function () {
      var combinations = _this.state.combinations.concat([combinationBlueprint()]);

      _this.setState({
        combinations: combinations,
        reels: generateReels(combinations)
      });
    }, _this.handleRemoveCombinationClick = function (index) {
      var combinations = _this.state.combinations.filter(function (_, loopingIndex) {
        return loopingIndex !== index;
      });

      _this.setState({
        combinations: combinations,
        reels: generateReels(combinations),
        editingCombinationIndex: _this.state.editingCombinationIndex === index ? null : _this.state.editingCombinationIndex
      });
    }, _this.handleEditCombinationTextClick = function (index) {
      _this.setState({ editingCombinationIndex: index });
    }, _this.handleSaveChapterClick = _asyncToGenerator$13( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$52({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.preTitle, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 8:
              _context2.t2 = _context2.sent;
              _context2.next = 11;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 11:
              _context2.t3 = _context2.sent;
              _context2.next = 14;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 14:
              _context2.t4 = _context2.sent;
              _context2.next = 17;
              return Promise.all(_this.state.combinations.map(function () {
                var _ref3 = _asyncToGenerator$13( /*#__PURE__*/regenerator.mark(function _callee(combination) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(combination.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return Promise.all(combination.symbols.map(function (symbol) {
                            return save(ContentManager.make(symbol, 'thron-asset'));
                          }));

                        case 5:
                          _context.t1 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            symbols: _context.t1
                          });

                        case 7:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 17:
              _context2.t5 = _context2.sent;
              state = {
                templateName: _context2.t0,
                preTitle: _context2.t1,
                title: _context2.t2,
                text: _context2.t3,
                media: _context2.t4,
                combinations: _context2.t5
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.handleDisplayModeSwitch = function () {
      _this.setState(getInitialSlotMachineState());

      _this.props.handleDisplayModeSwitch();
    }, _this.handleStartSlotMachineClick = function () {
      // If the timeout timer is running, we do nothing.
      if (_this.state.timeoutTimerRunning) {
        return;
      }

      // We compute the next combination index
      var nextCombinationIndex = getNextCombinationIndex(_this.state.slotMachineCombinationIndex);

      _this.setState({
        shouldSlotMachineRun: true,
        timeoutTimerRunning: true,
        isTooltipBoxVisible: false
      });

      // Let the slot machine run for a bit before stopping
      window.setTimeout(function () {
        // If the next combinationIndex is going to be the last one, we call the
        // onExerciseComplete callback and then update the state.
        if (nextCombinationIndex === _this.state.combinations.length - 1 && _this.state.exerciseCompleted === false) {
          _this.props.onExerciseComplete(_this.props.content._id).then(function () {
            _this.setState({ exerciseCompleted: true });
          });
        }

        // We allow to press the start/stop button once every 2000 milliseconds
        _this.setState({
          slotMachineCombinationIndex: nextCombinationIndex,
          timeoutTimerRunning: false,
          shouldSlotMachineRun: false,
          isTooltipBoxVisible: true
        });
      }, 2000);
    }, _this.handleRestartSlotMachineClick = function () {
      _this.setState(getInitialSlotMachineState());
    }, _temp), _possibleConstructorReturn$48(_this, _ret);
  }

  _createClass$36(SlotMachine, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        // @todo 2019-01-10 Check for undefined added for backwards compatibility
        preTitle: chapter.preTitle === undefined ? makeContent('text') : chapter.preTitle,
        title: chapter.title,
        text: chapter.text,
        media: chapter.media,
        combinations: chapter.combinations
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // When we have all the three reel references...
      // if (this.slotMachineReelReferences.filter(ref => ref !== null).length === 3) {
      //   requestAnimationFrame(() => {
      //     this.slotMachineReelReferences.forEach(reel => this.resetReelPosition(reel));
      //   });
      // }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      // We are leaving the DISPLAY_MODE_EDIT
      if (prevState.displayMode === DISPLAY_MODE_EDIT && this.state.displayMode !== DISPLAY_MODE_EDIT) {
        // Reset the reel position to be ready for the next spin...
        requestAnimationFrame(function () {
          _this3.slotMachineReelReferences.forEach(function (reel) {
            return _this3.resetReelPosition(reel);
          });
        });

        // And remove the scroll sync between the reels (since the user can't
        // scroll outside of the DISPLAY_MODE_EDIT mode).

        var _slotMachineReelRefer = _toArray(this.slotMachineReelReferences),
            masterReel = _slotMachineReelRefer[0],
            slaves = _slotMachineReelRefer.slice(1);

        masterReel.removeEventListener('scroll', this.synchronizeReelScroll.bind(this, masterReel, slaves), false);
      }

      // We are entering the DISPLAY_MODE_EDIT
      if (prevState.displayMode !== DISPLAY_MODE_EDIT && this.state.displayMode === DISPLAY_MODE_EDIT) {
        // Turn all the reels to show the first symbol...
        requestAnimationFrame(function () {
          _this3.slotMachineReelReferences.forEach(function (reel) {
            return reel.scrollTop = 0;
          });
        });

        // And synchronize the scroll of the second and third reels with the first

        var _slotMachineReelRefer2 = _toArray(this.slotMachineReelReferences),
            _masterReel = _slotMachineReelRefer2[0],
            _slaves = _slotMachineReelRefer2.slice(1);

        _masterReel.addEventListener('scroll', this.synchronizeReelScroll.bind(this, _masterReel, _slaves), false);
      }

      // The combinations number has changed
      if (this.state.displayMode !== DISPLAY_MODE_EDIT && prevState.combinations.length !== this.state.combinations.length) {
        // We therefore rotate the reels to be ready for the next spin
        requestAnimationFrame(function () {
          _this3.slotMachineReelReferences.forEach(function (reel) {
            return _this3.resetReelPosition(reel);
          });
        });
      }

      if (prevState.exerciseCompleted === false && this.state.exerciseCompleted === true) {
        exerciseCompletedAnimationChange(function (state) {
          return _this3.setState({ exerciseCompletedAnimationState: state });
        });
      }
    }

    /**
     * Rotate the reel to be ready for the next spin
     *
     * @param {Element} reel
     */


    /**
     * Synchronize the slave reels with the masterReel scroll
     * @param masterReel
     * @param slaves
     */


    /**
     * Update the combination at "index" with the new content ids.
     *
     * @param assets
     * @param index
     */


    /**
     * Add a new combination and update the reels accordingly
     */


    /**
     * Remove the combination at "index" and update the reels accordingly
     * @param index
     */


    /**
     * Reset the slot machine status when switching display mode.
     */


    /**
     * Handle the slot machine start and stop button
     */

  }, {
    key: 'getCombinationContentText',


    /**
     *
     * @returns {*}
     */
    value: function getCombinationContentText() {
      var index = this.getCombinationContentIndex();

      if (index === null) {
        return null;
      }

      return this.state.combinations[index].text;
    }

    /**
     *
     * @returns {null|number}
     */

  }, {
    key: 'getCombinationContentIndex',
    value: function getCombinationContentIndex() {
      return this.state.displayMode === DISPLAY_MODE_EDIT ? this.state.editingCombinationIndex : this.state.slotMachineCombinationIndex;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              position: 'relative',
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { zIndex: 2, position: 'absolute', top: '-1rem', right: 0, display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, _extends$52({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleAddCombinationClick },
              __('+Combination')
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              { style: { marginBottom: 0 } },
              React__default.createElement(TextTranslatable, {
                plain: true,
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            ref: function ref(_ref5) {
              return _this4.stickyContainerReference = _ref5;
            },
            displayMode: this.state.displayMode,
            height: getChapterHeight$7(this.state.screenHeight),
            onEnter: this.props.onEnter },
          React__default.createElement(
            StickyContent,
            {
              onProgressChange: function onProgressChange(progress) {
                if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this4.state.displayMode) !== -1) {
                  _this4.textScrollableCallback(progress);
                }
              },
              style: { height: this.state.screenHeight }
            },
            React__default.createElement(
              'div',
              { style: {
                  display: 'flex',
                  flexDirection: 'column',
                  height: this.state.screenHeight
                } },
              React__default.createElement(
                ExerciseTutorialModal,
                { isVisible: this.state.isHelpModalVisible },
                React__default.createElement(
                  'h3',
                  null,
                  trans(this.props.language, 'How it works?')
                ),
                React__default.createElement(
                  'p',
                  null,
                  ['ko_KP', 'ja_JP'].indexOf(this.props.language) !== -1 ? React__default.createElement(
                    React__default.Fragment,
                    null,
                    React__default.createElement(ExerciseTutorialModalSlotMachineIcon, { theme: this.props.theme, language: this.props.language }),
                    '\xA0',
                    trans(this.props.language, 'Click on to discover the combinations and tips.')
                  ) : React__default.createElement(
                    React__default.Fragment,
                    null,
                    trans(this.props.language, 'Click on'),
                    '\xA0',
                    React__default.createElement(ExerciseTutorialModalSlotMachineIcon, { theme: this.props.theme, language: this.props.language }),
                    '\xA0',
                    trans(this.props.language, 'to discover the combinations and tips.')
                  )
                ),
                React__default.createElement(
                  'p',
                  null,
                  React__default.createElement('img', { style: { width: '14rem' }, src: this.props.theme.exerciseTutorialSources.slotMachine, alt: '' })
                ),
                React__default.createElement(
                  ExerciseTutorialButton,
                  { onClick: function onClick() {
                      return _this4.setState({ isHelpModalVisible: false });
                    } },
                  trans(this.props.language, 'Ok got it')
                )
              ),
              this.state.displayMode !== DISPLAY_MODE_EDIT && React__default.createElement(ExerciseCompleted, {
                style: { zIndex: 3 },
                state: this.state.exerciseCompletedAnimationState,
                isVisible: this.state.exerciseCompleted,
                onClick: function onClick() {
                  exerciseCompletedAnimationFactory(_this4.stickyContainerReference, getChapterHeight$7(_this4.state.screenHeight));
                }
              }),
              React__default.createElement(
                Scrollable,
                {
                  innerPaddingTop: '1rem',
                  fade: true,
                  fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                  onProgressCallback: function onProgressCallback(callback) {
                    return _this4.textScrollableCallback = callback;
                  },
                  style: {
                    flexShrink: 0,
                    pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                    maxHeight: this.state.screenHeight * .25
                  }
                },
                React__default.createElement(
                  PreTitle,
                  { dark: true, style: {
                      marginRight: '1rem',
                      marginBottom: '1rem',
                      marginLeft: '1rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.preTitle,
                    onBlur: this.onPreTitleBlur })
                ),
                React__default.createElement(
                  'div',
                  { style: {
                      marginRight: '1rem',
                      marginBottom: '1rem',
                      marginLeft: '1rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.text,
                    onBlur: this.onTextBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    flex: 1,
                    position: 'relative',
                    overflowY: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  } },
                React__default.createElement(
                  Media,
                  {
                    width: remToPixels(10),
                    src: this.state.media.value,
                    options: this.state.media.options,
                    style: {
                      flex: 1,
                      alignSelf: 'center',
                      width: '100vw',
                      maxHeight: '100%',
                      objectFit: 'cover',
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'rgb(210 210 210 / 0.2)'
                    },
                    wrapperStyle: { maxHeight: '100%' },
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: this.onMediaChange
                  },
                  React__default.createElement(StyledStepIndicator$1, {
                    total: this.state.combinations.length,
                    active: this.state.exerciseCompleted ? this.state.combinations.length - 1 : this.state.slotMachineCombinationIndex === null ? -1 : this.state.slotMachineCombinationIndex,
                    showPercentage: function showPercentage(percentage) {
                      return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                    },
                    step: false,
                    gradient: true
                  })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    zIndex: 1,
                    flexShrink: 0
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      width: '100%',
                      padding: '1rem'
                    } },
                  this.state.slotMachineCombinationIndex === this.state.combinations.length - 1 ? React__default.createElement(SlotMachineButton2, {
                    language: this.props.language,
                    shouldSlotMachineRun: this.state.shouldSlotMachineRun,
                    onClick: this.handleRestartSlotMachineClick
                  }) : React__default.createElement(SlotMachineButton2, {
                    language: this.props.language,
                    disabled: this.state.shouldSlotMachineRun === true,
                    shouldSlotMachineRun: this.state.shouldSlotMachineRun,
                    onClick: this.handleStartSlotMachineClick
                  })
                ),
                React__default.createElement(
                  'div',
                  { style: { zIndex: 1 } },
                  React__default.createElement(
                    'div',
                    { style: { position: 'relative' } },
                    React__default.createElement(SlotMachineContainerScrollOverlay, { style: {
                        left: this.state.displayMode === DISPLAY_MODE_EDIT ? '11.5rem' : null
                      } }),
                    React__default.createElement(
                      SlotMachineReelsOverlayContainer,
                      {
                        style: { display: this.state.displayMode === DISPLAY_MODE_EDIT ? 'none' : null } },
                      new Array(3).fill(null).map(function (_, index) {
                        return React__default.createElement(
                          SlotMachineReelOverlayContainer,
                          { key: index },
                          React__default.createElement(SlotMachineReelOverlay, { top: true }),
                          React__default.createElement(SlotMachineReelOverlay, { bottom: true })
                        );
                      })
                    ),
                    React__default.createElement(
                      'div',
                      { style: {
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'space-between',
                          height: themeResponsiveProperty('14rem', '23.5rem')(this.props)
                        } },
                      this.state.reels.map(function (reel, index) {
                        return React__default.createElement(
                          'div',
                          { key: index, style: {
                              flex: 1,
                              zIndex: index === 0 ? 2 : null,
                              overflowY: 'auto',
                              willChange: null
                              // borderRadius: '.5rem',
                            }, ref: function ref(_ref4) {
                              return _this4.slotMachineReelReferences[index] = _ref4;
                            } },
                          React__default.createElement(
                            'div',
                            { style: {
                                overflow: _this4.state.displayMode === DISPLAY_MODE_EDIT ? null : 'hidden',
                                position: 'relative',
                                width: themeResponsiveProperty(null, '9.5rem')(_this4.props),
                                height: themeResponsiveProperty('14rem', '23.5rem')(_this4.props)
                              } },
                            React__default.createElement(
                              Reel,
                              {
                                reelIndex: index,
                                speed: reel.speed,
                                symbolsCount: reel.symbols.length,
                                editing: _this4.state.displayMode === DISPLAY_MODE_EDIT },
                              (_this4.state.displayMode === DISPLAY_MODE_EDIT ? reel.symbols : arrayRepeat(reel.symbols, getRepeatAmount(reel.symbols.length))).map(function (symbol, combinationIndex) {
                                return React__default.createElement(
                                  'div',
                                  { key: combinationIndex, style: { position: 'relative' } },
                                  index === 0 && React__default.createElement(
                                    TemplateControl,
                                    { displayMode: _this4.state.displayMode, style: { position: 'absolute', top: '.25rem', left: '.25rem' } },
                                    _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                                      React__default.Fragment,
                                      null,
                                      React__default.createElement(
                                        TemplateControlButton,
                                        { onClick: function onClick() {
                                            return _this4.handleRemoveCombinationClick(combinationIndex);
                                          } },
                                        __('Remove combination')
                                      ),
                                      React__default.createElement(
                                        TemplateControlButton,
                                        {
                                          onClick: function onClick() {
                                            return _this4.handleEditCombinationTextClick(combinationIndex);
                                          },
                                          active: _this4.state.editingCombinationIndex === combinationIndex },
                                        __('Edit text')
                                      )
                                    ),
                                    React__default.createElement(
                                      ThronBrowserTriggerer,
                                      {
                                        selectedAssets: _this4.state.displayMode === DISPLAY_MODE_EDIT ? _this4.state.combinations[combinationIndex].symbols.map(function (symbol) {
                                          return symbol.options;
                                        }) : [],
                                        shouldOpenThronBrowser: true,
                                        limit: 3,
                                        onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
                                          return _this4.onCombinationSymbolChange(assets, combinationIndex);
                                        } },
                                      _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                                        TemplateControlButton,
                                        null,
                                        __('Select images')
                                      )
                                    )
                                  ),
                                  React__default.createElement(_Symbol, { key: combinationIndex, src: symbol })
                                );
                              }),
                              _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement('div', { style: { height: '7.25rem' } })
                            ),
                            React__default.createElement(
                              ReelOverlay,
                              {
                                editing: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                                reelIndex: index,
                                combinationIndex: reel.symbols.length - 2 - (_this4.state.slotMachineCombinationIndex === null ? -1 : _this4.state.slotMachineCombinationIndex),
                                shouldRotate: _this4.state.shouldSlotMachineRun },
                              arrayRepeat(reel.symbols, getRepeatAmount(reel.symbols.length)).map(function (symbol, combinationIndex) {
                                return React__default.createElement(_Symbol, { key: combinationIndex, src: symbol });
                              })
                            )
                          )
                        );
                      })
                    )
                  )
                )
              )
            ),
            React__default.createElement(
              FullscreenTooltipBoxContainer,
              {
                visible: isTooltipBoxVisible$1(this.state),
                style: {
                  bottom: '14rem'
                }
              },
              React__default.createElement(
                TooltipBoxInner,
                { visible: isTooltipBoxVisible$1(this.state) },
                React__default.createElement(CloseTooltipBoxButton, { onClick: function onClick() {
                    _this4.setState({
                      isTooltipBoxVisible: false
                    });
                  } }),
                this.state.displayMode === DISPLAY_MODE_EDIT && this.state.editingCombinationIndex === null && React__default.createElement(
                  'i',
                  { style: { color: '#aaa' } },
                  __('Click on a combination\'s "Edit text" button to edit its text.')
                ),
                (this.state.displayMode === DISPLAY_MODE_EDIT && this.state.editingCombinationIndex !== null || this.state.displayMode !== DISPLAY_MODE_EDIT && this.state.slotMachineCombinationIndex !== null) && React__default.createElement(
                  'div',
                  { key: this.state.editingCombinationIndex + '-' + this.state.slotMachineCombinationIndex },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.getCombinationContentText(),
                    onBlur: function onBlur(value) {
                      return _this4.onCombinationTextBlur(_this4.getCombinationContentIndex(), value);
                    } })
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          ref: function ref(_ref7) {
            return _this4.stickyContainerReference = _ref7;
          },
          displayMode: this.state.displayMode,
          height: getChapterHeight$7(this.state.screenHeight),
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight } },
          React__default.createElement(
            MainContainer$1,
            { style: { height: this.state.screenHeight } },
            React__default.createElement(
              ExerciseTutorialModal,
              { isVisible: this.state.isHelpModalVisible },
              React__default.createElement(
                'h3',
                null,
                trans(this.props.language, 'How it works?')
              ),
              React__default.createElement(
                'p',
                null,
                ['ko_KP', 'ja_JP'].indexOf(this.props.language) !== -1 ? React__default.createElement(
                  React__default.Fragment,
                  null,
                  React__default.createElement(ExerciseTutorialModalSlotMachineIcon, { theme: this.props.theme, language: this.props.language }),
                  '\xA0',
                  trans(this.props.language, 'Click on to discover the combinations and tips.')
                ) : React__default.createElement(
                  React__default.Fragment,
                  null,
                  trans(this.props.language, 'Click on'),
                  '\xA0',
                  React__default.createElement(ExerciseTutorialModalSlotMachineIcon, { theme: this.props.theme, language: this.props.language }),
                  '\xA0',
                  trans(this.props.language, 'to discover the combinations and tips.')
                )
              ),
              React__default.createElement(
                'p',
                null,
                React__default.createElement('img', { style: { width: '14rem' }, src: this.props.theme.exerciseTutorialSources.slotMachine, alt: '' })
              ),
              React__default.createElement(
                ExerciseTutorialButton,
                { onClick: function onClick() {
                    return _this4.setState({ isHelpModalVisible: false });
                  } },
                trans(this.props.language, 'Ok got it')
              )
            ),
            this.state.displayMode !== DISPLAY_MODE_EDIT && React__default.createElement(ExerciseCompleted, {
              style: { zIndex: 3 },
              state: this.state.exerciseCompletedAnimationState,
              isVisible: this.state.exerciseCompleted,
              onClick: function onClick() {
                exerciseCompletedAnimationFactory(_this4.stickyContainerReference, getChapterHeight$7(_this4.state.screenHeight));
              } }),
            React__default.createElement(
              Header$1,
              null,
              React__default.createElement(
                TemplateControl,
                {
                  style: { zIndex: 2, position: 'absolute', top: '1rem', right: '4rem', display: 'flex' },
                  displayMode: this.state.displayMode },
                React__default.createElement(TemplateControlDefaultButtons, _extends$52({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleAddCombinationClick },
                  __('+Combination')
                ),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleSaveChapterClick },
                  __('Save')
                )
              ),
              React__default.createElement(ExerciseTutorialHelpIcon, {
                style: { color: '#000' },
                onClick: function onClick() {
                  return _this4.setState({ isHelpModalVisible: true });
                } }),
              React__default.createElement(
                PreTitle,
                { dark: true, style: {
                    position: 'absolute',
                    top: '1.25rem',
                    right: '40%',
                    left: '3.75rem'
                  } },
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.preTitle,
                  onBlur: this.onPreTitleBlur })
              ),
              React__default.createElement(
                Title,
                { style: { flexBasis: '35%', paddingLeft: '3.75rem', paddingRight: '1rem' } },
                React__default.createElement(
                  TitleText,
                  { lightBackground: true, style: { marginBottom: 0 } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: { flexBasis: '65%', padding: '1rem 3.75rem 1rem 2rem' } },
                React__default.createElement(TextTranslatable, {
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.text,
                  onBlur: this.onTextBlur })
              ),
              React__default.createElement(
                'div',
                { style: {
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: '2.75rem',
                    left: '23.75rem',
                    transform: 'translateX(-100%)'
                  } },
                React__default.createElement(BigChapterNumber, { color: 'rgba(67,67,67,0.15)', number: this.state.index + 1 })
              )
            ),
            React__default.createElement(
              Container$6,
              { columns: ['35%', '65%'] },
              React__default.createElement(
                'div',
                { style: {
                    zIndex: 2,
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end'
                  } },
                React__default.createElement(
                  'div',
                  { style: { position: 'relative', flex: 1, marginLeft: '4.75rem' } },
                  React__default.createElement('div', { style: {
                      position: 'absolute',
                      top: '4.25rem',
                      right: 0,
                      bottom: '4.25rem',
                      left: 0,
                      backgroundColor: '#707070'
                    } }),
                  React__default.createElement(
                    'div',
                    { style: { position: 'relative', marginTop: '3.75rem', marginBottom: '3.75rem' } },
                    this.state.slotMachineCombinationIndex === this.state.combinations.length - 1 ? React__default.createElement(SlotMachineRestartButton, { onClick: this.handleRestartSlotMachineClick }) : React__default.createElement(SlotMachineStartStopButton, {
                      disabled: this.state.shouldSlotMachineRun === true,
                      onClick: this.handleStartSlotMachineClick }),
                    React__default.createElement(
                      'div',
                      { style: { display: 'flex', alignItems: 'center', height: '23.5rem' } },
                      React__default.createElement(Media, {
                        style: { flex: 1 },
                        height: remToPixels(23.5),
                        src: this.state.media.value,
                        options: this.state.media.options,
                        shadow: true,
                        shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                        onChange: this.onMediaChange })
                    )
                  ),
                  React__default.createElement(StyledStepIndicator$1, {
                    total: this.state.combinations.length,
                    active: this.state.exerciseCompleted ? this.state.combinations.length - 1 : this.state.slotMachineCombinationIndex === null ? -1 : this.state.slotMachineCombinationIndex,
                    showPercentage: function showPercentage(percentage) {
                      return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                    },
                    step: false })
                )
              ),
              React__default.createElement(
                'div',
                { style: { zIndex: 1 } },
                React__default.createElement(
                  'div',
                  { style: { position: 'relative' } },
                  React__default.createElement(SlotMachineContainerScrollOverlay, { style: {
                      left: this.state.displayMode === DISPLAY_MODE_EDIT ? '11.5rem' : null
                    } }),
                  React__default.createElement('div', { style: {
                      position: 'absolute',
                      top: '.5rem',
                      right: 0,
                      bottom: '.5rem',
                      left: 0,
                      backgroundColor: '#252525'
                    } }),
                  React__default.createElement(
                    SlotMachineReelsOverlayContainer,
                    {
                      style: { display: this.state.displayMode === DISPLAY_MODE_EDIT ? 'none' : null } },
                    new Array(3).fill(null).map(function (_, index) {
                      return React__default.createElement(
                        SlotMachineReelOverlayContainer,
                        { key: index },
                        React__default.createElement(SlotMachineReelOverlay, { top: true }),
                        React__default.createElement(SlotMachineReelOverlay, { bottom: true })
                      );
                    })
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '23.5rem',
                        margin: '3.75rem 4.5rem 3.75rem 2rem'
                      } },
                    this.state.reels.map(function (reel, index) {
                      return React__default.createElement(
                        'div',
                        { key: index, style: {
                            zIndex: index === 0 ? 2 : null,
                            overflowY: 'auto',
                            willChange: null
                            // borderRadius: '.5rem',
                          }, ref: function ref(_ref6) {
                            return _this4.slotMachineReelReferences[index] = _ref6;
                          } },
                        React__default.createElement(
                          'div',
                          { style: {
                              overflow: _this4.state.displayMode === DISPLAY_MODE_EDIT ? null : 'hidden',
                              position: 'relative',
                              width: '9.5rem',
                              height: '23.5rem'
                            } },
                          React__default.createElement(
                            Reel,
                            {
                              reelIndex: index,
                              speed: reel.speed,
                              symbolsCount: reel.symbols.length,
                              editing: _this4.state.displayMode === DISPLAY_MODE_EDIT },
                            (_this4.state.displayMode === DISPLAY_MODE_EDIT ? reel.symbols : arrayRepeat(reel.symbols, getRepeatAmount(reel.symbols.length))).map(function (symbol, combinationIndex) {
                              return React__default.createElement(
                                'div',
                                { key: combinationIndex, style: { position: 'relative' } },
                                index === 0 && React__default.createElement(
                                  TemplateControl,
                                  { displayMode: _this4.state.displayMode, style: { position: 'absolute', top: '.25rem', left: '.25rem' } },
                                  _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                                    React__default.Fragment,
                                    null,
                                    React__default.createElement(
                                      TemplateControlButton,
                                      { onClick: function onClick() {
                                          return _this4.handleRemoveCombinationClick(combinationIndex);
                                        } },
                                      __('Remove combination')
                                    ),
                                    React__default.createElement(
                                      TemplateControlButton,
                                      {
                                        onClick: function onClick() {
                                          return _this4.handleEditCombinationTextClick(combinationIndex);
                                        },
                                        active: _this4.state.editingCombinationIndex === combinationIndex },
                                      __('Edit text')
                                    )
                                  ),
                                  React__default.createElement(
                                    ThronBrowserTriggerer,
                                    {
                                      selectedAssets: _this4.state.displayMode === DISPLAY_MODE_EDIT ? _this4.state.combinations[combinationIndex].symbols.map(function (symbol) {
                                        return symbol.options;
                                      }) : [],
                                      shouldOpenThronBrowser: true,
                                      limit: 3,
                                      onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
                                        return _this4.onCombinationSymbolChange(assets, combinationIndex);
                                      } },
                                    _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                                      TemplateControlButton,
                                      null,
                                      __('Select images')
                                    )
                                  )
                                ),
                                React__default.createElement(_Symbol, { key: combinationIndex, src: symbol })
                              );
                            }),
                            _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement('div', { style: { height: '7.25rem' } })
                          ),
                          React__default.createElement(
                            ReelOverlay,
                            {
                              editing: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                              reelIndex: index,
                              combinationIndex: reel.symbols.length - 2 - (_this4.state.slotMachineCombinationIndex === null ? -1 : _this4.state.slotMachineCombinationIndex),
                              shouldRotate: _this4.state.shouldSlotMachineRun },
                            arrayRepeat(reel.symbols, getRepeatAmount(reel.symbols.length)).map(function (symbol, combinationIndex) {
                              return React__default.createElement(_Symbol, { key: combinationIndex, src: symbol });
                            })
                          )
                        )
                      );
                    })
                  ),
                  React__default.createElement(
                    TooltipBoxContainer,
                    null,
                    React__default.createElement(TooltipBoxDecoration, { small: true, style: { position: 'absolute', bottom: '7.5rem', left: 0 } }),
                    React__default.createElement(
                      TooltipBoxInner,
                      { solidColor: true, style: { right: 0, width: '100%' }, visible: this.state.displayMode === DISPLAY_MODE_EDIT || this.state.slotMachineCombinationIndex !== null && this.state.shouldSlotMachineRun === false },
                      this.state.displayMode === DISPLAY_MODE_EDIT && this.state.editingCombinationIndex === null && React__default.createElement(
                        'i',
                        { style: { color: '#aaa' } },
                        __('Click on a combination\'s "Edit text" button to edit its text.')
                      ),
                      (this.state.displayMode === DISPLAY_MODE_EDIT && this.state.editingCombinationIndex !== null || this.state.displayMode !== DISPLAY_MODE_EDIT && this.state.slotMachineCombinationIndex !== null) && React__default.createElement(
                        'div',
                        { style: { width: '100%' }, key: this.state.editingCombinationIndex + '-' + this.state.slotMachineCombinationIndex },
                        React__default.createElement(TextTranslatable, {
                          highlight: this.props.highlightWord,
                          onLanguageChange: this.props.onContentLanguageChange,
                          onContentUpdate: this.props.onContentUpdate,
                          displayMode: this.state.displayMode,
                          content: this.getCombinationContentText(),
                          onBlur: function onBlur(value) {
                            return _this4.onCombinationTextBlur(_this4.getCombinationContentIndex(), value);
                          } })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return SlotMachine;
}(React.Component);

function combinationBlueprint() {
  return _extends$52({}, {
    text: makeContent('text'),
    symbols: [makeContent('thron-asset', 'http://via.placeholder.com/' + SYMBOL_W_H_PIXELS), makeContent('thron-asset', 'http://via.placeholder.com/' + SYMBOL_W_H_PIXELS), makeContent('thron-asset', 'http://via.placeholder.com/' + SYMBOL_W_H_PIXELS)]
  });
}

var blueprint$13 = function blueprint(templateName) {
  return {
    templateName: templateName,
    preTitle: makeContent('text'),
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/540x800'),
    combinations: [combinationBlueprint(), combinationBlueprint(), combinationBlueprint()]
  };
};

var SlotMachine$1 = styled.withTheme(asTemplate('SlotMachine', SlotMachine, blueprint$13));

var MainContainer$1 = styled__default.div(_templateObject$26);

var Header$1 = styled__default.div(_templateObject2$14, HEADER_HEIGHT_PX / 16);

var Container$6 = styled__default.div(_templateObject3$11, function (props) {
  return props.height;
}, function (_ref8) {
  var columns = _ref8.columns;
  return flexColumns(columns);
});

var StyledStepIndicator$1 = styled__default(StepIndicator)(_templateObject4$7, themeResponsiveProperty(styled.css(_templateObject5$4), styled.css(_templateObject6$3)));

var _Symbol = styled__default.div(_templateObject7$3, themeResponsiveProperty(null, SYMBOL_WIDTH_REM + 'rem'), SYMBOL_HEIGHT_REM, function (_ref9) {
  var src = _ref9.src;
  return src;
});

var reelStopping = function reelStopping(combinationIndex) {
  return styled.keyframes(_templateObject8$2, combinationIndex * SYMBOL_HEIGHT_REM + .75, combinationIndex * SYMBOL_HEIGHT_REM);
};

var hideReelOverlay = styled.keyframes(_templateObject9$2);

var reelRotation = function reelRotation(symbolsCount) {
  return styled.keyframes(_templateObject10$2, (getRepeatAmount(symbolsCount) * symbolsCount - 1) * SYMBOL_HEIGHT_REM - 3.25, (symbolsCount - 1) * SYMBOL_HEIGHT_REM - 3.25);
};

var Reel = styled__default.div(_templateObject11$2, function (_ref10) {
  var editing = _ref10.editing,
      reelIndex = _ref10.reelIndex;
  return editing && reelIndex > 0 && styled.css(_templateObject12$2);
}, function (_ref11) {
  var editing = _ref11.editing,
      speed = _ref11.speed,
      reelIndex = _ref11.reelIndex,
      symbolsCount = _ref11.symbolsCount;
  return !editing && styled.css(_templateObject13$1, reelRotation(symbolsCount), speed, reelIndex * 200);
});

var ReelOverlay = styled__default.div(_templateObject14, themeResponsiveProperty(2 - SYMBOL_HEIGHT_REM + 'rem', 6.75 - SYMBOL_HEIGHT_REM + 'rem'), function (_ref12) {
  var editing = _ref12.editing;
  return editing && styled.css(_templateObject15);
}, function (_ref13) {
  var reelIndex = _ref13.reelIndex,
      shouldRotate = _ref13.shouldRotate,
      combinationIndex = _ref13.combinationIndex;
  return !shouldRotate && styled.css(_templateObject16, reelStopping(combinationIndex), .4, reelIndex * 200);
}, function (_ref14) {
  var reelIndex = _ref14.reelIndex,
      shouldRotate = _ref14.shouldRotate,
      combinationIndex = _ref14.combinationIndex;
  return shouldRotate && styled.css(_templateObject17, combinationIndex * SYMBOL_HEIGHT_REM, hideReelOverlay, reelIndex * 200);
});

var SlotMachineContainerScrollOverlay = styled__default.div(_templateObject18);

var SlotMachineReelOverlay = styled__default.div(_templateObject19, themeResponsiveProperty(null, SYMBOL_WIDTH_REM + 'rem'), themeResponsiveProperty('2rem', '6.75rem'), themeResponsiveProperty('#000', 'rgba(0,0,0,.9)'), function (_ref15) {
  var top = _ref15.top;
  return top && styled.css(_templateObject20);
}, function (_ref16) {
  var bottom = _ref16.bottom;
  return bottom && styled.css(_templateObject21);
});

var SlotMachineButtonContainer = styled__default.button(_templateObject22, function (_ref17) {
  var disabled = _ref17.disabled;
  return disabled ? 'default' : 'pointer';
}, themeResponsiveProperty(styled.css(_templateObject23, function (props) {
  return props.theme.primaryBackgroundColor;
}), styled.css(_templateObject24)), function (_ref18) {
  var disabled = _ref18.disabled;
  return !disabled && styled.css(_templateObject25);
});

var SlotMachineButton = function SlotMachineButton(_ref19) {
  var children = _ref19.children,
      props = _objectWithoutProperties$17(_ref19, ['children']);

  return React__default.createElement(
    SlotMachineButtonContainer,
    props,
    React__default.createElement(
      'svg',
      { viewBox: '0 0 15 26', style: { width: '4rem' } },
      React__default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React__default.createElement('path', { d: 'M12.426 2.138a4.747 4.747 0 0 1-1.38 1.62c-.568.425-1.279.771-1.993.875-.26.038-.517.07-.782.08-.8.028-1.614.186-2.375.431A8.669 8.669 0 0 0 2.29 7.41a8.43 8.43 0 0 0-1.255 1.707 8.233 8.233 0 0 0-.678 6.402 8.242 8.242 0 0 0 1.468 2.769 8.486 8.486 0 0 0 1.71 1.613 8.63 8.63 0 0 0 3.699 1.504c.195.03.391.057.589.074.194.017.39.015.585.026.194.011.382.045.57.09.048.012.084.022.12.027.037.005.079.023.115.023a8.58 8.58 0 0 1 .387.114 4.84 4.84 0 0 1 2.024 1.302 4.727 4.727 0 0 1 .87 1.34 4.574 4.574 0 0 1 .36 1.599c.004.066.082-27.008.082-25.97 0 .73-.175 1.456-.511 2.108z', fill: '#252525' }),
        React__default.createElement('ellipse', { fill: props.disabled ? '#3a3a3a' : '#636363', cx: 8.25, cy: 13.093, rx: 6.75, ry: 6.593 }),
        children
      )
    )
  );
};

var SlotMachineButton2 = function SlotMachineButton2(_ref20) {
  var language = _ref20.language,
      shouldSlotMachineRun = _ref20.shouldSlotMachineRun,
      children = _ref20.children,
      props = _objectWithoutProperties$17(_ref20, ['language', 'shouldSlotMachineRun', 'children']);

  return React__default.createElement(
    SlotMachineButtonContainer,
    _extends$52({
      shouldSlotMachineRun: shouldSlotMachineRun
    }, props),
    trans(language, 'Spin')
  );
};

var SlotMachineRestartButton = function SlotMachineRestartButton(props) {
  return React__default.createElement(
    SlotMachineButton,
    props,
    React__default.createElement('path', { d: 'M8.66 14.72a.126.126 0 0 0 .073.161l1.038.392c-.487.353-1.06.54-1.662.54-1.578 0-2.86-1.299-2.86-2.894a.125.125 0 0 0-.125-.126.125.125 0 0 0-.124.126c0 1.734 1.395 3.144 3.109 3.144.603 0 1.18-.172 1.681-.5l-.191.914a.125.125 0 0 0 .121.151c.058 0 .11-.04.122-.1l.29-1.386-1.313-.496a.124.124 0 0 0-.16.074zm-.505-4.655c-.603 0-1.18.172-1.681.5l.191-.914a.124.124 0 0 0-.243-.052l-.29 1.387 1.313.496a.123.123 0 0 0 .16-.074.126.126 0 0 0-.073-.162l-1.04-.392a2.815 2.815 0 0 1 1.663-.539c1.578 0 2.861 1.298 2.861 2.894 0 .07.056.125.124.125a.125.125 0 0 0 .124-.125c0-1.734-1.394-3.144-3.109-3.144z', stroke: '#FFF', strokeWidth: .25, fill: '#FFF', fillRule: 'nonzero' })
  );
};

var SlotMachineStartStopButton = function SlotMachineStartStopButton(props) {
  return React__default.createElement(
    SlotMachineButton,
    props,
    React__default.createElement(
      'g',
      { stroke: '#FCFCFC', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: .5 },
      React__default.createElement('path', { d: 'M10.088 13.977l.891.977M10.088 15.93l.891-.976M10.088 10.069l.891.977M10.088 12.023l.891-.977M5.333 14.954h.393c.499.002.965-.271 1.242-.726l1.485-2.459c.276-.453.74-.726 1.237-.726h1.29M8.453 14.228c.277.455.743.728 1.242.726h1.284M5.333 11.046h.393c.499-.002.965.271 1.242.726' })
    )
  );
};

var SlotMachineReelsOverlayContainer = styled__default.div(_templateObject26, themeResponsiveProperty(null, styled.css(_templateObject27)));

var SlotMachineReelOverlayContainer = styled__default.div(_templateObject28, themeResponsiveProperty('33.333333%', SYMBOL_WIDTH_REM + 'rem'));

var TooltipBoxContainer = styled__default.div(_templateObject29, themeResponsiveProperty(styled.css(_templateObject30, function (props) {
  return props.visible ? .75 : 0;
}, TooltipBoxInner), styled.css(_templateObject31)));

var ExerciseTutorialModalSlotMachineIcon = function ExerciseTutorialModalSlotMachineIcon(_ref21) {
  var language = _ref21.language,
      props = _objectWithoutProperties$17(_ref21, ['language']);

  return themeResponsiveProperty(React__default.createElement(
    SlotMachineButtonContainer,
    { style: {
        width: 'auto',
        height: 'auto',
        marginRight: '0.25rem',
        marginLeft: '0.25rem',
        padding: '.5rem .75rem'
      } },
    trans(language, 'Spin')
  ), React__default.createElement(
    'svg',
    _extends$52({ viewBox: '1.3 6.3 13.8 13.6', style: {
        width: '2.5rem',
        verticalAlign: 'middle',
        marginRight: '.325rem',
        marginLeft: '.325rem'
      } }, props),
    React__default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      React__default.createElement('ellipse', { fill: '#636363', cx: 8.25, cy: 13.093, rx: 6.75, ry: 6.593 }),
      React__default.createElement(
        'g',
        { stroke: '#FCFCFC', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: .5 },
        React__default.createElement('path', { d: 'M10.088 13.977l.891.977M10.088 15.93l.891-.976M10.088 10.069l.891.977M10.088 12.023l.891-.977M5.333 14.954h.393c.499.002.965-.271 1.242-.726l1.485-2.459c.276-.453.74-.726 1.237-.726h1.29M8.453 14.228c.277.455.743.728 1.242.726h1.284M5.333 11.046h.393c.499-.002.965.271 1.242.726' })
      )
    )
  ))({ theme: props.theme });
};

function getNextCombinationIndex(currentIndex) {
  return currentIndex === null ? 0 : currentIndex + 1;
}

var _templateObject$27 = _taggedTemplateLiteral$27(['\n  z-index: 1;\n  position: relative;\n\n  ', ';\n\n  &:first-child {\n    padding-left: ', ';\n  }\n\n  &:last-child {\n    padding-right: ', ';\n  }\n'], ['\n  z-index: 1;\n  position: relative;\n\n  ', ';\n\n  &:first-child {\n    padding-left: ', ';\n  }\n\n  &:last-child {\n    padding-right: ', ';\n  }\n']),
    _templateObject2$15 = _taggedTemplateLiteral$27(['\n    z-index: 2;\n  '], ['\n    z-index: 2;\n  ']);

function _taggedTemplateLiteral$27(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CombinationThumbnailContainer = styled__default.div(_templateObject$27, function (_ref) {
  var active = _ref.active;
  return active && styled.css(_templateObject2$15);
}, themeResponsiveProperty('2rem', '5rem'), themeResponsiveProperty('4rem', '5rem'));

var _extends$53 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$28 = _taggedTemplateLiteral$28(['\n  z-index: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 9rem;\n  height: 9rem;\n  margin: .5rem;\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  border-radius: ', ';\n  cursor: pointer;\n\n  transition: all .3s ease;\n'], ['\n  z-index: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 9rem;\n  height: 9rem;\n  margin: .5rem;\n  background: url(', ') no-repeat center;\n  background-size: cover;\n  border-radius: ', ';\n  cursor: pointer;\n\n  transition: all .3s ease;\n']),
    _templateObject2$16 = _taggedTemplateLiteral$28(['\n  position: absolute;\n  width: 1.5rem;\n  color: #fff;\n'], ['\n  position: absolute;\n  width: 1.5rem;\n  color: #fff;\n']),
    _templateObject3$12 = _taggedTemplateLiteral$28(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  border-radius: ', ';\n  background-color: ', ';\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  border-radius: ', ';\n  background-color: ', ';\n']);

function _taggedTemplateLiteral$28(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$18(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function CombinationThumbnail(_ref) {
  var src = _ref.src,
      active = _ref.active,
      discovered = _ref.discovered,
      props = _objectWithoutProperties$18(_ref, ['src', 'active', 'discovered']);

  return React__default.createElement(
    Container$7,
    _extends$53({ src: src }, props),
    !props.active && React__default.createElement(Overlay$2, null),
    discovered && React__default.createElement(CheckCircleIcon, null),
    !active && React__default.createElement(Plus, null)
  );
}

var Container$7 = styled__default.div(_templateObject$28, function (_ref2) {
  var src = _ref2.src;
  return src;
}, themeResponsiveProperty(null, '.5rem'));

var Plus = styled__default(function (props) {
  return React__default.createElement(
    'svg',
    _extends$53({
      viewBox: '0 0 28 28',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    React__default.createElement('path', {
      d: 'M26 11h-9V2c0-1.063-.938-2-2-2h-2c-1.125 0-2 .938-2 2v9H2c-1.125 0-2 .938-2 2v2c0 1.125.875 2 2 2h9v9c0 1.125.875 2 2 2h2c1.063 0 2-.875 2-2v-9h9c1.063 0 2-.875 2-2v-2c0-1.063-.938-2-2-2z',
      fill: 'currentColor'
    })
  );
})(_templateObject2$16);

var Overlay$2 = styled__default.div(_templateObject3$12, themeResponsiveProperty(null, '.5rem'), themeResponsiveProperty('rgba(0,0,0,.2)', 'rgba(0,0,0,.8)'));

var _extends$54 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$37 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$14(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$63(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$49(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$52(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCombinationMediaAtIndex(combinations, combinationIndex) {
  return combinations.find(function (_, index) {
    return index === combinationIndex;
  }).media;
}

function calculateChapterHeight(combinationsLength, screenHeight) {
  return Math.max(combinationsLength * screenHeight / 4, screenHeight * 3);
}

var Exercise3 = function (_Component) {
  _inherits$52(Exercise3, _Component);

  function Exercise3() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$63(this, Exercise3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$49(this, (_ref = Exercise3.__proto__ || Object.getPrototypeOf(Exercise3)).call.apply(_ref, [this].concat(args))), _this), _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$54({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content), {

      isHelpModalVisible: true,
      exerciseCompleted: false,
      exerciseCompletedAnimationState: null,

      activeCombinationIndex: null,
      isTooltipOverlayVisible: false,
      discovered: {}
    }), _this.stickyContainerReference = null, _this.thumbnailsContainerReference = null, _this.thumbnailsContainerInnerReference = null, _this.onPreTitleBlur = function (value) {
      _this.setState({ preTitle: setContentValue(_this.state.preTitle, value) });
    }, _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.onCombinationMediaChange = function (index, asset) {
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$54({}, loopingCombination, { media: setContentValue(loopingCombination.media, asset.value, asset.options) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.onCombinationThumbnailChange = function (index, asset) {
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$54({}, loopingCombination, { thumbnail: setContentValue(loopingCombination.thumbnail, asset.src, asset.options) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.onCombinationThumbnailClick = function (index, combination) {
      // @todo 2018-06-11 Is the index ok? Shall we use anything for "unique"?
      var nextDiscovered = _this.state.displayMode === DISPLAY_MODE_EDIT ? _this.state.discovered : _extends$54({}, _this.state.discovered, _defineProperty$3({}, index, true));

      if (Object.keys(nextDiscovered).length === _this.state.combinations.length) {
        _this.props.onExerciseComplete(_this.props.content._id).then(function () {
          _this.setState({ exerciseCompleted: true });
        }).catch(console.error);
      }

      _this.setState({
        activeCombinationIndex: index,
        isTooltipOverlayVisible: true,
        discovered: nextDiscovered
      });
    }, _this.onCombinationTextBlur = function (index, value) {
      // const combinations = updateCombination(this.state.combinations, index, combination => (
      //   { ...combination, text: setContentValue(combination.text, value) }
      // ));

      // Update the blurred combination (looping the combinations array, and
      // replacing the text that has been blurred).
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$54({}, loopingCombination, { text: setContentValue(loopingCombination.text, value) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.handleAddCombinationClick = function () {
      var combinations = _this.state.combinations.concat([combinationBlueprint$1()]);

      _this.setState({ combinations: combinations });
    }, _this.handleRemoveCombinationClick = function (index) {
      var combinations = _this.state.combinations.filter(function (_, loopingIndex) {
        return loopingIndex !== index;
      });

      _this.setState({
        combinations: combinations,
        activeCombinationIndex: null,
        isTooltipOverlayVisible: false
      });
    }, _this.handleSaveChapterClick = _asyncToGenerator$14( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$54({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.preTitle, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 8:
              _context2.t2 = _context2.sent;
              _context2.next = 11;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 11:
              _context2.t3 = _context2.sent;
              _context2.next = 14;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 14:
              _context2.t4 = _context2.sent;
              _context2.next = 17;
              return Promise.all(_this.state.combinations.map(function () {
                var _ref3 = _asyncToGenerator$14( /*#__PURE__*/regenerator.mark(function _callee(combination) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(combination.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return save(ContentManager.make(combination.thumbnail, 'thron-asset'));

                        case 5:
                          _context.t1 = _context.sent;
                          _context.next = 8;
                          return save(ContentManager.make(combination.media, 'thron-asset'));

                        case 8:
                          _context.t2 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            thumbnail: _context.t1,
                            media: _context.t2
                          });

                        case 10:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 17:
              _context2.t5 = _context2.sent;
              state = {
                templateName: _context2.t0,
                preTitle: _context2.t1,
                title: _context2.t2,
                text: _context2.t3,
                media: _context2.t4,
                combinations: _context2.t5
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.handleDisplayModeSwitch = function () {
      _this.setState({
        exerciseCompleted: false,
        activeCombinationIndex: null,
        isTooltipOverlayVisible: false,
        discovered: {}
      });

      _this.props.handleDisplayModeSwitch();
    }, _this.onExerciseScroll = function (progress) {
      if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this.state.displayMode) !== -1) {
        _this.textScrollableCallback(progress);
      }

      if (_this.thumbnailsContainerReference === null || _this.thumbnailsContainerInnerReference === null) {
        return;
      }

      var containerWidth = _this.thumbnailsContainerReference.offsetWidth;
      var innerWidth = _this.thumbnailsContainerInnerReference.scrollWidth;

      _this.thumbnailsContainerInnerReference.style.transform = 'translateZ(0) translateX(-' + (innerWidth - containerWidth) * clamp(progress, 0, 1) + 'px)';
    }, _temp), _possibleConstructorReturn$49(_this, _ret);
  }

  _createClass$37(Exercise3, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        // @todo 2019-01-10 Check for undefined added for backwards compatibility
        preTitle: chapter.preTitle === undefined ? makeContent('text') : chapter.preTitle,
        title: chapter.title,
        text: chapter.text,
        media: chapter.media,
        combinations: chapter.combinations
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;

      if (prevState.exerciseCompleted === false && this.state.exerciseCompleted === true) {
        exerciseCompletedAnimationChange(function (state) {
          return _this3.setState({ exerciseCompletedAnimationState: state });
        });
      }
    }

    /**
     * Add a new combination and update the reels accordingly
     */


    /**
     * Remove the combination at "index" and reset the editing combination
     * @param index
     */


    /**
     * Reset the exercise status when switching display mode.
     */

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              position: 'relative',
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { zIndex: 2, position: 'absolute', top: '-1rem', right: 0, display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, _extends$54({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleAddCombinationClick },
              __('+Combination')
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              { style: { marginBottom: 0 } },
              React__default.createElement(TextTranslatable, {
                plain: true,
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            ref: function ref(_ref4) {
              return _this4.stickyContainerReference = _ref4;
            },
            displayMode: this.state.displayMode,
            height: calculateChapterHeight(this.state.combinations.length, this.state.screenHeight),
            onEnter: this.props.onEnter },
          React__default.createElement(
            StickyContent,
            { style: { height: this.state.screenHeight }, onProgressChange: this.onExerciseScroll },
            React__default.createElement(
              ExerciseTutorialModal,
              { isVisible: this.state.isHelpModalVisible },
              React__default.createElement(
                'h3',
                null,
                trans(this.props.language, 'How it works?')
              ),
              React__default.createElement(
                'p',
                null,
                trans(this.props.language, 'Click on the images on the right side to discover the combinations and tips.')
              ),
              React__default.createElement(
                'p',
                null,
                React__default.createElement('img', { style: { width: '10rem' }, src: this.props.theme.exerciseTutorialSources.exercise3, alt: '' })
              ),
              React__default.createElement(
                ExerciseTutorialButton,
                { dark: true, onClick: function onClick() {
                    return _this4.setState({ isHelpModalVisible: false });
                  } },
                trans(this.props.language, 'Ok got it')
              )
            ),
            React__default.createElement(ExerciseCompleted, {
              style: { zIndex: 3 },
              state: this.state.exerciseCompletedAnimationState,
              isVisible: this.state.exerciseCompleted,
              onClick: function onClick() {
                exerciseCompletedAnimationFactory(_this4.stickyContainerReference, calculateChapterHeight(_this4.state.combinations.length, _this4.state.screenHeight));
              } }),
            React__default.createElement(
              'div',
              { style: {
                  display: 'flex',
                  flexDirection: 'column',
                  height: this.state.screenHeight
                } },
              React__default.createElement(
                Scrollable,
                {
                  innerPaddingTop: '1rem',
                  fade: true,
                  fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                  onProgressCallback: function onProgressCallback(callback) {
                    return _this4.textScrollableCallback = callback;
                  },
                  style: {
                    flexShrink: 0,
                    pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                    maxHeight: this.state.screenHeight * .3
                  }
                },
                React__default.createElement(
                  PreTitle,
                  { dark: true, style: {
                      marginRight: '1rem',
                      marginBottom: '1rem',
                      marginLeft: '1rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.preTitle,
                    onBlur: this.onPreTitleBlur })
                ),
                React__default.createElement(
                  'div',
                  { style: {
                      marginRight: '1rem',
                      marginBottom: '1rem',
                      marginLeft: '1rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.text,
                    onBlur: this.onTextBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      position: 'relative',
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'rgb(210 210 210 / 0.2)'
                    } },
                  React__default.createElement(
                    'div',
                    { style: {
                        zIndex: 1,
                        width: '13rem',
                        // height: '25rem',
                        display: 'flex',
                        alignItems: 'center'
                      } },
                    React__default.createElement(Media, {
                      style: { width: '100%' },
                      width: remToPixels(13),
                      height: remToPixels(25),
                      src: this.state.media.value,
                      options: this.state.media.options,
                      shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                      onChange: this.onMediaChange })
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        zIndex: 1,
                        width: '13rem',
                        // height: '25rem',
                        display: 'flex',
                        alignItems: 'center'
                      } },
                    this.state.activeCombinationIndex !== null ? React__default.createElement(Media, {
                      key: this.state.activeCombinationIndex,
                      style: { width: '100%' },
                      width: remToPixels(13),
                      height: remToPixels(25),
                      src: getCombinationMediaAtIndex(this.state.combinations, this.state.activeCombinationIndex).value,
                      options: getCombinationMediaAtIndex(this.state.combinations, this.state.activeCombinationIndex).options,
                      shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                      onChange: function onChange(asset) {
                        return _this4.onCombinationMediaChange(_this4.state.activeCombinationIndex, asset);
                      } }) :
                    // @todo 2018-06-18 Render something, instead of nothing
                    null
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        zIndex: 1,
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        left: 0
                      } },
                    React__default.createElement(StepIndicator, {
                      total: this.state.combinations.length,
                      active: Object.keys(this.state.discovered).length - 1,
                      showPercentage: function showPercentage(percentage) {
                        return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                      },
                      step: false,
                      gradient: true,
                      dark: true,
                      style: {
                        index: 1,
                        padding: '1rem calc(100% - 14.25rem) 1rem 1rem'
                      }
                    })
                  )
                ),
                React__default.createElement(
                  'div',
                  { style: { overflowX: 'auto' } },
                  React__default.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    this.state.combinations.map(function (combination, index, combinations) {
                      return React__default.createElement(
                        CombinationThumbnailContainer,
                        {
                          key: index,
                          active: _this4.state.activeCombinationIndex === index },
                        _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                          'div',
                          { style: { zIndex: 2, position: 'absolute', top: '.25rem', left: '.25rem' } },
                          React__default.createElement(
                            TemplateControlButton,
                            { onClick: function onClick() {
                                return _this4.handleRemoveCombinationClick(index);
                              } },
                            __('Remove combination')
                          ),
                          React__default.createElement(
                            ThronBrowserTriggerer,
                            {
                              singleSelection: true,
                              shouldOpenThronBrowser: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                              onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
                                return _this4.onCombinationThumbnailChange(index, assets[0]);
                              } },
                            React__default.createElement(
                              TemplateControlButton,
                              null,
                              __('Edit image')
                            )
                          )
                        ),
                        React__default.createElement(CombinationThumbnail, {
                          discovered: _this4.state.discovered[index],
                          active: _this4.state.activeCombinationIndex === index,
                          src: thronImage({ src: combination.thumbnail.value, options: combination.thumbnail.options }, remToPixels(9), remToPixels(9)),
                          onClick: function onClick() {
                            return _this4.onCombinationThumbnailClick(index, combination);
                          } })
                      );
                    })
                  )
                )
              ),
              React__default.createElement(
                FullscreenTooltipBoxContainer,
                { visible: this.state.isTooltipOverlayVisible, style: {
                    zIndex: 2
                  } },
                React__default.createElement(
                  TooltipBoxInner,
                  { style: { right: 0, width: 'auto' }, visible: this.state.isTooltipOverlayVisible },
                  React__default.createElement(CloseTooltipBoxButton, { onClick: function onClick() {
                      return _this4.setState({ isTooltipOverlayVisible: false });
                    } }),
                  this.state.displayMode === DISPLAY_MODE_EDIT && this.state.activeCombinationIndex === null && React__default.createElement(
                    'i',
                    { style: { color: '#aaa' } },
                    __('Click on a thumbnail to edit its associated image and text.')
                  ),
                  React__default.createElement(
                    'div',
                    { style: { width: '100%' } },
                    this.state.combinations.map(function (combination, index) {
                      return React__default.createElement(
                        'span',
                        { key: index, style: { display: _this4.state.activeCombinationIndex === index ? 'block' : 'none' } },
                        React__default.createElement(TextTranslatable, {
                          highlight: _this4.props.highlightWord,
                          onLanguageChange: _this4.props.onContentLanguageChange,
                          onContentUpdate: _this4.props.onContentUpdate,
                          displayMode: _this4.state.displayMode,
                          content: combination.text,
                          onBlur: function onBlur(value) {
                            return _this4.onCombinationTextBlur(index, value);
                          } })
                      );
                    })
                  )
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          ref: function ref(_ref7) {
            return _this4.stickyContainerReference = _ref7;
          },
          displayMode: this.state.displayMode,
          height: calculateChapterHeight(this.state.combinations.length, this.state.screenHeight),
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight }, onProgressChange: this.onExerciseScroll },
          React__default.createElement(
            ExerciseTutorialModal,
            { isVisible: this.state.isHelpModalVisible },
            React__default.createElement(
              'h3',
              null,
              trans(this.props.language, 'How it works?')
            ),
            React__default.createElement(
              'p',
              null,
              trans(this.props.language, 'Click on the images on the right side to discover the combinations and tips.')
            ),
            React__default.createElement(
              'p',
              null,
              React__default.createElement('img', { style: { width: '10rem' }, src: this.props.theme.exerciseTutorialSources.exercise3, alt: '' })
            ),
            React__default.createElement(
              ExerciseTutorialButton,
              { dark: true, onClick: function onClick() {
                  return _this4.setState({ isHelpModalVisible: false });
                } },
              trans(this.props.language, 'Ok got it')
            )
          ),
          React__default.createElement(ExerciseCompleted, {
            style: { zIndex: 3 },
            state: this.state.exerciseCompletedAnimationState,
            isVisible: this.state.exerciseCompleted,
            onClick: function onClick() {
              exerciseCompletedAnimationFactory(_this4.stickyContainerReference, calculateChapterHeight(_this4.state.combinations.length, _this4.state.screenHeight));
            } }),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                flexDirection: 'column',
                height: this.state.screenHeight
              } },
            React__default.createElement(
              'div',
              { style: {
                  flexBasis: '25%',
                  padding: '4.5rem 3rem 0'
                } },
              React__default.createElement(
                TemplateControl,
                {
                  style: { zIndex: 2, position: 'absolute', top: '1rem', right: '4rem', display: 'flex' },
                  displayMode: this.state.displayMode },
                React__default.createElement(TemplateControlDefaultButtons, _extends$54({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleAddCombinationClick },
                  __('+Combination')
                ),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleSaveChapterClick },
                  __('Save')
                )
              ),
              React__default.createElement(ExerciseTutorialHelpIcon, {
                style: { color: '#000' },
                onClick: function onClick() {
                  return _this4.setState({ isHelpModalVisible: true });
                } }),
              React__default.createElement(
                PreTitle,
                { dark: true, style: {
                    position: 'absolute',
                    top: '1.5rem',
                    right: '40%',
                    left: '3rem'
                  } },
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.preTitle,
                  onBlur: this.onPreTitleBlur })
              ),
              React__default.createElement(
                Title,
                { style: { flexBasis: '35%' } },
                React__default.createElement(
                  TitleText,
                  { lightBackground: true, style: { marginBottom: 0 } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: '2.75rem',
                    left: '23.75rem',
                    transform: 'translateX(-100%)'
                  } },
                React__default.createElement(BigChapterNumber, { color: 'rgba(67,67,67,0.15)', number: this.state.index + 1 })
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0 5rem 10rem',
                  flexBasis: '75%'
                } },
              React__default.createElement('div', { style: {
                  position: 'absolute',
                  top: '3rem',
                  right: '7.5rem',
                  left: '2.5rem',
                  height: '22.25rem',
                  backgroundColor: '#878787'
                } }),
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: '2rem',
                    left: '27rem',
                    right: 0
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      left: 0
                    } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.text,
                    onBlur: this.onTextBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    bottom: '-2.5rem',
                    left: 0,
                    width: '15rem'
                  } },
                React__default.createElement(StepIndicator, {
                  total: this.state.combinations.length,
                  active: Object.keys(this.state.discovered).length - 1,
                  showPercentage: function showPercentage(percentage) {
                    return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                  },
                  step: false,
                  dark: true })
              ),
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    width: '26rem',
                    display: 'flex',
                    alignItems: 'center'
                  } },
                React__default.createElement(
                  'div',
                  { style: { zIndex: 1, width: '13rem', height: '25rem', display: 'flex', alignItems: 'center' } },
                  React__default.createElement(Media, {
                    style: { width: '100%' },
                    width: remToPixels(13),
                    height: remToPixels(25),
                    src: this.state.media.value,
                    options: this.state.media.options,
                    shadow: true,
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: this.onMediaChange })
                ),
                React__default.createElement(
                  'div',
                  { style: {
                      zIndex: 2,
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translateY(-50%) translateX(-50%)',
                      width: '3.5rem',
                      height: '3.5rem',
                      backgroundColor: '#464646',

                      display: this.state.activeCombinationIndex !== null ? 'flex' : 'none',
                      alignItems: 'center',
                      justifyContent: 'center'
                    } },
                  React__default.createElement(
                    'svg',
                    { style: { width: '1.3125rem', height: '1.25rem' }, viewBox: '0 0 26 25' },
                    React__default.createElement('path', {
                      d: 'M15.364 10.136H25.5v4.728H15.364V25h-4.728V14.864H.5v-4.728h10.136V0h4.728v10.136z',
                      fill: '#b7b7b7',
                      fillRule: 'evenodd'
                    })
                  )
                ),
                React__default.createElement(
                  'div',
                  { style: { zIndex: 1, width: '13rem', height: '25rem', display: 'flex', alignItems: 'center' } },
                  this.state.activeCombinationIndex !== null ? React__default.createElement(Media, {
                    key: this.state.activeCombinationIndex,
                    style: { width: '100%' },
                    width: remToPixels(13),
                    height: remToPixels(25),
                    src: getCombinationMediaAtIndex(this.state.combinations, this.state.activeCombinationIndex).value,
                    options: getCombinationMediaAtIndex(this.state.combinations, this.state.activeCombinationIndex).options,
                    shadow: true,
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: function onChange(asset) {
                      return _this4.onCombinationMediaChange(_this4.state.activeCombinationIndex, asset);
                    } }) :
                  // @todo 2018-06-18 Render something, instead of nothing
                  null
                )
              ),
              React__default.createElement(
                'div',
                { style: { overflow: 'hidden', willChange: null, transform: 'translateZ(0)', width: '39rem', marginLeft: '26rem', paddingTop: '2rem', paddingBottom: '2rem' }, ref: function ref(_ref6) {
                    return _this4.thumbnailsContainerReference = _ref6;
                  } },
                React__default.createElement(
                  'div',
                  { style: { display: 'flex', willChange: null, paddingRight: '5rem', paddingLeft: '1.5rem' }, ref: function ref(_ref5) {
                      return _this4.thumbnailsContainerInnerReference = _ref5;
                    } },
                  this.state.combinations.map(function (combination, index, combinations) {
                    return React__default.createElement(
                      CombinationThumbnailContainer,
                      {
                        key: index,
                        active: _this4.state.activeCombinationIndex === index },
                      _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                        'div',
                        { style: { zIndex: 2, position: 'absolute', top: '.25rem', left: '.25rem' } },
                        React__default.createElement(
                          TemplateControlButton,
                          { onClick: function onClick() {
                              return _this4.handleRemoveCombinationClick(index);
                            } },
                          __('Remove combination')
                        ),
                        React__default.createElement(
                          ThronBrowserTriggerer,
                          {
                            singleSelection: true,
                            shouldOpenThronBrowser: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                            onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
                              return _this4.onCombinationThumbnailChange(index, assets[0]);
                            } },
                          React__default.createElement(
                            TemplateControlButton,
                            null,
                            __('Edit image')
                          )
                        )
                      ),
                      React__default.createElement(CombinationThumbnail, {
                        discovered: _this4.state.discovered[index],
                        active: _this4.state.activeCombinationIndex === index,
                        src: thronImage({ src: combination.thumbnail.value, options: combination.thumbnail.options }, remToPixels(10), remToPixels(11)),
                        onClick: function onClick() {
                          return _this4.onCombinationThumbnailClick(index, combination);
                        } })
                    );
                  })
                )
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  position: 'relative',
                  margin: '0 5rem'
                } },
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    left: '28.5rem',
                    bottom: '6.5rem',
                    width: '23rem',
                    height: '11rem',
                    color: '#fff'
                  } },
                React__default.createElement(
                  TooltipBoxBackgroundText,
                  { style: {
                      top: '-1.25rem'
                    } },
                  __('The look')
                ),
                React__default.createElement(TooltipBoxDecoration, { style: { position: 'absolute', top: '-2rem', left: 0 } }),
                React__default.createElement(
                  TooltipBoxInner,
                  { style: { right: 0, width: 'auto' }, visible: this.state.displayMode === DISPLAY_MODE_EDIT || this.state.activeCombinationIndex !== null },
                  this.state.displayMode === DISPLAY_MODE_EDIT && this.state.activeCombinationIndex === null && React__default.createElement(
                    'i',
                    { style: { color: '#aaa' } },
                    __('Click on a thumbnail to edit its associated image and text.')
                  ),
                  React__default.createElement(
                    'div',
                    { style: { width: '100%' } },
                    this.state.combinations.map(function (combination, index) {
                      return React__default.createElement(
                        'span',
                        { key: index, style: { display: _this4.state.activeCombinationIndex === index ? 'block' : 'none' } },
                        React__default.createElement(TextTranslatable, {
                          highlight: _this4.props.highlightWord,
                          onLanguageChange: _this4.props.onContentLanguageChange,
                          onContentUpdate: _this4.props.onContentUpdate,
                          displayMode: _this4.state.displayMode,
                          content: combination.text,
                          onBlur: function onBlur(value) {
                            return _this4.onCombinationTextBlur(index, value);
                          } })
                      );
                    })
                  )
                )
              )
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Exercise3;
}(React.Component);

function combinationBlueprint$1() {
  return _extends$54({}, {
    text: makeContent('text'),
    thumbnail: makeContent('thron-asset', 'http://via.placeholder.com/320x352'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/432x800')
  });
}

var blueprint$14 = function blueprint(templateName) {
  return {
    templateName: templateName,
    preTitle: makeContent('text'),
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/432x800'),
    combinations: [combinationBlueprint$1()]
  };
};

var Exercise3$1 = styled.withTheme(asTemplate('Exercise3', Exercise3, blueprint$14));

var _extends$55 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$38 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$15(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$64(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$50(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$53(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCombinationMediaAtIndex$1(combinations, combinationIndex) {
  return combinations.find(function (_, index) {
    return index === combinationIndex;
  }).media;
}

function calculateChapterHeight$1(combinationsLength, screenHeight) {
  return Math.max(combinationsLength * screenHeight / 4, screenHeight * 3);
}

var Exercise4 = function (_Component) {
  _inherits$53(Exercise4, _Component);

  function Exercise4() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$64(this, Exercise4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$50(this, (_ref = Exercise4.__proto__ || Object.getPrototypeOf(Exercise4)).call.apply(_ref, [this].concat(args))), _this), _this.textScrollableCallback = function () {
      return null;
    }, _this.state = _extends$55({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content), {

      isHelpModalVisible: true,
      exerciseCompleted: false,
      exerciseCompletedAnimationState: null,

      activeCombinationIndex: null,
      isTooltipOverlayVisible: false,
      discovered: {}
    }), _this.stickyContainerReference = null, _this.thumbnailsContainerReference = null, _this.thumbnailsContainerInnerReference = null, _this.onPreTitleBlur = function (value) {
      _this.setState({ preTitle: setContentValue(_this.state.preTitle, value) });
    }, _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.onCombinationMediaChange = function (index, asset) {
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$55({}, loopingCombination, { media: setContentValue(loopingCombination.media, asset.value, asset.options) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.onCombinationThumbnailChange = function (index, asset) {
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$55({}, loopingCombination, { thumbnail: setContentValue(loopingCombination.thumbnail, asset.src, asset.options) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.onCombinationThumbnailClick = function (index, combination) {
      // @todo 2018-06-11 Is the index ok? Shall we use anything for "unique"?
      var nextDiscovered = _this.state.displayMode === DISPLAY_MODE_EDIT ? _this.state.discovered : _extends$55({}, _this.state.discovered, _defineProperty$4({}, index, true));

      if (Object.keys(nextDiscovered).length === _this.state.combinations.length) {
        _this.props.onExerciseComplete(_this.props.content._id).then(function () {
          _this.setState({ exerciseCompleted: true });
        }).catch(console.error);
      }

      _this.setState({
        activeCombinationIndex: index,
        isTooltipOverlayVisible: true,
        discovered: nextDiscovered
      });
    }, _this.onCombinationTextBlur = function (index, value) {
      // const combinations = updateCombination(this.state.combinations, index, combination => (
      //   { ...combination, text: setContentValue(combination.text, value) }
      // ));

      // Update the blurred combination (looping the combinations array, and
      // replacing the text that has been blurred).
      var combinations = _this.state.combinations.map(function (loopingCombination, loopingIndex) {
        return loopingIndex === index ? _extends$55({}, loopingCombination, { text: setContentValue(loopingCombination.text, value) }) : loopingCombination;
      });

      _this.setState({ combinations: combinations });
    }, _this.handleAddCombinationClick = function () {
      var combinations = _this.state.combinations.concat([combinationBlueprint$2()]);

      _this.setState({ combinations: combinations });
    }, _this.handleRemoveCombinationClick = function (index) {
      var combinations = _this.state.combinations.filter(function (_, loopingIndex) {
        return loopingIndex !== index;
      });

      _this.setState({
        combinations: combinations,
        activeCombinationIndex: null,
        isTooltipOverlayVisible: false
      });
    }, _this.handleSaveChapterClick = _asyncToGenerator$15( /*#__PURE__*/regenerator.mark(function _callee2() {
      var save, state;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$55({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context2.t0 = _this.props.templateName;
              _context2.next = 5;
              return save(ContentManager.make(_this.state.preTitle, 'text'));

            case 5:
              _context2.t1 = _context2.sent;
              _context2.next = 8;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 8:
              _context2.t2 = _context2.sent;
              _context2.next = 11;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 11:
              _context2.t3 = _context2.sent;
              _context2.next = 14;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 14:
              _context2.t4 = _context2.sent;
              _context2.next = 17;
              return Promise.all(_this.state.combinations.map(function () {
                var _ref3 = _asyncToGenerator$15( /*#__PURE__*/regenerator.mark(function _callee(combination) {
                  return regenerator.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return save(ContentManager.make(combination.text, 'text'));

                        case 2:
                          _context.t0 = _context.sent;
                          _context.next = 5;
                          return save(ContentManager.make(combination.thumbnail, 'thron-asset'));

                        case 5:
                          _context.t1 = _context.sent;
                          _context.next = 8;
                          return save(ContentManager.make(combination.media, 'thron-asset'));

                        case 8:
                          _context.t2 = _context.sent;
                          return _context.abrupt('return', {
                            text: _context.t0,
                            thumbnail: _context.t1,
                            media: _context.t2
                          });

                        case 10:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 17:
              _context2.t5 = _context2.sent;
              state = {
                templateName: _context2.t0,
                preTitle: _context2.t1,
                title: _context2.t2,
                text: _context2.t3,
                media: _context2.t4,
                combinations: _context2.t5
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.handleDisplayModeSwitch = function () {
      _this.setState({
        exerciseCompleted: false,
        activeCombinationIndex: null,
        isTooltipOverlayVisible: false,
        discovered: {}
      });

      _this.props.handleDisplayModeSwitch();
    }, _this.onExerciseScroll = function (progress) {
      if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this.state.displayMode) !== -1) {
        _this.textScrollableCallback(progress);
      }

      if (_this.thumbnailsContainerReference === null || _this.thumbnailsContainerInnerReference === null) {
        return;
      }

      var containerWidth = _this.thumbnailsContainerReference.offsetWidth;
      var innerWidth = _this.thumbnailsContainerInnerReference.scrollWidth;

      _this.thumbnailsContainerInnerReference.style.transform = 'translateZ(0) translateX(-' + (innerWidth - containerWidth) * clamp(progress, 0, 1) + 'px)';
    }, _temp), _possibleConstructorReturn$50(_this, _ret);
  }

  _createClass$38(Exercise4, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        // @todo 2019-01-10 Check for undefined added for backwards compatibility
        preTitle: chapter.preTitle === undefined ? makeContent('text') : chapter.preTitle,
        title: chapter.title,
        text: chapter.text,
        media: chapter.media,
        combinations: chapter.combinations
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this3 = this;

      if (prevState.exerciseCompleted === false && this.state.exerciseCompleted === true) {
        exerciseCompletedAnimationChange(function (state) {
          return _this3.setState({ exerciseCompletedAnimationState: state });
        });
      }
    }

    /**
     * Add a new combination and update the reels accordingly
     */


    /**
     * Remove the combination at "index" and reset the editing combination
     * @param index
     */


    /**
     * Reset the exercise status when switching display mode.
     */

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(
          'div',
          { style: {
              position: 'relative',
              display: 'flex',
              marginTop: '1rem',
              marginRight: '1rem',
              marginLeft: '1rem'
            } },
          React__default.createElement(
            TemplateControl,
            {
              style: { zIndex: 2, position: 'absolute', top: '-1rem', right: 0, display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, _extends$55({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleAddCombinationClick },
              __('+Combination')
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { marginRight: '1rem' } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
          ),
          React__default.createElement(
            Title,
            { style: { flex: 1 } },
            React__default.createElement(
              TitleText,
              { style: { marginBottom: 0 } },
              React__default.createElement(TextTranslatable, {
                plain: true,
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.title,
                onBlur: this.onTitleBlur })
            )
          )
        ),
        React__default.createElement(
          StickyContainer$1,
          {
            ref: function ref(_ref4) {
              return _this4.stickyContainerReference = _ref4;
            },
            displayMode: this.state.displayMode,
            height: calculateChapterHeight$1(this.state.combinations.length, this.state.screenHeight),
            onEnter: this.props.onEnter },
          React__default.createElement(
            StickyContent,
            { style: { height: this.state.screenHeight }, onProgressChange: this.onExerciseScroll },
            React__default.createElement(
              ExerciseTutorialModal,
              { isVisible: this.state.isHelpModalVisible },
              React__default.createElement(
                'h3',
                null,
                trans(this.props.language, 'How it works?')
              ),
              React__default.createElement(
                'p',
                null,
                trans(this.props.language, 'Click on the images at the bottom to discover the combinations and tips.')
              ),
              React__default.createElement(
                'p',
                null,
                React__default.createElement('img', { style: { width: '10rem' }, src: this.props.theme.exerciseTutorialSources.exercise4, alt: '' })
              ),
              React__default.createElement(
                ExerciseTutorialButton,
                { dark: true, onClick: function onClick() {
                    return _this4.setState({ isHelpModalVisible: false });
                  } },
                trans(this.props.language, 'Ok got it')
              )
            ),
            React__default.createElement(ExerciseCompleted, {
              style: { zIndex: 3 },
              state: this.state.exerciseCompletedAnimationState,
              isVisible: this.state.exerciseCompleted,
              onClick: function onClick() {
                exerciseCompletedAnimationFactory(_this4.stickyContainerReference, calculateChapterHeight$1(_this4.state.combinations.length, _this4.state.screenHeight));
              } }),
            React__default.createElement(
              'div',
              { style: {
                  display: 'flex',
                  flexDirection: 'column',
                  height: this.state.screenHeight
                } },
              React__default.createElement(
                Scrollable,
                {
                  innerPaddingTop: '1rem',
                  fade: true,
                  fadeColor: ['#fff', 'rgb(255 255 255 / 0)'],
                  onProgressCallback: function onProgressCallback(callback) {
                    return _this4.textScrollableCallback = callback;
                  },
                  style: {
                    flexShrink: 0,
                    pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                    maxHeight: this.state.screenHeight * .3
                  }
                },
                React__default.createElement(
                  PreTitle,
                  { dark: true, style: {
                      marginRight: '1rem',
                      marginBottom: '1rem',
                      marginLeft: '1rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.preTitle,
                    onBlur: this.onPreTitleBlur })
                ),
                React__default.createElement(
                  'div',
                  { style: {
                      marginRight: '1rem',
                      marginBottom: '1rem',
                      marginLeft: '1rem'
                    } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.text,
                    onBlur: this.onTextBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      position: 'relative',
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'rgb(210 210 210 / 0.2)'
                    } },
                  React__default.createElement(
                    'div',
                    { style: {
                        zIndex: 1,
                        width: '13rem',
                        // height: '25rem',
                        display: 'flex',
                        alignItems: 'center'
                      } },
                    React__default.createElement(Media, {
                      style: { width: '100%' },
                      width: remToPixels(13),
                      height: remToPixels(25),
                      src: this.state.media.value,
                      options: this.state.media.options,
                      shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                      onChange: this.onMediaChange })
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        zIndex: 1,
                        width: '13rem',
                        // height: '25rem',
                        display: 'flex',
                        alignItems: 'center'
                      } },
                    this.state.activeCombinationIndex !== null ? React__default.createElement(Media, {
                      key: this.state.activeCombinationIndex,
                      style: { width: '100%' },
                      width: remToPixels(13),
                      height: remToPixels(25),
                      src: getCombinationMediaAtIndex$1(this.state.combinations, this.state.activeCombinationIndex).value,
                      options: getCombinationMediaAtIndex$1(this.state.combinations, this.state.activeCombinationIndex).options,
                      shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                      onChange: function onChange(asset) {
                        return _this4.onCombinationMediaChange(_this4.state.activeCombinationIndex, asset);
                      } }) :
                    // @todo 2018-06-18 Render something, instead of nothing
                    null
                  ),
                  React__default.createElement(
                    'div',
                    { style: {
                        zIndex: 1,
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        left: 0
                      } },
                    React__default.createElement(StepIndicator, {
                      total: this.state.combinations.length,
                      active: Object.keys(this.state.discovered).length - 1,
                      showPercentage: function showPercentage(percentage) {
                        return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                      },
                      step: false,
                      gradient: true,
                      dark: true,
                      style: {
                        padding: '1rem calc(100% - 14.25rem) 1rem 1rem'
                      }
                    })
                  )
                ),
                React__default.createElement(
                  'div',
                  { style: { overflowX: 'auto' } },
                  React__default.createElement(
                    'div',
                    { style: { display: 'flex' } },
                    this.state.combinations.map(function (combination, index, combinations) {
                      return React__default.createElement(
                        CombinationThumbnailContainer,
                        {
                          key: index,
                          active: _this4.state.activeCombinationIndex === index },
                        _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                          'div',
                          { style: { zIndex: 2, position: 'absolute', top: '.25rem', left: '.25rem' } },
                          React__default.createElement(
                            TemplateControlButton,
                            { onClick: function onClick() {
                                return _this4.handleRemoveCombinationClick(index);
                              } },
                            __('Remove combination')
                          ),
                          React__default.createElement(
                            ThronBrowserTriggerer,
                            {
                              singleSelection: true,
                              shouldOpenThronBrowser: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                              onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
                                return _this4.onCombinationThumbnailChange(index, assets[0]);
                              } },
                            React__default.createElement(
                              TemplateControlButton,
                              null,
                              __('Edit image')
                            )
                          )
                        ),
                        React__default.createElement(CombinationThumbnail, {
                          discovered: _this4.state.discovered[index],
                          active: _this4.state.activeCombinationIndex === index,
                          src: thronImage({ src: combination.thumbnail.value, options: combination.thumbnail.options }, remToPixels(9), remToPixels(9)),
                          onClick: function onClick() {
                            return _this4.onCombinationThumbnailClick(index, combination);
                          } })
                      );
                    })
                  )
                )
              ),
              React__default.createElement(
                FullscreenTooltipBoxContainer,
                { visible: this.state.isTooltipOverlayVisible, style: {
                    zIndex: 2
                  } },
                React__default.createElement(
                  TooltipBoxInner,
                  { style: { right: 0, width: 'auto' }, visible: this.state.isTooltipOverlayVisible },
                  React__default.createElement(CloseTooltipBoxButton, { onClick: function onClick() {
                      return _this4.setState({ isTooltipOverlayVisible: false });
                    } }),
                  this.state.displayMode === DISPLAY_MODE_EDIT && this.state.activeCombinationIndex === null && React__default.createElement(
                    'i',
                    { style: { color: '#aaa' } },
                    __('Click on a thumbnail to edit its associated image and text.')
                  ),
                  React__default.createElement(
                    'div',
                    { style: { width: '100%' } },
                    this.state.combinations.map(function (combination, index) {
                      return React__default.createElement(
                        'span',
                        { key: index, style: { display: _this4.state.activeCombinationIndex === index ? 'block' : 'none' } },
                        React__default.createElement(TextTranslatable, {
                          highlight: _this4.props.highlightWord,
                          onLanguageChange: _this4.props.onContentLanguageChange,
                          onContentUpdate: _this4.props.onContentUpdate,
                          displayMode: _this4.state.displayMode,
                          content: combination.text,
                          onBlur: function onBlur(value) {
                            return _this4.onCombinationTextBlur(index, value);
                          } })
                      );
                    })
                  )
                )
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          ref: function ref(_ref7) {
            return _this4.stickyContainerReference = _ref7;
          },
          displayMode: this.state.displayMode,
          height: calculateChapterHeight$1(this.state.combinations.length, this.state.screenHeight),
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          { style: { height: this.state.screenHeight }, onProgressChange: this.onExerciseScroll },
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                flexDirection: 'column',
                height: this.state.screenHeight
              } },
            React__default.createElement(
              ExerciseTutorialModal,
              { isVisible: this.state.isHelpModalVisible },
              React__default.createElement(
                'h3',
                null,
                trans(this.props.language, 'How it works?')
              ),
              React__default.createElement(
                'p',
                null,
                trans(this.props.language, 'Click on the images at the bottom to discover the combinations and tips.')
              ),
              React__default.createElement(
                'p',
                null,
                React__default.createElement('img', { style: { width: '10rem' }, src: this.props.theme.exerciseTutorialSources.exercise4, alt: '' })
              ),
              React__default.createElement(
                ExerciseTutorialButton,
                { dark: true, onClick: function onClick() {
                    return _this4.setState({ isHelpModalVisible: false });
                  } },
                trans(this.props.language, 'Ok got it')
              )
            ),
            React__default.createElement(ExerciseCompleted, {
              style: { zIndex: 3 },
              state: this.state.exerciseCompletedAnimationState,
              isVisible: this.state.exerciseCompleted,
              onClick: function onClick() {
                exerciseCompletedAnimationFactory(_this4.stickyContainerReference, calculateChapterHeight$1(_this4.state.combinations.length, _this4.state.screenHeight));
              } }),
            React__default.createElement(
              'div',
              { style: {
                  flexBasis: '25%',
                  padding: '4.5rem 3rem 0'
                } },
              React__default.createElement(
                TemplateControl,
                {
                  style: { zIndex: 2, position: 'absolute', top: '1rem', right: '4rem', display: 'flex' },
                  displayMode: this.state.displayMode },
                React__default.createElement(TemplateControlDefaultButtons, _extends$55({}, this.props, { handleDisplayModeSwitch: this.handleDisplayModeSwitch })),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleAddCombinationClick },
                  __('+Combination')
                ),
                React__default.createElement(
                  TemplateControlButton,
                  { onClick: this.handleSaveChapterClick },
                  __('Save')
                )
              ),
              React__default.createElement(ExerciseTutorialHelpIcon, {
                style: { color: '#000' },
                onClick: function onClick() {
                  return _this4.setState({ isHelpModalVisible: true });
                } }),
              React__default.createElement(
                PreTitle,
                { dark: true, style: {
                    position: 'absolute',
                    top: '1.5rem',
                    right: '40%',
                    left: '3rem'
                  } },
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.preTitle,
                  onBlur: this.onPreTitleBlur })
              ),
              React__default.createElement(
                Title,
                { style: { flexBasis: '35%' } },
                React__default.createElement(
                  TitleText,
                  { lightBackground: true, style: { marginBottom: 0 } },
                  React__default.createElement(TextTranslatable, {
                    plain: true,
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.title,
                    onBlur: this.onTitleBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: '2.75rem',
                    left: '23.75rem',
                    transform: 'translateX(-100%)'
                  } },
                React__default.createElement(BigChapterNumber, { color: 'rgba(67,67,67,0.15)', number: this.state.index + 1 })
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  zIndex: 1,
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0 5rem 10rem',
                  flexBasis: '75%'
                } },
              React__default.createElement('div', { style: {
                  position: 'absolute',
                  top: '3rem',
                  right: 0,
                  left: '2.5rem',
                  height: '22.25rem',
                  backgroundColor: '#878787'
                } }),
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: '2rem',
                    left: '27rem',
                    right: 0
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      left: 0
                    } },
                  React__default.createElement(TextTranslatable, {
                    highlight: this.props.highlightWord,
                    onLanguageChange: this.props.onContentLanguageChange,
                    onContentUpdate: this.props.onContentUpdate,
                    displayMode: this.state.displayMode,
                    content: this.state.text,
                    onBlur: this.onTextBlur })
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    bottom: '-2.5rem',
                    left: 0,
                    width: '15rem'
                  } },
                React__default.createElement(StepIndicator, {
                  total: this.state.combinations.length,
                  active: Object.keys(this.state.discovered).length - 1,
                  showPercentage: function showPercentage(percentage) {
                    return trans(_this4.props.language, 'Completed: :percentage%', { percentage: percentage });
                  },
                  step: false,
                  dark: true })
              ),
              React__default.createElement(
                'div',
                { style: {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    width: '26rem',
                    display: 'flex',
                    alignItems: 'center'
                  } },
                React__default.createElement(
                  'div',
                  { style: { zIndex: 1, width: '13rem', height: '25rem', display: 'flex', alignItems: 'center' } },
                  React__default.createElement(Media, {
                    style: { width: '100%' },
                    width: remToPixels(13),
                    height: remToPixels(25),
                    src: this.state.media.value,
                    options: this.state.media.options,
                    shadow: true,
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: this.onMediaChange })
                ),
                React__default.createElement(
                  'div',
                  { style: {
                      zIndex: 2,
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translateY(-50%) translateX(-50%)',
                      width: '3.5rem',
                      height: '3.5rem',
                      backgroundColor: '#464646',

                      display: this.state.activeCombinationIndex !== null ? 'flex' : 'none',
                      alignItems: 'center',
                      justifyContent: 'center'
                    } },
                  React__default.createElement(
                    'svg',
                    { viewBox: '0 0 26 25', style: { width: '1.3125rem', height: '1.25em' } },
                    React__default.createElement('path', {
                      d: 'M15.364 10.136H25.5v4.728H15.364V25h-4.728V14.864H.5v-4.728h10.136V0h4.728v10.136z',
                      fill: '#b7b7b7',
                      fillRule: 'evenodd'
                    })
                  )
                ),
                React__default.createElement(
                  'div',
                  { style: { zIndex: 1, width: '13rem', height: '25rem', display: 'flex', alignItems: 'center' } },
                  this.state.activeCombinationIndex !== null ? React__default.createElement(Media, {
                    key: this.state.activeCombinationIndex,
                    style: { width: '100%' },
                    width: remToPixels(13),
                    height: remToPixels(25),
                    src: getCombinationMediaAtIndex$1(this.state.combinations, this.state.activeCombinationIndex).value,
                    options: getCombinationMediaAtIndex$1(this.state.combinations, this.state.activeCombinationIndex).options,
                    shadow: true,
                    shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
                    onChange: function onChange(asset) {
                      return _this4.onCombinationMediaChange(_this4.state.activeCombinationIndex, asset);
                    } }) :
                  // @todo 2018-06-18 Render something, instead of nothing
                  null
                )
              ),
              React__default.createElement(
                'div',
                { style: {
                    position: 'relative',
                    margin: '0 5rem'
                  } },
                React__default.createElement(
                  'div',
                  { style: {
                      position: 'absolute',
                      left: '24.5rem',
                      top: '-9.5rem',
                      width: '27.5rem',
                      height: '17rem',
                      color: '#fff'
                    } },
                  React__default.createElement(
                    TooltipBoxBackgroundText,
                    { style: {
                        top: '.5rem',
                        alignItems: 'flex-start'
                      } },
                    __('The look')
                  ),
                  React__default.createElement(TooltipBoxDecoration, { style: { position: 'absolute', top: '-2rem', left: 0 } }),
                  React__default.createElement(
                    TooltipBoxInner,
                    { style: { right: 0, width: 'auto' }, visible: this.state.displayMode === DISPLAY_MODE_EDIT || this.state.activeCombinationIndex !== null },
                    this.state.displayMode === DISPLAY_MODE_EDIT && this.state.activeCombinationIndex === null && React__default.createElement(
                      'i',
                      { style: { color: '#aaa' } },
                      __('Click on a thumbnail to edit its associated image and text.')
                    ),
                    React__default.createElement(
                      'div',
                      { style: { width: '100%' } },
                      this.state.combinations.map(function (combination, index) {
                        return React__default.createElement(
                          'span',
                          { key: index, style: { display: _this4.state.activeCombinationIndex === index ? 'block' : 'none' } },
                          React__default.createElement(TextTranslatable, {
                            highlight: _this4.props.highlightWord,
                            onLanguageChange: _this4.props.onContentLanguageChange,
                            onContentUpdate: _this4.props.onContentUpdate,
                            displayMode: _this4.state.displayMode,
                            content: combination.text,
                            onBlur: function onBlur(value) {
                              return _this4.onCombinationTextBlur(index, value);
                            } })
                        );
                      })
                    )
                  )
                )
              )
            ),
            React__default.createElement(
              'div',
              { style: {
                  zIndex: 2,
                  overflow: 'hidden',
                  willChange: null,
                  position: 'absolute',
                  right: '2rem',
                  bottom: '0rem',
                  left: '28rem',
                  paddingTop: '2rem',
                  paddingBottom: '2rem'
                }, ref: function ref(_ref6) {
                  return _this4.thumbnailsContainerReference = _ref6;
                } },
              React__default.createElement(
                'div',
                { style: { display: 'flex', paddingRight: '5rem', paddingLeft: '1.5rem' }, ref: function ref(_ref5) {
                    return _this4.thumbnailsContainerInnerReference = _ref5;
                  } },
                this.state.combinations.map(function (combination, index) {
                  return React__default.createElement(
                    CombinationThumbnailContainer,
                    {
                      key: index,
                      active: _this4.state.activeCombinationIndex === index },
                    _this4.state.displayMode === DISPLAY_MODE_EDIT && React__default.createElement(
                      'div',
                      { style: { zIndex: 2, position: 'absolute', top: '.25rem', left: '.25rem' } },
                      React__default.createElement(
                        TemplateControlButton,
                        { onClick: function onClick() {
                            return _this4.handleRemoveCombinationClick(index);
                          } },
                        __('Remove combination')
                      ),
                      React__default.createElement(
                        ThronBrowserTriggerer,
                        {
                          singleSelection: true,
                          shouldOpenThronBrowser: _this4.state.displayMode === DISPLAY_MODE_EDIT,
                          onThronBrowserSelectionChange: function onThronBrowserSelectionChange(assets) {
                            return _this4.onCombinationThumbnailChange(index, assets[0]);
                          } },
                        React__default.createElement(
                          TemplateControlButton,
                          null,
                          __('Edit image')
                        )
                      )
                    ),
                    React__default.createElement(CombinationThumbnail, {
                      discovered: _this4.state.discovered[index],
                      active: _this4.state.activeCombinationIndex === index,
                      src: thronImage({ src: combination.thumbnail.value, options: combination.thumbnail.options }, remToPixels(10), remToPixels(11)),
                      onClick: function onClick() {
                        return _this4.onCombinationThumbnailClick(index, combination);
                      } })
                  );
                })
              )
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Exercise4;
}(React.Component);

function combinationBlueprint$2() {
  return _extends$55({}, {
    text: makeContent('text'),
    thumbnail: makeContent('thron-asset', 'http://via.placeholder.com/320x352'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/432x800')
  });
}

var blueprint$15 = function blueprint(templateName) {
  return {
    templateName: templateName,
    preTitle: makeContent('text'),
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/432x800'),
    combinations: [combinationBlueprint$2()]
  };
};

var Exercise4$1 = styled.withTheme(asTemplate('Exercise4', Exercise4, blueprint$15));

var _templateObject$29 = _taggedTemplateLiteral$29(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: ', ';\n  text-align: center;\n  background-color: #222;\n  color: #fff;\n\n  p {\n    font-size: ', ';\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: ', ';\n  text-align: center;\n  background-color: #222;\n  color: #fff;\n\n  p {\n    font-size: ', ';\n  }\n']);

function _taggedTemplateLiteral$29(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ThemeMarkAsCompleted = styled__default.div(_templateObject$29, themeResponsiveProperty('2rem 1rem', '4rem 2.5rem'), themeResponsiveProperty('1rem', null));

var _templateObject$30 = _taggedTemplateLiteral$30(['\n    display: inline-block;\n    padding: .25rem .5rem;\n    background-color: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    text-align: center;\n\n    ', ';\n\n    ', '\n\n    ', '\n\n    ', ';\n\n    ', '\n  '], ['\n    display: inline-block;\n    padding: .25rem .5rem;\n    background-color: ', ';\n    color: ', ';\n    text-transform: uppercase;\n    text-align: center;\n\n    ', ';\n\n    ', '\n\n    ', '\n\n    ', ';\n\n    ', '\n  ']),
    _templateObject2$17 = _taggedTemplateLiteral$30(['\n      opacity: .6;\n    '], ['\n      opacity: .6;\n    ']),
    _templateObject3$13 = _taggedTemplateLiteral$30(['\n      min-width: 8rem;\n      padding: .75rem 1.75rem;\n    '], ['\n      min-width: 8rem;\n      padding: .75rem 1.75rem;\n    ']),
    _templateObject4$8 = _taggedTemplateLiteral$30(['\n      min-width: 6rem;\n      padding: .5rem 1rem;\n    '], ['\n      min-width: 6rem;\n      padding: .5rem 1rem;\n    ']),
    _templateObject5$5 = _taggedTemplateLiteral$30(['\n      background-color: transparent;\n      color: #000;\n    '], ['\n      background-color: transparent;\n      color: #000;\n    ']),
    _templateObject6$4 = _taggedTemplateLiteral$30(['\n      background-color: ', ';\n      color: ', ';\n    '], ['\n      background-color: ', ';\n      color: ', ';\n    ']);

function _taggedTemplateLiteral$30(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$19(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function buttonStyle (_ref) {
  var size = _ref.size,
      link = _ref.link,
      color = _ref.color,
      disabled = _ref.disabled,
      props = _objectWithoutProperties$19(_ref, ['size', 'link', 'color', 'disabled']);

  return styled.css(_templateObject$30, function (props) {
    return props.theme.primaryBackgroundColor;
  }, function (props) {
    return props.theme.primaryColor;
  }, disabled && styled.css(_templateObject2$17), size === 'large' && styled.css(_templateObject3$13), size === 'medium' && styled.css(_templateObject4$8), link && styled.css(_templateObject5$5), color === 'secondary' && styled.css(_templateObject6$4, function (props) {
    return props.theme.secondaryBackgroundColor;
  }, function (props) {
    return props.theme.secondaryColor;
  }));
}

var _templateObject$31 = _taggedTemplateLiteral$31(['\n  ', ';\n'], ['\n  ', ';\n']);

function _taggedTemplateLiteral$31(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button$2 = styled__default.div(_templateObject$31, function (props) {
  return buttonStyle(props);
});

var _createClass$39 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$65(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$51(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$54(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExerciseConfirmButton = function (_React$PureComponent) {
  _inherits$54(ExerciseConfirmButton, _React$PureComponent);

  function ExerciseConfirmButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$65(this, ExerciseConfirmButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$51(this, (_ref = ExerciseConfirmButton.__proto__ || Object.getPrototypeOf(ExerciseConfirmButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      exerciseCompleted: false,
      loading: false
    }, _this.handleMarkAsCompleted = function () {
      _this.setState({ loading: true });

      _this.props.onExerciseComplete(_this.props.content._id).then(function () {
        _this.setState({
          exerciseCompleted: true,
          loading: false
        });
      }).catch(function (error) {
        console.error(error);
        _this.setState({ loading: false });
      });
    }, _this.handleDisplayModeSwitch = function () {
      _this.setState({
        exerciseCompleted: false
      });

      _this.props.handleDisplayModeSwitch();
    }, _temp), _possibleConstructorReturn$51(_this, _ret);
  }

  _createClass$39(ExerciseConfirmButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var height = this.state.exerciseCompleted ? 0 : themeResponsiveProperty(null, 300)(this.props);

      return React__default.createElement(
        StickyContainer$1,
        {
          height: height,
          displayMode: this.props.displayMode,
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          { style: { height: height } },
          React__default.createElement(
            TemplateControl,
            {
              style: {
                position: 'absolute',
                top: themeResponsiveProperty('.5rem', '1rem')(this.props),
                left: themeResponsiveProperty('.5rem', '1rem')(this.props)
              },
              displayMode: this.props.displayMode },
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.props.remove },
              'Remove'
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.props.moveUp },
              'Up'
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.props.moveDown },
              'Down'
            ),
            React__default.createElement(
              TemplateControlButton,
              { onClick: function onClick() {
                  _this2.setState({ exerciseCompleted: false });
                } },
              'Reset'
            )
          ),
          !this.state.exerciseCompleted && React__default.createElement(
            ThemeMarkAsCompleted,
            { style: { height: height } },
            React__default.createElement(
              'p',
              { style: { marginTop: 0, marginBottom: 0 } },
              trans(this.props.language, 'When you are done studying, mark this theme as completed by tapping the button below.')
            ),
            React__default.createElement(
              Button$2,
              {
                style: { marginTop: '2rem' },
                onClick: this.handleMarkAsCompleted,
                disabled: this.state.loading || this.state.exerciseCompleted,
                color: 'secondary',
                size: 'large' },
              trans(this.props.language, 'Mark as completed')
            )
          )
        )
      );
    }
  }]);

  return ExerciseConfirmButton;
}(React__default.PureComponent);

var blueprint$16 = function blueprint(templateName) {
  return {
    templateName: templateName
  };
};

var ExerciseConfirmButton$1 = styled.withTheme(asTemplate('ExerciseConfirmButton', ExerciseConfirmButton, blueprint$16));

var _createClass$40 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$66(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$52(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$55(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallProgressStore = function (_ReduceStore) {
  _inherits$55(OverallProgressStore, _ReduceStore);

  function OverallProgressStore() {
    _classCallCheck$66(this, OverallProgressStore);

    return _possibleConstructorReturn$52(this, (OverallProgressStore.__proto__ || Object.getPrototypeOf(OverallProgressStore)).call(this, Dispatcher$2));
  }

  _createClass$40(OverallProgressStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return null;
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case OverallProgressActionTypes.OVERALL_PROGRESS_SET_CURRENT_TEMPLATE:
          return action.index + 1;

        default:
          return state;
      }
    }
  }]);

  return OverallProgressStore;
}(ReduceStore);

var OverallProgressStore$1 = new OverallProgressStore();

var _createClass$41 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$32 = _taggedTemplateLiteral$32(['\n  z-index: 99;\n  position: fixed;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: ', 'rem;\n  height: ', 'px;\n  background-color: rgba(255,255,255,.7);\n'], ['\n  z-index: 99;\n  position: fixed;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: ', 'rem;\n  height: ', 'px;\n  background-color: rgba(255,255,255,.7);\n']),
    _templateObject2$18 = _taggedTemplateLiteral$32(['\n  padding: .25rem 0.375rem;\n  color: #7c7c7c;\n'], ['\n  padding: .25rem 0.375rem;\n  color: #7c7c7c;\n']),
    _templateObject3$14 = _taggedTemplateLiteral$32(['\n  flex: 1;\n  width: .125rem;\n  overflow: hidden;\n  position: relative;\n  transform: translateZ(0);\n  background-color: rgba(51,51,51,.25);\n'], ['\n  flex: 1;\n  width: .125rem;\n  overflow: hidden;\n  position: relative;\n  transform: translateZ(0);\n  background-color: rgba(51,51,51,.25);\n']),
    _templateObject4$9 = _taggedTemplateLiteral$32(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: .125rem;\n  background-color: rgba(51,51,51,1);\n\n  transition: transform 300ms linear;\n  will-change: transform;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: .125rem;\n  background-color: rgba(51,51,51,1);\n\n  transition: transform 300ms linear;\n  will-change: transform;\n']);

function _taggedTemplateLiteral$32(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$67(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$53(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$56(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function padWithZero(number) {
  return ('00' + (number === null ? 0 : number)).slice(-2);
}

var OverallProgress = function (_Component) {
  _inherits$56(OverallProgress, _Component);

  function OverallProgress() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$67(this, OverallProgress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$53(this, (_ref = OverallProgress.__proto__ || Object.getPrototypeOf(OverallProgress)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentChapter: OverallProgressStore$1.getState(),
      screenHeight: ScreenSizeStore$1.getHeight()
    }, _this.subscriptions = [], _temp), _possibleConstructorReturn$53(_this, _ret);
  }

  _createClass$41(OverallProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      OverallProgressActions.setCurrentTemplate(0);

      this.subscriptions.push(OverallProgressStore$1.addListener(function () {
        _this2.setState({ currentChapter: OverallProgressStore$1.getState() });
      }));

      this.subscriptions.push(ScreenSizeStore$1.addListener(function () {
        _this2.setState({
          screenHeight: ScreenSizeStore$1.getHeight()
        });
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        Container$8,
        {
          containerHeight: remToPixels(23),
          screenHeight: this.state.screenHeight },
        React__default.createElement(
          Number$2,
          null,
          padWithZero(this.state.currentChapter)
        ),
        React__default.createElement(
          BarContainer,
          null,
          React__default.createElement(Bar, { progress: this.state.currentChapter / this.props.chaptersLength - 1 })
        ),
        React__default.createElement(
          Number$2,
          null,
          padWithZero(this.props.chaptersLength)
        )
      );
    }
  }]);

  return OverallProgress;
}(React.Component);

var Container$8 = styled__default.div.attrs(function (props) {
  return {
    style: {
      top: props.screenHeight / 2 - props.containerHeight / 2 + 'px'
    }
  };
})(_templateObject$32, function (props) {
  return props.theme.isMobile ? 1.5 : props.theme.isTablet ? 2 : 0;
}, function (props) {
  return props.containerHeight;
});

var Number$2 = styled__default.div(_templateObject2$18);

var BarContainer = styled__default.div(_templateObject3$14);

var Bar = styled__default.div.attrs(function (props) {
  return {
    style: {
      transform: 'translate3d(0, ' + props.progress * 100 + '%, 0)'
    }
  };
})(_templateObject4$9);

var ScreenSizeActions = {
  update: function update(width, height) {
    Dispatcher$2.dispatch({
      actionType: ScreenSizeActionTypes.SCREEN_SIZE_UPDATE,
      width: width,
      height: height
    });
  }
};

var _extends$56 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$42 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$16(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$68(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$54(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$57(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function mapNumber(input, inputStart, inputEnd, outputStart, outputEnd) {
  return outputStart + (outputEnd - outputStart) / (inputEnd - inputStart) * (input - inputStart);
}

var Credits = function (_Component) {
  _inherits$57(Credits, _Component);

  function Credits() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$68(this, Credits);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$54(this, (_ref = Credits.__proto__ || Object.getPrototypeOf(Credits)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$56({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.overlayContainerReference = null, _this.titleTextContainerReference = null, _this.textScrollableCallback = function () {
      return null;
    }, _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.onMediaChange = function (asset) {
      _this.setState({ media: setContentValue(_this.state.media, asset.value, asset.options) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$16( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$56({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.next = 11;
              return save(ContentManager.make(_this.state.media, 'thron-asset'));

            case 11:
              _context.t3 = _context.sent;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                media: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$54(_this, _ret);
  }

  _createClass$42(Credits, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        media: chapter.media
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return this.props.theme.isMobile ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 3,
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          {
            onProgressChange: function onProgressChange(progress) {
              if (_this3.overlayContainerReference !== null) {
                _this3.overlayContainerReference.style.opacity = clamp(mapNumber(progress, 0, .1, 0, 1), 0, 1);
              }

              if (_this3.titleTextContainerReference !== null) {
                _this3.titleTextContainerReference.style.transform = 'translate3d(0, -' + clamp(mapNumber(progress, .1, .8, 0, 100), 0, 100) + '%, 0)';
              }

              if ([DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(_this3.state.displayMode) !== -1) {
                _this3.textScrollableCallback(progress);
              }
            },
            style: { height: this.state.screenHeight } },
          React__default.createElement(Media, {
            wrapperSytle: {
              height: this.state.screenHeight
            },
            style: {
              height: this.state.screenHeight,
              objectFit: 'cover'
            },
            src: this.state.media.value,
            options: this.state.media.options,
            shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
            onChange: this.onMediaChange }),
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', left: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { ref: function ref(_ref3) {
                return _this3.overlayContainerReference = _ref3;
              }, style: {
                zIndex: 2,
                display: 'flex',
                position: 'absolute',
                right: '0',
                bottom: '0',
                left: '0',
                opacity: 0,
                padding: '0 1rem',
                color: '#fff',
                background: 'linear-gradient(0deg, rgb(0 0 0 / 1) 4rem, rgb(0 0 0 / .4) 70%, rgb(0 0 0 / 0) 100%)'
              } },
            React__default.createElement(
              Scrollable,
              {
                innerPaddingTop: '10rem',
                innerPaddingBottom: '4rem',
                fade: true,
                onProgressCallback: function onProgressCallback(callback) {
                  return _this3.textScrollableCallback = callback;
                },
                style: {
                  pointerEvents: [DISPLAY_MODE_STATIC, DISPLAY_MODE_PREVIEW].indexOf(this.state.displayMode) !== -1 ? 'none' : null,
                  height: this.state.screenHeight
                }
              },
              React__default.createElement(
                'div',
                { style: {
                    display: 'flex'
                  } },
                React__default.createElement(
                  'div',
                  { style: { marginRight: '1rem' } },
                  React__default.createElement(BigChapterNumber, { color: 'rgba(51,51,51,0.46)', small: true, number: this.state.index + 1 })
                ),
                React__default.createElement(
                  Title,
                  { style: { flex: 1 } },
                  React__default.createElement(
                    TitleText,
                    null,
                    React__default.createElement(TextTranslatable, {
                      highlight: this.props.highlightWord,
                      onLanguageChange: this.props.onContentLanguageChange,
                      onContentUpdate: this.props.onContentUpdate,
                      displayMode: this.state.displayMode,
                      content: this.state.title,
                      onBlur: this.onTitleBlur })
                  )
                )
              ),
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            ),
            React__default.createElement(
              'div',
              { style: {
                  // minWidth: '1.375rem',
                  // marginLeft: '.5rem',
                  paddingBottom: '1rem',
                  paddingTop: '1rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                } },
              React__default.createElement('div', null),
              React__default.createElement(
                'div',
                { style: {
                    fontSize: 0,
                    textAlign: 'end'
                  } },
                React__default.createElement(ButtonList, {
                  displayMode: this.state.displayMode,
                  buttons: this.props.buttons,
                  content: this.state.text
                })
              )
            )
          )
        )
      ) : this.props.theme.isTablet ? React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          height: this.state.screenHeight * 3,
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          {
            disableHardwareAcceleration: true,
            onProgressChange: function onProgressChange(progress) {
              if (_this3.overlayContainerReference !== null) {
                _this3.overlayContainerReference.style.opacity = clamp(mapNumber(progress, .1, .8, 0, 1), 0, 1);
              }

              if (_this3.titleTextContainerReference !== null) {
                _this3.titleTextContainerReference.style.transform = 'translate3d(0, -' + clamp(mapNumber(progress, .1, .8, 0, 100), 0, 100) + '%, 0)';
              }
            },
            style: { height: this.state.screenHeight } },
          React__default.createElement(Media, {
            wrapperSytle: {
              height: this.state.screenHeight
            },
            style: {
              height: this.state.screenHeight,
              objectFit: 'cover'
            },
            src: this.state.media.value,
            options: this.state.media.options,
            shouldOpenThronBrowser: this.state.displayMode === DISPLAY_MODE_EDIT,
            onChange: this.onMediaChange }),
          React__default.createElement('div', { ref: function ref(_ref4) {
              return _this3.overlayContainerReference = _ref4;
            }, style: {
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              opacity: 0,
              backgroundColor: 'rgba(0,0,0,.85)',
              pointerEvents: 'none'
            } }),
          React__default.createElement(
            'div',
            { style: {
                pointerEvents: 'none',
                position: 'absolute',
                top: '7.5rem',
                right: '2.75rem'
              } },
            React__default.createElement(BigChapterNumber, { color: 'rgba(0,0,0,0.7)', number: this.state.index + 1 })
          ),
          React__default.createElement(
            TemplateControl,
            {
              style: { position: 'absolute', zIndex: 999, top: '1rem', left: '1rem', display: 'flex' },
              displayMode: this.state.displayMode },
            React__default.createElement(TemplateControlDefaultButtons, this.props),
            React__default.createElement(
              TemplateControlButton,
              { onClick: this.handleSaveChapterClick },
              __('Save')
            )
          ),
          React__default.createElement(
            'div',
            { style: { zIndex: 1, position: 'absolute', bottom: '4rem', right: '2rem', minWidth: '1rem', height: '2rem' } },
            React__default.createElement(ButtonList, {
              displayMode: this.state.displayMode,
              buttons: this.props.buttons,
              content: this.state.text })
          ),
          React__default.createElement(
            'div',
            { ref: function ref(_ref5) {
                return _this3.titleTextContainerReference = _ref5;
              }, style: {
                position: 'absolute',
                right: 0,
                left: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                transform: 'translate3d(0, 0%, 0)',
                height: this.state.screenHeight,
                color: '#fff',
                pointerEvents: 'none'
              } },
            React__default.createElement(
              Title,
              { style: { pointerEvents: 'initial' } },
              React__default.createElement(
                TitleText,
                { style: { width: '30rem' } },
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(
              'div',
              { style: { pointerEvents: 'initial', width: '30rem' } },
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            )
          )
        )
      ) : null;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return Credits;
}(React.Component);

var blueprint$17 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    media: makeContent('thron-asset', 'http://via.placeholder.com/700x500')
  };
};

var Credits$1 = styled.withTheme(asTemplate('Credits', Credits, blueprint$17));

var _extends$57 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$43 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator$17(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck$69(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$55(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$58(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleSubtitle = function (_Component) {
  _inherits$58(TitleSubtitle, _Component);

  function TitleSubtitle() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$69(this, TitleSubtitle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$55(this, (_ref = TitleSubtitle.__proto__ || Object.getPrototypeOf(TitleSubtitle)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$57({
      index: _this.props.index,
      screenHeight: _this.props.screenHeight,
      displayMode: _this.props.displayMode
    }, _this.getStateFromChapter(_this.props.content)), _this.onTitleBlur = function (value) {
      _this.setState({ title: setContentValue(_this.state.title, value) });
    }, _this.onTextBlur = function (value) {
      _this.setState({ text: setContentValue(_this.state.text, value) });
    }, _this.handleSaveChapterClick = _asyncToGenerator$17( /*#__PURE__*/regenerator.mark(function _callee() {
      var save, state;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              save = function save(content) {
                return _this.props.onContentUpdate(_extends$57({ chapter_id: _this.props.content._id }, content));
              };

              LoadingOverlayActions.show(__("Saving the chapter..."));

              _context.t0 = _this.props.templateName;
              _context.next = 5;
              return save(ContentManager.make(_this.state.title, 'text'));

            case 5:
              _context.t1 = _context.sent;
              _context.next = 8;
              return save(ContentManager.make(_this.state.text, 'text'));

            case 8:
              _context.t2 = _context.sent;
              _context.t3 = _this.state.fullScreen;
              state = {
                templateName: _context.t0,
                title: _context.t1,
                text: _context.t2,
                fullScreen: _context.t3
              };


              _this.props.onChapterUpdate(_this.props.content._id, state).then(function (chapter) {
                _this.setState(_this.getStateFromChapter(chapter), LoadingOverlayActions.hide);
              });

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn$55(_this, _ret);
  }

  _createClass$43(TitleSubtitle, [{
    key: 'getStateFromChapter',
    value: function getStateFromChapter(chapter) {
      return {
        title: chapter.title,
        text: chapter.text,
        fullScreen: chapter.fullScreen
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return React__default.createElement(
        StickyContainer$1,
        {
          displayMode: this.state.displayMode,
          onEnter: this.props.onEnter },
        React__default.createElement(
          StickyContent,
          { disableHardwareAcceleration: true },
          React__default.createElement(
            'div',
            null,
            React__default.createElement(
              'div',
              { style: {
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: this.state.fullScreen ? '6rem' : '1rem',
                  right: '2.75rem'
                } },
              React__default.createElement(BigChapterNumber, { color: 'rgba(0,0,0,0.7)', number: this.state.index + 1 })
            ),
            React__default.createElement(
              TemplateControl,
              {
                style: { position: 'absolute', zIndex: 999, top: '1rem', left: '1rem', display: 'flex' },
                displayMode: this.state.displayMode },
              React__default.createElement(TemplateControlDefaultButtons, this.props),
              React__default.createElement(
                TemplateControlButton,
                { onClick: this.handleSaveChapterClick },
                __('Save')
              ),
              React__default.createElement(
                TemplateControlButton,
                { onClick: function onClick() {
                    return _this3.setState(function (_ref3) {
                      var fullScreen = _ref3.fullScreen;
                      return { fullScreen: !fullScreen };
                    });
                  } },
                'Size: ',
                this.state.fullScreen ? 'Default' : 'Full screen'
              )
            ),
            React__default.createElement(
              'div',
              { style: { zIndex: 1, position: 'absolute', bottom: '4rem', right: '2rem', minWidth: '1rem', height: '2rem' } },
              React__default.createElement(ButtonList, {
                displayMode: this.state.displayMode,
                buttons: this.props.buttons,
                content: this.state.text })
            )
          ),
          React__default.createElement(
            'div',
            { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: this.state.fullScreen ? this.state.screenHeight : null,
                padding: '6rem 4rem',
                color: '#fff',
                backgroundColor: '#444'
              } },
            React__default.createElement(
              Title,
              null,
              React__default.createElement(
                TitleText,
                { style: { minWidth: '5rem', maxWidth: '30rem' } },
                React__default.createElement(TextTranslatable, {
                  plain: true,
                  highlight: this.props.highlightWord,
                  onLanguageChange: this.props.onContentLanguageChange,
                  onContentUpdate: this.props.onContentUpdate,
                  displayMode: this.state.displayMode,
                  content: this.state.title,
                  onBlur: this.onTitleBlur })
              )
            ),
            React__default.createElement(
              'div',
              { style: { minWidth: '5rem', maxWidth: '30rem' } },
              React__default.createElement(TextTranslatable, {
                highlight: this.props.highlightWord,
                onLanguageChange: this.props.onContentLanguageChange,
                onContentUpdate: this.props.onContentUpdate,
                displayMode: this.state.displayMode,
                content: this.state.text,
                onBlur: this.onTextBlur })
            )
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      return {
        index: nextProps.index,
        screenHeight: nextProps.screenHeight,
        displayMode: nextProps.displayMode
      };
    }
  }]);

  return TitleSubtitle;
}(React.Component);

var blueprint$18 = function blueprint(templateName) {
  return {
    templateName: templateName,
    title: makeContent('text'),
    text: makeContent('text'),
    fullScreen: false
  };
};

var TitleSubtitle$1 = asTemplate('TitleSubtitle', TitleSubtitle, blueprint$18);

var _createClass$44 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$70(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$56(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$59(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MediaZoomStore = function (_ReduceStore) {
  _inherits$59(MediaZoomStore, _ReduceStore);

  function MediaZoomStore() {
    _classCallCheck$70(this, MediaZoomStore);

    return _possibleConstructorReturn$56(this, (MediaZoomStore.__proto__ || Object.getPrototypeOf(MediaZoomStore)).call(this, Dispatcher$2));
  }

  _createClass$44(MediaZoomStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        source: null,
        options: {}
      };
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case MediaZoomActionTypes.MEDIA_ZOOM_REQUEST_ZOOM:
          return action.payload;

        default:
          return state;
      }
    }
  }]);

  return MediaZoomStore;
}(ReduceStore);

var MediaZoomStore$1 = new MediaZoomStore();

var _this6 = undefined;

var _extends$58 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$45 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$33 = _taggedTemplateLiteral$33(['\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n'], ['\n  width: 100%;\n  margin: 0 auto;\n  padding: 0;\n']);

function _taggedTemplateLiteral$33(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator$18(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray$3(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck$71(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$57(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$60(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function sort(array) {
  return array.slice().sort(function (a, b) {
    if (a._order < b._order) {
      return -1;
    }

    if (a._order > b._order) {
      return 1;
    }

    return 0;
  });
}

function templateFactory(templateName) {
  switch (templateName) {
    case 'Intro':
      return Intro$1;
    case 'StreetCulture':
      return StreetCulture$1;
    case 'AdvertisingCampaign':
      return AdvertisingCampaign$1;
    case 'Items':
      return Items$1;
    case 'PopUpProject':
      return PopUpProject$1;
    case 'HowToSell':
      return HowToSell$1;
    case 'Hashtag':
      return Hashtag$1;
    case 'Highlights':
      return Highlights$1;
    case 'Credits':
      return Credits$1;
    case 'TitleSubtitle':
      return TitleSubtitle$1;

    case 'MoodboardIntro':
      return MoodboardIntro$1;
    case 'MoodboardDetails':
      return MoodboardDetails$1;
    case 'MoodboardRunway':
      return MoodboardRunway$1;
    case 'MoodboardLookbook':
      return MoodboardLookbook$1;

    case 'Memory':
      return Memory$1;
    case 'SlotMachine':
      return SlotMachine$1;
    case 'Exercise3':
      return Exercise3$1;
    case 'Exercise4':
      return Exercise4$1;
    case 'ExerciseConfirmButton':
      return ExerciseConfirmButton$1;

    default:
      throw new Error('Invalid template [' + templateName + '].');
  }
}

function shouldDisplayTemplateSelector(displayMode) {
  return displayMode === DISPLAY_MODE_EDIT || displayMode === DISPLAY_MODE_PREVIEW;
}

var defaultTheme = {
  accentColor: '#545454',
  accentColorBright: '#f400a1',
  primaryBackgroundColor: '#000',
  primaryColor: '#fff',
  secondaryBackgroundColor: '#505050',
  secondaryColor: '#fff',
  isMobile: true,
  isTablet: false
};

var ThemeBuilder = function (_Component) {
  _inherits$60(ThemeBuilder, _Component);

  function ThemeBuilder() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck$71(this, ThemeBuilder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$57(this, (_ref = ThemeBuilder.__proto__ || Object.getPrototypeOf(ThemeBuilder)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      chapters: sort(_this.props.chapters)
    }, _this.containerReference = null, _this.subscriptions = [], _this.onAddNewChapterClick = function (instance) {
      var state = instance.blueprint();

      LoadingOverlayActions.show(__("Adding a new chapter..."));

      var order = _this.state.chapters.length === 0 ? 1 : Math.max.apply(Math, _toConsumableArray$3(_this.state.chapters.map(function (chapter) {
        return chapter._order;
      }))) + 1;

      _this.props.onChapterCreation(state, order).then(function (chapter) {
        _this.setState({ chapters: _this.state.chapters.concat([chapter]) }, LoadingOverlayActions.hide);
      }).catch(console.error);
    }, _this.onRemoveChapterClick = function () {
      var _ref2 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee(chapterId) {
        var confirmed;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                confirmed = window.confirm('Removing a chapter cannot be undone.\n\nDo you want to permanently remove this chapter?');

                if (!(confirmed === false)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                LoadingOverlayActions.show(__("Removing the chapter..."));

                _this.props.onChapterDeletion(chapterId).then(function (chapters) {
                  _this.setState({ chapters: chapters }, LoadingOverlayActions.hide);
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn$57(_this, _ret);
  }

  _createClass$45(ThemeBuilder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.subscriptions.push(MediaZoomStore$1.addListener(function () {
        var _MediaZoomStore$getSt = MediaZoomStore$1.getState(),
            source = _MediaZoomStore$getSt.source,
            options = _MediaZoomStore$getSt.options;

        _this3.props.onMediaZoomRequest(source, options);
      }));

      this.subscriptions.push(OverallProgressStore$1.addListener(function () {
        var index = OverallProgressStore$1.getState();
        _this3.props.onChapterEnter(index);
      }));

      this.theme = _extends$58({}, this.props.theme, this.props.partialTheme);

      window.addEventListener('resize', this.handleWindowResize, false);
      window.addEventListener('load', this.handleWindowResize, false);

      this.handleWindowResize();

      // Initialize the Language Switcher (updating all the <Text /> inputs) only
      // in translation-mode and static-mode
      if (this.props.displayMode === DISPLAY_MODE_TRANSLATE || this.props.displayMode === DISPLAY_MODE_STATIC) {
        LanguageSwitcherActions.initialise(this.props.languages, this.props.defaultLanguage);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });

      window.removeEventListener('resize', this.handleWindowResize, false);
      window.removeEventListener('load', this.handleWindowResize, false);
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      requestAnimationFrame(function () {
        ScreenSizeActions.update(window.innerWidth, window.innerHeight);
      });
    }
  }, {
    key: 'handleChapterSort',
    value: function handleChapterSort(index, amount) {
      var _this4 = this;

      var chapters = this.state.chapters.slice();
      var maxIndex = chapters.length - 1;

      var newIndex = clamp(index + amount, 0, maxIndex);

      // The chapter is already either first or last
      if (index === newIndex) {
        return;
      }

      var newOrder = chapters[newIndex]._order;

      chapters[newIndex]._order = chapters[index]._order;
      chapters[index]._order = newOrder;

      LoadingOverlayActions.show(__("Updating the chapters order..."));

      var orderMap = sort(chapters).map(function (chapter, index) {
        return { id: chapter._id, sort: index + 1 };
      });

      this.props.onChapterOrderChange(orderMap).then(function (chapters) {
        _this4.setState({ chapters: sort(chapters) }, LoadingOverlayActions.hide);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return React__default.createElement(
        styled.ThemeProvider,
        { theme: _extends$58({}, this.props.theme, this.props.partialTheme) },
        React__default.createElement(
          Container$9,
          { className: 'theme-builder', ref: function ref(_ref3) {
              return _this5.containerReference = _ref3;
            } },
          React__default.createElement(LoadingOverlay, null),
          React__default.createElement(ThronBrowserModal, null),
          React__default.createElement(TranslationModal, null),
          _reactDom.createPortal(React__default.createElement(OverallProgress, { chaptersLength: this.state.chapters.length }), window.document.body),
          this.props.displayMode === DISPLAY_MODE_TRANSLATE && React__default.createElement(LanguageSwitcher, null),
          this.state.chapters.map(function (content, index) {
            // @todo 2020-03-10 remove before deploy
            var Template = void 0;

            try {
              Template = templateFactory(content.templateName);
            } catch (error) {
              console.error(error);
              return null;
            }

            return React__default.createElement(Template, {
              key: content._id,
              containerReference: _this5.containerReference,
              index: index,
              displayMode: _this5.props.displayMode,
              content: content,
              buttons: _this5.props.chapterButtons,
              language: _this5.props.defaultLanguage,
              highlightWord: _this5.props.highlightWord,
              remove: function remove() {
                return _this5.onRemoveChapterClick(content._id);
              },
              moveUp: function moveUp() {
                return _this5.handleChapterSort(index, -1);
              },
              moveDown: function moveDown() {
                return _this5.handleChapterSort(index, +1);
              },
              onChapterUpdate: _this5.props.onChapterUpdate,
              onContentUpdate: _this5.props.onContentUpdate,
              onContentLanguageChange: _this5.props.onContentLanguageChange,
              canTranslateAsset: _this5.props.canTranslateAsset,
              onExerciseComplete: _this5.props.onExerciseComplete
            });
          }),
          shouldDisplayTemplateSelector(this.props.displayMode) && React__default.createElement(
            'div',
            { style: { padding: '5rem', backgroundColor: '#ccc' } },
            React__default.createElement(
              'div',
              null,
              [Intro$1, StreetCulture$1, Items$1, HowToSell$1, AdvertisingCampaign$1, PopUpProject$1, Hashtag$1, Highlights$1, Credits$1 /*, TitleSubtitle*/].map(function (instance) {
                return React__default.createElement(
                  'div',
                  {
                    key: instance.TEMPLATE_NAME,
                    onClick: function onClick() {
                      return _this5.onAddNewChapterClick(instance);
                    },
                    style: { display: 'inline-block', color: '#fff', backgroundColor: '#333', margin: '.25rem', padding: '0.4rem 0.6rem', cursor: 'pointer' } },
                  __(instance.TEMPLATE_NAME)
                );
              })
            ),
            React__default.createElement(
              'div',
              null,
              [MoodboardIntro$1, MoodboardDetails$1, MoodboardRunway$1, MoodboardLookbook$1].map(function (instance) {
                return React__default.createElement(
                  'div',
                  {
                    key: instance.TEMPLATE_NAME,
                    onClick: function onClick() {
                      return _this5.onAddNewChapterClick(instance);
                    },
                    style: { display: 'inline-block', color: '#fff', backgroundColor: '#333', margin: '.25rem', padding: '0.4rem 0.6rem', cursor: 'pointer' } },
                  __(instance.TEMPLATE_NAME)
                );
              })
            ),
            React__default.createElement(
              'div',
              null,
              [Memory$1, SlotMachine$1, Exercise3$1, Exercise4$1, ExerciseConfirmButton$1].map(function (instance) {
                return React__default.createElement(
                  'div',
                  {
                    key: instance.TEMPLATE_NAME,
                    onClick: function onClick() {
                      return _this5.onAddNewChapterClick(instance);
                    },
                    style: { display: 'inline-block', color: '#fff', backgroundColor: '#333', margin: '.25rem', padding: '0.4rem 0.6rem', cursor: 'pointer' } },
                  __(instance.TEMPLATE_NAME)
                );
              })
            )
          )
        )
      );
    }
  }]);

  return ThemeBuilder;
}(React.Component);

ThemeBuilder.defaultProps = {
  theme: defaultTheme,
  partialTheme: {},
  displayMode: DISPLAY_MODE_PREVIEW,
  highlightWord: undefined,
  defaultLanguage: null,
  languages: [],
  chapters: [],
  chapterButtons: [],
  onChapterCreation: function () {
    var _ref4 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee2(state, order) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', null);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this6);
    }));

    function onChapterCreation(_x2, _x3) {
      return _ref4.apply(this, arguments);
    }

    return onChapterCreation;
  }(),
  onChapterUpdate: function () {
    var _ref5 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee3(id, state) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', null);

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }));

    function onChapterUpdate(_x4, _x5) {
      return _ref5.apply(this, arguments);
    }

    return onChapterUpdate;
  }(),
  onChapterOrderChange: function () {
    var _ref6 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee4(orderMap) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', null);

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this6);
    }));

    function onChapterOrderChange(_x6) {
      return _ref6.apply(this, arguments);
    }

    return onChapterOrderChange;
  }(),
  onChapterDeletion: function () {
    var _ref7 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee5(id) {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', null);

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }));

    function onChapterDeletion(_x7) {
      return _ref7.apply(this, arguments);
    }

    return onChapterDeletion;
  }(),
  onContentUpdate: function () {
    var _ref8 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee6(content) {
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', null);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }));

    function onContentUpdate(_x8) {
      return _ref8.apply(this, arguments);
    }

    return onContentUpdate;
  }(),
  onContentLanguageChange: function () {
    var _ref9 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee7(id, language) {
      return regenerator.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', null);

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this6);
    }));

    function onContentLanguageChange(_x9, _x10) {
      return _ref9.apply(this, arguments);
    }

    return onContentLanguageChange;
  }(),
  canTranslateAsset: false,
  onExerciseComplete: function () {
    var _ref10 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee8(id) {
      return regenerator.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', null);

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this6);
    }));

    function onExerciseComplete(_x11) {
      return _ref10.apply(this, arguments);
    }

    return onExerciseComplete;
  }(),
  onMediaZoomRequest: function onMediaZoomRequest(source, options) {
    return null;
  },
  onChapterEnter: function () {
    var _ref11 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee9(index) {
      return regenerator.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', null);

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this6);
    }));

    function onChapterEnter(_x12) {
      return _ref11.apply(this, arguments);
    }

    return onChapterEnter;
  }(),
  onGlossaryTermShow: function () {
    var _ref12 = _asyncToGenerator$18( /*#__PURE__*/regenerator.mark(function _callee10(glossaryId) {
      return regenerator.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', null);

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this6);
    }));

    function onGlossaryTermShow(_x13) {
      return _ref12.apply(this, arguments);
    }

    return onGlossaryTermShow;
  }()
};

var Container$9 = styled__default.div(_templateObject$33);

var Dispatcher$3 = new Dispatcher$1();

var GlossaryModalActionTypes = {
  GLOSSARY_MODAL_OPEN: 'GLOSSARY_MODAL_OPEN',
  GLOSSARY_MODAL_CLOSE: 'GLOSSARY_MODAL_CLOSE'
};

var GlossaryModalActions = {
  open: function open(chapter, contentId, displayMode, onChapterListRequest, onChapterSyncRequest, awsCredentials) {
    Dispatcher$3.dispatch({
      actionType: GlossaryModalActionTypes.GLOSSARY_MODAL_OPEN,
      chapter: chapter,
      contentId: contentId,
      displayMode: displayMode,
      onChapterListRequest: onChapterListRequest,
      onChapterSyncRequest: onChapterSyncRequest,
      awsCredentials: awsCredentials
    });
  },
  close: function close() {
    Dispatcher$3.dispatch({
      actionType: GlossaryModalActionTypes.GLOSSARY_MODAL_CLOSE
    });
  }
};

var _extends$59 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$46 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$34 = _taggedTemplateLiteral$34(['\n  margin: .125rem;\n  padding: .25rem .25rem;\n  cursor: pointer;\n\n  background-color: #ddd;\n  color: #000;\n  border: 1px solid #d4d4d4;\n\n  font-size: .625rem;\n\tbox-shadow: 1px 1px 4px rgba(0,0,0,.2);\n'], ['\n  margin: .125rem;\n  padding: .25rem .25rem;\n  cursor: pointer;\n\n  background-color: #ddd;\n  color: #000;\n  border: 1px solid #d4d4d4;\n\n  font-size: .625rem;\n\tbox-shadow: 1px 1px 4px rgba(0,0,0,.2);\n']),
    _templateObject2$19 = _taggedTemplateLiteral$34(['\n  width: 2.75rem;\n  height: 2.75rem;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  color: ', ';\n'], ['\n  width: 2.75rem;\n  height: 2.75rem;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  color: ', ';\n']),
    _templateObject3$15 = _taggedTemplateLiteral$34(['\n  width: 1.375rem;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  color: ', ';\n'], ['\n  width: 1.375rem;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  color: ', ';\n']),
    _templateObject4$10 = _taggedTemplateLiteral$34(['\n  0% { color: rgba(255,12,0,0.4); }\n  50% { color: rgb(255,255,255,.4); }\n  100% { color: rgb(255,12,0,.4); }\n'], ['\n  0% { color: rgba(255,12,0,0.4); }\n  50% { color: rgb(255,255,255,.4); }\n  100% { color: rgb(255,12,0,.4); }\n']),
    _templateObject5$6 = _taggedTemplateLiteral$34(['\n  // Same as StickyContainer container pulse effect\n  animation: ', ' 3s linear infinite;\n'], ['\n  // Same as StickyContainer container pulse effect\n  animation: ', ' 3s linear infinite;\n']);

function _objectWithoutProperties$20(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral$34(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$72(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$58(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$61(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HIGHLIGHTS_TEMPLATE_NAME = 'Highlights';

var GlossaryButton = function (_Component) {
  _inherits$61(GlossaryButton, _Component);

  function GlossaryButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$72(this, GlossaryButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$58(this, (_ref = GlossaryButton.__proto__ || Object.getPrototypeOf(GlossaryButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      glossaryCount: 0
    }, _this.onChapterSyncRequest = function (chapter, contentId, terms) {
      _this.setState({ glossaryCount: terms.length });
      _this.props.onChapterSyncRequest(chapter, contentId, terms);
    }, _this.onButtonClick = function () {
      GlossaryModalActions.open(_this.props.chapter, _this.props.contentId, _this.props.displayMode, _this.props.onChapterListRequest, _this.onChapterSyncRequest, _this.props.awsCredentials);
    }, _temp), _possibleConstructorReturn$58(_this, _ret);
  }
  // noinspection JSUnresolvedVariable


  _createClass$46(GlossaryButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.onChapterListRequest(this.props.chapter, this.props.contentId).then(function (terms) {
        _this2.setState({ glossaryCount: terms.filter(function (term) {
            return term.selected;
          }).length });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.displayMode === DISPLAY_MODE_EDIT) {
        return themeResponsiveProperty(React__default.createElement(GlossaryIconPulse, {
          onClick: this.onButtonClick,
          style: {
            marginLeft: '.5rem',
            color: '#ff0c00'
          }
        }), React__default.createElement(
          Button$3,
          { onClick: this.onButtonClick },
          'Glossary (',
          this.state.glossaryCount,
          ')'
        ))(this.props);
      }

      if (this.state.glossaryCount > 0) {
        return themeResponsiveProperty(React__default.createElement(GlossaryIcon2, {
          onClick: this.onButtonClick,
          style: {
            marginTop: this.props.chapter.templateName === HIGHLIGHTS_TEMPLATE_NAME ? 0 : '1rem',
            marginLeft: '.5rem'
          }
        }), React__default.createElement(GlossaryIcon, { onClick: this.onButtonClick, templateName: this.props.chapter.templateName }))(this.props);
      }

      return null;
    }
  }]);

  return GlossaryButton;
}(React.Component);

var GlossaryButton$1 = styled.withTheme(GlossaryButton);

var Button$3 = styled__default.div(_templateObject$34);

var Icon$3 = function Icon(props) {
  return React__default.createElement(
    'svg',
    _extends$59({ viewBox: '0 0 19 28' }, props),
    React__default.createElement(
      'g',
      { fillRule: 'nonzero', fill: 'none' },
      React__default.createElement('path', { d: 'M17.11 1.97a2.16 2.16 0 0 0-1.7-.941H3.51a2.16 2.16 0 0 0-1.7.942c-.445.62-.68 1.37-.668 2.137v2.704c-.001.18.122.334.294.37h3.757v19.206a.376.376 0 0 0 .229.353c.14.06.301.024.406-.088l5.667-5.922 5.666 5.922c.07.074.166.116.267.116.046.01.095.01.141 0a.376.376 0 0 0 .233-.347V4.108a3.57 3.57 0 0 0-.692-2.137zM5.16 6.438H1.843V4.126c0-.194.017-.387.051-.578.07-.398.229-.774.465-1.098a1.337 1.337 0 0 1 1.133-.634c.46 0 .887.239 1.134.634.346.489.527 1.079.515 1.682l.017 2.305z', stroke: 'currentColor', strokeWidth: .578, fill: 'currentColor' }),
      React__default.createElement('path', { d: 'M13.506 14.867a2.563 2.563 0 0 1-1.836.848 2.558 2.558 0 0 1-1.875-.756c-.663-.67-.675-1.311-.675-2.981s0-2.311.675-2.999a2.53 2.53 0 0 1 1.813-.757c1.241-.026 2.304.901 2.47 2.155h-.566a1.982 1.982 0 0 0-1.326-1.561 1.928 1.928 0 0 0-1.972.475c-.521.532-.567 1.098-.567 2.687 0 1.589.04 2.155.567 2.686.363.373.857.58 1.371.578a1.929 1.929 0 0 0 1.508-.716c.318-.416.473-.936.436-1.462v-.67h-1.927v-.497h2.494v1.202a2.44 2.44 0 0 1-.59 1.768z', fill: '#fff' })
    )
  );
};

var Element$1 = styled__default(Icon$3)(_templateObject2$19, function (props) {
  return props.theme.accentColorBright;
});

var GlossaryIcon = function GlossaryIcon(_ref2) {
  var templateName = _ref2.templateName,
      props = _objectWithoutProperties$20(_ref2, ['templateName']);

  return React__default.createElement(Element$1, _extends$59({}, props, {
    style: _extends$59({}, props.style, { marginTop: templateName === HIGHLIGHTS_TEMPLATE_NAME ? 0 : '1.25rem' }) }));
};

var Icon2 = function Icon2(props) {
  return React__default.createElement(
    'svg',
    _extends$59({
      viewBox: '0 0 22 31'
    }, props, {
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    React__default.createElement('path', {
      d: 'M0 30.857l11-6.563 11 6.563V3.669C22 2.146 20.74.857 19.25.857H2.75C1.203.857 0 2.146 0 3.669v27.188z',
      fill: 'currentColor'
    })
  );
};

var GlossaryIcon2 = styled__default(Icon2)(_templateObject3$15, function (props) {
  return props.theme.accentColorBright;
});

var colorPulse = styled.keyframes(_templateObject4$10);

var GlossaryIconPulse = styled__default(GlossaryIcon2)(_templateObject5$6, colorPulse);

var _extends$60 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$47 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$73(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$59(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$62(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlossaryModalStore = function (_ReduceStore) {
  _inherits$62(GlossaryModalStore, _ReduceStore);

  function GlossaryModalStore() {
    _classCallCheck$73(this, GlossaryModalStore);

    return _possibleConstructorReturn$59(this, (GlossaryModalStore.__proto__ || Object.getPrototypeOf(GlossaryModalStore)).call(this, Dispatcher$3));
  }

  _createClass$47(GlossaryModalStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isVisible: false,
        chapter: null,
        contentId: null,
        displayMode: null,
        onChapterListRequest: function onChapterListRequest() {
          return Promise.resolve(null);
        },
        onChapterSyncRequest: function onChapterSyncRequest() {
          return Promise.resolve(null);
        },
        awsCredentials: [null, null]
      };
    }
  }, {
    key: 'reduce',
    value: function reduce(state, action) {
      switch (action.actionType) {
        case GlossaryModalActionTypes.GLOSSARY_MODAL_OPEN:
          return {
            isVisible: true,
            chapter: action.chapter,
            contentId: action.contentId,
            displayMode: action.displayMode,
            onChapterListRequest: action.onChapterListRequest,
            onChapterSyncRequest: action.onChapterSyncRequest,
            awsCredentials: action.awsCredentials
          };

        case GlossaryModalActionTypes.GLOSSARY_MODAL_CLOSE:
          return _extends$60({}, this.getInitialState());

        default:
          return state;
      }
    }
  }]);

  return GlossaryModalStore;
}(ReduceStore);

var GlossaryModalStore$1 = new GlossaryModalStore();

var _templateObject$35 = _taggedTemplateLiteral$35(['\n  display: flex;\n  flex-direction: ', ';\n  align-items: flex-end;\n  justify-content: space-between;\n  border-bottom: .125rem solid #e1e1e1;\n\n\tmargin-top: 1rem;\n  padding: 1rem 1.5rem;\n  color: #000;\n\n  background-color: ', ';\n  border-left: ', ' solid #888;\n\n  cursor: ', ';\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  &,\n  > * {\n    box-sizing: border-box;\n  }\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  align-items: flex-end;\n  justify-content: space-between;\n  border-bottom: .125rem solid #e1e1e1;\n\n\tmargin-top: 1rem;\n  padding: 1rem 1.5rem;\n  color: #000;\n\n  background-color: ', ';\n  border-left: ', ' solid #888;\n\n  cursor: ', ';\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  &,\n  > * {\n    box-sizing: border-box;\n  }\n']);

function _taggedTemplateLiteral$35(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Term = styled__default.div(_templateObject$35, themeResponsiveProperty('column', null), function (props) {
  return props.selected && props.shouldShowSelectedState ? '#ddd' : null;
}, function (props) {
  return props.selected && props.shouldShowSelectedState ? '6px' : '0';
}, function (props) {
  return props.shouldShowSelectedState ? 'pointer' : null;
});

var _slicedToArray$2 = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function useOnScreen(ref) {
  var onShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var onHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var rootMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '0px';

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$2(_useState, 2),
      isIntersecting = _useState2[0],
      setIntersecting = _useState2[1];

  var observer = React.useMemo(function () {
    return new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray$2(_ref, 1),
          entry = _ref2[0];

      if (entry.isIntersecting === true) {
        onShow();
      } else {
        onHide();
      }
      setIntersecting(entry.isIntersecting);
    }, {
      rootMargin: rootMargin + " 0px 0px 0px"
    });
  }, [ref, onShow]);

  React.useEffect(function () {
    observer.observe(ref.current);
    return function () {
      return observer.disconnect();
    };
  }, []);

  return [isIntersecting];
}

function IntersectCallbackObject(_ref) {
  var _ref$onShow = _ref.onShow,
      onShow = _ref$onShow === undefined ? function () {} : _ref$onShow,
      _ref$onHide = _ref.onHide,
      onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
      _ref$rootMargin = _ref.rootMargin,
      rootMargin = _ref$rootMargin === undefined ? '0px' : _ref$rootMargin,
      children = _ref.children;

  var ref = React.useRef();
  useOnScreen(ref, onShow, onHide, rootMargin);

  return React__default.createElement(
    "div",
    { ref: ref },
    children
  );
}

var _templateObject$36 = _taggedTemplateLiteral$36(['\n  // @todo 2020-03-10\n  //  Should be about 60% but is also used in the Theme Builder Glossary Modal\n  //  and 60% is too much.\n  flex: 0 0 40%;\n  padding-right: ', ';\n  //font-size: .875rem;\n\n  h4 {\n    margin: 0;\n    padding: 0;\n    font-weight: bold;\n    text-transform: uppercase;\n  }\n\n  p {\n    color: #3e3e3e;\n    white-space: pre-wrap;\n\t\t//font-size: .75rem;\n    //line-height: 1rem;\n  }\n'], ['\n  // @todo 2020-03-10\n  //  Should be about 60% but is also used in the Theme Builder Glossary Modal\n  //  and 60% is too much.\n  flex: 0 0 40%;\n  padding-right: ', ';\n  //font-size: .875rem;\n\n  h4 {\n    margin: 0;\n    padding: 0;\n    font-weight: bold;\n    text-transform: uppercase;\n  }\n\n  p {\n    color: #3e3e3e;\n    white-space: pre-wrap;\n\t\t//font-size: .75rem;\n    //line-height: 1rem;\n  }\n']);

function _taggedTemplateLiteral$36(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$21(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TermInfo(_ref) {
  var _ref$onShow = _ref.onShow,
      onShow = _ref$onShow === undefined ? function () {} : _ref$onShow,
      _ref$onHide = _ref.onHide,
      onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
      props = _objectWithoutProperties$21(_ref, ['onShow', 'onHide']);

  return React__default.createElement(
    IntersectCallbackObject,
    {
      onShow: onShow,
      onHide: onHide,
      rootMargin: '-100px'
    },
    React__default.createElement(StyledTermInfo, props)
  );
}

var StyledTermInfo = styled__default.div(_templateObject$36, themeResponsiveProperty(null, '2rem'));

var AWS = require('aws-sdk');

function synthesizeSpeech(credentials, text, voiceId, languageCode, callback) {
  if (credentials === null) {
    return;
  }

  var awsCredentials = new AWS.Credentials({
    accessKeyId: credentials.AccessKeyId,
    secretAccessKey: credentials.SecretAccessKey,
    sessionToken: credentials.SessionToken
  });

  var polly = new AWS.Polly({
    credentials: awsCredentials,
    region: 'eu-west-1',
    apiVersion: '2016-06-10'
  });

  var params = {
    Engine: 'neural', /* required */
    LanguageCode: languageCode,
    OutputFormat: 'mp3', /* required */
    SampleRate: '22050',
    Text: text, /* required */
    TextType: 'text',
    VoiceId: voiceId /* required */
  };

  polly.synthesizeSpeech(params, function (error, data) {
    if (error) {
      console.error(error, error.stack); // an error occurred
      return;
    }

    var url = URL.createObjectURL(new Blob([data.AudioStream], { type: data.ContentType }));

    callback(url);
  });
}

var _templateObject$37 = _taggedTemplateLiteral$37(['\n  display: inline-block;\n  margin-left: .5rem;\n  padding: .25rem .5rem;\n  background-color: #cc1616;\n  color: #fff;\n  font-size: .625rem;\n  text-transform: uppercase;\n  \n  &:after {\n    content: "', '";\n  }\n'], ['\n  display: inline-block;\n  margin-left: .5rem;\n  padding: .25rem .5rem;\n  background-color: #cc1616;\n  color: #fff;\n  font-size: .625rem;\n  text-transform: uppercase;\n  \n  &:after {\n    content: "', '";\n  }\n']);

function _taggedTemplateLiteral$37(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// @todo 2019-07-11
//    Extract and refactor to re-use the one used by the front-end
var ConfidentialLabel = styled__default.div(_templateObject$37, __('Draft'));

var _extends$61 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$48 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject$38 = _taggedTemplateLiteral$38(['\n  margin-left: .5rem;\n  padding: 0 .5rem;\n  background: transparent;\n  border: none;\n'], ['\n  margin-left: .5rem;\n  padding: 0 .5rem;\n  background: transparent;\n  border: none;\n']);

function _taggedTemplateLiteral$38(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$22(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$74(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$60(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$63(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermTitle = function (_React$Component) {
  _inherits$63(TermTitle, _React$Component);

  function TermTitle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$74(this, TermTitle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$60(this, (_ref = TermTitle.__proto__ || Object.getPrototypeOf(TermTitle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      audioUrl: null
    }, _this.audioReference = React__default.createRef(), _temp), _possibleConstructorReturn$60(_this, _ret);
  }

  _createClass$48(TermTitle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.term.speech_enabled) {
        synthesizeSpeech(this.props.awsCredentials, this.props.term.name, this.props.term.speech_voice, this.props.term.speech_language, function (url) {
          return _this2.setState({ audioUrl: url });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          shouldShowSelectCheckbox = _props.shouldShowSelectCheckbox,
          _props$isSelected = _props.isSelected,
          isSelected = _props$isSelected === undefined ? null : _props$isSelected,
          term = _props.term,
          awsCredentials = _props.awsCredentials,
          props = _objectWithoutProperties$22(_props, ['shouldShowSelectCheckbox', 'isSelected', 'term', 'awsCredentials']);

      return React__default.createElement(
        'div',
        null,
        React__default.createElement(
          'h4',
          _extends$61({ style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start'
            } }, props),
          shouldShowSelectCheckbox && React__default.createElement('input', {
            style: { margin: '0 .5rem 0 0' },
            type: 'checkbox',
            readOnly: true,
            checked: isSelected }),
          React__default.createElement(
            'span',
            null,
            term.name
          ),
          term.speech_enabled && React__default.createElement(
            ListenButton,
            { type: 'button', onClick: function onClick(event) {
                return handleListenButtonClick(event, awsCredentials, term, _this3.audioReference.current);
              } },
            React__default.createElement('audio', { ref: this.audioReference, src: this.state.audioUrl }),
            React__default.createElement(
              'svg',
              {
                viewBox: '0 0 25 21',
                fill: 'none',
                style: {
                  width: '1.5rem',
                  height: '1.5rem'
                }
              },
              React__default.createElement('path', { d: 'M17.8125 7.34774C17.4479 7.1394 16.9271 7.34774 16.7188 7.7644C16.5104 8.18107 16.7188 8.64982 17.1354 8.85815C17.8646 9.22274 18.3333 9.89982 18.3333 10.5769C18.3333 11.3061 17.8646 11.9832 17.1354 12.3477C16.7188 12.5561 16.5104 13.0248 16.7188 13.4415C16.9271 13.8582 17.4479 14.0665 17.8125 13.8582C19.1667 13.2332 20 11.9832 20 10.5769C20 9.22274 19.1667 7.97274 17.8125 7.34774ZM12.0312 0.576904C11.7188 0.576904 11.4062 0.733154 11.1979 0.993571L6.5625 5.5769H1.25C0.520833 5.5769 0 6.14982 0 6.8269V14.3269C0 15.0561 0.520833 15.5769 1.25 15.5769H6.5625L11.1979 20.2123C11.4062 20.4727 11.7188 20.5769 12.0312 20.5769C12.7083 20.5769 13.3333 20.1082 13.3333 19.3269V1.87899C13.3333 1.09774 12.7083 0.576904 12.0312 0.576904ZM11.6667 18.3373L7.23958 13.9102H1.66667V7.24357H7.23958L11.6667 2.86857V18.3373ZM25 10.5769C25 7.1394 23.1771 4.0144 20.3646 2.39982C19.9479 2.1394 19.4271 2.29565 19.2188 2.71232C18.9583 3.0769 19.1146 3.59774 19.5312 3.80607C21.8229 5.16024 23.2812 7.7644 23.2812 10.5769C23.2812 13.4415 21.8229 16.0457 19.5312 17.3998C19.1146 17.6082 18.9583 18.129 19.2188 18.4936C19.4271 18.9102 19.9479 19.0665 20.3646 18.8061C23.1771 17.1915 25 14.0665 25 10.5769Z', fill: 'currentColor' })
            )
          ),
          term.confidential && React__default.createElement(ConfidentialLabel, null)
        ),
        term.translated_name !== null && React__default.createElement(
          'span',
          { style: { fontWeight: 'normal' } },
          term.translated_name
        )
      );
    }
  }]);

  return TermTitle;
}(React__default.Component);

var ListenButton = styled__default.button(_templateObject$38);

function handleListenButtonClick(event, awsCredentials, term, audioReference) {
  event.stopPropagation();

  if (awsCredentials === undefined || awsCredentials === null) {
    return;
  }

  audioReference.play();
}

var _extends$62 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$23(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TermDescription = (function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties$23(_ref, ["children"]);

  return React__default.createElement(
    "p",
    _extends$62({ dir: "auto", style: { marginTop: 0, marginBottom: 0 } }, props),
    children
  );
});

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject$2(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject$2(src[key]) &&
            isObject$2(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}

/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass$1() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass$1() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass$1() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  var window = getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css$2(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is$1(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index$6() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

var Methods = {
  addClass: addClass$1,
  removeClass: removeClass$1,
  hasClass: hasClass$1,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles,
  offset: offset,
  css: css$2,
  each: each,
  html: html,
  text: text,
  is: is$1,
  index: index$6,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now$2() {
  return Date.now();
}

function getComputedStyle$1(el) {
  var window = getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$3(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode$1(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$1() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode$1(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$3(to[nextKey]) && isObject$3(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$3(to[nextKey]) && isObject$3(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject$3(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = getDocument();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}

var support;

function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}

var browser;

function calcBrowser() {
  var window = getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

var supportsResizeObserver = function supportsResizeObserver() {
  var window = getWindow();
  return typeof window.ResizeObserver !== 'undefined';
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    extend$1(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = getWindow();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = getWindow();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

function _extends$63() { _extends$63 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$63.apply(this, arguments); }
var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = getWindow();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      observer: _extends$63({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
};

var modular = {
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        extend$1(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
};

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  extend$1(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  extend$1(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  extend$1(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  extend$1(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate$2 = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd$1(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition$1 = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd$1
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = $(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  extend$1(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now$2();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      extend$1(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now$2();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now$2()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now$2();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now$2();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now$2() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$1(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  extend$1(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$49(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
var prototypes = {
  modular: modular,
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate$2,
  transition: transition$1,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = extend$1({}, defaults);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    extend$1(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now$2(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes$$1 = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes$$1.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update$$1() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = getDocument();
      var wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    extend$1(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now$2();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass$49(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer$1]);

/* eslint-disable consistent-return */

function _extends$67() { _extends$67 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$67.apply(this, arguments); }
var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    extend$1(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
};
var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      pagination: _extends$67({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

function _extends$73() { _extends$73 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$73.apply(this, arguments); }
var A11y = {
  getRandomNumber: function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }

    var randomChar = function randomChar() {
      return Math.round(16 * Math.random()).toString(16);
    };

    return 'x'.repeat(size).replace(/x/g, randomChar);
  },
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  makeElNotFocusable: function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElRoleDescription: function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
    return $el;
  },
  addElControls: function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  addElId: function addElId($el, id) {
    $el.attr('id', id);
    return $el;
  },
  addElLive: function addElLive($el, live) {
    $el.attr('aria-live', live);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    var swiper = this;
    var params = swiper.params.a11y;
    var $targetEl = $(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;
    if (swiper.params.loop || !swiper.navigation) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
        swiper.a11y.makeElNotFocusable($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
        swiper.a11y.makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
        swiper.a11y.makeElNotFocusable($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
        swiper.a11y.makeElFocusable($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;

    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletEl) {
        var $bulletEl = $(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      });
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.a11y;
    swiper.$el.append(swiper.a11y.liveRegion); // Container

    var $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      swiper.a11y.addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    var $wrapperEl = swiper.$wrapperEl;
    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
    var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    swiper.a11y.addElId($wrapperEl, wrapperId);
    swiper.a11y.addElLive($wrapperEl, live); // Slide

    if (params.itemRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
    }

    swiper.a11y.addElRole($(swiper.slides), params.slideRole);
    var slidesLength = swiper.params.loop ? swiper.slides.filter(function (el) {
      return !el.classList.contains(swiper.params.slideDuplicateClass);
    }).length : swiper.slides.length;
    swiper.slides.each(function (slideEl, index) {
      var $slideEl = $(slideEl);
      var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
      var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
      swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
    }); // Navigation

    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      swiper.a11y.makeElFocusable($nextEl);

      if ($nextEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($nextEl, 'button');
        $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      swiper.a11y.addElControls($nextEl, wrapperId);
    }

    if ($prevEl && $prevEl.length) {
      swiper.a11y.makeElFocusable($prevEl);

      if ($prevEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($prevEl, 'button');
        $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      swiper.a11y.addElControls($prevEl, wrapperId);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  }
};
var A11y$1 = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      a11y: _extends$73({}, A11y, {
        liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
      })
    });
  },
  on: {
    afterInit: function afterInit(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
};

/**
 * Swiper 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */

function isObject$4(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend$2(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$4(src[key]) && isObject$4(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend$2(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

// eslint-disable-next-line

function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend$2(params, Swiper.defaults);
  extend$2(params, Swiper.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$4(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend$2(params[key], obj[key]);
        extend$2(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}

// eslint-disable-next-line

function initSwiper(swiperParams) {
  return new Swiper(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = Swiper.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React__default.createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject$4(swiperParams[key]) && isObject$4(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function processChildren(c) {
  var slides = [];
  React__default.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}

function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (isObject$4(currentParams[key]) && isObject$4(passedParams[key])) {
      extend$2(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return React.useEffect(callback, deps);
  return React.useLayoutEffect(callback, deps);
}

var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends$82() { _extends$82 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$82.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Swiper$1 = /*#__PURE__*/React.forwardRef(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var eventsAssigned = false;

  var _useState = React.useState('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = React.useState(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = React.useState(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = React.useRef(false);
  var swiperElRef = React.useRef(null);
  var swiperRef = React.useRef(null);
  var oldPassedParamsRef = React.useRef(null);
  var oldSlides = React.useRef(null);
  var nextElRef = React.useRef(null);
  var prevElRef = React.useRef(null);
  var paginationElRef = React.useRef(null);
  var scrollbarElRef = React.useRef(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend$2(swiperRef.current.params.virtual, extendWith);
      extend$2(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  React.useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  React.useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default.createElement(Tag, _extends$82({
    ref: swiperElRef,
    className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/React__default.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper$1.displayName = 'Swiper';

var _excluded$1 = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends$83() { _extends$83 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$83.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SwiperSlide = /*#__PURE__*/React.forwardRef(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);

  var slideElRef = React.useRef(null);

  var _useState = React.useState('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default.createElement(Tag, _extends$83({
    ref: slideElRef,
    className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/React__default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';

/**
 * Swiper React 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */

var css$3 = "/**\n * Swiper 6.8.4\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2021 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: August 23, 2021\n */\n\n@font-face{font-family:swiper-icons;src:url('data:application/font-woff;charset=utf-8;base64, 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') format('woff');font-weight:400;font-style:normal}:root{--swiper-theme-color:#007aff}.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-container-pointer-events{touch-action:pan-y}.swiper-container-pointer-events.swiper-container-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-container-3d{perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}";
styleInject$1(css$3);

var css$4 = ".swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:50%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0px,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white{--swiper-pagination-color:#ffffff}.swiper-pagination-black{--swiper-pagination-color:#000000}.swiper-pagination-lock{display:none}";
styleInject$1(css$4);

var css$5 = ".swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}";
styleInject$1(css$5);

var _extends$84 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject$39 = _taggedTemplateLiteral$39(['\n  --swiper-theme-color: #000;\n\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n\n  .swiper-wrapper {\n    height: auto;\n  }\n\n  .swiper-slide {\n    width: auto;\n    font-size: 0;\n  }\n\n  .swiper-pagination {\n    position: initial;\n    margin-top: 0.5rem\n  }\n'], ['\n  --swiper-theme-color: #000;\n\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n\n  .swiper-wrapper {\n    height: auto;\n  }\n\n  .swiper-slide {\n    width: auto;\n    font-size: 0;\n  }\n\n  .swiper-pagination {\n    position: initial;\n    margin-top: 0.5rem\n  }\n']);

function _taggedTemplateLiteral$39(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$24(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// install Swiper modules
Swiper.use([Pagination$1, A11y$1]);

var TermMediaContainer = (function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties$24(_ref, ['children']);

  return children.length === 0 ? React__default.createElement('div', { className: 'term-media-container-slider--empty' }) : React__default.createElement(
    StyledSwiper,
    _extends$84({
      slidesPerView: 'auto',
      spaceBetween: remToPixels(.75),
      pagination: {
        'clickable': true
      },
      className: 'term-media-container-slider'
    }, props),
    React__default.Children.map(children, function (child, index) {
      return React__default.createElement(
        SwiperSlide,
        {
          key: index,
          style: {}
        },
        child
      );
    })
  );
});

var StyledSwiper = styled__default(Swiper$1)(_templateObject$39);

var _templateObject$40 = _taggedTemplateLiteral$40(['\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n  padding: 0 .75rem;\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n'], ['\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n  padding: 0 .75rem;\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n']),
    _templateObject2$20 = _taggedTemplateLiteral$40(['\n  // With object-fit and width we ensure the image is not wider than the\n  // available space (the slide width). We might cut some portions of the image\n  // but the UX is a lot better.\n  // Disabled because not supported on iOS\n  // object-fit: cover;\n  // width: 100%;\n\n  height: 12rem;\n'], ['\n  // With object-fit and width we ensure the image is not wider than the\n  // available space (the slide width). We might cut some portions of the image\n  // but the UX is a lot better.\n  // Disabled because not supported on iOS\n  // object-fit: cover;\n  // width: 100%;\n\n  height: 12rem;\n']),
    _templateObject3$16 = _taggedTemplateLiteral$40(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  font-size: 0;\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  font-size: 0;\n']);

function _taggedTemplateLiteral$40(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$25(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TermMedia = (function (_ref) {
  var src = _ref.src,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'image' : _ref$type,
      props = _objectWithoutProperties$25(_ref, ['src', 'type']);

  return React__default.createElement(
    Container$10,
    props,
    React__default.createElement(Image$1, { src: src }),
    type.toLowerCase() === 'video' && React__default.createElement(
      ImageOverlayIcon$1,
      null,
      React__default.createElement(
        'svg',
        { viewBox: '0 0 26 26', style: {
            width: '3.25rem',
            height: '3.25rem'
          } },
        React__default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          React__default.createElement('path', { stroke: '#979797', strokeWidth: .5, fillOpacity: .83, fill: '#272727', d: 'M.25.25h25.5v25.5H.25z' }),
          React__default.createElement('path', { fill: '#FFF', d: 'M16.073 12.934L10.4 17.046V8.82z' })
        )
      )
    )
  );
});

var Container$10 = styled__default.div(_templateObject$40);

var Image$1 = styled__default.img(_templateObject2$20);

var ImageOverlayIcon$1 = styled__default.div(_templateObject3$16);

var _templateObject$41 = _taggedTemplateLiteral$41(['\n  z-index: 9;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  padding: 0 .5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  box-shadow: rgba(0,0,0,.1) 0 .0625rem .1875rem;\n'], ['\n  z-index: 9;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  padding: 0 .5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  box-shadow: rgba(0,0,0,.1) 0 .0625rem .1875rem;\n']);

function _taggedTemplateLiteral$41(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalHeader = styled__default.div(_templateObject$41);

var _extends$85 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$26(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ModalTitle = (function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties$26(_ref, ['children']);

  return React__default.createElement(
    'h3',
    _extends$85({ style: { fontWeight: 'normal', marginLeft: '1rem' } }, props),
    children
  );
});

var _templateObject$42 = _taggedTemplateLiteral$42(['\n\tcursor: pointer;\n\tpadding: .5rem 1rem;\n\tcolor: #323334;\n\tfont-weight: 200;\n\tvertical-align: bottom;\n\tline-height: 2.25rem;\n  font-size: 2.75rem;\n\tfont-family: monospace;\n'], ['\n\tcursor: pointer;\n\tpadding: .5rem 1rem;\n\tcolor: #323334;\n\tfont-weight: 200;\n\tvertical-align: bottom;\n\tline-height: 2.25rem;\n  font-size: 2.75rem;\n\tfont-family: monospace;\n']);

function _taggedTemplateLiteral$42(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Element$2 = styled__default.span(_templateObject$42);

var ModalCloseIcon = (function (props) {
	return React__default.createElement(
		Element$2,
		props,
		'\xD7'
	);
});

var _templateObject$43 = _taggedTemplateLiteral$43(['\n  margin-top: 1.5rem;\n  font-style: italic;\n  color: ', ';\n'], ['\n  margin-top: 1.5rem;\n  font-style: italic;\n  color: ', ';\n']);

function _taggedTemplateLiteral$43(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$27(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TermTagList = (function (_ref) {
  var tags = _ref.tags,
      props = _objectWithoutProperties$27(_ref, ['tags']);

  return React__default.createElement(
    Container$11,
    props,
    tags.map(function (tag) {
      return tag.name;
    }).join(', ')
  );
});

var Container$11 = styled__default.div(_templateObject$43, function (props) {
  return props.theme.accentColor;
});

var _extends$86 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$50 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$75(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$61(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$64(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isSelected(term, selected) {
  return selected.some(function (id) {
    return id === term.id;
  });
}

/**
 * Filter by case-insensitive title and description.
 *
 * @param terms
 * @param query
 * @returns Array
 */
function filterByQuery(terms, query) {
  if (query === null) {
    return terms;
  }

  return terms.filter(function (term) {
    return term.name.toLowerCase().includes(query.toLowerCase()) || term.description.toLowerCase().includes(query.toLowerCase());
  });
}

/**
 * Show all terms if the displayMode is DISPLAY_MODE_EDIT, otherwise only the
 * selected terms.
 *
 * @param terms
 * @param displayMode
 * @returns Array
 */
function filterForDisplayMode(terms, displayMode) {
  if (displayMode === DISPLAY_MODE_EDIT) {
    return terms;
  }

  return terms.filter(function (term) {
    return term.selected;
  });
}

var initialState = {
  terms: [],
  selected: [],
  query: null
};

var GlossaryModal = function (_Component) {
  _inherits$64(GlossaryModal, _Component);

  function GlossaryModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$75(this, GlossaryModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$61(this, (_ref = GlossaryModal.__proto__ || Object.getPrototypeOf(GlossaryModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends$86({}, GlossaryModalStore$1.getState(), initialState), _this.subscriptions = [], _this.onGlossaryModalUpdate = function () {
      var nextState = GlossaryModalStore$1.getState();

      if (nextState.isVisible === true && _this.state.isVisible === false) {
        nextState.onChapterListRequest(nextState.chapter, nextState.contentId).then(function (terms) {
          _this.setState({ terms: terms, selected: terms.filter(function (term) {
              return term.selected;
            }).map(function (term) {
              return term.id;
            }) });
        });
      }

      if (nextState.isVisible === false && _this.state.isVisible === true) {
        // Override current state with `initialState`
        Object.keys(initialState).forEach(function (property) {
          return nextState[property] = initialState[property];
        });
      }

      _this.setState(nextState);
    }, _this.onTermClick = function (term) {
      if (_this.state.displayMode !== DISPLAY_MODE_EDIT) {
        return;
      }

      var selected = isSelected(term, _this.state.selected) ? _this.state.selected.filter(function (id) {
        return id !== term.id;
      }) : _this.state.selected.concat([term.id]);

      _this.setState({ selected: selected });
    }, _this.onSearchValueChange = function (event) {
      _this.setState({ query: event.target.value });
    }, _this.handleModalClose = function () {
      _this.state.onChapterSyncRequest(_this.state.chapter, _this.state.contentId,
      // Converts the array of selected "id" into an Array of term objects
      _this.state.terms.filter(function (term) {
        return _this.state.selected.some(function (id) {
          return id === term.id;
        });
      }));

      GlossaryModalActions.close();
    }, _this.onTermMediaClick = function (asset) {
      _this.props.onMediaZoomRequest(asset.assetUrl, { id: asset.contentId, pKey: asset.pKey, type: asset.type });
    }, _temp), _possibleConstructorReturn$61(_this, _ret);
  }
  /**
   * @var {{
   *   isVisible: Boolean,
   *   chapter: Object|null,
   *   contentId: string|number,
   *   displayMode: string,
   *   onChapterListRequest: Function<Promise(chapter)>,
   *   onChapterSyncRequest: Function<Promise(chapters, terms[])>,
   *   awsCredentials: string[2]
   *   terms: Array,
   *   selected: Array,
   *   query: string|null,
   * }}
   */


  _createClass$50(GlossaryModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.subscriptions.push(GlossaryModalStore$1.addListener(this.onGlossaryModalUpdate));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.subscriptions.forEach(function (subscription) {
        return subscription.remove();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.state.isVisible && React__default.createElement(
        Modal,
        { visible: true, onClickOutside: GlossaryModalActions.close },
        this.state.displayMode === DISPLAY_MODE_EDIT ? React__default.createElement(
          ModalHeader,
          { style: { padding: '1rem 1.5rem' } },
          React__default.createElement(
            'div',
            null,
            React__default.createElement('input', { type: 'text', placeholder: 'Search...', onChange: this.onSearchValueChange, style: { padding: '.5rem .75rem' } })
          ),
          React__default.createElement(
            'div',
            { style: { display: 'flex' } },
            React__default.createElement(
              'button',
              { onClick: GlossaryModalActions.close },
              'Cancel'
            ),
            React__default.createElement(
              'button',
              { onClick: this.handleModalClose },
              'Save & Close'
            )
          )
        ) : React__default.createElement(
          ModalHeader,
          null,
          React__default.createElement(
            ModalTitle,
            null,
            'GLOSSARY'
          ),
          React__default.createElement(ModalCloseIcon, { onClick: GlossaryModalActions.close })
        ),
        filterForDisplayMode(filterByQuery(this.state.terms, this.state.query), this.state.displayMode).map(function (term) {
          return React__default.createElement(
            Term,
            {
              key: term.id,
              onClick: function onClick() {
                return _this2.onTermClick(term);
              },
              shouldShowSelectedState: _this2.state.displayMode === DISPLAY_MODE_EDIT,
              selected: isSelected(term, _this2.state.selected),
              theme: {
                isMobile: _this2.props.isMobile,
                isTablet: _this2.props.isTablet
              }
            },
            React__default.createElement(
              TermInfo,
              { theme: {
                  isMobile: _this2.props.isMobile,
                  isTablet: _this2.props.isTablet
                },
                onShow: function onShow() {
                  return _this2.props.onGlossaryTermShow(term.id);
                }
              },
              React__default.createElement(TermTitle, {
                shouldShowSelectCheckbox: _this2.state.displayMode === DISPLAY_MODE_EDIT,
                isSelected: isSelected(term, _this2.state.selected),
                awsCredentials: _this2.state.awsCredentials,
                term: term }),
              React__default.createElement(
                TermDescription,
                null,
                term.description
              ),
              React__default.createElement(TermTagList, { tags: term.tags })
            ),
            React__default.createElement(
              TermMediaContainer,
              null,
              term.assets.map(function (asset) {
                return React__default.createElement(TermMedia, {
                  key: asset.id,
                  src: thronImage({ src: null, options: { id: asset.contentId, pKey: asset.pKey, type: asset.type } }, asset.type === THRON_ASSET_TYPE_VIDEO ? remToPixels(15) : 0, // we enforce a more square-ish ratio for videos
                  remToPixels(12)),
                  type: asset.type,
                  onClick: function onClick() {
                    return _this2.onTermMediaClick(asset);
                  } });
              })
            )
          );
        })
      );
    }
  }]);

  return GlossaryModal;
}(React.Component);

GlossaryModal.defaultProps = {
  isMobile: false,
  isTablet: true,
  onMediaZoomRequest: function onMediaZoomRequest(source, options) {
    return null;
  },
  onGlossaryTermShow: function onGlossaryTermShow(glossaryId) {
    return null;
  }
};

var _createClass$51 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$76(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$62(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$65(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThronPlayer = function (_Component) {
  _inherits$65(ThronPlayer, _Component);

  function ThronPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$76(this, ThronPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$62(this, (_ref = ThronPlayer.__proto__ || Object.getPrototypeOf(ThronPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.player = null, _temp), _possibleConstructorReturn$62(_this, _ret);
  }

  _createClass$51(ThronPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = {
        clientId: 'valentino',
        xcontentId: this.props.id,
        sessId: this.props.pKey,
        autoplay: true,
        minHeightWidthPercent: 0
      };

      // noinspection JSUnresolvedFunction
      this.player = window.THRONContentExperience('thron-player', options);

      function onBeforeInit(playerInstance) {
        var schema = window.THRONSchemaHelper.getSchema();

        window.THRONSchemaHelper.removeElementsById(schema, 'IMAGE', ['fullscreenButton', 'captionText']);
        window.THRONSchemaHelper.removeElementsById(schema, 'IMAGEGALLERY', ['fullscreenButton', 'captionText']);

        window.THRONSchemaHelper.removeElementsById(schema, 'VIDEO', ['fullscreenButton', 'captionText', 'speedButton', 'downloadableButton']);
        window.THRONSchemaHelper.removeElementsById(schema, 'VIDEOGALLERY', ['fullscreenButton', 'captionText', 'speedButton', 'downloadableButton']);

        window.THRONSchemaHelper.removeElementsById(schema, 'LIVEEVENT', ['fullscreenButton']);

        window.THRONSchemaHelper.removeElementsById(schema, 'AUDIO', ['fullscreenButton', 'captionText']);
        window.THRONSchemaHelper.removeElementsById(schema, 'AUDIOGALLERY', ['fullscreenButton', 'captionText']);

        window.THRONSchemaHelper.removeElementsById(schema, 'URL', ['fullscreenButton', 'captionText']);
        window.THRONSchemaHelper.removeElementsById(schema, 'PAGELET', ['fullscreenButton']);

        window.THRONSchemaHelper.removeElementsById(schema, 'OTHER', ['fullscreenButton', 'captionText']);
        window.THRONSchemaHelper.removeElementsById(schema, 'OTHER_DOCUMENT', ['fullscreenButton', 'captionText']);

        playerInstance.params({ bars: schema });
      }

      this.player.on('beforeInit', onBeforeInit);
      this.player.on('complete', this.props.onComplete);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.player.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement('div', { id: 'thron-player', style: {
          width: '100%',
          height: '100%',
          overflowScrolling: 'touch',
          WebkitOverflowScrolling: 'touch' } });
    }
  }]);

  return ThronPlayer;
}(React.Component);

ThronPlayer.defaultProps = {
  onComplete: function onComplete() {
    return null;
  }
};

var _extends$87 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CloseCircle = function CloseCircle(props) {
  return React__default.createElement(
    "svg",
    _extends$87({ viewBox: "0 0 32 32" }, props),
    React__default.createElement("path", {
      d: "M16 .75C7.437.75.5 7.687.5 16.25c0 8.562 6.938 15.5 15.5 15.5 8.563 0 15.5-6.938 15.5-15.5C31.5 7.687 24.562.75 16 .75zm7.563 19.625c.312.25.312.75 0 1.062l-2.438 2.438c-.313.312-.813.312-1.063 0L16 19.75l-4.125 4.125c-.25.312-.75.312-1.063 0l-2.437-2.5c-.313-.25-.313-.75 0-1.063l4.125-4.063-4.125-4.062c-.313-.25-.313-.75 0-1.063l2.5-2.437c.25-.312.75-.312 1.063 0L16 12.75l4.063-4.063c.25-.312.75-.312 1.062 0l2.438 2.438c.312.312.312.812 0 1.062L19.5 16.25l4.063 4.125z",
      fill: "currentColor"
    })
  );
};

var _templateObject$44 = _taggedTemplateLiteral$44(['\n  z-index: 209; // ModalFullScreen is 109\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: env(safe-area-inset-top);\n  background-color: rgb(0 0 0 / .7);\n  cursor: pointer;\n'], ['\n  z-index: 209; // ModalFullScreen is 109\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: env(safe-area-inset-top);\n  background-color: rgb(0 0 0 / .7);\n  cursor: pointer;\n']),
    _templateObject2$21 = _taggedTemplateLiteral$44(['\n  z-index: 1;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  right: 0;\n  padding: max(.5rem, env(safe-area-inset-top)) .5rem;\n  border: none;\n  background-color: transparent;\n\n  svg {\n    width: 2rem;\n    color: #fff;\n  }\n'], ['\n  z-index: 1;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  right: 0;\n  padding: max(.5rem, env(safe-area-inset-top)) .5rem;\n  border: none;\n  background-color: transparent;\n\n  svg {\n    width: 2rem;\n    color: #fff;\n  }\n']),
    _templateObject3$17 = _taggedTemplateLiteral$44(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n']);

function _taggedTemplateLiteral$44(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties$28(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ThronAssetModal = (function (_ref) {
  var onCloseButtonClick = _ref.onCloseButtonClick,
      src = _ref.src,
      options = _ref.options,
      props = _objectWithoutProperties$28(_ref, ['onCloseButtonClick', 'src', 'options']);

  return React__default.createElement(
    Modal$1,
    props,
    React__default.createElement(CloseButton, { onClick: onCloseButtonClick }),
    React__default.createElement(
      ModalInner,
      null,
      options ? /* We assume the options are for the thron player */React__default.createElement(ThronPlayer, { id: options.id, pKey: options.pKey }) : React__default.createElement('img', { src: src, alt: '', style: { maxWidth: '100%', maxHeight: '100%' } })
    ),
    React__default.createElement(
      CloseButton,
      { onClick: onCloseButtonClick },
      React__default.createElement(CloseCircle, null)
    )
  );
});

var Modal$1 = styled__default.div(_templateObject$44);

var CloseButton = styled__default.button(_templateObject2$21);

var ModalInner = styled__default.div(_templateObject3$17);

exports.default = ThemeBuilder;
exports.GlossaryButton = GlossaryButton$1;
exports.GlossaryModal = GlossaryModal;
exports.Term = Term;
exports.TermInfo = TermInfo;
exports.TermTitle = TermTitle;
exports.TermDescription = TermDescription;
exports.TermTagList = TermTagList;
exports.TermMediaContainer = TermMediaContainer;
exports.TermMedia = TermMedia;
exports.ThronAssetModal = ThronAssetModal;
